import { notification as ur, Flex as as, Typography as fn, Button as xc, Table as _c, Radio as Dd, ConfigProvider as Ld, Modal as Vd } from "antd";
import * as d from "react";
import Q, { useState as Ze, useContext as Lr, createContext as oi, isValidElement as jd, version as zd, useRef as De, useLayoutEffect as Hd, useEffect as gt, useMemo as pn, forwardRef as Bd, useCallback as kr, useImperativeHandle as Wd } from "react";
import Kd from "zustand";
import ks, { createPortal as qd, unstable_batchedUpdates as Ud, flushSync as Gd } from "react-dom";
import { format as Xd } from "date-fns";
(async () => typeof window < "u" && (window.React || (window.React = await import("react")), window.ReactDOM || (window.ReactDOM = await import("react-dom"))))();
function Pc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Dn = {}, Ri = { exports: {} }, Fs;
function si() {
  return Fs || (Fs = 1, function(e) {
    function t(r) {
      return r && r.__esModule ? r : {
        default: r
      };
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ri)), Ri.exports;
}
var Ln = {}, Ds;
function Yd() {
  if (Ds) return Ln;
  Ds = 1, Object.defineProperty(Ln, "__esModule", {
    value: !0
  }), Ln.default = void 0;
  var e = {
    // Options
    items_per_page: "/ стр.",
    jump_to: "Перейти",
    jump_to_confirm: "подтвердить",
    page: "Страница",
    // Pagination
    prev_page: "Назад",
    next_page: "Вперед",
    prev_5: "Предыдущие 5",
    next_5: "Следующие 5",
    prev_3: "Предыдущие 3",
    next_3: "Следующие 3",
    page_size: "размер страницы"
  };
  return Ln.default = e, Ln;
}
var Vn = {}, jn = {}, zn = {}, Ni = { exports: {} }, Ti = { exports: {} }, Ii = { exports: {} }, Ai = { exports: {} }, Ls;
function $c() {
  return Ls || (Ls = 1, function(e) {
    function t(r) {
      "@babel/helpers - typeof";
      return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
      } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ai)), Ai.exports;
}
var ki = { exports: {} }, Vs;
function Qd() {
  return Vs || (Vs = 1, function(e) {
    var t = $c().default;
    function r(n, a) {
      if (t(n) != "object" || !n) return n;
      var i = n[Symbol.toPrimitive];
      if (i !== void 0) {
        var o = i.call(n, a || "default");
        if (t(o) != "object") return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (a === "string" ? String : Number)(n);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(ki)), ki.exports;
}
var js;
function Zd() {
  return js || (js = 1, function(e) {
    var t = $c().default, r = Qd();
    function n(a) {
      var i = r(a, "string");
      return t(i) == "symbol" ? i : i + "";
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ii)), Ii.exports;
}
var zs;
function Jd() {
  return zs || (zs = 1, function(e) {
    var t = Zd();
    function r(n, a, i) {
      return (a = t(a)) in n ? Object.defineProperty(n, a, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[a] = i, n;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ti)), Ti.exports;
}
var Hs;
function ef() {
  return Hs || (Hs = 1, function(e) {
    var t = Jd();
    function r(a, i) {
      var o = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(a);
        i && (s = s.filter(function(l) {
          return Object.getOwnPropertyDescriptor(a, l).enumerable;
        })), o.push.apply(o, s);
      }
      return o;
    }
    function n(a) {
      for (var i = 1; i < arguments.length; i++) {
        var o = arguments[i] != null ? arguments[i] : {};
        i % 2 ? r(Object(o), !0).forEach(function(s) {
          t(a, s, o[s]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(o)) : r(Object(o)).forEach(function(s) {
          Object.defineProperty(a, s, Object.getOwnPropertyDescriptor(o, s));
        });
      }
      return a;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ni)), Ni.exports;
}
var Hn = {}, Bs;
function tf() {
  return Bs || (Bs = 1, Object.defineProperty(Hn, "__esModule", {
    value: !0
  }), Hn.commonLocale = void 0, Hn.commonLocale = {
    yearFormat: "YYYY",
    dayFormat: "D",
    cellMeridiemFormat: "A",
    monthBeforeYear: !0
  }), Hn;
}
var Ws;
function rf() {
  if (Ws) return zn;
  Ws = 1;
  var e = si().default;
  Object.defineProperty(zn, "__esModule", {
    value: !0
  }), zn.default = void 0;
  var t = e(ef()), r = tf(), n = (0, t.default)((0, t.default)({}, r.commonLocale), {}, {
    locale: "ru_RU",
    today: "Сегодня",
    now: "Сейчас",
    backToToday: "Текущая дата",
    ok: "ОК",
    clear: "Очистить",
    week: "Неделя",
    month: "Месяц",
    year: "Год",
    timeSelect: "Выбрать время",
    dateSelect: "Выбрать дату",
    monthSelect: "Выбрать месяц",
    yearSelect: "Выбрать год",
    decadeSelect: "Выбрать десятилетие",
    dateFormat: "D-M-YYYY",
    dateTimeFormat: "D-M-YYYY HH:mm:ss",
    previousMonth: "Предыдущий месяц (PageUp)",
    nextMonth: "Следующий месяц (PageDown)",
    previousYear: "Предыдущий год (Control + left)",
    nextYear: "Следующий год (Control + right)",
    previousDecade: "Предыдущее десятилетие",
    nextDecade: "Следущее десятилетие",
    previousCentury: "Предыдущий век",
    nextCentury: "Следующий век"
  });
  return zn.default = n, zn;
}
var Bn = {}, Ks;
function Oc() {
  if (Ks) return Bn;
  Ks = 1, Object.defineProperty(Bn, "__esModule", {
    value: !0
  }), Bn.default = void 0;
  const e = {
    placeholder: "Выберите время",
    rangePlaceholder: ["Время начала", "Время окончания"]
  };
  return Bn.default = e, Bn;
}
var qs;
function Mc() {
  if (qs) return jn;
  qs = 1;
  var e = si().default;
  Object.defineProperty(jn, "__esModule", {
    value: !0
  }), jn.default = void 0;
  var t = e(rf()), r = e(/* @__PURE__ */ Oc());
  const n = {
    lang: Object.assign({
      placeholder: "Выберите дату",
      yearPlaceholder: "Выберите год",
      quarterPlaceholder: "Выберите квартал",
      monthPlaceholder: "Выберите месяц",
      weekPlaceholder: "Выберите неделю",
      rangePlaceholder: ["Начальная дата", "Конечная дата"],
      rangeYearPlaceholder: ["Начальный год", "Год окончания"],
      rangeMonthPlaceholder: ["Начальный месяц", "Конечный месяц"],
      rangeWeekPlaceholder: ["Начальная неделя", "Конечная неделя"],
      shortWeekDays: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
      shortMonths: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"]
    }, t.default),
    timePickerLocale: Object.assign({}, r.default)
  };
  return jn.default = n, jn;
}
var Us;
function nf() {
  if (Us) return Vn;
  Us = 1;
  var e = si().default;
  Object.defineProperty(Vn, "__esModule", {
    value: !0
  }), Vn.default = void 0;
  var t = e(/* @__PURE__ */ Mc());
  return Vn.default = t.default, Vn;
}
var Gs;
function af() {
  if (Gs) return Dn;
  Gs = 1;
  var e = si().default;
  Object.defineProperty(Dn, "__esModule", {
    value: !0
  }), Dn.default = void 0;
  var t = e(Yd()), r = e(/* @__PURE__ */ nf()), n = e(/* @__PURE__ */ Mc()), a = e(/* @__PURE__ */ Oc());
  const i = "${label} не является типом ${type}", o = {
    locale: "ru",
    Pagination: t.default,
    DatePicker: n.default,
    TimePicker: a.default,
    Calendar: r.default,
    global: {
      placeholder: "Пожалуйста выберите",
      close: "Закрыть"
    },
    Table: {
      filterTitle: "Фильтр",
      filterConfirm: "OK",
      filterReset: "Сбросить",
      filterEmptyText: "Без фильтров",
      filterCheckAll: "Выбрать все элементы",
      filterSearchPlaceholder: "Поиск в фильтрах",
      emptyText: "Нет данных",
      selectAll: "Выбрать всё",
      selectInvert: "Инвертировать выбор",
      selectNone: "Очистить все данные",
      selectionAll: "Выбрать все данные",
      sortTitle: "Сортировка",
      expand: "Развернуть строку",
      collapse: "Свернуть строку",
      triggerDesc: "Нажмите для сортировки по убыванию",
      triggerAsc: "Нажмите для сортировки по возрастанию",
      cancelSort: "Нажмите, чтобы отменить сортировку"
    },
    Tour: {
      Next: "Далее",
      Previous: "Назад",
      Finish: "Завершить"
    },
    Modal: {
      okText: "OK",
      cancelText: "Отмена",
      justOkText: "OK"
    },
    Popconfirm: {
      okText: "OK",
      cancelText: "Отмена"
    },
    Transfer: {
      titles: ["", ""],
      searchPlaceholder: "Поиск",
      itemUnit: "элем.",
      itemsUnit: "элем.",
      remove: "Удалить",
      selectAll: "Выбрать все данные",
      deselectAll: "Очистить все данные",
      selectCurrent: "Выбрать текущую страницу",
      selectInvert: "Инвертировать выбор",
      removeAll: "Удалить все данные",
      removeCurrent: "Удалить текущую страницу"
    },
    Upload: {
      uploading: "Загрузка...",
      removeFile: "Удалить файл",
      uploadError: "При загрузке произошла ошибка",
      previewFile: "Предпросмотр файла",
      downloadFile: "Загрузить файл"
    },
    Empty: {
      description: "Нет данных"
    },
    Icon: {
      icon: "иконка"
    },
    Text: {
      edit: "Редактировать",
      copy: "Копировать",
      copied: "Скопировано",
      expand: "Раскрыть",
      collapse: "Свернуть"
    },
    Form: {
      optional: "(необязательно)",
      defaultValidateMessages: {
        default: "Ошибка проверки поля ${label}",
        required: "Пожалуйста, введите ${label}",
        enum: "${label} должен быть одним из [${enum}]",
        whitespace: "${label} не может быть пустым",
        date: {
          format: "${label} не правильный формат даты",
          parse: "${label} не может быть преобразовано в дату",
          invalid: "${label} не является корректной датой"
        },
        types: {
          string: i,
          method: i,
          array: i,
          object: i,
          number: i,
          date: i,
          boolean: i,
          integer: i,
          float: i,
          regexp: i,
          email: i,
          url: i,
          hex: i
        },
        string: {
          len: "${label} должна быть ${len} символов",
          min: "${label} должна быть больше или равна ${min} символов",
          max: "${label} должна быть меньше или равна ${max} символов",
          range: "Длина ${label} должна быть между ${min}-${max} символами"
        },
        number: {
          len: "${label} должна быть равна ${len}",
          min: "${label} должна быть больше или равна ${min}",
          max: "${label} должна быть меньше или равна ${max}",
          range: "${label} должна быть между ${min}-${max}"
        },
        array: {
          len: "Количество элементов ${label} должно быть равно ${len}",
          min: "Количество элементов ${label} должно быть больше или равно ${min}",
          max: "Количество элементов ${label} должно быть меньше или равно ${max}",
          range: "Количество элементов ${label} должно быть между ${min} и ${max}"
        },
        pattern: {
          mismatch: "${label} не соответствует шаблону ${pattern}"
        }
      }
    },
    Image: {
      preview: "Предпросмотр"
    },
    QRCode: {
      expired: "QR-код устарел",
      refresh: "Обновить"
    },
    ColorPicker: {
      presetEmpty: "Пустой",
      transparent: "Прозрачный",
      singleColor: "Один цвет",
      gradientColor: "Градиент"
    }
  };
  return Dn.default = o, Dn;
}
var Fi, Xs;
function of() {
  return Xs || (Xs = 1, Fi = /* @__PURE__ */ af()), Fi;
}
var sf = /* @__PURE__ */ of();
const lf = /* @__PURE__ */ Pc(sf);
function cf(e) {
  const { isOpen: t = !1 } = {}, [r, n] = Ze(t);
  return {
    isOpen: r,
    onOpen: () => n(!0),
    onClose: () => n(!1),
    onToggle: () => n((s) => !s)
  };
}
const Di = {
  "0x800B010A": "Не удается построить цепочку сертификатов до доверенного корневого центра, убедитесь что установлены все корневые и промежуточные сертификаты [0x800B010A]",
  "0x80090020": "Внутренняя ошибка [0x80090020]. Если используется внешний токен, убедитесь, что ввели корректный PIN-код",
  // 2148073504
  "0x8007065B": "Истекла лицензия на КриптоПро CSP [0x8007065B]",
  "0x800B0109": "Отсутствует сертификат УЦ в хранилище корневых сертификатов [0x800B0109]",
  // A certificate chain processed, but terminated in a root certificate which is not trusted by the trust provider.
  "0x8009200C": "Не удается найти сертификат и закрытый ключ для расшифровки [0x8009200C]",
  "0x80090008": "Указан неверный алгоритм (используется устаревшая версия КриптоПро CSP или КриптоПро ЭЦП Browser plug-in) [0x80090008]",
  // 2148073480
  "0x000004C7": "Операция отменена пользователем [0x000004C7]",
  // Не удается получить доступ к сертификатам
  "0x8009000D": "Нет доступа к закрытому ключу. Ввод пароля отменен или произошел сбой в запомненных паролях [0x8009000D]",
  "0x800B0101": "Истек/не наступил срок действия требуемого сертификата [0x800B0101]",
  // untested:
  "0x80070026": "Недопустимый формат данных записываемого сертификата [0x80070026]",
  // @see issue #20
  "0x8009200B": "Не удается найти закрытый ключ для подписи, убедитесь что сертификат установлен правильно [0x8009200B]",
  "0x8010006E": "Действие отменено пользователем [0x8010006E]",
  // 2148532334
  NPObject: "Не удается подписать, убедитесь что выбранный сертификат подходит для подписи",
  // Error calling method on NPObject!
  "Automation server": "Библиотека CAPICOM не была автоматически зарегистрирована или заблокирована на Вашем компьютере (2146827859)",
  "сервером программирования": "Библиотека CAPICOM не была автоматически зарегистрирована или заблокирована на Вашем компьютере (2146827859)"
};
function is() {
}
is.prototype.toString = function() {
  let e = "";
  for (const t in this)
    this.hasOwnProperty(t) && (e += `${t}="${this[t].replace(/"/g, "'")}", `);
  return e;
};
const uf = [
  { oid: "1.2.643.3.131.1.1", short: "INN", full: "ИНН" },
  { oid: "1.2.643.100.4", short: "INNLE", full: "ИНН ЮЛ" },
  { oid: "1.2.643.100.1", short: "OGRN", full: "ОГРН" },
  { oid: "1.2.643.100.5", short: "OGRNIP", full: "ОГРНИП" },
  { oid: "1.2.643.100.3", short: "SNILS", full: "СНИЛС" },
  { oid: "1.2.840.113549.1.9.1", short: "E", full: "emailAddress" },
  { oid: "2.5.4.3", short: "CN", full: "commonName" },
  { oid: "2.5.4.4", short: "SN", full: "surname" },
  { oid: "2.5.4.42", short: "G", full: "givenName" },
  { oid: "2.5.4.6", short: "C", full: "countryName" },
  { oid: "2.5.4.7", short: "L", full: "localityName" },
  { oid: "2.5.4.8", short: "S", full: "stateOrProvinceName" },
  { oid: "2.5.4.9", short: "STREET", full: "streetAddress" },
  { oid: "2.5.4.10", short: "O", full: "organizationName" },
  { oid: "2.5.4.11", short: "OU", full: "organizationalUnitName" },
  { oid: "2.5.4.12", short: "T", full: "title" }
  //  { oid: '2.5.4.16',             short: '?',      full: 'postalAddress' },
];
function df(e) {
  const t = new is();
  for (const r of Object.keys(e)) {
    const n = uf.find((a) => a.oid == r || a.full == r);
    n ? t[n.short] = e[r] : t[r] = e[r];
  }
  return t;
}
function ff(e, t) {
  let r, n;
  const a = /(\.0+)+$/, i = e.replace(a, "").split("."), o = t.replace(a, "").split("."), s = Math.min(i.length, o.length);
  for (r = 0; r < s; r++)
    if (n = parseInt(i[r], 10) - parseInt(o[r], 10), n)
      return n;
  return i.length - o.length;
}
function vf() {
  let e, t = "", r = !1, n = 0;
  this.init = function() {
    return window.cadesplugin_skip_extension_install = !0, window.allow_firefox_cadesplugin_async = !0, import("./cadesplugin_api-CtLsKJZy.mjs"), e = !!cadesplugin.CreateObjectAsync, n = cadesplugin.CAPICOM_CERTIFICATE_INCLUDE_END_ENTITY_ONLY, new Promise((b) => {
      if (!window.cadesplugin)
        throw new Error("КриптоПро ЭЦП Browser plug-in не обнаружен");
      b();
    }).then(() => e ? cadesplugin.then(() => cadesplugin.CreateObjectAsync("CAdESCOM.About")).then((b) => b.Version).then((b) => (t = b, { version: b })).catch((b) => {
      const g = u(b);
      throw new Error(g);
    }) : new Promise((b) => {
      try {
        const g = cadesplugin.CreateObject("CAdESCOM.About");
        if (!g || !g.Version)
          throw new Error("КриптоПро ЭЦП Browser plug-in не загружен");
        t = g.Version, b({
          version: t
        });
      } catch (g) {
        const m = u(g);
        throw new Error(m);
      }
    }));
  }, this.bind = function(b) {
    return r = !0, Promise.resolve(r);
  }, this.unbind = function() {
    return r = !1, Promise.resolve(r);
  }, this.certificateInfo = function(b, g) {
    g || (g = {
      checkValid: !1
    });
    const m = function() {
      return `Название:              ${this.Name}
Издатель:              ${this.IssuerName}
Субъект:               ${this.SubjectName}
Версия:                ${this.Version}
Алгоритм:              ${this.Algorithm}
Серийный №:            ${this.SerialNumber}
Отпечаток SHA1:        ${this.Thumbprint}
Не действителен до:    ${this.ValidFromDate}
Не действителен после: ${this.ValidToDate}
Приватный ключ:        ${this.HasPrivateKey ? "Есть" : "Нет"}
Криптопровайдер:       ${this.ProviderName}
Валидный:              ${this.IsValid ? "Да" : "Нет"}`;
    };
    if (e) {
      let f = {};
      return c(b).then(
        (y) => Promise.all([
          y.HasPrivateKey(),
          g.checkValid ? y.IsValid().then((p) => p.Result) : void 0,
          y.IssuerName,
          y.SerialNumber,
          y.SubjectName,
          y.Thumbprint,
          y.ValidFromDate,
          y.ValidToDate,
          y.Version,
          y.PublicKey().then((p) => p.Algorithm).then((p) => p.FriendlyName),
          y.HasPrivateKey().then(
            (p) => !p && ["", void 0] || y.PrivateKey.then(
              (C) => Promise.all([C.ProviderName, C.ProviderType])
            )
          )
        ])
      ).then((y) => {
        if (f = {
          HasPrivateKey: y[0],
          IsValid: y[1],
          IssuerName: y[2],
          Issuer: void 0,
          SerialNumber: y[3],
          SubjectName: y[4],
          Subject: void 0,
          Name: void 0,
          Thumbprint: y[5],
          ValidFromDate: new Date(y[6]),
          ValidToDate: new Date(y[7]),
          Version: y[8],
          Algorithm: y[9],
          ProviderName: y[10][0],
          ProviderType: y[10][1]
        }, f.Subject = v(f.SubjectName), f.Issuer = v(f.IssuerName), f.Name = f.Subject.CN, !g.checkValid) {
          const p = /* @__PURE__ */ new Date();
          f.IsValid = p >= f.ValidFromDate && p <= f.ValidToDate;
        }
        return f.toString = m, f;
      }).catch((y) => {
        const p = u(y);
        throw new Error(p);
      });
    }
    return new Promise((f) => {
      try {
        const y = c(b), p = y.HasPrivateKey(), C = v(y.SubjectName), S = {
          HasPrivateKey: p,
          IsValid: g.checkValid ? y.IsValid().Result : void 0,
          IssuerName: y.IssuerName,
          Issuer: v(y.IssuerName),
          SerialNumber: y.SerialNumber,
          SubjectName: y.SubjectName,
          Subject: C,
          Name: C.CN,
          Thumbprint: y.Thumbprint,
          ValidFromDate: new Date(y.ValidFromDate),
          ValidToDate: new Date(y.ValidToDate),
          Version: y.Version,
          Algorithm: y.PublicKey().Algorithm.FriendlyName,
          ProviderName: p && y.PrivateKey.ProviderName || "",
          ProviderType: p && y.PrivateKey.ProviderType || void 0
        };
        if (!g.checkValid) {
          const E = /* @__PURE__ */ new Date();
          S.IsValid = E >= S.ValidFromDate && E <= S.ValidToDate;
        }
        S.toString = m, f(S);
      } catch (y) {
        const p = u(y);
        throw new Error(p);
      }
    });
  }, this.listCertificates = function() {
    const b = o();
    if (e) {
      let g, m;
      return cadesplugin.then(() => cadesplugin.CreateObjectAsync("CAPICOM.Store")).then((f) => (g = f, g.Open(
        cadesplugin.CAPICOM_CURRENT_USER_STORE,
        cadesplugin.CAPICOM_MY_STORE,
        cadesplugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED
      ))).then(() => s(g)).then((f) => (m = f, g.Close())).then(() => {
        if (b) {
          let f;
          return g.Open(cadesplugin.CADESCOM_CONTAINER_STORE).then(() => {
            const y = m.map((p) => p.id);
            return s(g, y);
          }).then((y) => (f = y, g.Close())).then(() => f).catch((y) => (console.log(y), []));
        }
        return [];
      }).then((f) => (m.push(...f), m)).catch((f) => {
        const y = u(f);
        throw new Error(y);
      });
    }
    return new Promise((g) => {
      try {
        const m = cadesplugin.CreateObject("CAPICOM.Store");
        m.Open(
          cadesplugin.CAPICOM_CURRENT_USER_STORE,
          cadesplugin.CAPICOM_MY_STORE,
          cadesplugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED
        );
        const f = s(m);
        if (m.Close(), b)
          try {
            m.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
            const y = f.map((C) => C.id), p = s(m, y);
            m.Close(), f.push(...p);
          } catch (y) {
            console.log(y);
          }
        g(f);
      } catch (m) {
        const f = u(m);
        throw new Error(f);
      }
    });
  }, this.readCertificate = function(b) {
    return e ? c(b).then((g) => g.Export(cadesplugin.CADESCOM_ENCODE_BASE64)).catch((g) => {
      const m = u(g);
      throw new Error(m);
    }) : new Promise((g) => {
      try {
        const f = c(b).Export(cadesplugin.CADESCOM_ENCODE_BASE64);
        g(f);
      } catch (m) {
        const f = u(m);
        throw new Error(f);
      }
    });
  }, this.signData = function(b, g, m) {
    typeof m == "string" && (m = { pin: m }), m || (m = {});
    const { pin: f, attached: y } = m;
    if (e) {
      let p, C, S;
      return c(g, f).then((E) => (p = E, Promise.all([
        cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner"),
        cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData")
      ]))).then((E) => (C = E[0], S = E[1], Promise.all([
        C.propset_Certificate(p),
        C.propset_Options(n),
        // Значение свойства ContentEncoding должно быть задано до заполнения свойства Content
        S.propset_ContentEncoding(
          cadesplugin.CADESCOM_BASE64_TO_BINARY
        )
      ]))).then(() => S.propset_Content(b)).then(
        () => S.SignCades(
          C,
          cadesplugin.CADESCOM_CADES_BES,
          !y
        )
      ).catch((E) => {
        const w = u(E);
        throw new Error(w);
      });
    }
  };
  const a = "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34112012-256", i = "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34102012-gostr34112012-256";
  this.signDataXML = function(b, g, m) {
    typeof m == "string" && (m = { pin: m }), m || (m = {});
    const { pin: f, attached: y } = m;
    if (e) {
      let p, C, S;
      return c(g, f).then((E) => (p = E, Promise.all([
        cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner"),
        cadesplugin.CreateObjectAsync("CAdESCOM.SignedXML")
      ]))).then((E) => (C = E[0], S = E[1], Promise.all([
        C.propset_Certificate(p),
        // Error: Отсутствует сертификат УЦ в хранилище корневых сертификатов [0x800B0109] - если true
        C.propset_CheckCertificate(!1),
        // Значение свойства ContentEncoding должно быть задано до заполнения свойства Content
        S.propset_Content(b),
        S.propset_SignatureType(
          cadesplugin.CADESCOM_XML_SIGNATURE_TYPE_ENVELOPED
        ),
        S.propset_SignatureMethod(i),
        S.propset_DigestMethod(a)
      ]))).then(() => S.Sign(C)).catch((E) => {
        const w = u(E);
        throw new Error(w);
      });
    }
    return new Promise((p) => {
      try {
        const C = c(g, f), S = cadesplugin.CreateObject("CAdESCOM.CPSigner");
        S.Certificate(C), S.CheckCertificate(!0);
        const E = cadesplugin.CreateObject("CAdESCOM.SignedXML");
        E.Content(b), E.SignatureType(
          cadesplugin.CADESCOM_XML_SIGNATURE_TYPE_ENVELOPED
        ), E.SignatureMethod(i), E.DigestMethod(a);
        const w = E.Sign(S);
        p(w);
      } catch (C) {
        const S = u(C);
        throw new Error(S);
      }
    });
  }, this.signHash = function(b, g, m) {
    typeof m == "string" && (m = { pin: m }), m || (m = {});
    const { pin: f, attached: y } = m;
    if (e) {
      let p, C, S, E;
      return c(g, f).then((w) => (p = w, Promise.all([
        cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner"),
        cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData"),
        cadesplugin.CreateObjectAsync("CAdESCOM.HashedData")
      ]))).then((w) => (C = w[0], S = w[1], E = w[2], Promise.all([
        C.propset_Certificate(p),
        C.propset_Options(n),
        // Значение свойства ContentEncoding должно быть задано до заполнения свойства Content
        E.propset_Algorithm(
          cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256
        ),
        E.propset_DataEncoding(
          cadesplugin.CADESCOM_BASE64_TO_BINARY
        ),
        E.SetHashValue(b)
      ]))).then(() => (console.log(E), S.SignHash(
        E,
        C,
        cadesplugin.CADESCOM_CADES_BES
      ))).catch((w) => {
        const P = u(w);
        throw new Error(P);
      });
    } else
      return new Promise((p) => {
        try {
          const C = c(g, f), S = cadesplugin.CreateObject("CAdESCOM.CPSigner");
          S.Certificate = C, S.Options = n;
          const E = cadesplugin.CreateObject(
            "CAdESCOM.CadesSignedData"
          ), w = cadesplugin.CreateObject("CAdESCOM.HashedData");
          w.Algorithm = cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256, w.DataEncoding = cadesplugin.CADESCOM_BASE64_TO_BINARY, w.SetHashValue(b);
          const P = E.SignHash(
            S,
            cadesplugin.CADESCOM_CADES_BES
          );
          p(P);
        } catch (C) {
          const S = u(C);
          throw new Error(S);
        }
      });
  }, this.verifySignedXML = function(b) {
    if (e)
      return cadesplugin.then(() => cadesplugin.CreateObjectAsync("CAdESCOM.SignedXML")).then((g) => g.Verify(b)).then(() => !0).catch((g) => g);
    ur.error({
      message: "в данный момент библиотека не поддерживает синхронную версию проверки, попробуйте другой браузер или обновить расширение"
    });
  }, this.verifySign = function(b, g, m) {
    m || (m = {});
    const { attached: f } = m;
    if (e) {
      let y;
      return cadesplugin.then(() => cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData")).then((p) => (y = p, f ? Promise.resolve() : y.propset_ContentEncoding(cadesplugin.CADESCOM_BASE64_TO_BINARY).then(() => y.propset_Content(b)))).then(
        () => y.VerifyCades(
          g,
          cadesplugin.CADESCOM_CADES_BES,
          !f
        )
      ).then(
        () => (
          // console.log('sign2: %s', sign2);
          !0
        )
      ).catch((p) => {
        const C = u(p);
        throw new Error(C);
      });
    }
    return new Promise((y) => {
      try {
        const p = cadesplugin.CreateObject(
          "CAdESCOM.CadesSignedData"
        );
        f || (p.ContentEncoding = cadesplugin.CADESCOM_BASE64_TO_BINARY, p.Content = b), p.VerifyCades(
          g,
          cadesplugin.CADESCOM_CADES_BES,
          !f
        ), y(!0);
      } catch (p) {
        const C = u(p);
        throw new Error(C);
      }
    });
  };
  function o() {
    return ff(t, "2.0.13292") >= 0;
  }
  function s(b, g = []) {
    if (e) {
      let y;
      return b.Certificates.then((p) => (y = p, p.Count)).then((p) => {
        const C = [];
        for (let S = 1; S <= p; S++) C.push(y.Item(S));
        return Promise.all(C);
      }).then((p) => {
        const C = [];
        for (const S in p)
          C.push(
            p[S].SubjectName,
            p[S].Thumbprint,
            p[S].ValidFromDate,
            p[S].ValidToDate
          );
        return Promise.all(C);
      }).then((p) => {
        const C = [];
        for (let S = 0; S < p.length; S += 4) {
          const E = p[S + 1];
          if (g.indexOf(E) + 1) break;
          const w = v(p[S]);
          C.push({
            id: E,
            name: h(w),
            subject: w,
            validFrom: new Date(p[S + 2]),
            validTo: new Date(p[S + 3])
          });
        }
        return C;
      });
    }
    const m = b.Certificates, f = [];
    for (let y = 1; y <= m.Count; y++) {
      const p = m.Item(y), C = p.Thumbprint;
      if (g.indexOf(C) + 1) break;
      const S = v(p.SubjectName);
      f.push({
        id: C,
        name: h(S),
        subject: S,
        validFrom: new Date(p.ValidFromDate),
        validTo: new Date(p.ValidToDate)
      });
    }
    return f;
  }
  function l(b, g) {
    if (e)
      return b.Certificates.then(
        (f) => f.Find(
          cadesplugin.CAPICOM_CERTIFICATE_FIND_SHA1_HASH,
          g
        )
      ).then(
        (f) => f.Count.then((y) => y === 1 ? f.Item(1) : null)
      );
    const m = b.Certificates.Find(
      cadesplugin.CAPICOM_CERTIFICATE_FIND_SHA1_HASH,
      g
    );
    return m.Count === 1 ? m.Item(1) : null;
  }
  function c(b, g) {
    if (e) {
      let y, p;
      return cadesplugin.then(() => cadesplugin.CreateObjectAsync("CAPICOM.Store")).then((C) => (y = C, y.Open(
        cadesplugin.CAPICOM_CURRENT_USER_STORE,
        cadesplugin.CAPICOM_MY_STORE,
        cadesplugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED
      ))).then(() => l(y, b)).then(
        (C) => y.Close().then(() => !C && o() ? y.Open(cadesplugin.CADESCOM_CONTAINER_STORE).then(() => l(y, b)).then((S) => y.Close().then(() => S)) : C)
      ).then((C) => {
        if (!C)
          throw new Error(
            `Не обнаружен сертификат c отпечатком ${b}`
          );
        return p = C;
      }).then(() => p.HasPrivateKey()).then((C) => {
        let S = Promise.resolve();
        return C && g && (S = S.then(() => p.PrivateKey).then(
          (E) => Promise.all([
            E.propset_KeyPin(g || ""),
            E.propset_CachePin(r)
          ])
        )), S;
      }).then(() => p);
    }
    let m;
    const f = cadesplugin.CreateObject("CAPICOM.Store");
    if (f.Open(
      cadesplugin.CAPICOM_CURRENT_USER_STORE,
      cadesplugin.CAPICOM_MY_STORE,
      cadesplugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED
    ), m = l(f, b), f.Close(), !m && o() && (f.Open(cadesplugin.CADESCOM_CONTAINER_STORE), m = l(f, b), f.Close()), !m)
      throw new Error(`Не обнаружен сертификат c отпечатком ${b}`);
    return m.HasPrivateKey && g && (m.PrivateKey.KeyPin = g || "", m.PrivateKey.CachePin !== void 0 && (m.PrivateKey.CachePin = r)), m;
  }
  function u(b) {
    if (console.log("Crypto-Pro error", b.message || b), b.message) {
      for (const g in Di)
        if (Di.hasOwnProperty(g) && b.message.indexOf(g) + 1) {
          b.message = Di[g];
          break;
        }
    }
    return b.message || b;
  }
  function v(b) {
    const g = new is();
    let m = b.match(
      /([а-яёА-ЯЁa-zA-Z0-9\.\s]+)=(?:("[^"]+?")|(.+?))(?:,|$)/g
    );
    return m ? m = m.map((f) => f.replace(/,$/, "")) : m = [], m.forEach((f) => {
      const y = f.match(/([^=]+)=(.*)/);
      if (y && y.length === 3) {
        const p = y[1].trim().replace(/^OID\./, "");
        g[p] = y[2].trim().replace(/^"(.*)"$/, "$1").replace(/""/g, '"');
      }
    }), df(g);
  }
  function h(b) {
    return `${b.CN}${b.INNLE ? `; ИНН ЮЛ ${b.INNLE}` : ""}${b.INN ? `; ИНН ${b.INN}` : ""}${b.SNILS ? `; СНИЛС ${b.SNILS}` : ""}`;
  }
}
const hf = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_5982_17837)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M2.93305%202.93256C4.22943%201.6362%206.02178%200.833496%208.00065%200.833496C9.97952%200.833496%2011.7719%201.6362%2013.0682%202.93256L12.7147%203.28612L13.0682%202.93256C14.3646%204.22894%2015.1673%206.02129%2015.1673%208.00016C15.1673%209.97903%2014.3646%2011.7714%2013.0682%2013.0677C11.7719%2014.3641%209.97952%2015.1668%208.00065%2015.1668C6.02178%2015.1668%204.22943%2014.3641%202.93305%2013.0678L3.2866%2012.7142L2.93305%2013.0677C1.63669%2011.7714%200.833984%209.97903%200.833984%208.00016C0.833984%206.0213%201.63669%204.22894%202.93305%202.93257L2.93305%202.93256ZM8.00065%201.8335C6.29765%201.8335%204.75667%202.52318%203.64015%203.63967C2.52366%204.75619%201.83398%206.29716%201.83398%208.00016C1.83398%209.70316%202.52366%2011.2441%203.64016%2012.3606C4.75667%2013.4771%206.29765%2014.1668%208.00065%2014.1668C9.70365%2014.1668%2011.2446%2013.4771%2012.3611%2012.3606C13.4776%2011.2441%2014.1673%209.70316%2014.1673%208.00016C14.1673%206.29716%2013.4776%204.75618%2012.3611%203.63967C11.2446%202.52318%209.70365%201.8335%208.00065%201.8335Z'%20fill='%23333333'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M7.99935%204.33349C8.45958%204.33349%208.83268%204.70659%208.83268%205.16682C8.83268%205.62705%208.45958%206.00015%207.99935%206.00015C7.53912%206.00015%207.16602%205.62705%207.16602%205.16682C7.16602%204.70659%207.53912%204.33349%207.99935%204.33349Z'%20fill='%23333333'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M7%207.5C7%207.22386%207.22386%207%207.5%207H8.16667C8.44281%207%208.66667%207.22386%208.66667%207.5L8.66667%2011.5C8.66667%2011.7761%208.44281%2012%208.16667%2012C7.89052%2012%207.66667%2011.7761%207.66667%2011.5L7.66667%208H7.5C7.22386%208%207%207.77614%207%207.5Z'%20fill='%23333333'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.5%2011.5C6.5%2011.2239%206.72386%2011%207%2011H9.33333C9.60948%2011%209.83333%2011.2239%209.83333%2011.5C9.83333%2011.7761%209.60948%2012%209.33333%2012H7C6.72386%2012%206.5%2011.7761%206.5%2011.5Z'%20fill='%23333333'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_5982_17837'%3e%3crect%20width='16'%20height='16'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", gf = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.54289%2017.0685L8.23016%204.36269C8.97999%202.93801%2011.02%202.93802%2011.7698%204.36269L18.4571%2017.0685C19.1581%2018.4003%2018.1923%2020%2016.6873%2020H3.31273C1.80771%2020%200.841934%2018.4003%201.54289%2017.0685Z'%20fill='%23FF7D05'%20stroke='%23FF7D05'%20stroke-width='1.5'/%3e%3cpath%20d='M9.84961%2017.5H10.15M9.99961%2014V7'%20stroke='white'%20stroke-width='1.75'%20stroke-linecap='round'/%3e%3c/svg%3e";
var yn = /* @__PURE__ */ ((e) => (e.StorageNotInitialized = "storage not initialized", e.InvalidCertificate = "invalid certificate", e))(yn || {});
const Rc = ({
  notificationType: e
}) => {
  const t = {
    "storage not initialized": "Не удалось найти сертификаты ЭЦП",
    "invalid certificate": "Подпись можно сделать только валидным ключом"
  }, r = {
    "storage not initialized": /* @__PURE__ */ Q.createElement(
      "img",
      {
        src: gf,
        className: "cryptography-notification__icon",
        alt: "warning"
      }
    ),
    "invalid certificate": /* @__PURE__ */ Q.createElement(
      "img",
      {
        src: hf,
        className: "cryptography-notification__icon",
        alt: "info"
      }
    )
  };
  return /* @__PURE__ */ Q.createElement("div", { className: "cryptography-notification" }, r[e], /* @__PURE__ */ Q.createElement("span", { className: "cryptography-notification__text" }, t[e]));
}, Tr = new vf(), Nc = Kd((e) => ({
  isInitialized: !1,
  isError: !1,
  errorList: [],
  isLoadingCerts: !1,
  certificates: void 0,
  isLoadingSelectedCertificate: !1,
  selectedCertificate: void 0,
  init: async () => {
    e({
      isInitialized: !1,
      certificates: void 0,
      selectedCertificate: void 0
    });
    try {
      await Tr.init(), e({ isInitialized: !0 });
    } catch {
      e((r) => ({
        isError: !0,
        isInitialized: !1,
        errorList: [
          ...r.errorList,
          yn.StorageNotInitialized
        ]
      }));
    }
  },
  fetchCertificates: async () => {
    e({ isLoadingCerts: !0, selectedCertificate: void 0 });
    try {
      const t = await Tr.listCertificates();
      e({ certificates: t, errorList: [] });
    } catch (t) {
      ur.error({
        message: "Произошла ошибка при получении сертификатов",
        placement: "topRight",
        description: String(t)
      }), e((r) => ({
        errorList: [
          ...r.errorList,
          yn.StorageNotInitialized
        ]
      }));
    } finally {
      e({ isLoadingCerts: !1 });
    }
  },
  fetchSelectCertificate: async (t) => {
    e({ isLoadingSelectedCertificate: !0 });
    try {
      const r = await Tr.certificateInfo(t);
      e({ selectedCertificate: r });
    } catch (r) {
      ur.error({
        message: "Произошла ошибка при получении сертификатов",
        placement: "topRight",
        description: String(r)
      });
    } finally {
      e({ isLoadingSelectedCertificate: !1 });
    }
  },
  signXML: async (t, r) => {
    try {
      const n = await Tr.signDataXML(t, r, {
        attached: !0
      });
      return console.log(n), n;
    } catch (n) {
      ur.error({
        message: "Произошла ошибка при подписании xml",
        placement: "topRight",
        description: String(n)
      });
    }
  },
  verifyXML: async (t) => {
    try {
      const r = await Tr.verifySignedXML(t);
      return console.log(r), r;
    } catch (r) {
      ur.error({
        message: "Произошла ошибка при верификации подписи xml",
        placement: "topRight",
        description: String(r)
      });
    }
  },
  signString: async (t, r) => {
    try {
      console.log("signHash");
      const n = await Tr.signData(`${btoa(t)}`, r);
      return console.log(n), n;
    } catch (n) {
      ur.error({
        message: "Произошла ошибка при подписании base64 string",
        placement: "topRight",
        description: String(n)
      });
    }
  },
  signHash: async (t, r) => {
    try {
      console.log("signHash");
      const n = await Tr.signHash(t, r);
      return console.log(n), n;
    } catch (n) {
      ur.error({
        message: "Произошла ошибка при подписании base64 string",
        placement: "topRight",
        description: String(n)
      });
    }
  },
  // не рабочая, тк signBase64 - не создаем пока что
  verifyString: async (t, r) => {
    try {
      const n = await Tr.verifySign(
        btoa(`${t}`),
        btoa(`${r}`)
      );
      return console.log(n), n;
    } catch (n) {
      ur.error({
        message: "Произошла ошибка при верификации base64 string",
        placement: "topRight",
        description: String(n)
      });
    }
  }
})), mf = () => /* @__PURE__ */ Q.createElement(as, { vertical: !0, gap: 16 }, /* @__PURE__ */ Q.createElement(
  Rc,
  {
    notificationType: yn.StorageNotInitialized
  }
), /* @__PURE__ */ Q.createElement(fn.Paragraph, { style: { marginBottom: 0 } }, "Убедитесь в следующем:", /* @__PURE__ */ Q.createElement("br", null), "1. Рабочее место настроено (", /* @__PURE__ */ Q.createElement(xc, { type: "link", style: { padding: 0 } }, "Инструкция"), ")", /* @__PURE__ */ Q.createElement("br", null), "2. Сертификат установлен на компьютер"), /* @__PURE__ */ Q.createElement(fn.Paragraph, { style: { color: "#888888", marginBottom: 0 } }, "Разрешите браузеру операции с сертификатами"));
var Li = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Ys;
function pf() {
  return Ys || (Ys = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var i = "", o = 0; o < arguments.length; o++) {
          var s = arguments[o];
          s && (i = a(i, n(s)));
        }
        return i;
      }
      function n(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return r.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var o = "";
        for (var s in i)
          t.call(i, s) && i[s] && (o = a(o, s));
        return o;
      }
      function a(i, o) {
        return o ? i ? i + " " + o : i + o : i;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Li)), Li.exports;
}
var yf = pf();
const ne = /* @__PURE__ */ Pc(yf);
function Tc(e) {
  if (Array.isArray(e)) return e;
}
function bf(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function no(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function os(e, t) {
  if (e) {
    if (typeof e == "string") return no(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? no(e, t) : void 0;
  }
}
function Ic() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function F(e, t) {
  return Tc(e) || bf(e, t) || os(e, t) || Ic();
}
function le(e) {
  "@babel/helpers - typeof";
  return le = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, le(e);
}
function Cf(e, t) {
  if (le(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (le(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ac(e) {
  var t = Cf(e, "string");
  return le(t) == "symbol" ? t : t + "";
}
function O(e, t, r) {
  return (t = Ac(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Sf(e) {
  if (Array.isArray(e)) return no(e);
}
function kc(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ef() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function te(e) {
  return Sf(e) || kc(e) || os(e) || Ef();
}
function Qs(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function I(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qs(Object(r), !0).forEach(function(n) {
      O(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qs(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function na(e) {
  for (var t = 0, r, n = 0, a = e.length; a >= 4; ++n, a -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function Gt() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function wf(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var r = t; r; ) {
    if (r === e)
      return !0;
    r = r.parentNode;
  }
  return !1;
}
var Zs = "data-rc-order", Js = "data-rc-priority", xf = "rc-util-key", ao = /* @__PURE__ */ new Map();
function Fc() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : xf;
}
function li(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function _f(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function ss(e) {
  return Array.from((ao.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function Dc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!Gt())
    return null;
  var r = t.csp, n = t.prepend, a = t.priority, i = a === void 0 ? 0 : a, o = _f(n), s = o === "prependQueue", l = document.createElement("style");
  l.setAttribute(Zs, o), s && i && l.setAttribute(Js, "".concat(i)), r != null && r.nonce && (l.nonce = r == null ? void 0 : r.nonce), l.innerHTML = e;
  var c = li(t), u = c.firstChild;
  if (n) {
    if (s) {
      var v = (t.styles || ss(c)).filter(function(h) {
        if (!["prepend", "prependQueue"].includes(h.getAttribute(Zs)))
          return !1;
        var b = Number(h.getAttribute(Js) || 0);
        return i >= b;
      });
      if (v.length)
        return c.insertBefore(l, v[v.length - 1].nextSibling), l;
    }
    c.insertBefore(l, u);
  } else
    c.appendChild(l);
  return l;
}
function Lc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = li(t);
  return (t.styles || ss(r)).find(function(n) {
    return n.getAttribute(Fc(t)) === e;
  });
}
function aa(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = Lc(e, t);
  if (r) {
    var n = li(t);
    n.removeChild(r);
  }
}
function Pf(e, t) {
  var r = ao.get(e);
  if (!r || !wf(document, r)) {
    var n = Dc("", t), a = n.parentNode;
    ao.set(e, a), e.removeChild(n);
  }
}
function wr(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = li(r), a = ss(n), i = I(I({}, r), {}, {
    styles: a
  });
  Pf(n, i);
  var o = Lc(t, i);
  if (o) {
    var s, l;
    if ((s = i.csp) !== null && s !== void 0 && s.nonce && o.nonce !== ((l = i.csp) === null || l === void 0 ? void 0 : l.nonce)) {
      var c;
      o.nonce = (c = i.csp) === null || c === void 0 ? void 0 : c.nonce;
    }
    return o.innerHTML !== e && (o.innerHTML = e), o;
  }
  var u = Dc(e, i);
  return u.setAttribute(Fc(i), t), u;
}
function $f(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function Le(e, t) {
  if (e == null) return {};
  var r, n, a = $f(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
function ci(e, t, r) {
  var n = d.useRef({});
  return (!("value" in n.current) || r(n.current.condition, t)) && (n.current.value = e(), n.current.condition = t), n.current.value;
}
var io = {}, ls = [], Of = function(t) {
  ls.push(t);
};
function bn(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = ls.reduce(function(n, a) {
      return a(n ?? "", "warning");
    }, t);
    r && console.error("Warning: ".concat(r));
  }
}
function Mf(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = ls.reduce(function(n, a) {
      return a(n ?? "", "note");
    }, t);
    r && console.warn("Note: ".concat(r));
  }
}
function Vc() {
  io = {};
}
function jc(e, t, r) {
  !t && !io[r] && (e(!1, r), io[r] = !0);
}
function Ae(e, t) {
  jc(bn, e, t);
}
function Rf(e, t) {
  jc(Mf, e, t);
}
Ae.preMessage = Of;
Ae.resetWarned = Vc;
Ae.noteOnce = Rf;
function ia(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = /* @__PURE__ */ new Set();
  function a(i, o) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, l = n.has(i);
    if (Ae(!l, "Warning: There may be circular references"), l)
      return !1;
    if (i === o)
      return !0;
    if (r && s > 1)
      return !1;
    n.add(i);
    var c = s + 1;
    if (Array.isArray(i)) {
      if (!Array.isArray(o) || i.length !== o.length)
        return !1;
      for (var u = 0; u < i.length; u++)
        if (!a(i[u], o[u], c))
          return !1;
      return !0;
    }
    if (i && o && le(i) === "object" && le(o) === "object") {
      var v = Object.keys(i);
      return v.length !== Object.keys(o).length ? !1 : v.every(function(h) {
        return a(i[h], o[h], c);
      });
    }
    return !1;
  }
  return a(e, t);
}
function Rt(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function el(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ac(n.key), n);
  }
}
function Nt(e, t, r) {
  return t && el(e.prototype, t), r && el(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var Nf = "%";
function oo(e) {
  return e.join(Nf);
}
var Tf = /* @__PURE__ */ function() {
  function e(t) {
    Rt(this, e), O(this, "instanceId", void 0), O(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = t;
  }
  return Nt(e, [{
    key: "get",
    value: function(r) {
      return this.opGet(oo(r));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(r) {
      return this.cache.get(r) || null;
    }
  }, {
    key: "update",
    value: function(r, n) {
      return this.opUpdate(oo(r), n);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(r, n) {
      var a = this.cache.get(r), i = n(a);
      i === null ? this.cache.delete(r) : this.cache.set(r, i);
    }
  }]), e;
}(), Cn = "data-token-hash", vr = "data-css-hash", If = "data-cache-path", Fr = "__cssinjs_instance__";
function Af() {
  var e = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var t = document.body.querySelectorAll("style[".concat(vr, "]")) || [], r = document.head.firstChild;
    Array.from(t).forEach(function(a) {
      a[Fr] = a[Fr] || e, a[Fr] === e && document.head.insertBefore(a, r);
    });
    var n = {};
    Array.from(document.querySelectorAll("style[".concat(vr, "]"))).forEach(function(a) {
      var i = a.getAttribute(vr);
      if (n[i]) {
        if (a[Fr] === e) {
          var o;
          (o = a.parentNode) === null || o === void 0 || o.removeChild(a);
        }
      } else
        n[i] = !0;
    });
  }
  return new Tf(e);
}
var ga = /* @__PURE__ */ d.createContext({
  hashPriority: "low",
  cache: Af(),
  defaultCache: !0
});
function be(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function oa(e, t) {
  return oa = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, oa(e, t);
}
function Vr(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && oa(e, t);
}
function sa(e) {
  return sa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, sa(e);
}
function cs() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (cs = function() {
    return !!e;
  })();
}
function kf(e, t) {
  if (t && (le(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return be(e);
}
function jr(e) {
  var t = cs();
  return function() {
    var r, n = sa(e);
    if (t) {
      var a = sa(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return kf(this, r);
  };
}
function Ff(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var us = /* @__PURE__ */ function() {
  function e() {
    Rt(this, e), O(this, "cache", void 0), O(this, "keys", void 0), O(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return Nt(e, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(r) {
      var n, a, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, o = {
        map: this.cache
      };
      return r.forEach(function(s) {
        if (!o)
          o = void 0;
        else {
          var l;
          o = (l = o) === null || l === void 0 || (l = l.map) === null || l === void 0 ? void 0 : l.get(s);
        }
      }), (n = o) !== null && n !== void 0 && n.value && i && (o.value[1] = this.cacheCallTimes++), (a = o) === null || a === void 0 ? void 0 : a.value;
    }
  }, {
    key: "get",
    value: function(r) {
      var n;
      return (n = this.internalGet(r, !0)) === null || n === void 0 ? void 0 : n[0];
    }
  }, {
    key: "has",
    value: function(r) {
      return !!this.internalGet(r);
    }
  }, {
    key: "set",
    value: function(r, n) {
      var a = this;
      if (!this.has(r)) {
        if (this.size() + 1 > e.MAX_CACHE_SIZE + e.MAX_CACHE_OFFSET) {
          var i = this.keys.reduce(function(c, u) {
            var v = F(c, 2), h = v[1];
            return a.internalGet(u)[1] < h ? [u, a.internalGet(u)[1]] : c;
          }, [this.keys[0], this.cacheCallTimes]), o = F(i, 1), s = o[0];
          this.delete(s);
        }
        this.keys.push(r);
      }
      var l = this.cache;
      r.forEach(function(c, u) {
        if (u === r.length - 1)
          l.set(c, {
            value: [n, a.cacheCallTimes++]
          });
        else {
          var v = l.get(c);
          v ? v.map || (v.map = /* @__PURE__ */ new Map()) : l.set(c, {
            map: /* @__PURE__ */ new Map()
          }), l = l.get(c).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(r, n) {
      var a = r.get(n[0]);
      if (n.length === 1) {
        var i;
        return a.map ? r.set(n[0], {
          map: a.map
        }) : r.delete(n[0]), (i = a.value) === null || i === void 0 ? void 0 : i[0];
      }
      var o = this.deleteByPath(a.map, n.slice(1));
      return (!a.map || a.map.size === 0) && !a.value && r.delete(n[0]), o;
    }
  }, {
    key: "delete",
    value: function(r) {
      if (this.has(r))
        return this.keys = this.keys.filter(function(n) {
          return !Ff(n, r);
        }), this.deleteByPath(this.cache, r);
    }
  }]), e;
}();
O(us, "MAX_CACHE_SIZE", 20);
O(us, "MAX_CACHE_OFFSET", 5);
var tl = 0, zc = /* @__PURE__ */ function() {
  function e(t) {
    Rt(this, e), O(this, "derivatives", void 0), O(this, "id", void 0), this.derivatives = Array.isArray(t) ? t : [t], this.id = tl, t.length === 0 && bn(t.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function."), tl += 1;
  }
  return Nt(e, [{
    key: "getDerivativeToken",
    value: function(r) {
      return this.derivatives.reduce(function(n, a) {
        return a(r, n);
      }, void 0);
    }
  }]), e;
}(), Vi = new us();
function so(e) {
  var t = Array.isArray(e) ? e : [e];
  return Vi.has(t) || Vi.set(t, new zc(t)), Vi.get(t);
}
var Df = /* @__PURE__ */ new WeakMap(), ji = {};
function Lf(e, t) {
  for (var r = Df, n = 0; n < t.length; n += 1) {
    var a = t[n];
    r.has(a) || r.set(a, /* @__PURE__ */ new WeakMap()), r = r.get(a);
  }
  return r.has(ji) || r.set(ji, e()), r.get(ji);
}
var rl = /* @__PURE__ */ new WeakMap();
function Jn(e) {
  var t = rl.get(e) || "";
  return t || (Object.keys(e).forEach(function(r) {
    var n = e[r];
    t += r, n instanceof zc ? t += n.id : n && le(n) === "object" ? t += Jn(n) : t += n;
  }), t = na(t), rl.set(e, t)), t;
}
function nl(e, t) {
  return na("".concat(t, "_").concat(Jn(e)));
}
var lo = Gt();
function G(e) {
  return typeof e == "number" ? "".concat(e, "px") : e;
}
function Za(e, t, r) {
  var n, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (i)
    return e;
  var o = I(I({}, a), {}, (n = {}, O(n, Cn, t), O(n, vr, r), n)), s = Object.keys(o).map(function(l) {
    var c = o[l];
    return c ? "".concat(l, '="').concat(c, '"') : null;
  }).filter(function(l) {
    return l;
  }).join(" ");
  return "<style ".concat(s, ">").concat(e, "</style>");
}
var za = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(r ? "".concat(r, "-") : "").concat(t).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, Vf = function(t, r, n) {
  return Object.keys(t).length ? ".".concat(r).concat(n != null && n.scope ? ".".concat(n.scope) : "", "{").concat(Object.entries(t).map(function(a) {
    var i = F(a, 2), o = i[0], s = i[1];
    return "".concat(o, ":").concat(s, ";");
  }).join(""), "}") : "";
}, Hc = function(t, r, n) {
  var a = {}, i = {};
  return Object.entries(t).forEach(function(o) {
    var s, l, c = F(o, 2), u = c[0], v = c[1];
    if (n != null && (s = n.preserve) !== null && s !== void 0 && s[u])
      i[u] = v;
    else if ((typeof v == "string" || typeof v == "number") && !(n != null && (l = n.ignore) !== null && l !== void 0 && l[u])) {
      var h, b = za(u, n == null ? void 0 : n.prefix);
      a[b] = typeof v == "number" && !(n != null && (h = n.unitless) !== null && h !== void 0 && h[u]) ? "".concat(v, "px") : String(v), i[u] = "var(".concat(b, ")");
    }
  }), [i, Vf(a, r, {
    scope: n == null ? void 0 : n.scope
  })];
}, al = process.env.NODE_ENV !== "test" && Gt() ? d.useLayoutEffect : d.useEffect, Vt = function(t, r) {
  var n = d.useRef(!0);
  al(function() {
    return t(n.current);
  }, r), al(function() {
    return n.current = !1, function() {
      n.current = !0;
    };
  }, []);
}, co = function(t, r) {
  Vt(function(n) {
    if (!n)
      return t();
  }, r);
}, jf = I({}, d), il = jf.useInsertionEffect, zf = function(t, r, n) {
  d.useMemo(t, n), Vt(function() {
    return r(!0);
  }, n);
}, Hf = il ? function(e, t, r) {
  return il(function() {
    return e(), t();
  }, r);
} : zf, Bf = I({}, d), Wf = Bf.useInsertionEffect, Kf = function(t) {
  var r = [], n = !1;
  function a(i) {
    if (n) {
      process.env.NODE_ENV !== "production" && bn(!1, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      return;
    }
    r.push(i);
  }
  return d.useEffect(function() {
    return n = !1, function() {
      n = !0, r.length && r.forEach(function(i) {
        return i();
      });
    };
  }, t), a;
}, qf = function() {
  return function(t) {
    t();
  };
}, Uf = typeof Wf < "u" ? Kf : qf;
function Gf() {
  return !1;
}
var uo = !1;
function Xf() {
  return uo;
}
const Yf = process.env.NODE_ENV === "production" ? Gf : Xf;
if (process.env.NODE_ENV !== "production" && typeof module < "u" && module && module.hot && typeof window < "u") {
  var Ra = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : null;
  if (Ra && typeof Ra.webpackHotUpdate == "function") {
    var Qf = Ra.webpackHotUpdate;
    Ra.webpackHotUpdate = function() {
      return uo = !0, setTimeout(function() {
        uo = !1;
      }, 0), Qf.apply(void 0, arguments);
    };
  }
}
function ds(e, t, r, n, a) {
  var i = d.useContext(ga), o = i.cache, s = [e].concat(te(t)), l = oo(s), c = Uf([l]), u = Yf(), v = function(m) {
    o.opUpdate(l, function(f) {
      var y = f || [void 0, void 0], p = F(y, 2), C = p[0], S = C === void 0 ? 0 : C, E = p[1], w = E;
      process.env.NODE_ENV !== "production" && E && u && (n == null || n(w, u), w = null);
      var P = w || r(), N = [S, P];
      return m ? m(N) : N;
    });
  };
  d.useMemo(
    function() {
      v();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [l]
    /* eslint-enable */
  );
  var h = o.opGet(l);
  process.env.NODE_ENV !== "production" && !h && (v(), h = o.opGet(l));
  var b = h[1];
  return Hf(function() {
    a == null || a(b);
  }, function(g) {
    return v(function(m) {
      var f = F(m, 2), y = f[0], p = f[1];
      return g && y === 0 && (a == null || a(b)), [y + 1, p];
    }), function() {
      o.opUpdate(l, function(m) {
        var f = m || [], y = F(f, 2), p = y[0], C = p === void 0 ? 0 : p, S = y[1], E = C - 1;
        return E === 0 ? (c(function() {
          (g || !o.opGet(l)) && (n == null || n(S, !1));
        }), null) : [C - 1, S];
      });
    };
  }, [l]), b;
}
var Zf = {}, Jf = process.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css", Br = /* @__PURE__ */ new Map();
function ev(e) {
  Br.set(e, (Br.get(e) || 0) + 1);
}
function tv(e, t) {
  if (typeof document < "u") {
    var r = document.querySelectorAll("style[".concat(Cn, '="').concat(e, '"]'));
    r.forEach(function(n) {
      if (n[Fr] === t) {
        var a;
        (a = n.parentNode) === null || a === void 0 || a.removeChild(n);
      }
    });
  }
}
var rv = 0;
function nv(e, t) {
  Br.set(e, (Br.get(e) || 0) - 1);
  var r = Array.from(Br.keys()), n = r.filter(function(a) {
    var i = Br.get(a) || 0;
    return i <= 0;
  });
  r.length - n.length > rv && n.forEach(function(a) {
    tv(a, t), Br.delete(a);
  });
}
var av = function(t, r, n, a) {
  var i = n.getDerivativeToken(t), o = I(I({}, i), r);
  return a && (o = a(o)), o;
}, Bc = "token";
function iv(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = Lr(ga), a = n.cache.instanceId, i = n.container, o = r.salt, s = o === void 0 ? "" : o, l = r.override, c = l === void 0 ? Zf : l, u = r.formatToken, v = r.getComputedToken, h = r.cssVar, b = Lf(function() {
    return Object.assign.apply(Object, [{}].concat(te(t)));
  }, t), g = Jn(b), m = Jn(c), f = h ? Jn(h) : "", y = ds(Bc, [s, e.id, g, m, f], function() {
    var p, C = v ? v(b, c, e) : av(b, c, e, u), S = I({}, C), E = "";
    if (h) {
      var w = Hc(C, h.key, {
        prefix: h.prefix,
        ignore: h.ignore,
        unitless: h.unitless,
        preserve: h.preserve
      }), P = F(w, 2);
      C = P[0], E = P[1];
    }
    var N = nl(C, s);
    C._tokenKey = N, S._tokenKey = nl(S, s);
    var M = (p = h == null ? void 0 : h.key) !== null && p !== void 0 ? p : N;
    C._themeKey = M, ev(M);
    var _ = "".concat(Jf, "-").concat(na(N));
    return C._hashId = _, [C, _, S, E, (h == null ? void 0 : h.key) || ""];
  }, function(p) {
    nv(p[0]._themeKey, a);
  }, function(p) {
    var C = F(p, 4), S = C[0], E = C[3];
    if (h && E) {
      var w = wr(E, na("css-variables-".concat(S._themeKey)), {
        mark: vr,
        prepend: "queue",
        attachTo: i,
        priority: -999
      });
      w[Fr] = a, w.setAttribute(Cn, S._themeKey);
    }
  });
  return y;
}
var ov = function(t, r, n) {
  var a = F(t, 5), i = a[2], o = a[3], s = a[4], l = n || {}, c = l.plain;
  if (!o)
    return null;
  var u = i._tokenKey, v = -999, h = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(v)
  }, b = Za(o, s, u, h, c);
  return [v, u, b];
};
function he() {
  return he = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, he.apply(null, arguments);
}
var sv = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Wc = "comm", Kc = "rule", qc = "decl", lv = "@import", cv = "@namespace", uv = "@keyframes", dv = "@layer", Uc = Math.abs, fs = String.fromCharCode;
function Gc(e) {
  return e.trim();
}
function Ha(e, t, r) {
  return e.replace(t, r);
}
function fv(e, t, r) {
  return e.indexOf(t, r);
}
function vn(e, t) {
  return e.charCodeAt(t) | 0;
}
function Sn(e, t, r) {
  return e.slice(t, r);
}
function pr(e) {
  return e.length;
}
function vv(e) {
  return e.length;
}
function Na(e, t) {
  return t.push(e), e;
}
var ui = 1, En = 1, Xc = 0, sr = 0, ht = 0, $n = "";
function vs(e, t, r, n, a, i, o, s) {
  return { value: e, root: t, parent: r, type: n, props: a, children: i, line: ui, column: En, length: o, return: "", siblings: s };
}
function hv() {
  return ht;
}
function gv() {
  return ht = sr > 0 ? vn($n, --sr) : 0, En--, ht === 10 && (En = 1, ui--), ht;
}
function hr() {
  return ht = sr < Xc ? vn($n, sr++) : 0, En++, ht === 10 && (En = 1, ui++), ht;
}
function Dr() {
  return vn($n, sr);
}
function Ba() {
  return sr;
}
function di(e, t) {
  return Sn($n, e, t);
}
function la(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function mv(e) {
  return ui = En = 1, Xc = pr($n = e), sr = 0, [];
}
function pv(e) {
  return $n = "", e;
}
function zi(e) {
  return Gc(di(sr - 1, fo(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function yv(e) {
  for (; (ht = Dr()) && ht < 33; )
    hr();
  return la(e) > 2 || la(ht) > 3 ? "" : " ";
}
function bv(e, t) {
  for (; --t && hr() && !(ht < 48 || ht > 102 || ht > 57 && ht < 65 || ht > 70 && ht < 97); )
    ;
  return di(e, Ba() + (t < 6 && Dr() == 32 && hr() == 32));
}
function fo(e) {
  for (; hr(); )
    switch (ht) {
      // ] ) " '
      case e:
        return sr;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && fo(ht);
        break;
      // (
      case 40:
        e === 41 && fo(e);
        break;
      // \
      case 92:
        hr();
        break;
    }
  return sr;
}
function Cv(e, t) {
  for (; hr() && e + ht !== 57; )
    if (e + ht === 84 && Dr() === 47)
      break;
  return "/*" + di(t, sr - 1) + "*" + fs(e === 47 ? e : hr());
}
function Sv(e) {
  for (; !la(Dr()); )
    hr();
  return di(e, sr);
}
function Ev(e) {
  return pv(Wa("", null, null, null, [""], e = mv(e), 0, [0], e));
}
function Wa(e, t, r, n, a, i, o, s, l) {
  for (var c = 0, u = 0, v = o, h = 0, b = 0, g = 0, m = 1, f = 1, y = 1, p = 0, C = "", S = a, E = i, w = n, P = C; f; )
    switch (g = p, p = hr()) {
      // (
      case 40:
        if (g != 108 && vn(P, v - 1) == 58) {
          fv(P += Ha(zi(p), "&", "&\f"), "&\f", Uc(c ? s[c - 1] : 0)) != -1 && (y = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        P += zi(p);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        P += yv(g);
        break;
      // \
      case 92:
        P += bv(Ba() - 1, 7);
        continue;
      // /
      case 47:
        switch (Dr()) {
          case 42:
          case 47:
            Na(wv(Cv(hr(), Ba()), t, r, l), l), (la(g || 1) == 5 || la(Dr() || 1) == 5) && pr(P) && Sn(P, -1, void 0) !== " " && (P += " ");
            break;
          default:
            P += "/";
        }
        break;
      // {
      case 123 * m:
        s[c++] = pr(P) * y;
      // } ; \0
      case 125 * m:
      case 59:
      case 0:
        switch (p) {
          // \0 }
          case 0:
          case 125:
            f = 0;
          // ;
          case 59 + u:
            y == -1 && (P = Ha(P, /\f/g, "")), b > 0 && (pr(P) - v || m === 0 && g === 47) && Na(b > 32 ? sl(P + ";", n, r, v - 1, l) : sl(Ha(P, " ", "") + ";", n, r, v - 2, l), l);
            break;
          // @ ;
          case 59:
            P += ";";
          // { rule/at-rule
          default:
            if (Na(w = ol(P, t, r, c, u, a, s, C, S = [], E = [], v, i), i), p === 123)
              if (u === 0)
                Wa(P, t, w, w, S, i, v, s, E);
              else {
                switch (h) {
                  // c(ontainer)
                  case 99:
                    if (vn(P, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (vn(P, 2) === 97) break;
                  default:
                    u = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                u ? Wa(e, w, w, n && Na(ol(e, w, w, 0, 0, a, s, C, a, S = [], v, E), E), a, E, v, s, n ? S : E) : Wa(P, w, w, w, [""], E, 0, s, E);
              }
        }
        c = u = b = 0, m = y = 1, C = P = "", v = o;
        break;
      // :
      case 58:
        v = 1 + pr(P), b = g;
      default:
        if (m < 1) {
          if (p == 123)
            --m;
          else if (p == 125 && m++ == 0 && gv() == 125)
            continue;
        }
        switch (P += fs(p), p * m) {
          // &
          case 38:
            y = u > 0 ? 1 : (P += "\f", -1);
            break;
          // ,
          case 44:
            s[c++] = (pr(P) - 1) * y, y = 1;
            break;
          // @
          case 64:
            Dr() === 45 && (P += zi(hr())), h = Dr(), u = v = pr(C = P += Sv(Ba())), p++;
            break;
          // -
          case 45:
            g === 45 && pr(P) == 2 && (m = 0);
        }
    }
  return i;
}
function ol(e, t, r, n, a, i, o, s, l, c, u, v) {
  for (var h = a - 1, b = a === 0 ? i : [""], g = vv(b), m = 0, f = 0, y = 0; m < n; ++m)
    for (var p = 0, C = Sn(e, h + 1, h = Uc(f = o[m])), S = e; p < g; ++p)
      (S = Gc(f > 0 ? b[p] + " " + C : Ha(C, /&\f/g, b[p]))) && (l[y++] = S);
  return vs(e, t, r, a === 0 ? Kc : s, l, c, u, v);
}
function wv(e, t, r, n) {
  return vs(e, t, r, Wc, fs(hv()), Sn(e, 2, -2), 0, n);
}
function sl(e, t, r, n, a) {
  return vs(e, t, r, qc, Sn(e, 0, n), Sn(e, n + 1, -1), n, a);
}
function vo(e, t) {
  for (var r = "", n = 0; n < e.length; n++)
    r += t(e[n], n, e, t) || "";
  return r;
}
function xv(e, t, r, n) {
  switch (e.type) {
    case dv:
      if (e.children.length) break;
    case lv:
    case cv:
    case qc:
      return e.return = e.return || e.value;
    case Wc:
      return "";
    case uv:
      return e.return = e.value + "{" + vo(e.children, n) + "}";
    case Kc:
      if (!pr(e.value = e.props.join(","))) return "";
  }
  return pr(r = vo(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function Yc(e, t) {
  var r = t.path, n = t.parentSelectors;
  Ae(!1, "[Ant Design CSS-in-JS] ".concat(r ? "Error in ".concat(r, ": ") : "").concat(e).concat(n.length ? " Selector: ".concat(n.join(" | ")) : ""));
}
var _v = function(t, r, n) {
  if (t === "content") {
    var a = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, i = ["normal", "none", "initial", "inherit", "unset"];
    (typeof r != "string" || i.indexOf(r) === -1 && !a.test(r) && (r.charAt(0) !== r.charAt(r.length - 1) || r.charAt(0) !== '"' && r.charAt(0) !== "'")) && Yc("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(r, "\"'`."), n);
  }
}, Pv = function(t, r, n) {
  t === "animation" && n.hashId && r !== "none" && Yc("You seem to be using hashed animation '".concat(r, "', in which case 'animationName' with Keyframe as value is recommended."), n);
}, ll = "data-ant-cssinjs-cache-path", Qc = "_FILE_STYLE__", Kr, Zc = !0;
function $v() {
  if (!Kr && (Kr = {}, Gt())) {
    var e = document.createElement("div");
    e.className = ll, e.style.position = "fixed", e.style.visibility = "hidden", e.style.top = "-9999px", document.body.appendChild(e);
    var t = getComputedStyle(e).content || "";
    t = t.replace(/^"/, "").replace(/"$/, ""), t.split(";").forEach(function(a) {
      var i = a.split(":"), o = F(i, 2), s = o[0], l = o[1];
      Kr[s] = l;
    });
    var r = document.querySelector("style[".concat(ll, "]"));
    if (r) {
      var n;
      Zc = !1, (n = r.parentNode) === null || n === void 0 || n.removeChild(r);
    }
    document.body.removeChild(e);
  }
}
function Ov(e) {
  return $v(), !!Kr[e];
}
function Mv(e) {
  var t = Kr[e], r = null;
  if (t && Gt())
    if (Zc)
      r = Qc;
    else {
      var n = document.querySelector("style[".concat(vr, '="').concat(Kr[e], '"]'));
      n ? r = n.innerHTML : delete Kr[e];
    }
  return [r, t];
}
var Jc = "_skip_check_", eu = "_multi_value_";
function Ka(e) {
  var t = vo(Ev(e), xv);
  return t.replace(/\{%%%\:[^;];}/g, ";");
}
function Rv(e) {
  return le(e) === "object" && e && (Jc in e || eu in e);
}
function cl(e, t, r) {
  if (!t)
    return e;
  var n = ".".concat(t), a = r === "low" ? ":where(".concat(n, ")") : n, i = e.split(",").map(function(o) {
    var s, l = o.trim().split(/\s+/), c = l[0] || "", u = ((s = c.match(/^\w+/)) === null || s === void 0 ? void 0 : s[0]) || "";
    return c = "".concat(u).concat(a).concat(c.slice(u.length)), [c].concat(te(l.slice(1))).join(" ");
  });
  return i.join(",");
}
var Nv = function e(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, a = n.root, i = n.injectHash, o = n.parentSelectors, s = r.hashId, l = r.layer, c = r.path, u = r.hashPriority, v = r.transformers, h = v === void 0 ? [] : v, b = r.linters, g = b === void 0 ? [] : b, m = "", f = {};
  function y(S) {
    var E = S.getName(s);
    if (!f[E]) {
      var w = e(S.style, r, {
        root: !1,
        parentSelectors: o
      }), P = F(w, 1), N = P[0];
      f[E] = "@keyframes ".concat(S.getName(s)).concat(N);
    }
  }
  function p(S) {
    var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return S.forEach(function(w) {
      Array.isArray(w) ? p(w, E) : w && E.push(w);
    }), E;
  }
  var C = p(Array.isArray(t) ? t : [t]);
  return C.forEach(function(S) {
    var E = typeof S == "string" && !a ? {} : S;
    if (typeof E == "string")
      m += "".concat(E, `
`);
    else if (E._keyframe)
      y(E);
    else {
      var w = h.reduce(function(P, N) {
        var M;
        return (N == null || (M = N.visit) === null || M === void 0 ? void 0 : M.call(N, P)) || P;
      }, E);
      Object.keys(w).forEach(function(P) {
        var N = w[P];
        if (le(N) === "object" && N && (P !== "animationName" || !N._keyframe) && !Rv(N)) {
          var M = !1, _ = P.trim(), x = !1;
          (a || i) && s ? _.startsWith("@") ? M = !0 : _ === "&" ? _ = cl("", s, u) : _ = cl(P, s, u) : a && !s && (_ === "&" || _ === "") && (_ = "", x = !0);
          var R = e(N, r, {
            root: x,
            injectHash: M,
            parentSelectors: [].concat(te(o), [_])
          }), $ = F(R, 2), T = $[0], A = $[1];
          f = I(I({}, f), A), m += "".concat(_).concat(T);
        } else {
          let V = function(k, B) {
            process.env.NODE_ENV !== "production" && (le(N) !== "object" || !(N != null && N[Jc])) && [_v, Pv].concat(te(g)).forEach(function(H) {
              return H(k, B, {
                path: c,
                hashId: s,
                parentSelectors: o
              });
            });
            var q = k.replace(/[A-Z]/g, function(H) {
              return "-".concat(H.toLowerCase());
            }), W = B;
            !sv[k] && typeof W == "number" && W !== 0 && (W = "".concat(W, "px")), k === "animationName" && B !== null && B !== void 0 && B._keyframe && (y(B), W = B.getName(s)), m += "".concat(q, ":").concat(W, ";");
          };
          var D, z = (D = N == null ? void 0 : N.value) !== null && D !== void 0 ? D : N;
          le(N) === "object" && N !== null && N !== void 0 && N[eu] && Array.isArray(z) ? z.forEach(function(k) {
            V(P, k);
          }) : V(P, z);
        }
      });
    }
  }), a ? l && (m && (m = "@layer ".concat(l.name, " {").concat(m, "}")), l.dependencies && (f["@layer ".concat(l.name)] = l.dependencies.map(function(S) {
    return "@layer ".concat(S, ", ").concat(l.name, ";");
  }).join(`
`))) : m = "{".concat(m, "}"), [m, f];
};
function tu(e, t) {
  return na("".concat(e.join("%")).concat(t));
}
function Tv() {
  return null;
}
var ru = "style";
function ho(e, t) {
  var r = e.token, n = e.path, a = e.hashId, i = e.layer, o = e.nonce, s = e.clientOnly, l = e.order, c = l === void 0 ? 0 : l, u = d.useContext(ga), v = u.autoClear, h = u.mock, b = u.defaultCache, g = u.hashPriority, m = u.container, f = u.ssrInline, y = u.transformers, p = u.linters, C = u.cache, S = u.layer, E = r._tokenKey, w = [E];
  S && w.push("layer"), w.push.apply(w, te(n));
  var P = lo;
  process.env.NODE_ENV !== "production" && h !== void 0 && (P = h === "client");
  var N = ds(
    ru,
    w,
    // Create cache if needed
    function() {
      var $ = w.join("|");
      if (Ov($)) {
        var T = Mv($), A = F(T, 2), D = A[0], z = A[1];
        if (D)
          return [D, E, z, {}, s, c];
      }
      var V = t(), k = Nv(V, {
        hashId: a,
        hashPriority: g,
        layer: S ? i : void 0,
        path: n.join("-"),
        transformers: y,
        linters: p
      }), B = F(k, 2), q = B[0], W = B[1], H = Ka(q), j = tu(w, H);
      return [H, E, j, W, s, c];
    },
    // Remove cache if no need
    function($, T) {
      var A = F($, 3), D = A[2];
      (T || v) && lo && aa(D, {
        mark: vr
      });
    },
    // Effect: Inject style here
    function($) {
      var T = F($, 4), A = T[0];
      T[1];
      var D = T[2], z = T[3];
      if (P && A !== Qc) {
        var V = {
          mark: vr,
          prepend: S ? !1 : "queue",
          attachTo: m,
          priority: c
        }, k = typeof o == "function" ? o() : o;
        k && (V.csp = {
          nonce: k
        });
        var B = [], q = [];
        Object.keys(z).forEach(function(H) {
          H.startsWith("@layer") ? B.push(H) : q.push(H);
        }), B.forEach(function(H) {
          wr(Ka(z[H]), "_layer-".concat(H), I(I({}, V), {}, {
            prepend: !0
          }));
        });
        var W = wr(A, D, V);
        W[Fr] = C.instanceId, W.setAttribute(Cn, E), process.env.NODE_ENV !== "production" && W.setAttribute(If, w.join("|")), q.forEach(function(H) {
          wr(Ka(z[H]), "_effect-".concat(H), V);
        });
      }
    }
  ), M = F(N, 3), _ = M[0], x = M[1], R = M[2];
  return function($) {
    var T;
    if (!f || P || !b)
      T = /* @__PURE__ */ d.createElement(Tv, null);
    else {
      var A;
      T = /* @__PURE__ */ d.createElement("style", he({}, (A = {}, O(A, Cn, x), O(A, vr, R), A), {
        dangerouslySetInnerHTML: {
          __html: _
        }
      }));
    }
    return /* @__PURE__ */ d.createElement(d.Fragment, null, T, $);
  };
}
var Iv = function(t, r, n) {
  var a = F(t, 6), i = a[0], o = a[1], s = a[2], l = a[3], c = a[4], u = a[5], v = n || {}, h = v.plain;
  if (c)
    return null;
  var b = i, g = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  };
  return b = Za(i, o, s, g, h), l && Object.keys(l).forEach(function(m) {
    if (!r[m]) {
      r[m] = !0;
      var f = Ka(l[m]), y = Za(f, o, "_effect-".concat(m), g, h);
      m.startsWith("@layer") ? b = y + b : b += y;
    }
  }), [u, s, b];
}, nu = "cssVar", Av = function(t, r) {
  var n = t.key, a = t.prefix, i = t.unitless, o = t.ignore, s = t.token, l = t.scope, c = l === void 0 ? "" : l, u = Lr(ga), v = u.cache.instanceId, h = u.container, b = s._tokenKey, g = [].concat(te(t.path), [n, c, b]), m = ds(nu, g, function() {
    var f = r(), y = Hc(f, n, {
      prefix: a,
      unitless: i,
      ignore: o,
      scope: c
    }), p = F(y, 2), C = p[0], S = p[1], E = tu(g, S);
    return [C, S, E, n];
  }, function(f) {
    var y = F(f, 3), p = y[2];
    lo && aa(p, {
      mark: vr
    });
  }, function(f) {
    var y = F(f, 3), p = y[1], C = y[2];
    if (p) {
      var S = wr(p, C, {
        mark: vr,
        prepend: "queue",
        attachTo: h,
        priority: -999
      });
      S[Fr] = v, S.setAttribute(Cn, n);
    }
  });
  return m;
}, kv = function(t, r, n) {
  var a = F(t, 4), i = a[1], o = a[2], s = a[3], l = n || {}, c = l.plain;
  if (!i)
    return null;
  var u = -999, v = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  }, h = Za(i, s, o, v, c);
  return [u, o, h];
}, Wn;
Wn = {}, O(Wn, ru, Iv), O(Wn, Bc, ov), O(Wn, nu, kv);
var Pr = /* @__PURE__ */ function() {
  function e(t, r) {
    Rt(this, e), O(this, "name", void 0), O(this, "style", void 0), O(this, "_keyframe", !0), this.name = t, this.style = r;
  }
  return Nt(e, [{
    key: "getName",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return r ? "".concat(r, "-").concat(this.name) : this.name;
    }
  }]), e;
}();
function en(e) {
  return e.notSplit = !0, e;
}
en(["borderTop", "borderBottom"]), en(["borderTop"]), en(["borderBottom"]), en(["borderLeft", "borderRight"]), en(["borderLeft"]), en(["borderRight"]);
var hs = /* @__PURE__ */ oi({});
function Fv(e) {
  return Tc(e) || kc(e) || os(e) || Ic();
}
function yr(e, t) {
  for (var r = e, n = 0; n < t.length; n += 1) {
    if (r == null)
      return;
    r = r[t[n]];
  }
  return r;
}
function au(e, t, r, n) {
  if (!t.length)
    return r;
  var a = Fv(t), i = a[0], o = a.slice(1), s;
  return !e && typeof i == "number" ? s = [] : Array.isArray(e) ? s = te(e) : s = I({}, e), n && r === void 0 && o.length === 1 ? delete s[i][o[0]] : s[i] = au(s[i], o, r, n), s;
}
function dr(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && n && r === void 0 && !yr(e, t.slice(0, -1)) ? e : au(e, t, r, n);
}
function Dv(e) {
  return le(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function ul(e) {
  return Array.isArray(e) ? [] : {};
}
var Lv = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function cn() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n = ul(t[0]);
  return t.forEach(function(a) {
    function i(o, s) {
      var l = new Set(s), c = yr(a, o), u = Array.isArray(c);
      if (u || Dv(c)) {
        if (!l.has(c)) {
          l.add(c);
          var v = yr(n, o);
          u ? n = dr(n, o, []) : (!v || le(v) !== "object") && (n = dr(n, o, ul(c))), Lv(c).forEach(function(h) {
            i([].concat(te(o), [h]), l);
          });
        }
      } else
        n = dr(n, o, c);
    }
    i([]);
  }), n;
}
function iu() {
}
let Sr = null;
function Vv() {
  Sr = null, Vc();
}
let gs = iu;
process.env.NODE_ENV !== "production" && (gs = (e, t, r) => {
  Ae(e, `[antd: ${t}] ${r}`), process.env.NODE_ENV === "test" && Vv();
});
const ou = /* @__PURE__ */ d.createContext({}), qr = process.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: t
  } = d.useContext(ou), r = (n, a, i) => {
    if (!n)
      if (t === !1 && a === "deprecated") {
        const o = Sr;
        Sr || (Sr = {}), Sr[e] = Sr[e] || [], Sr[e].includes(i || "") || Sr[e].push(i || ""), o || console.warn("[antd] There exists deprecated usage in your code:", Sr);
      } else
        process.env.NODE_ENV !== "production" && gs(n, e, i);
  };
  return r.deprecated = (n, a, i, o) => {
    r(n, "deprecated", `\`${a}\` is deprecated. Please use \`${i}\` instead.${o ? ` ${o}` : ""}`);
  }, r;
} : () => {
  const e = () => {
  };
  return e.deprecated = iu, e;
}, fi = gs, jv = /* @__PURE__ */ oi(void 0), Yt = "${label} is not a valid ${type}", vi = {
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: Yt,
        method: Yt,
        array: Yt,
        object: Yt,
        number: Yt,
        date: Yt,
        boolean: Yt,
        integer: Yt,
        float: Yt,
        regexp: Yt,
        email: Yt,
        url: Yt,
        hex: Yt
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  }
};
Object.assign({}, vi.Modal);
let qa = [];
const dl = () => qa.reduce((e, t) => Object.assign(Object.assign({}, e), t), vi.Modal);
function zv(e) {
  if (e) {
    const t = Object.assign({}, e);
    return qa.push(t), dl(), () => {
      qa = qa.filter((r) => r !== t), dl();
    };
  }
  Object.assign({}, vi.Modal);
}
const su = /* @__PURE__ */ oi(void 0), lu = "internalMark", cu = (e) => {
  const {
    locale: t = {},
    children: r,
    _ANT_MARK__: n
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = qr("LocaleProvider");
    process.env.NODE_ENV !== "production" && i(n === lu, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  d.useEffect(() => zv(t == null ? void 0 : t.Modal), [t]);
  const a = d.useMemo(() => Object.assign(Object.assign({}, t), {
    exist: !0
  }), [t]);
  return /* @__PURE__ */ d.createElement(su.Provider, {
    value: a
  }, r);
};
process.env.NODE_ENV !== "production" && (cu.displayName = "LocaleProvider");
const uu = {
  blue: "#1677FF",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  /**
   * @deprecated Use magenta instead
   */
  pink: "#EB2F96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, ca = Object.assign(Object.assign({}, uu), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
}), $t = Math.round;
function Hi(e, t) {
  const r = e.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [], n = r.map((a) => parseFloat(a));
  for (let a = 0; a < 3; a += 1)
    n[a] = t(n[a] || 0, r[a] || "", a);
  return r[3] ? n[3] = r[3].includes("%") ? n[3] / 100 : n[3] : n[3] = 1, n;
}
const fl = (e, t, r) => r === 0 ? e : e / 100;
function Kn(e, t) {
  const r = t || 255;
  return e > r ? r : e < 0 ? 0 : e;
}
class ut {
  constructor(t) {
    O(this, "isValid", !0), O(this, "r", 0), O(this, "g", 0), O(this, "b", 0), O(this, "a", 1), O(this, "_h", void 0), O(this, "_s", void 0), O(this, "_l", void 0), O(this, "_v", void 0), O(this, "_max", void 0), O(this, "_min", void 0), O(this, "_brightness", void 0);
    function r(n) {
      return n[0] in t && n[1] in t && n[2] in t;
    }
    if (t) if (typeof t == "string") {
      let a = function(i) {
        return n.startsWith(i);
      };
      const n = t.trim();
      /^#?[A-F\d]{3,8}$/i.test(n) ? this.fromHexString(n) : a("rgb") ? this.fromRgbString(n) : a("hsl") ? this.fromHslString(n) : (a("hsv") || a("hsb")) && this.fromHsvString(n);
    } else if (t instanceof ut)
      this.r = t.r, this.g = t.g, this.b = t.b, this.a = t.a, this._h = t._h, this._s = t._s, this._l = t._l, this._v = t._v;
    else if (r("rgb"))
      this.r = Kn(t.r), this.g = Kn(t.g), this.b = Kn(t.b), this.a = typeof t.a == "number" ? Kn(t.a, 1) : 1;
    else if (r("hsl"))
      this.fromHsl(t);
    else if (r("hsv"))
      this.fromHsv(t);
    else
      throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(t));
  }
  // ======================= Setter =======================
  setR(t) {
    return this._sc("r", t);
  }
  setG(t) {
    return this._sc("g", t);
  }
  setB(t) {
    return this._sc("b", t);
  }
  setA(t) {
    return this._sc("a", t, 1);
  }
  setHue(t) {
    const r = this.toHsv();
    return r.h = t, this._c(r);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function t(i) {
      const o = i / 255;
      return o <= 0.03928 ? o / 12.92 : Math.pow((o + 0.055) / 1.055, 2.4);
    }
    const r = t(this.r), n = t(this.g), a = t(this.b);
    return 0.2126 * r + 0.7152 * n + 0.0722 * a;
  }
  getHue() {
    if (typeof this._h > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._h = 0 : this._h = $t(60 * (this.r === this.getMax() ? (this.g - this.b) / t + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / t + 2 : (this.r - this.g) / t + 4));
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._s = 0 : this._s = t / this.getMax();
    }
    return this._s;
  }
  getLightness() {
    return typeof this._l > "u" && (this._l = (this.getMax() + this.getMin()) / 510), this._l;
  }
  getValue() {
    return typeof this._v > "u" && (this._v = this.getMax() / 255), this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    return typeof this._brightness > "u" && (this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3), this._brightness;
  }
  // ======================== Func ========================
  darken(t = 10) {
    const r = this.getHue(), n = this.getSaturation();
    let a = this.getLightness() - t / 100;
    return a < 0 && (a = 0), this._c({
      h: r,
      s: n,
      l: a,
      a: this.a
    });
  }
  lighten(t = 10) {
    const r = this.getHue(), n = this.getSaturation();
    let a = this.getLightness() + t / 100;
    return a > 1 && (a = 1), this._c({
      h: r,
      s: n,
      l: a,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(t, r = 50) {
    const n = this._c(t), a = r / 100, i = (s) => (n[s] - this[s]) * a + this[s], o = {
      r: $t(i("r")),
      g: $t(i("g")),
      b: $t(i("b")),
      a: $t(i("a") * 100) / 100
    };
    return this._c(o);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(t = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, t);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(t = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, t);
  }
  onBackground(t) {
    const r = this._c(t), n = this.a + r.a * (1 - this.a), a = (i) => $t((this[i] * this.a + r[i] * r.a * (1 - this.a)) / n);
    return this._c({
      r: a("r"),
      g: a("g"),
      b: a("b"),
      a: n
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(t) {
    return this.r === t.r && this.g === t.g && this.b === t.b && this.a === t.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let t = "#";
    const r = (this.r || 0).toString(16);
    t += r.length === 2 ? r : "0" + r;
    const n = (this.g || 0).toString(16);
    t += n.length === 2 ? n : "0" + n;
    const a = (this.b || 0).toString(16);
    if (t += a.length === 2 ? a : "0" + a, typeof this.a == "number" && this.a >= 0 && this.a < 1) {
      const i = $t(this.a * 255).toString(16);
      t += i.length === 2 ? i : "0" + i;
    }
    return t;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const t = this.getHue(), r = $t(this.getSaturation() * 100), n = $t(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${t},${r}%,${n}%,${this.a})` : `hsl(${t},${r}%,${n}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(t, r, n) {
    const a = this.clone();
    return a[t] = Kn(r, n), a;
  }
  _c(t) {
    return new this.constructor(t);
  }
  getMax() {
    return typeof this._max > "u" && (this._max = Math.max(this.r, this.g, this.b)), this._max;
  }
  getMin() {
    return typeof this._min > "u" && (this._min = Math.min(this.r, this.g, this.b)), this._min;
  }
  fromHexString(t) {
    const r = t.replace("#", "");
    function n(a, i) {
      return parseInt(r[a] + r[i || a], 16);
    }
    r.length < 6 ? (this.r = n(0), this.g = n(1), this.b = n(2), this.a = r[3] ? n(3) / 255 : 1) : (this.r = n(0, 1), this.g = n(2, 3), this.b = n(4, 5), this.a = r[6] ? n(6, 7) / 255 : 1);
  }
  fromHsl({
    h: t,
    s: r,
    l: n,
    a
  }) {
    if (this._h = t % 360, this._s = r, this._l = n, this.a = typeof a == "number" ? a : 1, r <= 0) {
      const h = $t(n * 255);
      this.r = h, this.g = h, this.b = h;
    }
    let i = 0, o = 0, s = 0;
    const l = t / 60, c = (1 - Math.abs(2 * n - 1)) * r, u = c * (1 - Math.abs(l % 2 - 1));
    l >= 0 && l < 1 ? (i = c, o = u) : l >= 1 && l < 2 ? (i = u, o = c) : l >= 2 && l < 3 ? (o = c, s = u) : l >= 3 && l < 4 ? (o = u, s = c) : l >= 4 && l < 5 ? (i = u, s = c) : l >= 5 && l < 6 && (i = c, s = u);
    const v = n - c / 2;
    this.r = $t((i + v) * 255), this.g = $t((o + v) * 255), this.b = $t((s + v) * 255);
  }
  fromHsv({
    h: t,
    s: r,
    v: n,
    a
  }) {
    this._h = t % 360, this._s = r, this._v = n, this.a = typeof a == "number" ? a : 1;
    const i = $t(n * 255);
    if (this.r = i, this.g = i, this.b = i, r <= 0)
      return;
    const o = t / 60, s = Math.floor(o), l = o - s, c = $t(n * (1 - r) * 255), u = $t(n * (1 - r * l) * 255), v = $t(n * (1 - r * (1 - l)) * 255);
    switch (s) {
      case 0:
        this.g = v, this.b = c;
        break;
      case 1:
        this.r = u, this.b = c;
        break;
      case 2:
        this.r = c, this.b = v;
        break;
      case 3:
        this.r = c, this.g = u;
        break;
      case 4:
        this.r = v, this.g = c;
        break;
      case 5:
      default:
        this.g = c, this.b = u;
        break;
    }
  }
  fromHsvString(t) {
    const r = Hi(t, fl);
    this.fromHsv({
      h: r[0],
      s: r[1],
      v: r[2],
      a: r[3]
    });
  }
  fromHslString(t) {
    const r = Hi(t, fl);
    this.fromHsl({
      h: r[0],
      s: r[1],
      l: r[2],
      a: r[3]
    });
  }
  fromRgbString(t) {
    const r = Hi(t, (n, a) => (
      // Convert percentage to number. e.g. 50% -> 128
      a.includes("%") ? $t(n / 100 * 255) : n
    ));
    this.r = r[0], this.g = r[1], this.b = r[2], this.a = r[3];
  }
}
var Ta = 2, vl = 0.16, Hv = 0.05, Bv = 0.05, Wv = 0.15, du = 5, fu = 4, Kv = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function hl(e, t, r) {
  var n;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? n = r ? Math.round(e.h) - Ta * t : Math.round(e.h) + Ta * t : n = r ? Math.round(e.h) + Ta * t : Math.round(e.h) - Ta * t, n < 0 ? n += 360 : n >= 360 && (n -= 360), n;
}
function gl(e, t, r) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var n;
  return r ? n = e.s - vl * t : t === fu ? n = e.s + vl : n = e.s + Hv * t, n > 1 && (n = 1), r && t === du && n > 0.1 && (n = 0.1), n < 0.06 && (n = 0.06), Math.round(n * 100) / 100;
}
function ml(e, t, r) {
  var n;
  return r ? n = e.v + Bv * t : n = e.v - Wv * t, n = Math.max(0, Math.min(1, n)), Math.round(n * 100) / 100;
}
function ua(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [], n = new ut(e), a = n.toHsv(), i = du; i > 0; i -= 1) {
    var o = new ut({
      h: hl(a, i, !0),
      s: gl(a, i, !0),
      v: ml(a, i, !0)
    });
    r.push(o);
  }
  r.push(n);
  for (var s = 1; s <= fu; s += 1) {
    var l = new ut({
      h: hl(a, s),
      s: gl(a, s),
      v: ml(a, s)
    });
    r.push(l);
  }
  return t.theme === "dark" ? Kv.map(function(c) {
    var u = c.index, v = c.amount;
    return new ut(t.backgroundColor || "#141414").mix(r[u], v).toHexString();
  }) : r.map(function(c) {
    return c.toHexString();
  });
}
var Bi = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, go = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
go.primary = go[5];
var mo = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
mo.primary = mo[5];
var po = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
po.primary = po[5];
var yo = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
yo.primary = yo[5];
var bo = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
bo.primary = bo[5];
var Co = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
Co.primary = Co[5];
var So = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
So.primary = So[5];
var Eo = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
Eo.primary = Eo[5];
var Ja = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
Ja.primary = Ja[5];
var wo = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
wo.primary = wo[5];
var xo = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
xo.primary = xo[5];
var _o = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
_o.primary = _o[5];
var Po = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
Po.primary = Po[5];
var Wi = {
  red: go,
  volcano: mo,
  orange: po,
  gold: yo,
  yellow: bo,
  lime: Co,
  green: So,
  cyan: Eo,
  blue: Ja,
  geekblue: wo,
  purple: xo,
  magenta: _o,
  grey: Po
};
function qv(e, {
  generateColorPalettes: t,
  generateNeutralColorPalettes: r
}) {
  const {
    colorSuccess: n,
    colorWarning: a,
    colorError: i,
    colorInfo: o,
    colorPrimary: s,
    colorBgBase: l,
    colorTextBase: c
  } = e, u = t(s), v = t(n), h = t(a), b = t(i), g = t(o), m = r(l, c), f = e.colorLink || e.colorInfo, y = t(f), p = new ut(b[1]).mix(new ut(b[3]), 50).toHexString();
  return Object.assign(Object.assign({}, m), {
    colorPrimaryBg: u[1],
    colorPrimaryBgHover: u[2],
    colorPrimaryBorder: u[3],
    colorPrimaryBorderHover: u[4],
    colorPrimaryHover: u[5],
    colorPrimary: u[6],
    colorPrimaryActive: u[7],
    colorPrimaryTextHover: u[8],
    colorPrimaryText: u[9],
    colorPrimaryTextActive: u[10],
    colorSuccessBg: v[1],
    colorSuccessBgHover: v[2],
    colorSuccessBorder: v[3],
    colorSuccessBorderHover: v[4],
    colorSuccessHover: v[4],
    colorSuccess: v[6],
    colorSuccessActive: v[7],
    colorSuccessTextHover: v[8],
    colorSuccessText: v[9],
    colorSuccessTextActive: v[10],
    colorErrorBg: b[1],
    colorErrorBgHover: b[2],
    colorErrorBgFilledHover: p,
    colorErrorBgActive: b[3],
    colorErrorBorder: b[3],
    colorErrorBorderHover: b[4],
    colorErrorHover: b[5],
    colorError: b[6],
    colorErrorActive: b[7],
    colorErrorTextHover: b[8],
    colorErrorText: b[9],
    colorErrorTextActive: b[10],
    colorWarningBg: h[1],
    colorWarningBgHover: h[2],
    colorWarningBorder: h[3],
    colorWarningBorderHover: h[4],
    colorWarningHover: h[4],
    colorWarning: h[6],
    colorWarningActive: h[7],
    colorWarningTextHover: h[8],
    colorWarningText: h[9],
    colorWarningTextActive: h[10],
    colorInfoBg: g[1],
    colorInfoBgHover: g[2],
    colorInfoBorder: g[3],
    colorInfoBorderHover: g[4],
    colorInfoHover: g[4],
    colorInfo: g[6],
    colorInfoActive: g[7],
    colorInfoTextHover: g[8],
    colorInfoText: g[9],
    colorInfoTextActive: g[10],
    colorLinkHover: y[4],
    colorLink: y[6],
    colorLinkActive: y[7],
    colorBgMask: new ut("#000").setA(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const Uv = (e) => {
  let t = e, r = e, n = e, a = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? r = 4 : e < 8 && e >= 7 ? r = 5 : e < 14 && e >= 8 ? r = 6 : e < 16 && e >= 14 ? r = 7 : e >= 16 && (r = 8), e < 6 && e >= 2 ? n = 1 : e >= 6 && (n = 2), e > 4 && e < 8 ? a = 4 : e >= 8 && (a = 6), {
    borderRadius: e,
    borderRadiusXS: n,
    borderRadiusSM: r,
    borderRadiusLG: t,
    borderRadiusOuter: a
  };
};
function Gv(e) {
  const {
    motionUnit: t,
    motionBase: r,
    borderRadius: n,
    lineWidth: a
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(r + t).toFixed(1)}s`,
    motionDurationMid: `${(r + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(r + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: a + 1
  }, Uv(n));
}
const Xv = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
};
function Yv(e) {
  return (e + 8) / e;
}
function Qv(e) {
  const t = Array.from({
    length: 10
  }).map((r, n) => {
    const a = n - 1, i = e * Math.pow(Math.E, a / 5), o = n > 1 ? Math.floor(i) : Math.ceil(i);
    return Math.floor(o / 2) * 2;
  });
  return t[1] = e, t.map((r) => ({
    size: r,
    lineHeight: Yv(r)
  }));
}
const Zv = (e) => {
  const t = Qv(e), r = t.map((u) => u.size), n = t.map((u) => u.lineHeight), a = r[1], i = r[0], o = r[2], s = n[1], l = n[0], c = n[2];
  return {
    fontSizeSM: i,
    fontSize: a,
    fontSizeLG: o,
    fontSizeXL: r[3],
    fontSizeHeading1: r[6],
    fontSizeHeading2: r[5],
    fontSizeHeading3: r[4],
    fontSizeHeading4: r[3],
    fontSizeHeading5: r[2],
    lineHeight: s,
    lineHeightLG: c,
    lineHeightSM: l,
    fontHeight: Math.round(s * a),
    fontHeightLG: Math.round(c * o),
    fontHeightSM: Math.round(l * i),
    lineHeightHeading1: n[6],
    lineHeightHeading2: n[5],
    lineHeightHeading3: n[4],
    lineHeightHeading4: n[3],
    lineHeightHeading5: n[2]
  };
};
function Jv(e) {
  const {
    sizeUnit: t,
    sizeStep: r
  } = e;
  return {
    sizeXXL: t * (r + 8),
    // 48
    sizeXL: t * (r + 4),
    // 32
    sizeLG: t * (r + 2),
    // 24
    sizeMD: t * (r + 1),
    // 20
    sizeMS: t * r,
    // 16
    size: t * r,
    // 16
    sizeSM: t * (r - 1),
    // 12
    sizeXS: t * (r - 2),
    // 8
    sizeXXS: t * (r - 3)
    // 4
  };
}
const ir = (e, t) => new ut(e).setA(t).toRgbString(), qn = (e, t) => new ut(e).darken(t).toHexString(), eh = (e) => {
  const t = ua(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, th = (e, t) => {
  const r = e || "#fff", n = t || "#000";
  return {
    colorBgBase: r,
    colorTextBase: n,
    colorText: ir(n, 0.88),
    colorTextSecondary: ir(n, 0.65),
    colorTextTertiary: ir(n, 0.45),
    colorTextQuaternary: ir(n, 0.25),
    colorFill: ir(n, 0.15),
    colorFillSecondary: ir(n, 0.06),
    colorFillTertiary: ir(n, 0.04),
    colorFillQuaternary: ir(n, 0.02),
    colorBgSolid: ir(n, 1),
    colorBgSolidHover: ir(n, 0.75),
    colorBgSolidActive: ir(n, 0.95),
    colorBgLayout: qn(r, 4),
    colorBgContainer: qn(r, 0),
    colorBgElevated: qn(r, 0),
    colorBgSpotlight: ir(n, 0.85),
    colorBgBlur: "transparent",
    colorBorder: qn(r, 15),
    colorBorderSecondary: qn(r, 6)
  };
};
function rh(e) {
  Bi.pink = Bi.magenta, Wi.pink = Wi.magenta;
  const t = Object.keys(uu).map((r) => {
    const n = e[r] === Bi[r] ? Wi[r] : ua(e[r]);
    return Array.from({
      length: 10
    }, () => 1).reduce((a, i, o) => (a[`${r}-${o + 1}`] = n[o], a[`${r}${o + 1}`] = n[o], a), {});
  }).reduce((r, n) => (r = Object.assign(Object.assign({}, r), n), r), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), qv(e, {
    generateColorPalettes: eh,
    generateNeutralColorPalettes: th
  })), Zv(e.fontSize)), Jv(e)), Xv(e)), Gv(e));
}
const vu = so(rh), $o = {
  token: ca,
  override: {
    override: ca
  },
  hashed: !0
}, hu = /* @__PURE__ */ Q.createContext($o), Oo = "ant", ms = "anticon", nh = ["outlined", "borderless", "filled", "underlined"], ah = (e, t) => t || (e ? `${Oo}-${e}` : Oo), Mt = /* @__PURE__ */ d.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: ah,
  iconPrefixCls: ms
}), {
  Consumer: ob
} = Mt, pl = {};
function ih(e) {
  const t = d.useContext(Mt), {
    getPrefixCls: r,
    direction: n,
    getPopupContainer: a
  } = t, i = t[e];
  return Object.assign(Object.assign({
    classNames: pl,
    styles: pl
  }, i), {
    getPrefixCls: r,
    direction: n,
    getPopupContainer: a
  });
}
const oh = `-ant-${Date.now()}-${Math.random()}`;
function sh(e, t) {
  const r = {}, n = (o, s) => {
    let l = o.clone();
    return l = (s == null ? void 0 : s(l)) || l, l.toRgbString();
  }, a = (o, s) => {
    const l = new ut(o), c = ua(l.toRgbString());
    r[`${s}-color`] = n(l), r[`${s}-color-disabled`] = c[1], r[`${s}-color-hover`] = c[4], r[`${s}-color-active`] = c[6], r[`${s}-color-outline`] = l.clone().setA(0.2).toRgbString(), r[`${s}-color-deprecated-bg`] = c[0], r[`${s}-color-deprecated-border`] = c[2];
  };
  if (t.primaryColor) {
    a(t.primaryColor, "primary");
    const o = new ut(t.primaryColor), s = ua(o.toRgbString());
    s.forEach((c, u) => {
      r[`primary-${u + 1}`] = c;
    }), r["primary-color-deprecated-l-35"] = n(o, (c) => c.lighten(35)), r["primary-color-deprecated-l-20"] = n(o, (c) => c.lighten(20)), r["primary-color-deprecated-t-20"] = n(o, (c) => c.tint(20)), r["primary-color-deprecated-t-50"] = n(o, (c) => c.tint(50)), r["primary-color-deprecated-f-12"] = n(o, (c) => c.setA(c.a * 0.12));
    const l = new ut(s[0]);
    r["primary-color-active-deprecated-f-30"] = n(l, (c) => c.setA(c.a * 0.3)), r["primary-color-active-deprecated-d-02"] = n(l, (c) => c.darken(2));
  }
  return t.successColor && a(t.successColor, "success"), t.warningColor && a(t.warningColor, "warning"), t.errorColor && a(t.errorColor, "error"), t.infoColor && a(t.infoColor, "info"), `
  :root {
    ${Object.keys(r).map((o) => `--${e}-${o}: ${r[o]};`).join(`
`)}
  }
  `.trim();
}
function lh(e, t) {
  const r = sh(e, t);
  Gt() ? wr(r, `${oh}-dynamic-theme`) : process.env.NODE_ENV !== "production" && fi(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const Mo = /* @__PURE__ */ d.createContext(!1), ch = ({
  children: e,
  disabled: t
}) => {
  const r = d.useContext(Mo);
  return /* @__PURE__ */ d.createElement(Mo.Provider, {
    value: t ?? r
  }, e);
}, wn = /* @__PURE__ */ d.createContext(void 0), uh = ({
  children: e,
  size: t
}) => {
  const r = d.useContext(wn);
  return /* @__PURE__ */ d.createElement(wn.Provider, {
    value: t || r
  }, e);
};
function dh() {
  const e = Lr(Mo), t = Lr(wn);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
var gu = /* @__PURE__ */ Nt(function e() {
  Rt(this, e);
}), mu = "CALC_UNIT", fh = new RegExp(mu, "g");
function Ki(e) {
  return typeof e == "number" ? "".concat(e).concat(mu) : e;
}
var vh = /* @__PURE__ */ function(e) {
  Vr(r, e);
  var t = jr(r);
  function r(n, a) {
    var i;
    Rt(this, r), i = t.call(this), O(be(i), "result", ""), O(be(i), "unitlessCssVar", void 0), O(be(i), "lowPriority", void 0);
    var o = le(n);
    return i.unitlessCssVar = a, n instanceof r ? i.result = "(".concat(n.result, ")") : o === "number" ? i.result = Ki(n) : o === "string" && (i.result = n), i;
  }
  return Nt(r, [{
    key: "add",
    value: function(a) {
      return a instanceof r ? this.result = "".concat(this.result, " + ").concat(a.getResult()) : (typeof a == "number" || typeof a == "string") && (this.result = "".concat(this.result, " + ").concat(Ki(a))), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(a) {
      return a instanceof r ? this.result = "".concat(this.result, " - ").concat(a.getResult()) : (typeof a == "number" || typeof a == "string") && (this.result = "".concat(this.result, " - ").concat(Ki(a))), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(a) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), a instanceof r ? this.result = "".concat(this.result, " * ").concat(a.getResult(!0)) : (typeof a == "number" || typeof a == "string") && (this.result = "".concat(this.result, " * ").concat(a)), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(a) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), a instanceof r ? this.result = "".concat(this.result, " / ").concat(a.getResult(!0)) : (typeof a == "number" || typeof a == "string") && (this.result = "".concat(this.result, " / ").concat(a)), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(a) {
      return this.lowPriority || a ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function(a) {
      var i = this, o = a || {}, s = o.unit, l = !0;
      return typeof s == "boolean" ? l = s : Array.from(this.unitlessCssVar).some(function(c) {
        return i.result.includes(c);
      }) && (l = !1), this.result = this.result.replace(fh, l ? "px" : ""), typeof this.lowPriority < "u" ? "calc(".concat(this.result, ")") : this.result;
    }
  }]), r;
}(gu), hh = /* @__PURE__ */ function(e) {
  Vr(r, e);
  var t = jr(r);
  function r(n) {
    var a;
    return Rt(this, r), a = t.call(this), O(be(a), "result", 0), n instanceof r ? a.result = n.result : typeof n == "number" && (a.result = n), a;
  }
  return Nt(r, [{
    key: "add",
    value: function(a) {
      return a instanceof r ? this.result += a.result : typeof a == "number" && (this.result += a), this;
    }
  }, {
    key: "sub",
    value: function(a) {
      return a instanceof r ? this.result -= a.result : typeof a == "number" && (this.result -= a), this;
    }
  }, {
    key: "mul",
    value: function(a) {
      return a instanceof r ? this.result *= a.result : typeof a == "number" && (this.result *= a), this;
    }
  }, {
    key: "div",
    value: function(a) {
      return a instanceof r ? this.result /= a.result : typeof a == "number" && (this.result /= a), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), r;
}(gu), gh = function(t, r) {
  var n = t === "css" ? vh : hh;
  return function(a) {
    return new n(a, r);
  };
}, yl = function(t, r) {
  return "".concat([r, t.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-"));
};
function Ut(e) {
  var t = d.useRef();
  t.current = e;
  var r = d.useCallback(function() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return (n = t.current) === null || n === void 0 ? void 0 : n.call.apply(n, [t].concat(i));
  }, []);
  return r;
}
function da(e) {
  var t = d.useRef(!1), r = d.useState(e), n = F(r, 2), a = n[0], i = n[1];
  d.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function o(s, l) {
    l && t.current || i(s);
  }
  return [a, o];
}
function qi(e) {
  return e !== void 0;
}
function hn(e, t) {
  var r = t || {}, n = r.defaultValue, a = r.value, i = r.onChange, o = r.postState, s = da(function() {
    return qi(a) ? a : qi(n) ? typeof n == "function" ? n() : n : typeof e == "function" ? e() : e;
  }), l = F(s, 2), c = l[0], u = l[1], v = a !== void 0 ? a : c, h = o ? o(v) : v, b = Ut(i), g = da([v]), m = F(g, 2), f = m[0], y = m[1];
  co(function() {
    var C = f[0];
    c !== C && b(c, C);
  }, [f]), co(function() {
    qi(a) || u(a);
  }, [a]);
  var p = Ut(function(C, S) {
    u(C, S), y([v], S);
  });
  return [h, p];
}
var Ia = { exports: {} }, ke = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bl;
function mh() {
  if (bl) return ke;
  bl = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function m(f) {
    if (typeof f == "object" && f !== null) {
      var y = f.$$typeof;
      switch (y) {
        case e:
          switch (f = f.type, f) {
            case r:
            case a:
            case n:
            case c:
            case u:
              return f;
            default:
              switch (f = f && f.$$typeof, f) {
                case s:
                case o:
                case l:
                case h:
                case v:
                case i:
                  return f;
                default:
                  return y;
              }
          }
        case t:
          return y;
      }
    }
  }
  return ke.ContextConsumer = o, ke.ContextProvider = i, ke.Element = e, ke.ForwardRef = l, ke.Fragment = r, ke.Lazy = h, ke.Memo = v, ke.Portal = t, ke.Profiler = a, ke.StrictMode = n, ke.Suspense = c, ke.SuspenseList = u, ke.isAsyncMode = function() {
    return !1;
  }, ke.isConcurrentMode = function() {
    return !1;
  }, ke.isContextConsumer = function(f) {
    return m(f) === o;
  }, ke.isContextProvider = function(f) {
    return m(f) === i;
  }, ke.isElement = function(f) {
    return typeof f == "object" && f !== null && f.$$typeof === e;
  }, ke.isForwardRef = function(f) {
    return m(f) === l;
  }, ke.isFragment = function(f) {
    return m(f) === r;
  }, ke.isLazy = function(f) {
    return m(f) === h;
  }, ke.isMemo = function(f) {
    return m(f) === v;
  }, ke.isPortal = function(f) {
    return m(f) === t;
  }, ke.isProfiler = function(f) {
    return m(f) === a;
  }, ke.isStrictMode = function(f) {
    return m(f) === n;
  }, ke.isSuspense = function(f) {
    return m(f) === c;
  }, ke.isSuspenseList = function(f) {
    return m(f) === u;
  }, ke.isValidElementType = function(f) {
    return typeof f == "string" || typeof f == "function" || f === r || f === a || f === n || f === c || f === u || f === b || typeof f == "object" && f !== null && (f.$$typeof === h || f.$$typeof === v || f.$$typeof === i || f.$$typeof === o || f.$$typeof === l || f.$$typeof === g || f.getModuleId !== void 0);
  }, ke.typeOf = m, ke;
}
var Fe = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cl;
function ph() {
  return Cl || (Cl = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), g = !1, m = !1, f = !1, y = !1, p = !1, C;
    C = Symbol.for("react.module.reference");
    function S(L) {
      return !!(typeof L == "string" || typeof L == "function" || L === r || L === a || p || L === n || L === c || L === u || y || L === b || g || m || f || typeof L == "object" && L !== null && (L.$$typeof === h || L.$$typeof === v || L.$$typeof === i || L.$$typeof === o || L.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      L.$$typeof === C || L.getModuleId !== void 0));
    }
    function E(L) {
      if (typeof L == "object" && L !== null) {
        var de = L.$$typeof;
        switch (de) {
          case e:
            var ye = L.type;
            switch (ye) {
              case r:
              case a:
              case n:
              case c:
              case u:
                return ye;
              default:
                var Ge = ye && ye.$$typeof;
                switch (Ge) {
                  case s:
                  case o:
                  case l:
                  case h:
                  case v:
                  case i:
                    return Ge;
                  default:
                    return de;
                }
            }
          case t:
            return de;
        }
      }
    }
    var w = o, P = i, N = e, M = l, _ = r, x = h, R = v, $ = t, T = a, A = n, D = c, z = u, V = !1, k = !1;
    function B(L) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function q(L) {
      return k || (k = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function W(L) {
      return E(L) === o;
    }
    function H(L) {
      return E(L) === i;
    }
    function j(L) {
      return typeof L == "object" && L !== null && L.$$typeof === e;
    }
    function K(L) {
      return E(L) === l;
    }
    function J(L) {
      return E(L) === r;
    }
    function Z(L) {
      return E(L) === h;
    }
    function ae(L) {
      return E(L) === v;
    }
    function oe(L) {
      return E(L) === t;
    }
    function fe(L) {
      return E(L) === a;
    }
    function me(L) {
      return E(L) === n;
    }
    function ue(L) {
      return E(L) === c;
    }
    function Ce(L) {
      return E(L) === u;
    }
    Fe.ContextConsumer = w, Fe.ContextProvider = P, Fe.Element = N, Fe.ForwardRef = M, Fe.Fragment = _, Fe.Lazy = x, Fe.Memo = R, Fe.Portal = $, Fe.Profiler = T, Fe.StrictMode = A, Fe.Suspense = D, Fe.SuspenseList = z, Fe.isAsyncMode = B, Fe.isConcurrentMode = q, Fe.isContextConsumer = W, Fe.isContextProvider = H, Fe.isElement = j, Fe.isForwardRef = K, Fe.isFragment = J, Fe.isLazy = Z, Fe.isMemo = ae, Fe.isPortal = oe, Fe.isProfiler = fe, Fe.isStrictMode = me, Fe.isSuspense = ue, Fe.isSuspenseList = Ce, Fe.isValidElementType = S, Fe.typeOf = E;
  }()), Fe;
}
var Sl;
function yh() {
  return Sl || (Sl = 1, process.env.NODE_ENV === "production" ? Ia.exports = mh() : Ia.exports = ph()), Ia.exports;
}
var Ui = yh(), bh = Symbol.for("react.element"), Ch = Symbol.for("react.transitional.element"), Sh = Symbol.for("react.fragment");
function pu(e) {
  return (
    // Base object type
    e && le(e) === "object" && // React Element type
    (e.$$typeof === bh || e.$$typeof === Ch) && // React Fragment type
    e.type === Sh
  );
}
var Eh = Number(zd.split(".")[0]), ps = function(t, r) {
  typeof t == "function" ? t(r) : le(t) === "object" && t && "current" in t && (t.current = r);
}, hi = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r.filter(Boolean);
  return a.length <= 1 ? a[0] : function(i) {
    r.forEach(function(o) {
      ps(o, i);
    });
  };
}, ma = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return ci(function() {
    return hi.apply(void 0, r);
  }, r, function(a, i) {
    return a.length !== i.length || a.every(function(o, s) {
      return o !== i[s];
    });
  });
}, On = function(t) {
  var r, n;
  if (!t)
    return !1;
  if (yu(t) && Eh >= 19)
    return !0;
  var a = Ui.isMemo(t) ? t.type.type : t.type;
  return !(typeof a == "function" && !((r = a.prototype) !== null && r !== void 0 && r.render) && a.$$typeof !== Ui.ForwardRef || typeof t == "function" && !((n = t.prototype) !== null && n !== void 0 && n.render) && t.$$typeof !== Ui.ForwardRef);
};
function yu(e) {
  return /* @__PURE__ */ jd(e) && !pu(e);
}
var pa = function(t) {
  if (t && yu(t)) {
    var r = t;
    return r.props.propertyIsEnumerable("ref") ? r.props.ref : r.ref;
  }
  return null;
};
function El(e, t, r, n) {
  var a = I({}, t[e]);
  if (n != null && n.deprecatedTokens) {
    var i = n.deprecatedTokens;
    i.forEach(function(s) {
      var l = F(s, 2), c = l[0], u = l[1];
      if (process.env.NODE_ENV !== "production" && Ae(!(a != null && a[c]), "Component Token `".concat(String(c), "` of ").concat(String(e), " is deprecated. Please use `").concat(String(u), "` instead.")), a != null && a[c] || a != null && a[u]) {
        var v;
        (v = a[u]) !== null && v !== void 0 || (a[u] = a == null ? void 0 : a[c]);
      }
    });
  }
  var o = I(I({}, r), a);
  return Object.keys(o).forEach(function(s) {
    o[s] === t[s] && delete o[s];
  }), o;
}
var bu = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u", Ro = !0;
function ya() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  if (!bu)
    return Object.assign.apply(Object, [{}].concat(t));
  Ro = !1;
  var n = {};
  return t.forEach(function(a) {
    if (le(a) === "object") {
      var i = Object.keys(a);
      i.forEach(function(o) {
        Object.defineProperty(n, o, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            return a[o];
          }
        });
      });
    }
  }), Ro = !0, n;
}
var wl = {};
function wh() {
}
var xh = function(t) {
  var r, n = t, a = wh;
  return bu && typeof Proxy < "u" && (r = /* @__PURE__ */ new Set(), n = new Proxy(t, {
    get: function(o, s) {
      if (Ro) {
        var l;
        (l = r) === null || l === void 0 || l.add(s);
      }
      return o[s];
    }
  }), a = function(o, s) {
    var l;
    wl[o] = {
      global: Array.from(r),
      component: I(I({}, (l = wl[o]) === null || l === void 0 ? void 0 : l.component), s)
    };
  }), {
    token: n,
    keys: r,
    flush: a
  };
};
function xl(e, t, r) {
  if (typeof r == "function") {
    var n;
    return r(ya(t, (n = t[e]) !== null && n !== void 0 ? n : {}));
  }
  return r ?? {};
}
function _h(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return "max(".concat(n.map(function(i) {
        return G(i);
      }).join(","), ")");
    },
    min: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return "min(".concat(n.map(function(i) {
        return G(i);
      }).join(","), ")");
    }
  };
}
var Ph = 1e3 * 60 * 10, $h = /* @__PURE__ */ function() {
  function e() {
    Rt(this, e), O(this, "map", /* @__PURE__ */ new Map()), O(this, "objectIDMap", /* @__PURE__ */ new WeakMap()), O(this, "nextID", 0), O(this, "lastAccessBeat", /* @__PURE__ */ new Map()), O(this, "accessBeat", 0);
  }
  return Nt(e, [{
    key: "set",
    value: function(r, n) {
      this.clear();
      var a = this.getCompositeKey(r);
      this.map.set(a, n), this.lastAccessBeat.set(a, Date.now());
    }
  }, {
    key: "get",
    value: function(r) {
      var n = this.getCompositeKey(r), a = this.map.get(n);
      return this.lastAccessBeat.set(n, Date.now()), this.accessBeat += 1, a;
    }
  }, {
    key: "getCompositeKey",
    value: function(r) {
      var n = this, a = r.map(function(i) {
        return i && le(i) === "object" ? "obj_".concat(n.getObjectID(i)) : "".concat(le(i), "_").concat(i);
      });
      return a.join("|");
    }
  }, {
    key: "getObjectID",
    value: function(r) {
      if (this.objectIDMap.has(r))
        return this.objectIDMap.get(r);
      var n = this.nextID;
      return this.objectIDMap.set(r, n), this.nextID += 1, n;
    }
  }, {
    key: "clear",
    value: function() {
      var r = this;
      if (this.accessBeat > 1e4) {
        var n = Date.now();
        this.lastAccessBeat.forEach(function(a, i) {
          n - a > Ph && (r.map.delete(i), r.lastAccessBeat.delete(i));
        }), this.accessBeat = 0;
      }
    }
  }]), e;
}(), _l = new $h();
function Oh(e, t) {
  return Q.useMemo(function() {
    var r = _l.get(t);
    if (r)
      return r;
    var n = e();
    return _l.set(t, n), n;
  }, t);
}
var Mh = function() {
  return {};
};
function Rh(e) {
  var t = e.useCSP, r = t === void 0 ? Mh : t, n = e.useToken, a = e.usePrefix, i = e.getResetStyles, o = e.getCommonStyle, s = e.getCompUnitless;
  function l(h, b, g, m) {
    var f = Array.isArray(h) ? h[0] : h;
    function y(N) {
      return "".concat(String(f)).concat(N.slice(0, 1).toUpperCase()).concat(N.slice(1));
    }
    var p = (m == null ? void 0 : m.unitless) || {}, C = typeof s == "function" ? s(h) : {}, S = I(I({}, C), {}, O({}, y("zIndexPopup"), !0));
    Object.keys(p).forEach(function(N) {
      S[y(N)] = p[N];
    });
    var E = I(I({}, m), {}, {
      unitless: S,
      prefixToken: y
    }), w = u(h, b, g, E), P = c(f, g, E);
    return function(N) {
      var M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : N, _ = w(N, M), x = F(_, 2), R = x[1], $ = P(M), T = F($, 2), A = T[0], D = T[1];
      return [A, R, D];
    };
  }
  function c(h, b, g) {
    var m = g.unitless, f = g.injectStyle, y = f === void 0 ? !0 : f, p = g.prefixToken, C = g.ignore, S = function(P) {
      var N = P.rootCls, M = P.cssVar, _ = M === void 0 ? {} : M, x = n(), R = x.realToken;
      return Av({
        path: [h],
        prefix: _.prefix,
        key: _.key,
        unitless: m,
        ignore: C,
        token: R,
        scope: N
      }, function() {
        var $ = xl(h, R, b), T = El(h, R, $, {
          deprecatedTokens: g == null ? void 0 : g.deprecatedTokens
        });
        return Object.keys($).forEach(function(A) {
          T[p(A)] = T[A], delete T[A];
        }), T;
      }), null;
    }, E = function(P) {
      var N = n(), M = N.cssVar;
      return [function(_) {
        return y && M ? /* @__PURE__ */ Q.createElement(Q.Fragment, null, /* @__PURE__ */ Q.createElement(S, {
          rootCls: P,
          cssVar: M,
          component: h
        }), _) : _;
      }, M == null ? void 0 : M.key];
    };
    return E;
  }
  function u(h, b, g) {
    var m = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, f = Array.isArray(h) ? h : [h, h], y = F(f, 1), p = y[0], C = f.join("-"), S = e.layer || {
      name: "antd"
    };
    return function(E) {
      var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : E, P = n(), N = P.theme, M = P.realToken, _ = P.hashId, x = P.token, R = P.cssVar, $ = a(), T = $.rootPrefixCls, A = $.iconPrefixCls, D = r(), z = R ? "css" : "js", V = Oh(function() {
        var j = /* @__PURE__ */ new Set();
        return R && Object.keys(m.unitless || {}).forEach(function(K) {
          j.add(za(K, R.prefix)), j.add(za(K, yl(p, R.prefix)));
        }), gh(z, j);
      }, [z, p, R == null ? void 0 : R.prefix]), k = _h(z), B = k.max, q = k.min, W = {
        theme: N,
        token: x,
        hashId: _,
        nonce: function() {
          return D.nonce;
        },
        clientOnly: m.clientOnly,
        layer: S,
        // antd is always at top of styles
        order: m.order || -999
      };
      typeof i == "function" && ho(I(I({}, W), {}, {
        clientOnly: !1,
        path: ["Shared", T]
      }), function() {
        return i(x, {
          prefix: {
            rootPrefixCls: T,
            iconPrefixCls: A
          },
          csp: D
        });
      });
      var H = ho(I(I({}, W), {}, {
        path: [C, E, A]
      }), function() {
        if (m.injectStyle === !1)
          return [];
        var j = xh(x), K = j.token, J = j.flush, Z = xl(p, M, g), ae = ".".concat(E), oe = El(p, M, Z, {
          deprecatedTokens: m.deprecatedTokens
        });
        R && Z && le(Z) === "object" && Object.keys(Z).forEach(function(Ce) {
          Z[Ce] = "var(".concat(za(Ce, yl(p, R.prefix)), ")");
        });
        var fe = ya(K, {
          componentCls: ae,
          prefixCls: E,
          iconCls: ".".concat(A),
          antCls: ".".concat(T),
          calc: V,
          // @ts-ignore
          max: B,
          // @ts-ignore
          min: q
        }, R ? Z : oe), me = b(fe, {
          hashId: _,
          prefixCls: E,
          rootPrefixCls: T,
          iconPrefixCls: A
        });
        J(p, oe);
        var ue = typeof o == "function" ? o(fe, E, w, m.resetFont) : null;
        return [m.resetStyle === !1 ? null : ue, me];
      });
      return [H, _];
    };
  }
  function v(h, b, g) {
    var m = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, f = u(h, b, g, I({
      resetStyle: !1,
      // Sub Style should default after root one
      order: -998
    }, m)), y = function(C) {
      var S = C.prefixCls, E = C.rootCls, w = E === void 0 ? S : E;
      return f(S, w), null;
    };
    return process.env.NODE_ENV !== "production" && (y.displayName = "SubStyle_".concat(String(Array.isArray(h) ? h.join(".") : h))), y;
  }
  return {
    genStyleHooks: l,
    genSubStyleComponent: v,
    genComponentStyleHook: u
  };
}
const Nh = "5.25.2";
function Gi(e) {
  return e >= 0 && e <= 255;
}
function Aa(e, t) {
  const {
    r,
    g: n,
    b: a,
    a: i
  } = new ut(e).toRgb();
  if (i < 1)
    return e;
  const {
    r: o,
    g: s,
    b: l
  } = new ut(t).toRgb();
  for (let c = 0.01; c <= 1; c += 0.01) {
    const u = Math.round((r - o * (1 - c)) / c), v = Math.round((n - s * (1 - c)) / c), h = Math.round((a - l * (1 - c)) / c);
    if (Gi(u) && Gi(v) && Gi(h))
      return new ut({
        r: u,
        g: v,
        b: h,
        a: Math.round(c * 100) / 100
      }).toRgbString();
  }
  return new ut({
    r,
    g: n,
    b: a,
    a: 1
  }).toRgbString();
}
var Th = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function Cu(e) {
  const {
    override: t
  } = e, r = Th(e, ["override"]), n = Object.assign({}, t);
  Object.keys(ca).forEach((h) => {
    delete n[h];
  });
  const a = Object.assign(Object.assign({}, r), n), i = 480, o = 576, s = 768, l = 992, c = 1200, u = 1600;
  if (a.motion === !1) {
    const h = "0s";
    a.motionDurationFast = h, a.motionDurationMid = h, a.motionDurationSlow = h;
  }
  return Object.assign(Object.assign(Object.assign({}, a), {
    // ============== Background ============== //
    colorFillContent: a.colorFillSecondary,
    colorFillContentHover: a.colorFill,
    colorFillAlter: a.colorFillQuaternary,
    colorBgContainerDisabled: a.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: a.colorBgContainer,
    colorSplit: Aa(a.colorBorderSecondary, a.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: a.colorTextQuaternary,
    colorTextDisabled: a.colorTextQuaternary,
    colorTextHeading: a.colorText,
    colorTextLabel: a.colorTextSecondary,
    colorTextDescription: a.colorTextTertiary,
    colorTextLightSolid: a.colorWhite,
    colorHighlight: a.colorError,
    colorBgTextHover: a.colorFillSecondary,
    colorBgTextActive: a.colorFill,
    colorIcon: a.colorTextTertiary,
    colorIconHover: a.colorText,
    colorErrorOutline: Aa(a.colorErrorBg, a.colorBgContainer),
    colorWarningOutline: Aa(a.colorWarningBg, a.colorBgContainer),
    // Font
    fontSizeIcon: a.fontSizeSM,
    // Line
    lineWidthFocus: a.lineWidth * 3,
    // Control
    lineWidth: a.lineWidth,
    controlOutlineWidth: a.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: a.controlHeight / 2,
    controlItemBgHover: a.colorFillTertiary,
    controlItemBgActive: a.colorPrimaryBg,
    controlItemBgActiveHover: a.colorPrimaryBgHover,
    controlItemBgActiveDisabled: a.colorFill,
    controlTmpOutline: a.colorFillQuaternary,
    controlOutline: Aa(a.colorPrimaryBg, a.colorBgContainer),
    lineType: a.lineType,
    borderRadius: a.borderRadius,
    borderRadiusXS: a.borderRadiusXS,
    borderRadiusSM: a.borderRadiusSM,
    borderRadiusLG: a.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: a.sizeXXS,
    paddingXS: a.sizeXS,
    paddingSM: a.sizeSM,
    padding: a.size,
    paddingMD: a.sizeMD,
    paddingLG: a.sizeLG,
    paddingXL: a.sizeXL,
    paddingContentHorizontalLG: a.sizeLG,
    paddingContentVerticalLG: a.sizeMS,
    paddingContentHorizontal: a.sizeMS,
    paddingContentVertical: a.sizeSM,
    paddingContentHorizontalSM: a.size,
    paddingContentVerticalSM: a.sizeXS,
    marginXXS: a.sizeXXS,
    marginXS: a.sizeXS,
    marginSM: a.sizeSM,
    margin: a.size,
    marginMD: a.sizeMD,
    marginLG: a.sizeLG,
    marginXL: a.sizeXL,
    marginXXL: a.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: i,
    screenXSMin: i,
    screenXSMax: o - 1,
    screenSM: o,
    screenSMMin: o,
    screenSMMax: s - 1,
    screenMD: s,
    screenMDMin: s,
    screenMDMax: l - 1,
    screenLG: l,
    screenLGMin: l,
    screenLGMax: c - 1,
    screenXL: c,
    screenXLMin: c,
    screenXLMax: u - 1,
    screenXXL: u,
    screenXXLMin: u,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new ut("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new ut("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new ut("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), n);
}
var Pl = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const Su = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0,
  opacityImage: !0
}, Ih = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, Ah = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, Eu = (e, t, r) => {
  const n = r.getDerivativeToken(e), {
    override: a
  } = t, i = Pl(t, ["override"]);
  let o = Object.assign(Object.assign({}, n), {
    override: a
  });
  return o = Cu(o), i && Object.entries(i).forEach(([s, l]) => {
    const {
      theme: c
    } = l, u = Pl(l, ["theme"]);
    let v = u;
    c && (v = Eu(Object.assign(Object.assign({}, o), u), {
      override: u
    }, c)), o[s] = v;
  }), o;
};
function gi() {
  const {
    token: e,
    hashed: t,
    theme: r,
    override: n,
    cssVar: a
  } = Q.useContext(hu), i = `${Nh}-${t || ""}`, o = r || vu, [s, l, c] = iv(o, [ca, e], {
    salt: i,
    override: n,
    getComputedToken: Eu,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: Cu,
    cssVar: a && {
      prefix: a.prefix,
      key: a.key,
      unitless: Su,
      ignore: Ih,
      preserve: Ah
    }
  });
  return [o, c, t ? l : "", s, a];
}
const ys = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, bs = (e, t = !1) => ({
  boxSizing: "border-box",
  margin: 0,
  padding: 0,
  color: e.colorText,
  fontSize: e.fontSize,
  // font-variant: @font-variant-base;
  lineHeight: e.lineHeight,
  listStyle: "none",
  // font-feature-settings: @font-feature-settings-base;
  fontFamily: t ? "inherit" : e.fontFamily
}), kh = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), mi = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), Fh = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active, &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), Dh = (e, t, r, n) => {
  const a = `[class^="${t}"], [class*=" ${t}"]`, i = r ? `.${r}` : a, o = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let s = {};
  return n !== !1 && (s = {
    fontFamily: e.fontFamily,
    fontSize: e.fontSize
  }), {
    [i]: Object.assign(Object.assign(Object.assign({}, s), o), {
      [a]: o
    })
  };
}, Cs = (e, t) => ({
  outline: `${G(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: t ?? 1,
  transition: "outline-offset 0s, outline 0s"
}), No = (e, t) => ({
  "&:focus-visible": Object.assign({}, Cs(e, t))
}), wu = (e) => ({
  [`.${e}`]: Object.assign(Object.assign({}, kh()), {
    [`.${e} .${e}-icon`]: {
      display: "block"
    }
  })
}), {
  genStyleHooks: Ss
} = Rh({
  usePrefix: () => {
    const {
      getPrefixCls: e,
      iconPrefixCls: t
    } = Lr(Mt);
    return {
      rootPrefixCls: e(),
      iconPrefixCls: t
    };
  },
  useToken: () => {
    const [e, t, r, n, a] = gi();
    return {
      theme: e,
      realToken: t,
      hashId: r,
      token: n,
      cssVar: a
    };
  },
  useCSP: () => {
    const {
      csp: e
    } = Lr(Mt);
    return e ?? {};
  },
  getResetStyles: (e, t) => {
    var r;
    const n = Fh(e);
    return [n, {
      "&": n
    }, wu((r = t == null ? void 0 : t.prefix.iconPrefixCls) !== null && r !== void 0 ? r : ms)];
  },
  getCommonStyle: Dh,
  getCompUnitless: () => Su
}), Lh = (e, t) => {
  const [r, n] = gi();
  return ho({
    token: n,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t == null ? void 0 : t.nonce,
    layer: {
      name: "antd"
    }
  }, () => [wu(e)]);
}, Vh = Object.assign({}, d), {
  useId: $l
} = Vh, jh = () => "", zh = typeof $l > "u" ? jh : $l;
function Hh(e, t, r) {
  var n, a;
  const i = qr("ConfigProvider"), o = e || {}, s = o.inherit === !1 || !t ? Object.assign(Object.assign({}, $o), {
    hashed: (n = t == null ? void 0 : t.hashed) !== null && n !== void 0 ? n : $o.hashed,
    cssVar: t == null ? void 0 : t.cssVar
  }) : t, l = zh();
  if (process.env.NODE_ENV !== "production") {
    const c = o.cssVar || s.cssVar, u = !!(typeof o.cssVar == "object" && (!((a = o.cssVar) === null || a === void 0) && a.key) || l);
    process.env.NODE_ENV !== "production" && i(!c || u, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return ci(() => {
    var c, u;
    if (!e)
      return t;
    const v = Object.assign({}, s.components);
    Object.keys(e.components || {}).forEach((g) => {
      v[g] = Object.assign(Object.assign({}, v[g]), e.components[g]);
    });
    const h = `css-var-${l.replace(/:/g, "")}`, b = ((c = o.cssVar) !== null && c !== void 0 ? c : s.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: r == null ? void 0 : r.prefixCls
    }, typeof s.cssVar == "object" ? s.cssVar : {}), typeof o.cssVar == "object" ? o.cssVar : {}), {
      key: typeof o.cssVar == "object" && ((u = o.cssVar) === null || u === void 0 ? void 0 : u.key) || h
    });
    return Object.assign(Object.assign(Object.assign({}, s), o), {
      token: Object.assign(Object.assign({}, s.token), o.token),
      components: v,
      cssVar: b
    });
  }, [o, s], (c, u) => c.some((v, h) => {
    const b = u[h];
    return !ia(v, b, !0);
  }));
}
function fa(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function Bh(e) {
  return e && le(e) === "object" && fa(e.nativeElement) ? e.nativeElement : fa(e) ? e : null;
}
function Ua(e) {
  var t = Bh(e);
  if (t)
    return t;
  if (e instanceof Q.Component) {
    var r;
    return (r = ks.findDOMNode) === null || r === void 0 ? void 0 : r.call(ks, e);
  }
  return null;
}
var Wh = ["children"], xu = /* @__PURE__ */ d.createContext({});
function Kh(e) {
  var t = e.children, r = Le(e, Wh);
  return /* @__PURE__ */ d.createElement(xu.Provider, {
    value: r
  }, t);
}
var qh = /* @__PURE__ */ function(e) {
  Vr(r, e);
  var t = jr(r);
  function r() {
    return Rt(this, r), t.apply(this, arguments);
  }
  return Nt(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(d.Component);
function Uh(e) {
  var t = d.useReducer(function(s) {
    return s + 1;
  }, 0), r = F(t, 2), n = r[1], a = d.useRef(e), i = Ut(function() {
    return a.current;
  }), o = Ut(function(s) {
    a.current = typeof s == "function" ? s(a.current) : s, n();
  });
  return [i, o];
}
var Ar = "none", ka = "appear", Fa = "enter", Da = "leave", Ol = "none", fr = "prepare", un = "start", dn = "active", Es = "end", _u = "prepared";
function Ml(e, t) {
  var r = {};
  return r[e.toLowerCase()] = t.toLowerCase(), r["Webkit".concat(e)] = "webkit".concat(t), r["Moz".concat(e)] = "moz".concat(t), r["ms".concat(e)] = "MS".concat(t), r["O".concat(e)] = "o".concat(t.toLowerCase()), r;
}
function Gh(e, t) {
  var r = {
    animationend: Ml("Animation", "AnimationEnd"),
    transitionend: Ml("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete r.animationend.animation, "TransitionEvent" in t || delete r.transitionend.transition), r;
}
var Xh = Gh(Gt(), typeof window < "u" ? window : {}), Pu = {};
if (Gt()) {
  var Yh = document.createElement("div");
  Pu = Yh.style;
}
var La = {};
function $u(e) {
  if (La[e])
    return La[e];
  var t = Xh[e];
  if (t)
    for (var r = Object.keys(t), n = r.length, a = 0; a < n; a += 1) {
      var i = r[a];
      if (Object.prototype.hasOwnProperty.call(t, i) && i in Pu)
        return La[e] = t[i], La[e];
    }
  return "";
}
var Ou = $u("animationend"), Mu = $u("transitionend"), Ru = !!(Ou && Mu), Rl = Ou || "animationend", Nl = Mu || "transitionend";
function Tl(e, t) {
  if (!e) return null;
  if (le(e) === "object") {
    var r = t.replace(/-\w/g, function(n) {
      return n[1].toUpperCase();
    });
    return e[r];
  }
  return "".concat(e, "-").concat(t);
}
const Qh = function(e) {
  var t = De();
  function r(a) {
    a && (a.removeEventListener(Nl, e), a.removeEventListener(Rl, e));
  }
  function n(a) {
    t.current && t.current !== a && r(t.current), a && a !== t.current && (a.addEventListener(Nl, e), a.addEventListener(Rl, e), t.current = a);
  }
  return d.useEffect(function() {
    return function() {
      r(t.current);
    };
  }, []), [n, r];
};
var Nu = Gt() ? Hd : gt, Tu = function(t) {
  return +setTimeout(t, 16);
}, Iu = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (Tu = function(t) {
  return window.requestAnimationFrame(t);
}, Iu = function(t) {
  return window.cancelAnimationFrame(t);
});
var Il = 0, pi = /* @__PURE__ */ new Map();
function Au(e) {
  pi.delete(e);
}
var Jt = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  Il += 1;
  var n = Il;
  function a(i) {
    if (i === 0)
      Au(n), t();
    else {
      var o = Tu(function() {
        a(i - 1);
      });
      pi.set(n, o);
    }
  }
  return a(r), n;
};
Jt.cancel = function(e) {
  var t = pi.get(e);
  return Au(e), Iu(t);
};
process.env.NODE_ENV !== "production" && (Jt.ids = function() {
  return pi;
});
const Zh = function() {
  var e = d.useRef(null);
  function t() {
    Jt.cancel(e.current);
  }
  function r(n) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var i = Jt(function() {
      a <= 1 ? n({
        isCanceled: function() {
          return i !== e.current;
        }
      }) : r(n, a - 1);
    });
    e.current = i;
  }
  return d.useEffect(function() {
    return function() {
      t();
    };
  }, []), [r, t];
};
var Jh = [fr, un, dn, Es], eg = [fr, _u], ku = !1, tg = !0;
function Fu(e) {
  return e === dn || e === Es;
}
const rg = function(e, t, r) {
  var n = da(Ol), a = F(n, 2), i = a[0], o = a[1], s = Zh(), l = F(s, 2), c = l[0], u = l[1];
  function v() {
    o(fr, !0);
  }
  var h = t ? eg : Jh;
  return Nu(function() {
    if (i !== Ol && i !== Es) {
      var b = h.indexOf(i), g = h[b + 1], m = r(i);
      m === ku ? o(g, !0) : g && c(function(f) {
        function y() {
          f.isCanceled() || o(g, !0);
        }
        m === !0 ? y() : Promise.resolve(m).then(y);
      });
    }
  }, [e, i]), d.useEffect(function() {
    return function() {
      u();
    };
  }, []), [v, i];
};
function ng(e, t, r, n) {
  var a = n.motionEnter, i = a === void 0 ? !0 : a, o = n.motionAppear, s = o === void 0 ? !0 : o, l = n.motionLeave, c = l === void 0 ? !0 : l, u = n.motionDeadline, v = n.motionLeaveImmediately, h = n.onAppearPrepare, b = n.onEnterPrepare, g = n.onLeavePrepare, m = n.onAppearStart, f = n.onEnterStart, y = n.onLeaveStart, p = n.onAppearActive, C = n.onEnterActive, S = n.onLeaveActive, E = n.onAppearEnd, w = n.onEnterEnd, P = n.onLeaveEnd, N = n.onVisibleChanged, M = da(), _ = F(M, 2), x = _[0], R = _[1], $ = Uh(Ar), T = F($, 2), A = T[0], D = T[1], z = da(null), V = F(z, 2), k = V[0], B = V[1], q = A(), W = De(!1), H = De(null);
  function j() {
    return r();
  }
  var K = De(!1);
  function J() {
    D(Ar), B(null, !0);
  }
  var Z = Ut(function(U) {
    var pe = A();
    if (pe !== Ar) {
      var se = j();
      if (!(U && !U.deadline && U.target !== se)) {
        var tt = K.current, Ie;
        pe === ka && tt ? Ie = E == null ? void 0 : E(se, U) : pe === Fa && tt ? Ie = w == null ? void 0 : w(se, U) : pe === Da && tt && (Ie = P == null ? void 0 : P(se, U)), tt && Ie !== !1 && J();
      }
    }
  }), ae = Qh(Z), oe = F(ae, 1), fe = oe[0], me = function(pe) {
    switch (pe) {
      case ka:
        return O(O(O({}, fr, h), un, m), dn, p);
      case Fa:
        return O(O(O({}, fr, b), un, f), dn, C);
      case Da:
        return O(O(O({}, fr, g), un, y), dn, S);
      default:
        return {};
    }
  }, ue = d.useMemo(function() {
    return me(q);
  }, [q]), Ce = rg(q, !e, function(U) {
    if (U === fr) {
      var pe = ue[fr];
      return pe ? pe(j()) : ku;
    }
    if (ye in ue) {
      var se;
      B(((se = ue[ye]) === null || se === void 0 ? void 0 : se.call(ue, j(), null)) || null);
    }
    return ye === dn && q !== Ar && (fe(j()), u > 0 && (clearTimeout(H.current), H.current = setTimeout(function() {
      Z({
        deadline: !0
      });
    }, u))), ye === _u && J(), tg;
  }), L = F(Ce, 2), de = L[0], ye = L[1], Ge = Fu(ye);
  K.current = Ge;
  var Oe = De(null);
  Nu(function() {
    if (!(W.current && Oe.current === t)) {
      R(t);
      var U = W.current;
      W.current = !0;
      var pe;
      !U && t && s && (pe = ka), U && t && i && (pe = Fa), (U && !t && c || !U && v && !t && c) && (pe = Da);
      var se = me(pe);
      pe && (e || se[fr]) ? (D(pe), de()) : D(Ar), Oe.current = t;
    }
  }, [t]), gt(function() {
    // Cancel appear
    (q === ka && !s || // Cancel enter
    q === Fa && !i || // Cancel leave
    q === Da && !c) && D(Ar);
  }, [s, i, c]), gt(function() {
    return function() {
      W.current = !1, clearTimeout(H.current);
    };
  }, []);
  var He = d.useRef(!1);
  gt(function() {
    x && (He.current = !0), x !== void 0 && q === Ar && ((He.current || x) && (N == null || N(x)), He.current = !0);
  }, [x, q]);
  var ve = k;
  return ue[fr] && ye === un && (ve = I({
    transition: "none"
  }, ve)), [q, ye, ve, x ?? t];
}
function ag(e) {
  var t = e;
  le(e) === "object" && (t = e.transitionSupport);
  function r(a, i) {
    return !!(a.motionName && t && i !== !1);
  }
  var n = /* @__PURE__ */ d.forwardRef(function(a, i) {
    var o = a.visible, s = o === void 0 ? !0 : o, l = a.removeOnLeave, c = l === void 0 ? !0 : l, u = a.forceRender, v = a.children, h = a.motionName, b = a.leavedClassName, g = a.eventProps, m = d.useContext(xu), f = m.motion, y = r(a, f), p = De(), C = De();
    function S() {
      try {
        return p.current instanceof HTMLElement ? p.current : Ua(C.current);
      } catch {
        return null;
      }
    }
    var E = ng(y, s, S, a), w = F(E, 4), P = w[0], N = w[1], M = w[2], _ = w[3], x = d.useRef(_);
    _ && (x.current = !0);
    var R = d.useCallback(function(V) {
      p.current = V, ps(i, V);
    }, [i]), $, T = I(I({}, g), {}, {
      visible: s
    });
    if (!v)
      $ = null;
    else if (P === Ar)
      _ ? $ = v(I({}, T), R) : !c && x.current && b ? $ = v(I(I({}, T), {}, {
        className: b
      }), R) : u || !c && !b ? $ = v(I(I({}, T), {}, {
        style: {
          display: "none"
        }
      }), R) : $ = null;
    else {
      var A;
      N === fr ? A = "prepare" : Fu(N) ? A = "active" : N === un && (A = "start");
      var D = Tl(h, "".concat(P, "-").concat(A));
      $ = v(I(I({}, T), {}, {
        className: ne(Tl(h, P), O(O({}, D, D && A), h, typeof h == "string")),
        style: M
      }), R);
    }
    if (/* @__PURE__ */ d.isValidElement($) && On($)) {
      var z = pa($);
      z || ($ = /* @__PURE__ */ d.cloneElement($, {
        ref: R
      }));
    }
    return /* @__PURE__ */ d.createElement(qh, {
      ref: C
    }, $);
  });
  return n.displayName = "CSSMotion", n;
}
const ba = ag(Ru);
var To = "add", Io = "keep", Ao = "remove", Xi = "removed";
function ig(e) {
  var t;
  return e && le(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, I(I({}, t), {}, {
    key: String(t.key)
  });
}
function ko() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(ig);
}
function og() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = [], n = 0, a = t.length, i = ko(e), o = ko(t);
  i.forEach(function(c) {
    for (var u = !1, v = n; v < a; v += 1) {
      var h = o[v];
      if (h.key === c.key) {
        n < v && (r = r.concat(o.slice(n, v).map(function(b) {
          return I(I({}, b), {}, {
            status: To
          });
        })), n = v), r.push(I(I({}, h), {}, {
          status: Io
        })), n += 1, u = !0;
        break;
      }
    }
    u || r.push(I(I({}, c), {}, {
      status: Ao
    }));
  }), n < a && (r = r.concat(o.slice(n).map(function(c) {
    return I(I({}, c), {}, {
      status: To
    });
  })));
  var s = {};
  r.forEach(function(c) {
    var u = c.key;
    s[u] = (s[u] || 0) + 1;
  });
  var l = Object.keys(s).filter(function(c) {
    return s[c] > 1;
  });
  return l.forEach(function(c) {
    r = r.filter(function(u) {
      var v = u.key, h = u.status;
      return v !== c || h !== Ao;
    }), r.forEach(function(u) {
      u.key === c && (u.status = Io);
    });
  }), r;
}
var sg = ["component", "children", "onVisibleChanged", "onAllRemoved"], lg = ["status"], cg = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function ug(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ba, r = /* @__PURE__ */ function(n) {
    Vr(i, n);
    var a = jr(i);
    function i() {
      var o;
      Rt(this, i);
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      return o = a.call.apply(a, [this].concat(l)), O(be(o), "state", {
        keyEntities: []
      }), O(be(o), "removeKey", function(u) {
        o.setState(function(v) {
          var h = v.keyEntities.map(function(b) {
            return b.key !== u ? b : I(I({}, b), {}, {
              status: Xi
            });
          });
          return {
            keyEntities: h
          };
        }, function() {
          var v = o.state.keyEntities, h = v.filter(function(b) {
            var g = b.status;
            return g !== Xi;
          }).length;
          h === 0 && o.props.onAllRemoved && o.props.onAllRemoved();
        });
      }), o;
    }
    return Nt(i, [{
      key: "render",
      value: function() {
        var s = this, l = this.state.keyEntities, c = this.props, u = c.component, v = c.children, h = c.onVisibleChanged;
        c.onAllRemoved;
        var b = Le(c, sg), g = u || d.Fragment, m = {};
        return cg.forEach(function(f) {
          m[f] = b[f], delete b[f];
        }), delete b.keys, /* @__PURE__ */ d.createElement(g, b, l.map(function(f, y) {
          var p = f.status, C = Le(f, lg), S = p === To || p === Io;
          return /* @__PURE__ */ d.createElement(t, he({}, m, {
            key: C.key,
            visible: S,
            eventProps: C,
            onVisibleChanged: function(w) {
              h == null || h(w, {
                key: C.key
              }), w || s.removeKey(C.key);
            }
          }), function(E, w) {
            return v(I(I({}, E), {}, {
              index: y
            }), w);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, l) {
        var c = s.keys, u = l.keyEntities, v = ko(c), h = og(u, v);
        return {
          keyEntities: h.filter(function(b) {
            var g = u.find(function(m) {
              var f = m.key;
              return b.key === f;
            });
            return !(g && g.status === Xi && b.status === Ao);
          })
        };
      }
    }]), i;
  }(d.Component);
  return O(r, "defaultProps", {
    component: "div"
  }), r;
}
ug(Ru);
function dg(e) {
  const {
    children: t
  } = e, [, r] = gi(), {
    motion: n
  } = r, a = d.useRef(!1);
  return a.current = a.current || n === !1, a.current ? /* @__PURE__ */ d.createElement(Kh, {
    motion: n
  }, t) : t;
}
const Du = /* @__PURE__ */ d.memo(({
  dropdownMatchSelectWidth: e
}) => (qr("ConfigProvider").deprecated(e === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null));
process.env.NODE_ENV !== "production" && (Du.displayName = "PropWarning");
const fg = process.env.NODE_ENV !== "production" ? Du : () => null;
var vg = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
let Fo = !1;
process.env.NODE_ENV;
const hg = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
let Lu;
function gg() {
  return Lu || Oo;
}
function mg(e) {
  return Object.keys(e).some((t) => t.endsWith("Color"));
}
const pg = (e) => {
  const {
    prefixCls: t,
    iconPrefixCls: r,
    theme: n,
    holderRender: a
  } = e;
  t !== void 0 && (Lu = t), n && mg(n) && (process.env.NODE_ENV !== "production" && fi(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), lh(gg(), n));
}, yg = (e) => {
  const {
    children: t,
    csp: r,
    autoInsertSpaceInButton: n,
    alert: a,
    anchor: i,
    form: o,
    locale: s,
    componentSize: l,
    direction: c,
    space: u,
    splitter: v,
    virtual: h,
    dropdownMatchSelectWidth: b,
    popupMatchSelectWidth: g,
    popupOverflow: m,
    legacyLocale: f,
    parentContext: y,
    iconPrefixCls: p,
    theme: C,
    componentDisabled: S,
    segmented: E,
    statistic: w,
    spin: P,
    calendar: N,
    carousel: M,
    cascader: _,
    collapse: x,
    typography: R,
    checkbox: $,
    descriptions: T,
    divider: A,
    drawer: D,
    skeleton: z,
    steps: V,
    image: k,
    layout: B,
    list: q,
    mentions: W,
    modal: H,
    progress: j,
    result: K,
    slider: J,
    breadcrumb: Z,
    menu: ae,
    pagination: oe,
    input: fe,
    textArea: me,
    empty: ue,
    badge: Ce,
    radio: L,
    rate: de,
    switch: ye,
    transfer: Ge,
    avatar: Oe,
    message: He,
    tag: ve,
    table: U,
    card: pe,
    tabs: se,
    timeline: tt,
    timePicker: Ie,
    upload: ge,
    notification: mt,
    tree: qe,
    colorPicker: Xe,
    datePicker: pt,
    rangePicker: at,
    flex: Ye,
    wave: Ve,
    dropdown: Ue,
    warning: xt,
    tour: Me,
    tooltip: Re,
    popover: dt,
    popconfirm: Xt,
    floatButtonGroup: Bt,
    variant: jt,
    inputNumber: er,
    treeSelect: st
  } = e, Qe = d.useCallback((Pe, je) => {
    const {
      prefixCls: yt
    } = e;
    if (je)
      return je;
    const rt = yt || y.getPrefixCls("");
    return Pe ? `${rt}-${Pe}` : rt;
  }, [y.getPrefixCls, e.prefixCls]), Je = p || y.iconPrefixCls || ms, xe = r || y.csp;
  Lh(Je, xe);
  const ee = Hh(C, y.theme, {
    prefixCls: Qe("")
  });
  process.env.NODE_ENV !== "production" && (Fo = Fo || !!ee);
  const X = {
    csp: xe,
    autoInsertSpaceInButton: n,
    alert: a,
    anchor: i,
    locale: s || f,
    direction: c,
    space: u,
    splitter: v,
    virtual: h,
    popupMatchSelectWidth: g ?? b,
    popupOverflow: m,
    getPrefixCls: Qe,
    iconPrefixCls: Je,
    theme: ee,
    segmented: E,
    statistic: w,
    spin: P,
    calendar: N,
    carousel: M,
    cascader: _,
    collapse: x,
    typography: R,
    checkbox: $,
    descriptions: T,
    divider: A,
    drawer: D,
    skeleton: z,
    steps: V,
    image: k,
    input: fe,
    textArea: me,
    layout: B,
    list: q,
    mentions: W,
    modal: H,
    progress: j,
    result: K,
    slider: J,
    breadcrumb: Z,
    menu: ae,
    pagination: oe,
    empty: ue,
    badge: Ce,
    radio: L,
    rate: de,
    switch: ye,
    transfer: Ge,
    avatar: Oe,
    message: He,
    tag: ve,
    table: U,
    card: pe,
    tabs: se,
    timeline: tt,
    timePicker: Ie,
    upload: ge,
    notification: mt,
    tree: qe,
    colorPicker: Xe,
    datePicker: pt,
    rangePicker: at,
    flex: Ye,
    wave: Ve,
    dropdown: Ue,
    warning: xt,
    tour: Me,
    tooltip: Re,
    popover: dt,
    popconfirm: Xt,
    floatButtonGroup: Bt,
    variant: jt,
    inputNumber: er,
    treeSelect: st
  };
  process.env.NODE_ENV !== "production" && qr("ConfigProvider")(!("autoInsertSpaceInButton" in e), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
  const ie = Object.assign({}, y);
  Object.keys(X).forEach((Pe) => {
    X[Pe] !== void 0 && (ie[Pe] = X[Pe]);
  }), hg.forEach((Pe) => {
    const je = e[Pe];
    je && (ie[Pe] = je);
  }), typeof n < "u" && (ie.button = Object.assign({
    autoInsertSpace: n
  }, ie.button));
  const Ee = ci(() => ie, ie, (Pe, je) => {
    const yt = Object.keys(Pe), rt = Object.keys(je);
    return yt.length !== rt.length || yt.some((It) => Pe[It] !== je[It]);
  }), {
    layer: we
  } = d.useContext(ga), Tt = d.useMemo(() => ({
    prefixCls: Je,
    csp: xe,
    layer: we ? "antd" : void 0
  }), [Je, xe, we]);
  let _e = /* @__PURE__ */ d.createElement(d.Fragment, null, /* @__PURE__ */ d.createElement(fg, {
    dropdownMatchSelectWidth: b
  }), t);
  const zt = d.useMemo(() => {
    var Pe, je, yt, rt;
    return cn(((Pe = vi.Form) === null || Pe === void 0 ? void 0 : Pe.defaultValidateMessages) || {}, ((yt = (je = Ee.locale) === null || je === void 0 ? void 0 : je.Form) === null || yt === void 0 ? void 0 : yt.defaultValidateMessages) || {}, ((rt = Ee.form) === null || rt === void 0 ? void 0 : rt.validateMessages) || {}, (o == null ? void 0 : o.validateMessages) || {});
  }, [Ee, o == null ? void 0 : o.validateMessages]);
  Object.keys(zt).length > 0 && (_e = /* @__PURE__ */ d.createElement(jv.Provider, {
    value: zt
  }, _e)), s && (_e = /* @__PURE__ */ d.createElement(cu, {
    locale: s,
    _ANT_MARK__: lu
  }, _e)), _e = /* @__PURE__ */ d.createElement(hs.Provider, {
    value: Tt
  }, _e), l && (_e = /* @__PURE__ */ d.createElement(uh, {
    size: l
  }, _e)), _e = /* @__PURE__ */ d.createElement(dg, null, _e);
  const tr = d.useMemo(() => {
    const Pe = ee || {}, {
      algorithm: je,
      token: yt,
      components: rt,
      cssVar: It
    } = Pe, Wt = vg(Pe, ["algorithm", "token", "components", "cssVar"]), ft = je && (!Array.isArray(je) || je.length > 0) ? so(je) : vu, At = {};
    Object.entries(rt || {}).forEach(([kt, Ft]) => {
      const vt = Object.assign({}, Ft);
      "algorithm" in vt && (vt.algorithm === !0 ? vt.theme = ft : (Array.isArray(vt.algorithm) || typeof vt.algorithm == "function") && (vt.theme = so(vt.algorithm)), delete vt.algorithm), At[kt] = vt;
    });
    const _t = Object.assign(Object.assign({}, ca), yt);
    return Object.assign(Object.assign({}, Wt), {
      theme: ft,
      token: _t,
      components: At,
      override: Object.assign({
        override: _t
      }, At),
      cssVar: It
    });
  }, [ee]);
  return C && (_e = /* @__PURE__ */ d.createElement(hu.Provider, {
    value: tr
  }, _e)), Ee.warning && (_e = /* @__PURE__ */ d.createElement(ou.Provider, {
    value: Ee.warning
  }, _e)), S !== void 0 && (_e = /* @__PURE__ */ d.createElement(ch, {
    disabled: S
  }, _e)), /* @__PURE__ */ d.createElement(Mt.Provider, {
    value: Ee
  }, _e);
}, Mn = (e) => {
  const t = d.useContext(Mt), r = d.useContext(su);
  return /* @__PURE__ */ d.createElement(yg, Object.assign({
    parentContext: t,
    legacyLocale: r
  }, e));
};
Mn.ConfigContext = Mt;
Mn.SizeContext = wn;
Mn.config = pg;
Mn.useConfig = dh;
Object.defineProperty(Mn, "SizeContext", {
  get: () => (process.env.NODE_ENV !== "production" && fi(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), wn)
});
process.env.NODE_ENV !== "production" && (Mn.displayName = "ConfigProvider");
const bg = new Pr("ant-skeleton-loading", {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
}), yi = (e) => ({
  height: e,
  lineHeight: G(e)
}), gn = (e) => Object.assign({
  width: e
}, yi(e)), Cg = (e) => ({
  background: e.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: bg,
  animationDuration: e.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
}), Yi = (e, t) => Object.assign({
  width: t(e).mul(5).equal(),
  minWidth: t(e).mul(5).equal()
}, yi(e)), Sg = (e) => {
  const {
    skeletonAvatarCls: t,
    gradientFromColor: r,
    controlHeight: n,
    controlHeightLG: a,
    controlHeightSM: i
  } = e;
  return {
    [t]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: r
    }, gn(n)),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    },
    [`${t}${t}-lg`]: Object.assign({}, gn(a)),
    [`${t}${t}-sm`]: Object.assign({}, gn(i))
  };
}, Eg = (e) => {
  const {
    controlHeight: t,
    borderRadiusSM: r,
    skeletonInputCls: n,
    controlHeightLG: a,
    controlHeightSM: i,
    gradientFromColor: o,
    calc: s
  } = e;
  return {
    [n]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: o,
      borderRadius: r
    }, Yi(t, s)),
    [`${n}-lg`]: Object.assign({}, Yi(a, s)),
    [`${n}-sm`]: Object.assign({}, Yi(i, s))
  };
}, Al = (e) => Object.assign({
  width: e
}, yi(e)), wg = (e) => {
  const {
    skeletonImageCls: t,
    imageSizeBase: r,
    gradientFromColor: n,
    borderRadiusSM: a,
    calc: i
  } = e;
  return {
    [t]: Object.assign(Object.assign({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "middle",
      background: n,
      borderRadius: a
    }, Al(i(r).mul(2).equal())), {
      [`${t}-path`]: {
        fill: "#bfbfbf"
      },
      [`${t}-svg`]: Object.assign(Object.assign({}, Al(r)), {
        maxWidth: i(r).mul(4).equal(),
        maxHeight: i(r).mul(4).equal()
      }),
      [`${t}-svg${t}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    }
  };
}, Qi = (e, t, r) => {
  const {
    skeletonButtonCls: n
  } = e;
  return {
    [`${r}${n}-circle`]: {
      width: t,
      minWidth: t,
      borderRadius: "50%"
    },
    [`${r}${n}-round`]: {
      borderRadius: t
    }
  };
}, Zi = (e, t) => Object.assign({
  width: t(e).mul(2).equal(),
  minWidth: t(e).mul(2).equal()
}, yi(e)), xg = (e) => {
  const {
    borderRadiusSM: t,
    skeletonButtonCls: r,
    controlHeight: n,
    controlHeightLG: a,
    controlHeightSM: i,
    gradientFromColor: o,
    calc: s
  } = e;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [r]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: o,
      borderRadius: t,
      width: s(n).mul(2).equal(),
      minWidth: s(n).mul(2).equal()
    }, Zi(n, s))
  }, Qi(e, n, r)), {
    [`${r}-lg`]: Object.assign({}, Zi(a, s))
  }), Qi(e, a, `${r}-lg`)), {
    [`${r}-sm`]: Object.assign({}, Zi(i, s))
  }), Qi(e, i, `${r}-sm`));
}, _g = (e) => {
  const {
    componentCls: t,
    skeletonAvatarCls: r,
    skeletonTitleCls: n,
    skeletonParagraphCls: a,
    skeletonButtonCls: i,
    skeletonInputCls: o,
    skeletonImageCls: s,
    controlHeight: l,
    controlHeightLG: c,
    controlHeightSM: u,
    gradientFromColor: v,
    padding: h,
    marginSM: b,
    borderRadius: g,
    titleHeight: m,
    blockRadius: f,
    paragraphLiHeight: y,
    controlHeightXS: p,
    paragraphMarginTop: C
  } = e;
  return {
    [t]: {
      display: "table",
      width: "100%",
      [`${t}-header`]: {
        display: "table-cell",
        paddingInlineEnd: h,
        verticalAlign: "top",
        // Avatar
        [r]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: v
        }, gn(l)),
        [`${r}-circle`]: {
          borderRadius: "50%"
        },
        [`${r}-lg`]: Object.assign({}, gn(c)),
        [`${r}-sm`]: Object.assign({}, gn(u))
      },
      [`${t}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [n]: {
          width: "100%",
          height: m,
          background: v,
          borderRadius: f,
          [`+ ${a}`]: {
            marginBlockStart: u
          }
        },
        // paragraph
        [a]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: y,
            listStyle: "none",
            background: v,
            borderRadius: f,
            "+ li": {
              marginBlockStart: p
            }
          }
        },
        [`${a}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${t}-content`]: {
        [`${n}, ${a} > li`]: {
          borderRadius: g
        }
      }
    },
    [`${t}-with-avatar ${t}-content`]: {
      // Title
      [n]: {
        marginBlockStart: b,
        [`+ ${a}`]: {
          marginBlockStart: C
        }
      }
    },
    // Skeleton element
    [`${t}${t}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, xg(e)), Sg(e)), Eg(e)), wg(e)),
    // Skeleton Block Button, Input
    [`${t}${t}-block`]: {
      width: "100%",
      [i]: {
        width: "100%"
      },
      [o]: {
        width: "100%"
      }
    },
    // With active animation
    [`${t}${t}-active`]: {
      [`
        ${n},
        ${a} > li,
        ${r},
        ${i},
        ${o},
        ${s}
      `]: Object.assign({}, Cg(e))
    }
  };
}, Pg = (e) => {
  const {
    colorFillContent: t,
    colorFill: r
  } = e, n = t, a = r;
  return {
    color: n,
    colorGradientEnd: a,
    gradientFromColor: n,
    gradientToColor: a,
    titleHeight: e.controlHeight / 2,
    blockRadius: e.borderRadiusSM,
    paragraphMarginTop: e.marginLG + e.marginXXS,
    paragraphLiHeight: e.controlHeight / 2
  };
}, Rn = Ss("Skeleton", (e) => {
  const {
    componentCls: t,
    calc: r
  } = e, n = ya(e, {
    skeletonAvatarCls: `${t}-avatar`,
    skeletonTitleCls: `${t}-title`,
    skeletonParagraphCls: `${t}-paragraph`,
    skeletonButtonCls: `${t}-button`,
    skeletonInputCls: `${t}-input`,
    skeletonImageCls: `${t}-image`,
    imageSizeBase: r(e.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${e.gradientFromColor} 25%, ${e.gradientToColor} 37%, ${e.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return [_g(n)];
}, Pg, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
}), Ga = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    style: a,
    active: i,
    children: o
  } = e, {
    getPrefixCls: s
  } = d.useContext(Mt), l = s("skeleton", t), [c, u, v] = Rn(l), h = ne(l, `${l}-element`, {
    [`${l}-active`]: i
  }, u, r, n, v);
  return c(/* @__PURE__ */ d.createElement("div", {
    className: h
  }, /* @__PURE__ */ d.createElement("div", {
    className: ne(`${l}-image`, r),
    style: a
  }, o)));
}, $g = () => /* @__PURE__ */ Q.createElement(as, { justify: "center", vertical: !0, gap: 8 }, /* @__PURE__ */ Q.createElement(Ga, { active: !0, style: { width: "672px", height: "20px" } }), /* @__PURE__ */ Q.createElement(Ga, { active: !0, style: { width: "672px", height: "20px" } }), /* @__PURE__ */ Q.createElement(Ga, { active: !0, style: { width: "672px", height: "20px" } }));
function Ur(e, t) {
  var r = Object.assign({}, e);
  return Array.isArray(t) && t.forEach(function(n) {
    delete r[n];
  }), r;
}
const Vu = (e) => {
  const t = Q.useContext(wn);
  return Q.useMemo(() => e ? typeof e == "string" ? e ?? t : typeof e == "function" ? e(t) : t : t, [e, t]);
}, bi = (e) => {
  const {
    prefixCls: t,
    className: r,
    style: n,
    size: a,
    shape: i
  } = e, o = ne({
    [`${t}-lg`]: a === "large",
    [`${t}-sm`]: a === "small"
  }), s = ne({
    [`${t}-circle`]: i === "circle",
    [`${t}-square`]: i === "square",
    [`${t}-round`]: i === "round"
  }), l = d.useMemo(() => typeof a == "number" ? {
    width: a,
    height: a,
    lineHeight: `${a}px`
  } : {}, [a]);
  return /* @__PURE__ */ d.createElement("span", {
    className: ne(t, o, s, r),
    style: Object.assign(Object.assign({}, l), n)
  });
}, Og = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    active: a,
    shape: i = "circle",
    size: o = "default"
  } = e, {
    getPrefixCls: s
  } = d.useContext(Mt), l = s("skeleton", t), [c, u, v] = Rn(l), h = Ur(e, ["prefixCls", "className"]), b = ne(l, `${l}-element`, {
    [`${l}-active`]: a
  }, r, n, u, v);
  return c(/* @__PURE__ */ d.createElement("div", {
    className: b
  }, /* @__PURE__ */ d.createElement(bi, Object.assign({
    prefixCls: `${l}-avatar`,
    shape: i,
    size: o
  }, h))));
}, Mg = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    active: a,
    block: i = !1,
    size: o = "default"
  } = e, {
    getPrefixCls: s
  } = d.useContext(Mt), l = s("skeleton", t), [c, u, v] = Rn(l), h = Ur(e, ["prefixCls"]), b = ne(l, `${l}-element`, {
    [`${l}-active`]: a,
    [`${l}-block`]: i
  }, r, n, u, v);
  return c(/* @__PURE__ */ d.createElement("div", {
    className: b
  }, /* @__PURE__ */ d.createElement(bi, Object.assign({
    prefixCls: `${l}-button`,
    size: o
  }, h))));
}, Rg = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", Ng = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    style: a,
    active: i
  } = e, {
    getPrefixCls: o
  } = d.useContext(Mt), s = o("skeleton", t), [l, c, u] = Rn(s), v = ne(s, `${s}-element`, {
    [`${s}-active`]: i
  }, r, n, c, u);
  return l(/* @__PURE__ */ d.createElement("div", {
    className: v
  }, /* @__PURE__ */ d.createElement("div", {
    className: ne(`${s}-image`, r),
    style: a
  }, /* @__PURE__ */ d.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${s}-image-svg`
  }, /* @__PURE__ */ d.createElement("title", null, "Image placeholder"), /* @__PURE__ */ d.createElement("path", {
    d: Rg,
    className: `${s}-image-path`
  })))));
}, Tg = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    active: a,
    block: i,
    size: o = "default"
  } = e, {
    getPrefixCls: s
  } = d.useContext(Mt), l = s("skeleton", t), [c, u, v] = Rn(l), h = Ur(e, ["prefixCls"]), b = ne(l, `${l}-element`, {
    [`${l}-active`]: a,
    [`${l}-block`]: i
  }, r, n, u, v);
  return c(/* @__PURE__ */ d.createElement("div", {
    className: b
  }, /* @__PURE__ */ d.createElement(bi, Object.assign({
    prefixCls: `${l}-input`,
    size: o
  }, h))));
}, Ig = (e, t) => {
  const {
    width: r,
    rows: n = 2
  } = t;
  if (Array.isArray(r))
    return r[e];
  if (n - 1 === e)
    return r;
}, Ag = (e) => {
  const {
    prefixCls: t,
    className: r,
    style: n,
    rows: a = 0
  } = e, i = Array.from({
    length: a
  }).map((o, s) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ d.createElement("li", {
      key: s,
      style: {
        width: Ig(s, e)
      }
    })
  ));
  return /* @__PURE__ */ d.createElement("ul", {
    className: ne(t, r),
    style: n
  }, i);
}, kg = ({
  prefixCls: e,
  className: t,
  width: r,
  style: n
}) => (
  // biome-ignore lint/a11y/useHeadingContent: HOC here
  /* @__PURE__ */ d.createElement("h3", {
    className: ne(e, t),
    style: Object.assign({
      width: r
    }, n)
  })
);
function Ji(e) {
  return e && typeof e == "object" ? e : {};
}
function Fg(e, t) {
  return e && !t ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function Dg(e, t) {
  return !e && t ? {
    width: "38%"
  } : e && t ? {
    width: "50%"
  } : {};
}
function Lg(e, t) {
  const r = {};
  return (!e || !t) && (r.width = "61%"), !e && t ? r.rows = 3 : r.rows = 2, r;
}
const Gr = (e) => {
  const {
    prefixCls: t,
    loading: r,
    className: n,
    rootClassName: a,
    style: i,
    children: o,
    avatar: s = !1,
    title: l = !0,
    paragraph: c = !0,
    active: u,
    round: v
  } = e, {
    getPrefixCls: h,
    direction: b,
    className: g,
    style: m
  } = ih("skeleton"), f = h("skeleton", t), [y, p, C] = Rn(f);
  if (r || !("loading" in e)) {
    const S = !!s, E = !!l, w = !!c;
    let P;
    if (S) {
      const _ = Object.assign(Object.assign({
        prefixCls: `${f}-avatar`
      }, Fg(E, w)), Ji(s));
      P = /* @__PURE__ */ d.createElement("div", {
        className: `${f}-header`
      }, /* @__PURE__ */ d.createElement(bi, Object.assign({}, _)));
    }
    let N;
    if (E || w) {
      let _;
      if (E) {
        const R = Object.assign(Object.assign({
          prefixCls: `${f}-title`
        }, Dg(S, w)), Ji(l));
        _ = /* @__PURE__ */ d.createElement(kg, Object.assign({}, R));
      }
      let x;
      if (w) {
        const R = Object.assign(Object.assign({
          prefixCls: `${f}-paragraph`
        }, Lg(S, E)), Ji(c));
        x = /* @__PURE__ */ d.createElement(Ag, Object.assign({}, R));
      }
      N = /* @__PURE__ */ d.createElement("div", {
        className: `${f}-content`
      }, _, x);
    }
    const M = ne(f, {
      [`${f}-with-avatar`]: S,
      [`${f}-active`]: u,
      [`${f}-rtl`]: b === "rtl",
      [`${f}-round`]: v
    }, g, n, a, p, C);
    return y(/* @__PURE__ */ d.createElement("div", {
      className: M,
      style: Object.assign(Object.assign({}, m), i)
    }, P, N));
  }
  return o ?? null;
};
Gr.Button = Mg;
Gr.Avatar = Og;
Gr.Input = Tg;
Gr.Image = Ng;
Gr.Node = Ga;
process.env.NODE_ENV !== "production" && (Gr.displayName = "Skeleton");
var Vg = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
function ju(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function jg(e) {
  return ju(e) instanceof ShadowRoot;
}
function ei(e) {
  return jg(e) ? ju(e) : null;
}
function zg(e) {
  return e.replace(/-(.)/g, function(t, r) {
    return r.toUpperCase();
  });
}
function Hg(e, t) {
  Ae(e, "[@ant-design/icons] ".concat(t));
}
function kl(e) {
  return le(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (le(e.icon) === "object" || typeof e.icon == "function");
}
function Fl() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, r) {
    var n = e[r];
    switch (r) {
      case "class":
        t.className = n, delete t.class;
        break;
      default:
        delete t[r], t[zg(r)] = n;
    }
    return t;
  }, {});
}
function Do(e, t, r) {
  return r ? /* @__PURE__ */ Q.createElement(e.tag, I(I({
    key: t
  }, Fl(e.attrs)), r), (e.children || []).map(function(n, a) {
    return Do(n, "".concat(t, "-").concat(e.tag, "-").concat(a));
  })) : /* @__PURE__ */ Q.createElement(e.tag, I({
    key: t
  }, Fl(e.attrs)), (e.children || []).map(function(n, a) {
    return Do(n, "".concat(t, "-").concat(e.tag, "-").concat(a));
  }));
}
function zu(e) {
  return ua(e)[0];
}
function Hu(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var Bg = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, Wg = function(t) {
  var r = Lr(hs), n = r.csp, a = r.prefixCls, i = r.layer, o = Bg;
  a && (o = o.replace(/anticon/g, a)), i && (o = "@layer ".concat(i, ` {
`).concat(o, `
}`)), gt(function() {
    var s = t.current, l = ei(s);
    wr(o, "@ant-design-icons", {
      prepend: !i,
      csp: n,
      attachTo: l
    });
  }, []);
}, Kg = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], ea = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function qg(e) {
  var t = e.primaryColor, r = e.secondaryColor;
  ea.primaryColor = t, ea.secondaryColor = r || zu(t), ea.calculated = !!r;
}
function Ug() {
  return I({}, ea);
}
var Nn = function(t) {
  var r = t.icon, n = t.className, a = t.onClick, i = t.style, o = t.primaryColor, s = t.secondaryColor, l = Le(t, Kg), c = d.useRef(), u = ea;
  if (o && (u = {
    primaryColor: o,
    secondaryColor: s || zu(o)
  }), Wg(c), Hg(kl(r), "icon should be icon definiton, but got ".concat(r)), !kl(r))
    return null;
  var v = r;
  return v && typeof v.icon == "function" && (v = I(I({}, v), {}, {
    icon: v.icon(u.primaryColor, u.secondaryColor)
  })), Do(v.icon, "svg-".concat(v.name), I(I({
    className: n,
    onClick: a,
    style: i,
    "data-icon": v.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, l), {}, {
    ref: c
  }));
};
Nn.displayName = "IconReact";
Nn.getTwoToneColors = Ug;
Nn.setTwoToneColors = qg;
function Bu(e) {
  var t = Hu(e), r = F(t, 2), n = r[0], a = r[1];
  return Nn.setTwoToneColors({
    primaryColor: n,
    secondaryColor: a
  });
}
function Gg() {
  var e = Nn.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var Xg = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
Bu(Ja.primary);
var Tn = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.className, n = e.icon, a = e.spin, i = e.rotate, o = e.tabIndex, s = e.onClick, l = e.twoToneColor, c = Le(e, Xg), u = d.useContext(hs), v = u.prefixCls, h = v === void 0 ? "anticon" : v, b = u.rootClassName, g = ne(b, h, O(O({}, "".concat(h, "-").concat(n.name), !!n.name), "".concat(h, "-spin"), !!a || n.name === "loading"), r), m = o;
  m === void 0 && s && (m = -1);
  var f = i ? {
    msTransform: "rotate(".concat(i, "deg)"),
    transform: "rotate(".concat(i, "deg)")
  } : void 0, y = Hu(l), p = F(y, 2), C = p[0], S = p[1];
  return /* @__PURE__ */ d.createElement("span", he({
    role: "img",
    "aria-label": n.name
  }, c, {
    ref: t,
    tabIndex: m,
    onClick: s,
    className: g
  }), /* @__PURE__ */ d.createElement(Nn, {
    icon: n,
    primaryColor: C,
    secondaryColor: S,
    style: f
  }));
});
Tn.displayName = "AntdIcon";
Tn.getTwoToneColor = Gg;
Tn.setTwoToneColor = Bu;
var Yg = function(t, r) {
  return /* @__PURE__ */ d.createElement(Tn, he({}, t, {
    ref: r,
    icon: Vg
  }));
}, Wu = /* @__PURE__ */ d.forwardRef(Yg);
process.env.NODE_ENV !== "production" && (Wu.displayName = "CloseOutlined");
var Qg = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" }, Zg = function(t, r) {
  return /* @__PURE__ */ d.createElement(Tn, he({}, t, {
    ref: r,
    icon: Qg
  }));
}, Ku = /* @__PURE__ */ d.forwardRef(Zg);
process.env.NODE_ENV !== "production" && (Ku.displayName = "EllipsisOutlined");
var Jg = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" }, em = function(t, r) {
  return /* @__PURE__ */ d.createElement(Tn, he({}, t, {
    ref: r,
    icon: Jg
  }));
}, qu = /* @__PURE__ */ d.forwardRef(em);
process.env.NODE_ENV !== "production" && (qu.displayName = "PlusOutlined");
const Uu = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
}, Ci = /* @__PURE__ */ oi(null);
function xn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [];
  return Q.Children.forEach(e, function(n) {
    n == null && !t.keepEmpty || (Array.isArray(n) ? r = r.concat(xn(n)) : pu(n) && n.props ? r = r.concat(xn(n.props.children, t)) : r.push(n));
  }), r;
}
var Lo = /* @__PURE__ */ d.createContext(null);
function tm(e) {
  var t = e.children, r = e.onBatchResize, n = d.useRef(0), a = d.useRef([]), i = d.useContext(Lo), o = d.useCallback(function(s, l, c) {
    n.current += 1;
    var u = n.current;
    a.current.push({
      size: s,
      element: l,
      data: c
    }), Promise.resolve().then(function() {
      u === n.current && (r == null || r(a.current), a.current = []);
    }), i == null || i(s, l, c);
  }, [r, i]);
  return /* @__PURE__ */ d.createElement(Lo.Provider, {
    value: o
  }, t);
}
var Gu = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, r) {
    var n = -1;
    return t.some(function(a, i) {
      return a[0] === r ? (n = i, !0) : !1;
    }), n;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(r) {
        var n = e(this.__entries__, r), a = this.__entries__[n];
        return a && a[1];
      }, t.prototype.set = function(r, n) {
        var a = e(this.__entries__, r);
        ~a ? this.__entries__[a][1] = n : this.__entries__.push([r, n]);
      }, t.prototype.delete = function(r) {
        var n = this.__entries__, a = e(n, r);
        ~a && n.splice(a, 1);
      }, t.prototype.has = function(r) {
        return !!~e(this.__entries__, r);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(r, n) {
        n === void 0 && (n = null);
        for (var a = 0, i = this.__entries__; a < i.length; a++) {
          var o = i[a];
          r.call(n, o[1], o[0]);
        }
      }, t;
    }()
  );
}(), Vo = typeof window < "u" && typeof document < "u" && window.document === document, ti = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), rm = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(ti) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), nm = 2;
function am(e, t) {
  var r = !1, n = !1, a = 0;
  function i() {
    r && (r = !1, e()), n && s();
  }
  function o() {
    rm(i);
  }
  function s() {
    var l = Date.now();
    if (r) {
      if (l - a < nm)
        return;
      n = !0;
    } else
      r = !0, n = !1, setTimeout(o, t);
    a = l;
  }
  return s;
}
var im = 20, om = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], sm = typeof MutationObserver < "u", lm = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = am(this.refresh.bind(this), im);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var r = this.observers_, n = r.indexOf(t);
      ~n && r.splice(n, 1), !r.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return t.forEach(function(r) {
        return r.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !Vo || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), sm ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !Vo || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var r = t.propertyName, n = r === void 0 ? "" : r, a = om.some(function(i) {
        return !!~n.indexOf(i);
      });
      a && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), Xu = function(e, t) {
  for (var r = 0, n = Object.keys(t); r < n.length; r++) {
    var a = n[r];
    Object.defineProperty(e, a, {
      value: t[a],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, _n = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || ti;
}, Yu = Si(0, 0, 0, 0);
function ri(e) {
  return parseFloat(e) || 0;
}
function Dl(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.reduce(function(n, a) {
    var i = e["border-" + a + "-width"];
    return n + ri(i);
  }, 0);
}
function cm(e) {
  for (var t = ["top", "right", "bottom", "left"], r = {}, n = 0, a = t; n < a.length; n++) {
    var i = a[n], o = e["padding-" + i];
    r[i] = ri(o);
  }
  return r;
}
function um(e) {
  var t = e.getBBox();
  return Si(0, 0, t.width, t.height);
}
function dm(e) {
  var t = e.clientWidth, r = e.clientHeight;
  if (!t && !r)
    return Yu;
  var n = _n(e).getComputedStyle(e), a = cm(n), i = a.left + a.right, o = a.top + a.bottom, s = ri(n.width), l = ri(n.height);
  if (n.boxSizing === "border-box" && (Math.round(s + i) !== t && (s -= Dl(n, "left", "right") + i), Math.round(l + o) !== r && (l -= Dl(n, "top", "bottom") + o)), !vm(e)) {
    var c = Math.round(s + i) - t, u = Math.round(l + o) - r;
    Math.abs(c) !== 1 && (s -= c), Math.abs(u) !== 1 && (l -= u);
  }
  return Si(a.left, a.top, s, l);
}
var fm = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof _n(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof _n(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function vm(e) {
  return e === _n(e).document.documentElement;
}
function hm(e) {
  return Vo ? fm(e) ? um(e) : dm(e) : Yu;
}
function gm(e) {
  var t = e.x, r = e.y, n = e.width, a = e.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, o = Object.create(i.prototype);
  return Xu(o, {
    x: t,
    y: r,
    width: n,
    height: a,
    top: r,
    right: t + n,
    bottom: a + r,
    left: t
  }), o;
}
function Si(e, t, r, n) {
  return { x: e, y: t, width: r, height: n };
}
var mm = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Si(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = hm(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), pm = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, r) {
      var n = gm(r);
      Xu(this, { target: t, contentRect: n });
    }
    return e;
  }()
), ym = (
  /** @class */
  function() {
    function e(t, r, n) {
      if (this.activeObservations_ = [], this.observations_ = new Gu(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = r, this.callbackCtx_ = n;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof _n(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) || (r.set(t, new mm(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof _n(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) && (r.delete(t), r.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && t.activeObservations_.push(r);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, r = this.activeObservations_.map(function(n) {
          return new pm(n.target, n.broadcastRect());
        });
        this.callback_.call(t, r, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), Qu = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Gu(), Zu = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = lm.getInstance(), n = new ym(t, r, this);
      Qu.set(this, n);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  Zu.prototype[e] = function() {
    var t;
    return (t = Qu.get(this))[e].apply(t, arguments);
  };
});
var bm = function() {
  return typeof ti.ResizeObserver < "u" ? ti.ResizeObserver : Zu;
}(), Er = /* @__PURE__ */ new Map();
function Ju(e) {
  e.forEach(function(t) {
    var r, n = t.target;
    (r = Er.get(n)) === null || r === void 0 || r.forEach(function(a) {
      return a(n);
    });
  });
}
var ed = new bm(Ju);
process.env.NODE_ENV;
process.env.NODE_ENV;
function Cm(e, t) {
  Er.has(e) || (Er.set(e, /* @__PURE__ */ new Set()), ed.observe(e)), Er.get(e).add(t);
}
function Sm(e, t) {
  Er.has(e) && (Er.get(e).delete(t), Er.get(e).size || (ed.unobserve(e), Er.delete(e)));
}
var Em = /* @__PURE__ */ function(e) {
  Vr(r, e);
  var t = jr(r);
  function r() {
    return Rt(this, r), t.apply(this, arguments);
  }
  return Nt(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(d.Component);
function wm(e, t) {
  var r = e.children, n = e.disabled, a = d.useRef(null), i = d.useRef(null), o = d.useContext(Lo), s = typeof r == "function", l = s ? r(a) : r, c = d.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), u = !s && /* @__PURE__ */ d.isValidElement(l) && On(l), v = u ? pa(l) : null, h = ma(v, a), b = function() {
    var y;
    return Ua(a.current) || // Support `nativeElement` format
    (a.current && le(a.current) === "object" ? Ua((y = a.current) === null || y === void 0 ? void 0 : y.nativeElement) : null) || Ua(i.current);
  };
  d.useImperativeHandle(t, function() {
    return b();
  });
  var g = d.useRef(e);
  g.current = e;
  var m = d.useCallback(function(f) {
    var y = g.current, p = y.onResize, C = y.data, S = f.getBoundingClientRect(), E = S.width, w = S.height, P = f.offsetWidth, N = f.offsetHeight, M = Math.floor(E), _ = Math.floor(w);
    if (c.current.width !== M || c.current.height !== _ || c.current.offsetWidth !== P || c.current.offsetHeight !== N) {
      var x = {
        width: M,
        height: _,
        offsetWidth: P,
        offsetHeight: N
      };
      c.current = x;
      var R = P === Math.round(E) ? E : P, $ = N === Math.round(w) ? w : N, T = I(I({}, x), {}, {
        offsetWidth: R,
        offsetHeight: $
      });
      o == null || o(T, f, C), p && Promise.resolve().then(function() {
        p(T, f);
      });
    }
  }, []);
  return d.useEffect(function() {
    var f = b();
    return f && !n && Cm(f, m), function() {
      return Sm(f, m);
    };
  }, [a.current, n]), /* @__PURE__ */ d.createElement(Em, {
    ref: i
  }, u ? /* @__PURE__ */ d.cloneElement(l, {
    ref: h
  }) : l);
}
var td = /* @__PURE__ */ d.forwardRef(wm);
process.env.NODE_ENV !== "production" && (td.displayName = "SingleObserver");
var xm = "rc-observer-key";
function _m(e, t) {
  var r = e.children, n = typeof r == "function" ? [r] : xn(r);
  return process.env.NODE_ENV !== "production" && (n.length > 1 ? bn(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : n.length === 0 && bn(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), n.map(function(a, i) {
    var o = (a == null ? void 0 : a.key) || "".concat(xm, "-").concat(i);
    return /* @__PURE__ */ d.createElement(td, he({}, e, {
      key: o,
      ref: i === 0 ? t : void 0
    }), a);
  });
}
var xr = /* @__PURE__ */ d.forwardRef(_m);
process.env.NODE_ENV !== "production" && (xr.displayName = "ResizeObserver");
xr.Collection = tm;
var Pm = function(t) {
  var r = t.activeTabOffset, n = t.horizontal, a = t.rtl, i = t.indicator, o = i === void 0 ? {} : i, s = o.size, l = o.align, c = l === void 0 ? "center" : l, u = Ze(), v = F(u, 2), h = v[0], b = v[1], g = De(), m = Q.useCallback(function(y) {
    return typeof s == "function" ? s(y) : typeof s == "number" ? s : y;
  }, [s]);
  function f() {
    Jt.cancel(g.current);
  }
  return gt(function() {
    var y = {};
    if (r)
      if (n) {
        y.width = m(r.width);
        var p = a ? "right" : "left";
        c === "start" && (y[p] = r[p]), c === "center" && (y[p] = r[p] + r.width / 2, y.transform = a ? "translateX(50%)" : "translateX(-50%)"), c === "end" && (y[p] = r[p] + r.width, y.transform = "translateX(-100%)");
      } else
        y.height = m(r.height), c === "start" && (y.top = r.top), c === "center" && (y.top = r.top + r.height / 2, y.transform = "translateY(-50%)"), c === "end" && (y.top = r.top + r.height, y.transform = "translateY(-100%)");
    return f(), g.current = Jt(function() {
      var C = h && y && Object.keys(y).every(function(S) {
        var E = y[S], w = h[S];
        return typeof E == "number" && typeof w == "number" ? Math.round(E) === Math.round(w) : E === w;
      });
      C || b(y);
    }), f;
  }, [JSON.stringify(r), n, a, c, m]), {
    style: h
  };
}, Ll = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function $m(e, t, r) {
  return pn(function() {
    for (var n, a = /* @__PURE__ */ new Map(), i = t.get((n = e[0]) === null || n === void 0 ? void 0 : n.key) || Ll, o = i.left + i.width, s = 0; s < e.length; s += 1) {
      var l = e[s].key, c = t.get(l);
      if (!c) {
        var u;
        c = t.get((u = e[s - 1]) === null || u === void 0 ? void 0 : u.key) || Ll;
      }
      var v = a.get(l) || I({}, c);
      v.right = o - v.left - v.width, a.set(l, v);
    }
    return a;
  }, [e.map(function(n) {
    return n.key;
  }).join("_"), t, r]);
}
function Vl(e, t) {
  var r = d.useRef(e), n = d.useState({}), a = F(n, 2), i = a[1];
  function o(s) {
    var l = typeof s == "function" ? s(r.current) : s;
    l !== r.current && t(l, r.current), r.current = l, i({});
  }
  return [r.current, o];
}
var Om = 0.1, jl = 0.01, Xa = 20, zl = Math.pow(0.995, Xa);
function Mm(e, t) {
  var r = Ze(), n = F(r, 2), a = n[0], i = n[1], o = Ze(0), s = F(o, 2), l = s[0], c = s[1], u = Ze(0), v = F(u, 2), h = v[0], b = v[1], g = Ze(), m = F(g, 2), f = m[0], y = m[1], p = De();
  function C(M) {
    var _ = M.touches[0], x = _.screenX, R = _.screenY;
    i({
      x,
      y: R
    }), window.clearInterval(p.current);
  }
  function S(M) {
    if (a) {
      var _ = M.touches[0], x = _.screenX, R = _.screenY;
      i({
        x,
        y: R
      });
      var $ = x - a.x, T = R - a.y;
      t($, T);
      var A = Date.now();
      c(A), b(A - l), y({
        x: $,
        y: T
      });
    }
  }
  function E() {
    if (a && (i(null), y(null), f)) {
      var M = f.x / h, _ = f.y / h, x = Math.abs(M), R = Math.abs(_);
      if (Math.max(x, R) < Om) return;
      var $ = M, T = _;
      p.current = window.setInterval(function() {
        if (Math.abs($) < jl && Math.abs(T) < jl) {
          window.clearInterval(p.current);
          return;
        }
        $ *= zl, T *= zl, t($ * Xa, T * Xa);
      }, Xa);
    }
  }
  var w = De();
  function P(M) {
    var _ = M.deltaX, x = M.deltaY, R = 0, $ = Math.abs(_), T = Math.abs(x);
    $ === T ? R = w.current === "x" ? _ : x : $ > T ? (R = _, w.current = "x") : (R = x, w.current = "y"), t(-R, -R) && M.preventDefault();
  }
  var N = De(null);
  N.current = {
    onTouchStart: C,
    onTouchMove: S,
    onTouchEnd: E,
    onWheel: P
  }, d.useEffect(function() {
    function M($) {
      N.current.onTouchStart($);
    }
    function _($) {
      N.current.onTouchMove($);
    }
    function x($) {
      N.current.onTouchEnd($);
    }
    function R($) {
      N.current.onWheel($);
    }
    return document.addEventListener("touchmove", _, {
      passive: !1
    }), document.addEventListener("touchend", x, {
      passive: !0
    }), e.current.addEventListener("touchstart", M, {
      passive: !0
    }), e.current.addEventListener("wheel", R, {
      passive: !1
    }), function() {
      document.removeEventListener("touchmove", _), document.removeEventListener("touchend", x);
    };
  }, []);
}
function rd(e) {
  var t = Ze(0), r = F(t, 2), n = r[0], a = r[1], i = De(0), o = De();
  return o.current = e, co(function() {
    var s;
    (s = o.current) === null || s === void 0 || s.call(o);
  }, [n]), function() {
    i.current === n && (i.current += 1, a(i.current));
  };
}
function Rm(e) {
  var t = De([]), r = Ze({}), n = F(r, 2), a = n[1], i = De(typeof e == "function" ? e() : e), o = rd(function() {
    var l = i.current;
    t.current.forEach(function(c) {
      l = c(l);
    }), t.current = [], i.current = l, a({});
  });
  function s(l) {
    t.current.push(l), o();
  }
  return [i.current, s];
}
var Hl = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
function Nm(e, t, r, n, a, i, o) {
  var s = o.tabs, l = o.tabPosition, c = o.rtl, u, v, h;
  return ["top", "bottom"].includes(l) ? (u = "width", v = c ? "right" : "left", h = Math.abs(r)) : (u = "height", v = "top", h = -r), pn(function() {
    if (!s.length)
      return [0, 0];
    for (var b = s.length, g = b, m = 0; m < b; m += 1) {
      var f = e.get(s[m].key) || Hl;
      if (Math.floor(f[v] + f[u]) > Math.floor(h + t)) {
        g = m - 1;
        break;
      }
    }
    for (var y = 0, p = b - 1; p >= 0; p -= 1) {
      var C = e.get(s[p].key) || Hl;
      if (C[v] < h) {
        y = p + 1;
        break;
      }
    }
    return y >= g ? [0, 0] : [y, g];
  }, [e, t, n, a, i, h, l, s.map(function(b) {
    return b.key;
  }).join("_"), c]);
}
function Bl(e) {
  var t;
  return e instanceof Map ? (t = {}, e.forEach(function(r, n) {
    t[n] = r;
  })) : t = e, JSON.stringify(t);
}
var Tm = "TABS_DQ";
function nd(e) {
  return String(e).replace(/"/g, Tm);
}
function ws(e, t, r, n) {
  return (
    // Only editable tabs can be removed
    !(!r || // Tabs cannot be removed when disabled
    n || // closable is false
    e === !1 || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    e === void 0 && (t === !1 || t === null))
  );
}
var ad = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.editable, a = e.locale, i = e.style;
  return !n || n.showAdd === !1 ? null : /* @__PURE__ */ d.createElement("button", {
    ref: t,
    type: "button",
    className: "".concat(r, "-nav-add"),
    style: i,
    "aria-label": (a == null ? void 0 : a.addAriaLabel) || "Add tab",
    onClick: function(s) {
      n.onEdit("add", {
        event: s
      });
    }
  }, n.addIcon || "+");
}), jo = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.position, n = e.prefixCls, a = e.extra;
  if (!a)
    return null;
  var i, o = {};
  return le(a) === "object" && !/* @__PURE__ */ d.isValidElement(a) ? o = a : o.right = a, r === "right" && (i = o.right), r === "left" && (i = o.left), i ? /* @__PURE__ */ d.createElement("div", {
    className: "".concat(n, "-extra-content"),
    ref: t
  }, i) : null;
});
process.env.NODE_ENV !== "production" && (jo.displayName = "ExtraContent");
var id = /* @__PURE__ */ d.createContext(null), Wl = [];
function Im(e, t) {
  var r = d.useState(function() {
    if (!Gt())
      return null;
    var g = document.createElement("div");
    return process.env.NODE_ENV !== "production" && t && g.setAttribute("data-debug", t), g;
  }), n = F(r, 1), a = n[0], i = d.useRef(!1), o = d.useContext(id), s = d.useState(Wl), l = F(s, 2), c = l[0], u = l[1], v = o || (i.current ? void 0 : function(g) {
    u(function(m) {
      var f = [g].concat(te(m));
      return f;
    });
  });
  function h() {
    a.parentElement || document.body.appendChild(a), i.current = !0;
  }
  function b() {
    var g;
    (g = a.parentElement) === null || g === void 0 || g.removeChild(a), i.current = !1;
  }
  return Vt(function() {
    return e ? o ? o(h) : h() : b(), b;
  }, [e]), Vt(function() {
    c.length && (c.forEach(function(g) {
      return g();
    }), u(Wl));
  }, [c]), [a, v];
}
function Am(e) {
  var t = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), r = document.createElement("div");
  r.id = t;
  var n = r.style;
  n.position = "absolute", n.left = "0", n.top = "0", n.width = "100px", n.height = "100px", n.overflow = "scroll";
  var a, i;
  if (e) {
    var o = getComputedStyle(e);
    n.scrollbarColor = o.scrollbarColor, n.scrollbarWidth = o.scrollbarWidth;
    var s = getComputedStyle(e, "::-webkit-scrollbar"), l = parseInt(s.width, 10), c = parseInt(s.height, 10);
    try {
      var u = l ? "width: ".concat(s.width, ";") : "", v = c ? "height: ".concat(s.height, ";") : "";
      wr(`
#`.concat(t, `::-webkit-scrollbar {
`).concat(u, `
`).concat(v, `
}`), t);
    } catch (g) {
      console.error(g), a = l, i = c;
    }
  }
  document.body.appendChild(r);
  var h = e && a && !isNaN(a) ? a : r.offsetWidth - r.clientWidth, b = e && i && !isNaN(i) ? i : r.offsetHeight - r.clientHeight;
  return document.body.removeChild(r), aa(t), {
    width: h,
    height: b
  };
}
function km(e) {
  return typeof document > "u" || !e || !(e instanceof Element) ? {
    width: 0,
    height: 0
  } : Am(e);
}
function Fm() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var Dm = "rc-util-locker-".concat(Date.now()), Kl = 0;
function Lm(e) {
  var t = !!e, r = d.useState(function() {
    return Kl += 1, "".concat(Dm, "_").concat(Kl);
  }), n = F(r, 1), a = n[0];
  Vt(function() {
    if (t) {
      var i = km(document.body).width, o = Fm();
      wr(`
html body {
  overflow-y: hidden;
  `.concat(o ? "width: calc(100% - ".concat(i, "px);") : "", `
}`), a);
    } else
      aa(a);
    return function() {
      aa(a);
    };
  }, [t, a]);
}
var Vm = !1;
function jm(e) {
  return Vm;
}
var ql = function(t) {
  return t === !1 ? !1 : !Gt() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, xs = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.open, n = e.autoLock, a = e.getContainer, i = e.debug, o = e.autoDestroy, s = o === void 0 ? !0 : o, l = e.children, c = d.useState(r), u = F(c, 2), v = u[0], h = u[1], b = v || r;
  process.env.NODE_ENV !== "production" && Ae(Gt() || !r, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), d.useEffect(function() {
    (s || r) && h(r);
  }, [r, s]);
  var g = d.useState(function() {
    return ql(a);
  }), m = F(g, 2), f = m[0], y = m[1];
  d.useEffect(function() {
    var R = ql(a);
    y(R ?? null);
  });
  var p = Im(b && !f, i), C = F(p, 2), S = C[0], E = C[1], w = f ?? S;
  Lm(n && r && Gt() && (w === S || w === document.body));
  var P = null;
  if (l && On(l) && t) {
    var N = l;
    P = N.ref;
  }
  var M = ma(P, t);
  if (!b || !Gt() || f === void 0)
    return null;
  var _ = w === !1 || jm(), x = l;
  return t && (x = /* @__PURE__ */ d.cloneElement(l, {
    ref: M
  })), /* @__PURE__ */ d.createElement(id.Provider, {
    value: E
  }, _ ? x : /* @__PURE__ */ qd(x, w));
});
process.env.NODE_ENV !== "production" && (xs.displayName = "Portal");
function zm() {
  var e = I({}, d);
  return e.useId;
}
var Ul = 0, Gl = zm();
const Hm = Gl ? (
  // Use React `useId`
  function(t) {
    var r = Gl();
    return t || (process.env.NODE_ENV === "test" ? "test-id" : r);
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var r = d.useState("ssr-id"), n = F(r, 2), a = n[0], i = n[1];
    return d.useEffect(function() {
      var o = Ul;
      Ul += 1, i("rc_unique_".concat(o));
    }, []), t || (process.env.NODE_ENV === "test" ? "test-id" : a);
  }
);
function Bm(e) {
  var t = e.prefixCls, r = e.align, n = e.arrow, a = e.arrowPos, i = n || {}, o = i.className, s = i.content, l = a.x, c = l === void 0 ? 0 : l, u = a.y, v = u === void 0 ? 0 : u, h = d.useRef();
  if (!r || !r.points)
    return null;
  var b = {
    position: "absolute"
  };
  if (r.autoArrow !== !1) {
    var g = r.points[0], m = r.points[1], f = g[0], y = g[1], p = m[0], C = m[1];
    f === p || !["t", "b"].includes(f) ? b.top = v : f === "t" ? b.top = 0 : b.bottom = 0, y === C || !["l", "r"].includes(y) ? b.left = c : y === "l" ? b.left = 0 : b.right = 0;
  }
  return /* @__PURE__ */ d.createElement("div", {
    ref: h,
    className: ne("".concat(t, "-arrow"), o),
    style: b
  }, s);
}
function Wm(e) {
  var t = e.prefixCls, r = e.open, n = e.zIndex, a = e.mask, i = e.motion;
  return a ? /* @__PURE__ */ d.createElement(ba, he({}, i, {
    motionAppear: !0,
    visible: r,
    removeOnLeave: !0
  }), function(o) {
    var s = o.className;
    return /* @__PURE__ */ d.createElement("div", {
      style: {
        zIndex: n
      },
      className: ne("".concat(t, "-mask"), s)
    });
  }) : null;
}
var od = /* @__PURE__ */ d.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
});
process.env.NODE_ENV !== "production" && (od.displayName = "PopupContent");
var sd = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.popup, n = e.className, a = e.prefixCls, i = e.style, o = e.target, s = e.onVisibleChanged, l = e.open, c = e.keepDom, u = e.fresh, v = e.onClick, h = e.mask, b = e.arrow, g = e.arrowPos, m = e.align, f = e.motion, y = e.maskMotion, p = e.forceRender, C = e.getPopupContainer, S = e.autoDestroy, E = e.portal, w = e.zIndex, P = e.onMouseEnter, N = e.onMouseLeave, M = e.onPointerEnter, _ = e.onPointerDownCapture, x = e.ready, R = e.offsetX, $ = e.offsetY, T = e.offsetR, A = e.offsetB, D = e.onAlign, z = e.onPrepare, V = e.stretch, k = e.targetWidth, B = e.targetHeight, q = typeof r == "function" ? r() : r, W = l || c, H = (C == null ? void 0 : C.length) > 0, j = d.useState(!C || !H), K = F(j, 2), J = K[0], Z = K[1];
  if (Vt(function() {
    !J && H && o && Z(!0);
  }, [J, H, o]), !J)
    return null;
  var ae = "auto", oe = {
    left: "-1000vw",
    top: "-1000vh",
    right: ae,
    bottom: ae
  };
  if (x || !l) {
    var fe, me = m.points, ue = m.dynamicInset || ((fe = m._experimental) === null || fe === void 0 ? void 0 : fe.dynamicInset), Ce = ue && me[0][1] === "r", L = ue && me[0][0] === "b";
    Ce ? (oe.right = T, oe.left = ae) : (oe.left = R, oe.right = ae), L ? (oe.bottom = A, oe.top = ae) : (oe.top = $, oe.bottom = ae);
  }
  var de = {};
  return V && (V.includes("height") && B ? de.height = B : V.includes("minHeight") && B && (de.minHeight = B), V.includes("width") && k ? de.width = k : V.includes("minWidth") && k && (de.minWidth = k)), l || (de.pointerEvents = "none"), /* @__PURE__ */ d.createElement(E, {
    open: p || W,
    getContainer: C && function() {
      return C(o);
    },
    autoDestroy: S
  }, /* @__PURE__ */ d.createElement(Wm, {
    prefixCls: a,
    open: l,
    zIndex: w,
    mask: h,
    motion: y
  }), /* @__PURE__ */ d.createElement(xr, {
    onResize: D,
    disabled: !l
  }, function(ye) {
    return /* @__PURE__ */ d.createElement(ba, he({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: p,
      leavedClassName: "".concat(a, "-hidden")
    }, f, {
      onAppearPrepare: z,
      onEnterPrepare: z,
      visible: l,
      onVisibleChanged: function(Oe) {
        var He;
        f == null || (He = f.onVisibleChanged) === null || He === void 0 || He.call(f, Oe), s(Oe);
      }
    }), function(Ge, Oe) {
      var He = Ge.className, ve = Ge.style, U = ne(a, He, n);
      return /* @__PURE__ */ d.createElement("div", {
        ref: hi(ye, t, Oe),
        className: U,
        style: I(I(I(I({
          "--arrow-x": "".concat(g.x || 0, "px"),
          "--arrow-y": "".concat(g.y || 0, "px")
        }, oe), de), ve), {}, {
          boxSizing: "border-box",
          zIndex: w
        }, i),
        onMouseEnter: P,
        onMouseLeave: N,
        onPointerEnter: M,
        onClick: v,
        onPointerDownCapture: _
      }, b && /* @__PURE__ */ d.createElement(Bm, {
        prefixCls: a,
        arrow: b,
        arrowPos: g,
        align: m
      }), /* @__PURE__ */ d.createElement(od, {
        cache: !l && !u
      }, q));
    });
  }));
});
process.env.NODE_ENV !== "production" && (sd.displayName = "Popup");
var ld = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.children, n = e.getTriggerDOMNode, a = On(r), i = d.useCallback(function(s) {
    ps(t, n ? n(s) : s);
  }, [n]), o = ma(i, pa(r));
  return a ? /* @__PURE__ */ d.cloneElement(r, {
    ref: o
  }) : r;
});
process.env.NODE_ENV !== "production" && (ld.displayName = "TriggerWrapper");
var Xl = /* @__PURE__ */ d.createContext(null);
function Yl(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function Km(e, t, r, n) {
  return d.useMemo(function() {
    var a = Yl(r ?? t), i = Yl(n ?? t), o = new Set(a), s = new Set(i);
    return e && (o.has("hover") && (o.delete("hover"), o.add("click")), s.has("hover") && (s.delete("hover"), s.add("click"))), [o, s];
  }, [e, t, r, n]);
}
const cd = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), r = t.width, n = t.height;
      if (r || n)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var a = e.getBoundingClientRect(), i = a.width, o = a.height;
      if (i || o)
        return !0;
    }
  }
  return !1;
};
function qm() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = arguments.length > 2 ? arguments[2] : void 0;
  return r ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function Um(e, t, r, n) {
  for (var a = r.points, i = Object.keys(e), o = 0; o < i.length; o += 1) {
    var s, l = i[o];
    if (qm((s = e[l]) === null || s === void 0 ? void 0 : s.points, a, n))
      return "".concat(t, "-placement-").concat(l);
  }
  return "";
}
function Ql(e, t, r, n) {
  return t || (r ? {
    motionName: "".concat(e, "-").concat(r)
  } : n ? {
    motionName: n
  } : null);
}
function Ca(e) {
  return e.ownerDocument.defaultView;
}
function zo(e) {
  for (var t = [], r = e == null ? void 0 : e.parentElement, n = ["hidden", "scroll", "clip", "auto"]; r; ) {
    var a = Ca(r).getComputedStyle(r), i = a.overflowX, o = a.overflowY, s = a.overflow;
    [i, o, s].some(function(l) {
      return n.includes(l);
    }) && t.push(r), r = r.parentElement;
  }
  return t;
}
function va(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function Un(e) {
  return va(parseFloat(e), 0);
}
function Zl(e, t) {
  var r = I({}, e);
  return (t || []).forEach(function(n) {
    if (!(n instanceof HTMLBodyElement || n instanceof HTMLHtmlElement)) {
      var a = Ca(n).getComputedStyle(n), i = a.overflow, o = a.overflowClipMargin, s = a.borderTopWidth, l = a.borderBottomWidth, c = a.borderLeftWidth, u = a.borderRightWidth, v = n.getBoundingClientRect(), h = n.offsetHeight, b = n.clientHeight, g = n.offsetWidth, m = n.clientWidth, f = Un(s), y = Un(l), p = Un(c), C = Un(u), S = va(Math.round(v.width / g * 1e3) / 1e3), E = va(Math.round(v.height / h * 1e3) / 1e3), w = (g - m - p - C) * S, P = (h - b - f - y) * E, N = f * E, M = y * E, _ = p * S, x = C * S, R = 0, $ = 0;
      if (i === "clip") {
        var T = Un(o);
        R = T * S, $ = T * E;
      }
      var A = v.x + _ - R, D = v.y + N - $, z = A + v.width + 2 * R - _ - x - w, V = D + v.height + 2 * $ - N - M - P;
      r.left = Math.max(r.left, A), r.top = Math.max(r.top, D), r.right = Math.min(r.right, z), r.bottom = Math.min(r.bottom, V);
    }
  }), r;
}
function Jl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = "".concat(t), n = r.match(/^(.*)\%$/);
  return n ? e * (parseFloat(n[1]) / 100) : parseFloat(r);
}
function ec(e, t) {
  var r = t || [], n = F(r, 2), a = n[0], i = n[1];
  return [Jl(e.width, a), Jl(e.height, i)];
}
function tc() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function tn(e, t) {
  var r = t[0], n = t[1], a, i;
  return r === "t" ? i = e.y : r === "b" ? i = e.y + e.height : i = e.y + e.height / 2, n === "l" ? a = e.x : n === "r" ? a = e.x + e.width : a = e.x + e.width / 2, {
    x: a,
    y: i
  };
}
function Ir(e, t) {
  var r = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(n, a) {
    return a === t ? r[n] || "c" : n;
  }).join("");
}
function Gm(e, t, r, n, a, i, o) {
  var s = d.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: a[n] || {}
  }), l = F(s, 2), c = l[0], u = l[1], v = d.useRef(0), h = d.useMemo(function() {
    return t ? zo(t) : [];
  }, [t]), b = d.useRef({}), g = function() {
    b.current = {};
  };
  e || g();
  var m = Ut(function() {
    if (t && r && e) {
      let ar = function(Jr, Rr) {
        var Nr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : tt, Fn = j.x + Jr, $a = j.y + Rr, Pi = Fn + Ce, $i = $a + ue, Oi = Math.max(Fn, Nr.left), Y = Math.max($a, Nr.top), ce = Math.min(Pi, Nr.right), et = Math.min($i, Nr.bottom);
        return Math.max(0, (ce - Oi) * (et - Y));
      }, Pa = function() {
        ft = j.y + ie, At = ft + ue, _t = j.x + X, kt = _t + Ce;
      };
      var p, C, S, E, w = t, P = w.ownerDocument, N = Ca(w), M = N.getComputedStyle(w), _ = M.width, x = M.height, R = M.position, $ = w.style.left, T = w.style.top, A = w.style.right, D = w.style.bottom, z = w.style.overflow, V = I(I({}, a[n]), i), k = P.createElement("div");
      (p = w.parentElement) === null || p === void 0 || p.appendChild(k), k.style.left = "".concat(w.offsetLeft, "px"), k.style.top = "".concat(w.offsetTop, "px"), k.style.position = R, k.style.height = "".concat(w.offsetHeight, "px"), k.style.width = "".concat(w.offsetWidth, "px"), w.style.left = "0", w.style.top = "0", w.style.right = "auto", w.style.bottom = "auto", w.style.overflow = "hidden";
      var B;
      if (Array.isArray(r))
        B = {
          x: r[0],
          y: r[1],
          width: 0,
          height: 0
        };
      else {
        var q, W, H = r.getBoundingClientRect();
        H.x = (q = H.x) !== null && q !== void 0 ? q : H.left, H.y = (W = H.y) !== null && W !== void 0 ? W : H.top, B = {
          x: H.x,
          y: H.y,
          width: H.width,
          height: H.height
        };
      }
      var j = w.getBoundingClientRect();
      j.x = (C = j.x) !== null && C !== void 0 ? C : j.left, j.y = (S = j.y) !== null && S !== void 0 ? S : j.top;
      var K = P.documentElement, J = K.clientWidth, Z = K.clientHeight, ae = K.scrollWidth, oe = K.scrollHeight, fe = K.scrollTop, me = K.scrollLeft, ue = j.height, Ce = j.width, L = B.height, de = B.width, ye = {
        left: 0,
        top: 0,
        right: J,
        bottom: Z
      }, Ge = {
        left: -me,
        top: -fe,
        right: ae - me,
        bottom: oe - fe
      }, Oe = V.htmlRegion, He = "visible", ve = "visibleFirst";
      Oe !== "scroll" && Oe !== ve && (Oe = He);
      var U = Oe === ve, pe = Zl(Ge, h), se = Zl(ye, h), tt = Oe === He ? se : pe, Ie = U ? se : tt;
      w.style.left = "auto", w.style.top = "auto", w.style.right = "0", w.style.bottom = "0";
      var ge = w.getBoundingClientRect();
      w.style.left = $, w.style.top = T, w.style.right = A, w.style.bottom = D, w.style.overflow = z, (E = w.parentElement) === null || E === void 0 || E.removeChild(k);
      var mt = va(Math.round(Ce / parseFloat(_) * 1e3) / 1e3), qe = va(Math.round(ue / parseFloat(x) * 1e3) / 1e3);
      if (mt === 0 || qe === 0 || fa(r) && !cd(r))
        return;
      var Xe = V.offset, pt = V.targetOffset, at = ec(j, Xe), Ye = F(at, 2), Ve = Ye[0], Ue = Ye[1], xt = ec(B, pt), Me = F(xt, 2), Re = Me[0], dt = Me[1];
      B.x -= Re, B.y -= dt;
      var Xt = V.points || [], Bt = F(Xt, 2), jt = Bt[0], er = Bt[1], st = tc(er), Qe = tc(jt), Je = tn(B, st), xe = tn(j, Qe), ee = I({}, V), X = Je.x - xe.x + Ve, ie = Je.y - xe.y + Ue, Ee = ar(X, ie), we = ar(X, ie, se), Tt = tn(B, ["t", "l"]), _e = tn(j, ["t", "l"]), zt = tn(B, ["b", "r"]), tr = tn(j, ["b", "r"]), Pe = V.overflow || {}, je = Pe.adjustX, yt = Pe.adjustY, rt = Pe.shiftX, It = Pe.shiftY, Wt = function(Rr) {
        return typeof Rr == "boolean" ? Rr : Rr >= 0;
      }, ft, At, _t, kt;
      Pa();
      var Ft = Wt(yt), vt = Qe[0] === st[0];
      if (Ft && Qe[0] === "t" && (At > Ie.bottom || b.current.bt)) {
        var nt = ie;
        vt ? nt -= ue - L : nt = Tt.y - tr.y - Ue;
        var br = ar(X, nt), $e = ar(X, nt, se);
        // Of course use larger one
        br > Ee || br === Ee && (!U || // Choose recommend one
        $e >= we) ? (b.current.bt = !0, ie = nt, Ue = -Ue, ee.points = [Ir(Qe, 0), Ir(st, 0)]) : b.current.bt = !1;
      }
      if (Ft && Qe[0] === "b" && (ft < Ie.top || b.current.tb)) {
        var re = ie;
        vt ? re += ue - L : re = zt.y - _e.y - Ue;
        var Ne = ar(X, re), ze = ar(X, re, se);
        // Of course use larger one
        Ne > Ee || Ne === Ee && (!U || // Choose recommend one
        ze >= we) ? (b.current.tb = !0, ie = re, Ue = -Ue, ee.points = [Ir(Qe, 0), Ir(st, 0)]) : b.current.tb = !1;
      }
      var it = Wt(je), lt = Qe[1] === st[1];
      if (it && Qe[1] === "l" && (kt > Ie.right || b.current.rl)) {
        var Dt = X;
        lt ? Dt -= Ce - de : Dt = Tt.x - tr.x - Ve;
        var bt = ar(Dt, ie), rr = ar(Dt, ie, se);
        // Of course use larger one
        bt > Ee || bt === Ee && (!U || // Choose recommend one
        rr >= we) ? (b.current.rl = !0, X = Dt, Ve = -Ve, ee.points = [Ir(Qe, 1), Ir(st, 1)]) : b.current.rl = !1;
      }
      if (it && Qe[1] === "r" && (_t < Ie.left || b.current.lr)) {
        var Ct = X;
        lt ? Ct += Ce - de : Ct = zt.x - _e.x - Ve;
        var lr = ar(Ct, ie), $r = ar(Ct, ie, se);
        // Of course use larger one
        lr > Ee || lr === Ee && (!U || // Choose recommend one
        $r >= we) ? (b.current.lr = !0, X = Ct, Ve = -Ve, ee.points = [Ir(Qe, 1), Ir(st, 1)]) : b.current.lr = !1;
      }
      Pa();
      var Kt = rt === !0 ? 0 : rt;
      typeof Kt == "number" && (_t < se.left && (X -= _t - se.left - Ve, B.x + de < se.left + Kt && (X += B.x - se.left + de - Kt)), kt > se.right && (X -= kt - se.right - Ve, B.x > se.right - Kt && (X += B.x - se.right + Kt)));
      var Ht = It === !0 ? 0 : It;
      typeof Ht == "number" && (ft < se.top && (ie -= ft - se.top - Ue, B.y + L < se.top + Ht && (ie += B.y - se.top + L - Ht)), At > se.bottom && (ie -= At - se.bottom - Ue, B.y > se.bottom - Ht && (ie += B.y - se.bottom + Ht)));
      var Cr = j.x + X, Or = Cr + Ce, nr = j.y + ie, In = nr + ue, Xr = B.x, An = Xr + de, Be = B.y, Te = Be + L, We = Math.max(Cr, Xr), Ot = Math.min(Or, An), Pt = (We + Ot) / 2, Mr = Pt - Cr, zr = Math.max(nr, Be), Yr = Math.min(In, Te), Qr = (zr + Yr) / 2, Zr = Qr - nr;
      o == null || o(t, ee);
      var cr = ge.right - j.x - (X + j.width), qt = ge.bottom - j.y - (ie + j.height);
      mt === 1 && (X = Math.round(X), cr = Math.round(cr)), qe === 1 && (ie = Math.round(ie), qt = Math.round(qt));
      var kn = {
        ready: !0,
        offsetX: X / mt,
        offsetY: ie / qe,
        offsetR: cr / mt,
        offsetB: qt / qe,
        arrowX: Mr / mt,
        arrowY: Zr / qe,
        scaleX: mt,
        scaleY: qe,
        align: ee
      };
      u(kn);
    }
  }), f = function() {
    v.current += 1;
    var C = v.current;
    Promise.resolve().then(function() {
      v.current === C && m();
    });
  }, y = function() {
    u(function(C) {
      return I(I({}, C), {}, {
        ready: !1
      });
    });
  };
  return Vt(y, [n]), Vt(function() {
    e || y();
  }, [e]), [c.ready, c.offsetX, c.offsetY, c.offsetR, c.offsetB, c.arrowX, c.arrowY, c.scaleX, c.scaleY, c.align, f];
}
function Xm(e, t, r, n, a) {
  Vt(function() {
    if (e && t && r) {
      let v = function() {
        n(), a();
      };
      var i = t, o = r, s = zo(i), l = zo(o), c = Ca(o), u = new Set([c].concat(te(s), te(l)));
      return u.forEach(function(h) {
        h.addEventListener("scroll", v, {
          passive: !0
        });
      }), c.addEventListener("resize", v, {
        passive: !0
      }), n(), function() {
        u.forEach(function(h) {
          h.removeEventListener("scroll", v), c.removeEventListener("resize", v);
        });
      };
    }
  }, [e, t, r]);
}
function Ym(e, t, r, n, a, i, o, s) {
  var l = d.useRef(e);
  l.current = e;
  var c = d.useRef(!1);
  d.useEffect(function() {
    if (t && n && (!a || i)) {
      var v = function() {
        c.current = !1;
      }, h = function(S) {
        var E;
        l.current && !o(((E = S.composedPath) === null || E === void 0 || (E = E.call(S)) === null || E === void 0 ? void 0 : E[0]) || S.target) && !c.current && s(!1);
      }, b = Ca(n);
      b.addEventListener("pointerdown", v, !0), b.addEventListener("mousedown", h, !0), b.addEventListener("contextmenu", h, !0);
      var g = ei(r);
      if (g && (g.addEventListener("mousedown", h, !0), g.addEventListener("contextmenu", h, !0)), process.env.NODE_ENV !== "production") {
        var m, f, y = r == null || (m = r.getRootNode) === null || m === void 0 ? void 0 : m.call(r), p = (f = n.getRootNode) === null || f === void 0 ? void 0 : f.call(n);
        bn(y === p, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        b.removeEventListener("pointerdown", v, !0), b.removeEventListener("mousedown", h, !0), b.removeEventListener("contextmenu", h, !0), g && (g.removeEventListener("mousedown", h, !0), g.removeEventListener("contextmenu", h, !0));
      };
    }
  }, [t, r, n, a, i]);
  function u() {
    c.current = !0;
  }
  return u;
}
var Qm = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function Zm() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : xs, t = /* @__PURE__ */ d.forwardRef(function(r, n) {
    var a = r.prefixCls, i = a === void 0 ? "rc-trigger-popup" : a, o = r.children, s = r.action, l = s === void 0 ? "hover" : s, c = r.showAction, u = r.hideAction, v = r.popupVisible, h = r.defaultPopupVisible, b = r.onPopupVisibleChange, g = r.afterPopupVisibleChange, m = r.mouseEnterDelay, f = r.mouseLeaveDelay, y = f === void 0 ? 0.1 : f, p = r.focusDelay, C = r.blurDelay, S = r.mask, E = r.maskClosable, w = E === void 0 ? !0 : E, P = r.getPopupContainer, N = r.forceRender, M = r.autoDestroy, _ = r.destroyPopupOnHide, x = r.popup, R = r.popupClassName, $ = r.popupStyle, T = r.popupPlacement, A = r.builtinPlacements, D = A === void 0 ? {} : A, z = r.popupAlign, V = r.zIndex, k = r.stretch, B = r.getPopupClassNameFromAlign, q = r.fresh, W = r.alignPoint, H = r.onPopupClick, j = r.onPopupAlign, K = r.arrow, J = r.popupMotion, Z = r.maskMotion, ae = r.popupTransitionName, oe = r.popupAnimation, fe = r.maskTransitionName, me = r.maskAnimation, ue = r.className, Ce = r.getTriggerDOMNode, L = Le(r, Qm), de = M || _ || !1, ye = d.useState(!1), Ge = F(ye, 2), Oe = Ge[0], He = Ge[1];
    Vt(function() {
      He(Uu());
    }, []);
    var ve = d.useRef({}), U = d.useContext(Xl), pe = d.useMemo(function() {
      return {
        registerSubPopup: function(ce, et) {
          ve.current[ce] = et, U == null || U.registerSubPopup(ce, et);
        }
      };
    }, [U]), se = Hm(), tt = d.useState(null), Ie = F(tt, 2), ge = Ie[0], mt = Ie[1], qe = d.useRef(null), Xe = Ut(function(Y) {
      qe.current = Y, fa(Y) && ge !== Y && mt(Y), U == null || U.registerSubPopup(se, Y);
    }), pt = d.useState(null), at = F(pt, 2), Ye = at[0], Ve = at[1], Ue = d.useRef(null), xt = Ut(function(Y) {
      fa(Y) && Ye !== Y && (Ve(Y), Ue.current = Y);
    }), Me = d.Children.only(o), Re = (Me == null ? void 0 : Me.props) || {}, dt = {}, Xt = Ut(function(Y) {
      var ce, et, St = Ye;
      return (St == null ? void 0 : St.contains(Y)) || ((ce = ei(St)) === null || ce === void 0 ? void 0 : ce.host) === Y || Y === St || (ge == null ? void 0 : ge.contains(Y)) || ((et = ei(ge)) === null || et === void 0 ? void 0 : et.host) === Y || Y === ge || Object.values(ve.current).some(function(ot) {
        return (ot == null ? void 0 : ot.contains(Y)) || Y === ot;
      });
    }), Bt = Ql(i, J, oe, ae), jt = Ql(i, Z, me, fe), er = d.useState(h || !1), st = F(er, 2), Qe = st[0], Je = st[1], xe = v ?? Qe, ee = Ut(function(Y) {
      v === void 0 && Je(Y);
    });
    Vt(function() {
      Je(v || !1);
    }, [v]);
    var X = d.useRef(xe);
    X.current = xe;
    var ie = d.useRef([]);
    ie.current = [];
    var Ee = Ut(function(Y) {
      var ce;
      ee(Y), ((ce = ie.current[ie.current.length - 1]) !== null && ce !== void 0 ? ce : xe) !== Y && (ie.current.push(Y), b == null || b(Y));
    }), we = d.useRef(), Tt = function() {
      clearTimeout(we.current);
    }, _e = function(ce) {
      var et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      Tt(), et === 0 ? Ee(ce) : we.current = setTimeout(function() {
        Ee(ce);
      }, et * 1e3);
    };
    d.useEffect(function() {
      return Tt;
    }, []);
    var zt = d.useState(!1), tr = F(zt, 2), Pe = tr[0], je = tr[1];
    Vt(function(Y) {
      (!Y || xe) && je(!0);
    }, [xe]);
    var yt = d.useState(null), rt = F(yt, 2), It = rt[0], Wt = rt[1], ft = d.useState(null), At = F(ft, 2), _t = At[0], kt = At[1], Ft = function(ce) {
      kt([ce.clientX, ce.clientY]);
    }, vt = Gm(xe, ge, W && _t !== null ? _t : Ye, T, D, z, j), nt = F(vt, 11), br = nt[0], $e = nt[1], re = nt[2], Ne = nt[3], ze = nt[4], it = nt[5], lt = nt[6], Dt = nt[7], bt = nt[8], rr = nt[9], Ct = nt[10], lr = Km(Oe, l, c, u), $r = F(lr, 2), Kt = $r[0], Ht = $r[1], Cr = Kt.has("click"), Or = Ht.has("click") || Ht.has("contextMenu"), nr = Ut(function() {
      Pe || Ct();
    }), In = function() {
      X.current && W && Or && _e(!1);
    };
    Xm(xe, Ye, ge, nr, In), Vt(function() {
      nr();
    }, [_t, T]), Vt(function() {
      xe && !(D != null && D[T]) && nr();
    }, [JSON.stringify(z)]);
    var Xr = d.useMemo(function() {
      var Y = Um(D, i, rr, W);
      return ne(Y, B == null ? void 0 : B(rr));
    }, [rr, B, D, i, W]);
    d.useImperativeHandle(n, function() {
      return {
        nativeElement: Ue.current,
        popupElement: qe.current,
        forceAlign: nr
      };
    });
    var An = d.useState(0), Be = F(An, 2), Te = Be[0], We = Be[1], Ot = d.useState(0), Pt = F(Ot, 2), Mr = Pt[0], zr = Pt[1], Yr = function() {
      if (k && Ye) {
        var ce = Ye.getBoundingClientRect();
        We(ce.width), zr(ce.height);
      }
    }, Qr = function() {
      Yr(), nr();
    }, Zr = function(ce) {
      je(!1), Ct(), g == null || g(ce);
    }, cr = function() {
      return new Promise(function(ce) {
        Yr(), Wt(function() {
          return ce;
        });
      });
    };
    Vt(function() {
      It && (Ct(), It(), Wt(null));
    }, [It]);
    function qt(Y, ce, et, St) {
      dt[Y] = function(ot) {
        var Oa;
        St == null || St(ot), _e(ce, et);
        for (var Mi = arguments.length, As = new Array(Mi > 1 ? Mi - 1 : 0), Ma = 1; Ma < Mi; Ma++)
          As[Ma - 1] = arguments[Ma];
        (Oa = Re[Y]) === null || Oa === void 0 || Oa.call.apply(Oa, [Re, ot].concat(As));
      };
    }
    (Cr || Or) && (dt.onClick = function(Y) {
      var ce;
      X.current && Or ? _e(!1) : !X.current && Cr && (Ft(Y), _e(!0));
      for (var et = arguments.length, St = new Array(et > 1 ? et - 1 : 0), ot = 1; ot < et; ot++)
        St[ot - 1] = arguments[ot];
      (ce = Re.onClick) === null || ce === void 0 || ce.call.apply(ce, [Re, Y].concat(St));
    });
    var kn = Ym(xe, Or, Ye, ge, S, w, Xt, _e), ar = Kt.has("hover"), Pa = Ht.has("hover"), Jr, Rr;
    ar && (qt("onMouseEnter", !0, m, function(Y) {
      Ft(Y);
    }), qt("onPointerEnter", !0, m, function(Y) {
      Ft(Y);
    }), Jr = function(ce) {
      (xe || Pe) && ge !== null && ge !== void 0 && ge.contains(ce.target) && _e(!0, m);
    }, W && (dt.onMouseMove = function(Y) {
      var ce;
      (ce = Re.onMouseMove) === null || ce === void 0 || ce.call(Re, Y);
    })), Pa && (qt("onMouseLeave", !1, y), qt("onPointerLeave", !1, y), Rr = function() {
      _e(!1, y);
    }), Kt.has("focus") && qt("onFocus", !0, p), Ht.has("focus") && qt("onBlur", !1, C), Kt.has("contextMenu") && (dt.onContextMenu = function(Y) {
      var ce;
      X.current && Ht.has("contextMenu") ? _e(!1) : (Ft(Y), _e(!0)), Y.preventDefault();
      for (var et = arguments.length, St = new Array(et > 1 ? et - 1 : 0), ot = 1; ot < et; ot++)
        St[ot - 1] = arguments[ot];
      (ce = Re.onContextMenu) === null || ce === void 0 || ce.call.apply(ce, [Re, Y].concat(St));
    }), ue && (dt.className = ne(Re.className, ue));
    var Nr = I(I({}, Re), dt), Fn = {}, $a = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    $a.forEach(function(Y) {
      L[Y] && (Fn[Y] = function() {
        for (var ce, et = arguments.length, St = new Array(et), ot = 0; ot < et; ot++)
          St[ot] = arguments[ot];
        (ce = Nr[Y]) === null || ce === void 0 || ce.call.apply(ce, [Nr].concat(St)), L[Y].apply(L, St);
      });
    });
    var Pi = /* @__PURE__ */ d.cloneElement(Me, I(I({}, Nr), Fn)), $i = {
      x: it,
      y: lt
    }, Oi = K ? I({}, K !== !0 ? K : {}) : null;
    return /* @__PURE__ */ d.createElement(d.Fragment, null, /* @__PURE__ */ d.createElement(xr, {
      disabled: !xe,
      ref: xt,
      onResize: Qr
    }, /* @__PURE__ */ d.createElement(ld, {
      getTriggerDOMNode: Ce
    }, Pi)), /* @__PURE__ */ d.createElement(Xl.Provider, {
      value: pe
    }, /* @__PURE__ */ d.createElement(sd, {
      portal: e,
      ref: Xe,
      prefixCls: i,
      popup: x,
      className: ne(R, Xr),
      style: $,
      target: Ye,
      onMouseEnter: Jr,
      onMouseLeave: Rr,
      onPointerEnter: Jr,
      zIndex: V,
      open: xe,
      keepDom: Pe,
      fresh: q,
      onClick: H,
      onPointerDownCapture: kn,
      mask: S,
      motion: Bt,
      maskMotion: jt,
      onVisibleChanged: Zr,
      onPrepare: cr,
      forceRender: N,
      autoDestroy: de,
      getPopupContainer: P,
      align: rr,
      arrow: Oi,
      arrowPos: $i,
      ready: br,
      offsetX: $e,
      offsetY: re,
      offsetR: Ne,
      offsetB: ze,
      onAlign: nr,
      stretch: k,
      targetWidth: Te / Dt,
      targetHeight: Mr / bt
    })));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const ud = Zm(xs);
var Et = {
  /**
   * TAB
   */
  TAB: 9,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40
}, Jm = Et.ESC, ep = Et.TAB;
function tp(e) {
  var t = e.visible, r = e.triggerRef, n = e.onVisibleChange, a = e.autoFocus, i = e.overlayRef, o = d.useRef(!1), s = function() {
    if (t) {
      var v, h;
      (v = r.current) === null || v === void 0 || (h = v.focus) === null || h === void 0 || h.call(v), n == null || n(!1);
    }
  }, l = function() {
    var v;
    return (v = i.current) !== null && v !== void 0 && v.focus ? (i.current.focus(), o.current = !0, !0) : !1;
  }, c = function(v) {
    switch (v.keyCode) {
      case Jm:
        s();
        break;
      case ep: {
        var h = !1;
        o.current || (h = l()), h ? v.preventDefault() : s();
        break;
      }
    }
  };
  d.useEffect(function() {
    return t ? (window.addEventListener("keydown", c), a && Jt(l, 3), function() {
      window.removeEventListener("keydown", c), o.current = !1;
    }) : function() {
      o.current = !1;
    };
  }, [t]);
}
var rp = /* @__PURE__ */ Bd(function(e, t) {
  var r = e.overlay, n = e.arrow, a = e.prefixCls, i = pn(function() {
    var s;
    return typeof r == "function" ? s = r() : s = r, s;
  }, [r]), o = hi(t, pa(i));
  return /* @__PURE__ */ Q.createElement(Q.Fragment, null, n && /* @__PURE__ */ Q.createElement("div", {
    className: "".concat(a, "-arrow")
  }), /* @__PURE__ */ Q.cloneElement(i, {
    ref: On(i) ? o : void 0
  }));
}), rn = {
  adjustX: 1,
  adjustY: 1
}, nn = [0, 0], np = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: rn,
    offset: [0, -4],
    targetOffset: nn
  },
  top: {
    points: ["bc", "tc"],
    overflow: rn,
    offset: [0, -4],
    targetOffset: nn
  },
  topRight: {
    points: ["br", "tr"],
    overflow: rn,
    offset: [0, -4],
    targetOffset: nn
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: rn,
    offset: [0, 4],
    targetOffset: nn
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: rn,
    offset: [0, 4],
    targetOffset: nn
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: rn,
    offset: [0, 4],
    targetOffset: nn
  }
}, ap = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function ip(e, t) {
  var r, n = e.arrow, a = n === void 0 ? !1 : n, i = e.prefixCls, o = i === void 0 ? "rc-dropdown" : i, s = e.transitionName, l = e.animation, c = e.align, u = e.placement, v = u === void 0 ? "bottomLeft" : u, h = e.placements, b = h === void 0 ? np : h, g = e.getPopupContainer, m = e.showAction, f = e.hideAction, y = e.overlayClassName, p = e.overlayStyle, C = e.visible, S = e.trigger, E = S === void 0 ? ["hover"] : S, w = e.autoFocus, P = e.overlay, N = e.children, M = e.onVisibleChange, _ = Le(e, ap), x = Q.useState(), R = F(x, 2), $ = R[0], T = R[1], A = "visible" in e ? C : $, D = Q.useRef(null), z = Q.useRef(null), V = Q.useRef(null);
  Q.useImperativeHandle(t, function() {
    return D.current;
  });
  var k = function(ae) {
    T(ae), M == null || M(ae);
  };
  tp({
    visible: A,
    triggerRef: V,
    onVisibleChange: k,
    autoFocus: w,
    overlayRef: z
  });
  var B = function(ae) {
    var oe = e.onOverlayClick;
    T(!1), oe && oe(ae);
  }, q = function() {
    return /* @__PURE__ */ Q.createElement(rp, {
      ref: z,
      overlay: P,
      prefixCls: o,
      arrow: a
    });
  }, W = function() {
    return typeof P == "function" ? q : q();
  }, H = function() {
    var ae = e.minOverlayWidthMatchTrigger, oe = e.alignPoint;
    return "minOverlayWidthMatchTrigger" in e ? ae : !oe;
  }, j = function() {
    var ae = e.openClassName;
    return ae !== void 0 ? ae : "".concat(o, "-open");
  }, K = /* @__PURE__ */ Q.cloneElement(N, {
    className: ne((r = N.props) === null || r === void 0 ? void 0 : r.className, A && j()),
    ref: On(N) ? hi(V, pa(N)) : void 0
  }), J = f;
  return !J && E.indexOf("contextMenu") !== -1 && (J = ["click"]), /* @__PURE__ */ Q.createElement(ud, he({
    builtinPlacements: b
  }, _, {
    prefixCls: o,
    ref: D,
    popupClassName: ne(y, O({}, "".concat(o, "-show-arrow"), a)),
    popupStyle: p,
    action: E,
    showAction: m,
    hideAction: J,
    popupPlacement: v,
    popupAlign: c,
    popupTransitionName: s,
    popupAnimation: l,
    popupVisible: A,
    stretch: H() ? "minWidth" : "",
    popup: W(),
    onPopupVisibleChange: k,
    onPopupClick: B,
    getPopupContainer: g
  }), K);
}
const op = /* @__PURE__ */ Q.forwardRef(ip);
var sp = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], an = void 0;
function lp(e, t) {
  var r = e.prefixCls, n = e.invalidate, a = e.item, i = e.renderItem, o = e.responsive, s = e.responsiveDisabled, l = e.registerSize, c = e.itemKey, u = e.className, v = e.style, h = e.children, b = e.display, g = e.order, m = e.component, f = m === void 0 ? "div" : m, y = Le(e, sp), p = o && !b;
  function C(N) {
    l(c, N);
  }
  d.useEffect(function() {
    return function() {
      C(null);
    };
  }, []);
  var S = i && a !== an ? i(a, {
    index: g
  }) : h, E;
  n || (E = {
    opacity: p ? 0 : 1,
    height: p ? 0 : an,
    overflowY: p ? "hidden" : an,
    order: o ? g : an,
    pointerEvents: p ? "none" : an,
    position: p ? "absolute" : an
  });
  var w = {};
  p && (w["aria-hidden"] = !0);
  var P = /* @__PURE__ */ d.createElement(f, he({
    className: ne(!n && r, u),
    style: I(I({}, E), v)
  }, w, y, {
    ref: t
  }), S);
  return o && (P = /* @__PURE__ */ d.createElement(xr, {
    onResize: function(M) {
      var _ = M.offsetWidth;
      C(_);
    },
    disabled: s
  }, P)), P;
}
var ta = /* @__PURE__ */ d.forwardRef(lp);
ta.displayName = "Item";
function cp(e) {
  if (typeof MessageChannel > "u")
    Jt(e);
  else {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(void 0);
  }
}
function up() {
  var e = d.useRef(null), t = function(n) {
    e.current || (e.current = [], cp(function() {
      Ud(function() {
        e.current.forEach(function(a) {
          a();
        }), e.current = null;
      });
    })), e.current.push(n);
  };
  return t;
}
function Gn(e, t) {
  var r = d.useState(t), n = F(r, 2), a = n[0], i = n[1], o = Ut(function(s) {
    e(function() {
      i(s);
    });
  });
  return [a, o];
}
var ni = /* @__PURE__ */ Q.createContext(null), dp = ["component"], fp = ["className"], vp = ["className"], hp = function(t, r) {
  var n = d.useContext(ni);
  if (!n) {
    var a = t.component, i = a === void 0 ? "div" : a, o = Le(t, dp);
    return /* @__PURE__ */ d.createElement(i, he({}, o, {
      ref: r
    }));
  }
  var s = n.className, l = Le(n, fp), c = t.className, u = Le(t, vp);
  return /* @__PURE__ */ d.createElement(ni.Provider, {
    value: null
  }, /* @__PURE__ */ d.createElement(ta, he({
    ref: r,
    className: ne(s, c)
  }, l, u)));
}, dd = /* @__PURE__ */ d.forwardRef(hp);
dd.displayName = "RawItem";
var gp = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], fd = "responsive", vd = "invalidate";
function mp(e) {
  return "+ ".concat(e.length, " ...");
}
function pp(e, t) {
  var r = e.prefixCls, n = r === void 0 ? "rc-overflow" : r, a = e.data, i = a === void 0 ? [] : a, o = e.renderItem, s = e.renderRawItem, l = e.itemKey, c = e.itemWidth, u = c === void 0 ? 10 : c, v = e.ssr, h = e.style, b = e.className, g = e.maxCount, m = e.renderRest, f = e.renderRawRest, y = e.suffix, p = e.component, C = p === void 0 ? "div" : p, S = e.itemComponent, E = e.onVisibleChange, w = Le(e, gp), P = v === "full", N = up(), M = Gn(N, null), _ = F(M, 2), x = _[0], R = _[1], $ = x || 0, T = Gn(N, /* @__PURE__ */ new Map()), A = F(T, 2), D = A[0], z = A[1], V = Gn(N, 0), k = F(V, 2), B = k[0], q = k[1], W = Gn(N, 0), H = F(W, 2), j = H[0], K = H[1], J = Gn(N, 0), Z = F(J, 2), ae = Z[0], oe = Z[1], fe = Ze(null), me = F(fe, 2), ue = me[0], Ce = me[1], L = Ze(null), de = F(L, 2), ye = de[0], Ge = de[1], Oe = d.useMemo(function() {
    return ye === null && P ? Number.MAX_SAFE_INTEGER : ye || 0;
  }, [ye, x]), He = Ze(!1), ve = F(He, 2), U = ve[0], pe = ve[1], se = "".concat(n, "-item"), tt = Math.max(B, j), Ie = g === fd, ge = i.length && Ie, mt = g === vd, qe = ge || typeof g == "number" && i.length > g, Xe = pn(function() {
    var ee = i;
    return ge ? x === null && P ? ee = i : ee = i.slice(0, Math.min(i.length, $ / u)) : typeof g == "number" && (ee = i.slice(0, g)), ee;
  }, [i, u, x, g, ge]), pt = pn(function() {
    return ge ? i.slice(Oe + 1) : i.slice(Xe.length);
  }, [i, Xe, ge, Oe]), at = kr(function(ee, X) {
    var ie;
    return typeof l == "function" ? l(ee) : (ie = l && (ee == null ? void 0 : ee[l])) !== null && ie !== void 0 ? ie : X;
  }, [l]), Ye = kr(o || function(ee) {
    return ee;
  }, [o]);
  function Ve(ee, X, ie) {
    ye === ee && (X === void 0 || X === ue) || (Ge(ee), ie || (pe(ee < i.length - 1), E == null || E(ee)), X !== void 0 && Ce(X));
  }
  function Ue(ee, X) {
    R(X.clientWidth);
  }
  function xt(ee, X) {
    z(function(ie) {
      var Ee = new Map(ie);
      return X === null ? Ee.delete(ee) : Ee.set(ee, X), Ee;
    });
  }
  function Me(ee, X) {
    K(X), q(j);
  }
  function Re(ee, X) {
    oe(X);
  }
  function dt(ee) {
    return D.get(at(Xe[ee], ee));
  }
  Vt(function() {
    if ($ && typeof tt == "number" && Xe) {
      var ee = ae, X = Xe.length, ie = X - 1;
      if (!X) {
        Ve(0, null);
        return;
      }
      for (var Ee = 0; Ee < X; Ee += 1) {
        var we = dt(Ee);
        if (P && (we = we || 0), we === void 0) {
          Ve(Ee - 1, void 0, !0);
          break;
        }
        if (ee += we, // Only one means `totalWidth` is the final width
        ie === 0 && ee <= $ || // Last two width will be the final width
        Ee === ie - 1 && ee + dt(ie) <= $) {
          Ve(ie, null);
          break;
        } else if (ee + tt > $) {
          Ve(Ee - 1, ee - we - ae + j);
          break;
        }
      }
      y && dt(0) + ae > $ && Ce(null);
    }
  }, [$, D, j, ae, at, Xe]);
  var Xt = U && !!pt.length, Bt = {};
  ue !== null && ge && (Bt = {
    position: "absolute",
    left: ue,
    top: 0
  });
  var jt = {
    prefixCls: se,
    responsive: ge,
    component: S,
    invalidate: mt
  }, er = s ? function(ee, X) {
    var ie = at(ee, X);
    return /* @__PURE__ */ d.createElement(ni.Provider, {
      key: ie,
      value: I(I({}, jt), {}, {
        order: X,
        item: ee,
        itemKey: ie,
        registerSize: xt,
        display: X <= Oe
      })
    }, s(ee, X));
  } : function(ee, X) {
    var ie = at(ee, X);
    return /* @__PURE__ */ d.createElement(ta, he({}, jt, {
      order: X,
      key: ie,
      item: ee,
      renderItem: Ye,
      itemKey: ie,
      registerSize: xt,
      display: X <= Oe
    }));
  }, st = {
    order: Xt ? Oe : Number.MAX_SAFE_INTEGER,
    className: "".concat(se, "-rest"),
    registerSize: Me,
    display: Xt
  }, Qe = m || mp, Je = f ? /* @__PURE__ */ d.createElement(ni.Provider, {
    value: I(I({}, jt), st)
  }, f(pt)) : /* @__PURE__ */ d.createElement(ta, he({}, jt, st), typeof Qe == "function" ? Qe(pt) : Qe), xe = /* @__PURE__ */ d.createElement(C, he({
    className: ne(!mt && n, b),
    style: h,
    ref: t
  }, w), Xe.map(er), qe ? Je : null, y && /* @__PURE__ */ d.createElement(ta, he({}, jt, {
    responsive: Ie,
    responsiveDisabled: !ge,
    order: Oe,
    className: "".concat(se, "-suffix"),
    registerSize: Re,
    display: !0,
    style: Bt
  }), y));
  return Ie ? /* @__PURE__ */ d.createElement(xr, {
    onResize: Ue,
    disabled: !ge
  }, xe) : xe;
}
var _r = /* @__PURE__ */ d.forwardRef(pp);
_r.displayName = "Overflow";
_r.Item = dd;
_r.RESPONSIVE = fd;
_r.INVALIDATE = vd;
var hd = /* @__PURE__ */ d.createContext(null);
function gd(e, t) {
  return e === void 0 ? null : "".concat(e, "-").concat(t);
}
function md(e) {
  var t = d.useContext(hd);
  return gd(t, e);
}
var yp = ["children", "locked"], gr = /* @__PURE__ */ d.createContext(null);
function bp(e, t) {
  var r = I({}, e);
  return Object.keys(t).forEach(function(n) {
    var a = t[n];
    a !== void 0 && (r[n] = a);
  }), r;
}
function ha(e) {
  var t = e.children, r = e.locked, n = Le(e, yp), a = d.useContext(gr), i = ci(function() {
    return bp(a, n);
  }, [a, n], function(o, s) {
    return !r && (o[0] !== s[0] || !ia(o[1], s[1], !0));
  });
  return /* @__PURE__ */ d.createElement(gr.Provider, {
    value: i
  }, t);
}
var Cp = [], pd = /* @__PURE__ */ d.createContext(null);
function Ei() {
  return d.useContext(pd);
}
var yd = /* @__PURE__ */ d.createContext(Cp);
function Sa(e) {
  var t = d.useContext(yd);
  return d.useMemo(function() {
    return e !== void 0 ? [].concat(te(t), [e]) : t;
  }, [t, e]);
}
var bd = /* @__PURE__ */ d.createContext(null), _s = /* @__PURE__ */ d.createContext({});
function rc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (cd(e)) {
    var r = e.nodeName.toLowerCase(), n = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(r) || // Editable element
      e.isContentEditable || // Anchor with href element
      r === "a" && !!e.getAttribute("href")
    ), a = e.getAttribute("tabindex"), i = Number(a), o = null;
    return a && !Number.isNaN(i) ? o = i : n && o === null && (o = 0), n && e.disabled && (o = null), o !== null && (o >= 0 || t && o < 0);
  }
  return !1;
}
function Sp(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = te(e.querySelectorAll("*")).filter(function(n) {
    return rc(n, t);
  });
  return rc(e, t) && r.unshift(e), r;
}
var Ho = Et.LEFT, Bo = Et.RIGHT, Wo = Et.UP, Ya = Et.DOWN, Qa = Et.ENTER, Cd = Et.ESC, Xn = Et.HOME, Yn = Et.END, nc = [Wo, Ya, Ho, Bo];
function Ep(e, t, r, n) {
  var a, i = "prev", o = "next", s = "children", l = "parent";
  if (e === "inline" && n === Qa)
    return {
      inlineTrigger: !0
    };
  var c = O(O({}, Wo, i), Ya, o), u = O(O(O(O({}, Ho, r ? o : i), Bo, r ? i : o), Ya, s), Qa, s), v = O(O(O(O(O(O({}, Wo, i), Ya, o), Qa, s), Cd, l), Ho, r ? s : l), Bo, r ? l : s), h = {
    inline: c,
    horizontal: u,
    vertical: v,
    inlineSub: c,
    horizontalSub: v,
    verticalSub: v
  }, b = (a = h["".concat(e).concat(t ? "" : "Sub")]) === null || a === void 0 ? void 0 : a[n];
  switch (b) {
    case i:
      return {
        offset: -1,
        sibling: !0
      };
    case o:
      return {
        offset: 1,
        sibling: !0
      };
    case l:
      return {
        offset: -1,
        sibling: !1
      };
    case s:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function wp(e) {
  for (var t = e; t; ) {
    if (t.getAttribute("data-menu-list"))
      return t;
    t = t.parentElement;
  }
  return null;
}
function xp(e, t) {
  for (var r = e || document.activeElement; r; ) {
    if (t.has(r))
      return r;
    r = r.parentElement;
  }
  return null;
}
function Ps(e, t) {
  var r = Sp(e, !0);
  return r.filter(function(n) {
    return t.has(n);
  });
}
function ac(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!e)
    return null;
  var a = Ps(e, t), i = a.length, o = a.findIndex(function(s) {
    return r === s;
  });
  return n < 0 ? o === -1 ? o = i - 1 : o -= 1 : n > 0 && (o += 1), o = (o + i) % i, a[o];
}
var Ko = function(t, r) {
  var n = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  return t.forEach(function(o) {
    var s = document.querySelector("[data-menu-id='".concat(gd(r, o), "']"));
    s && (n.add(s), i.set(s, o), a.set(o, s));
  }), {
    elements: n,
    key2element: a,
    element2key: i
  };
};
function _p(e, t, r, n, a, i, o, s, l, c) {
  var u = d.useRef(), v = d.useRef();
  v.current = t;
  var h = function() {
    Jt.cancel(u.current);
  };
  return d.useEffect(function() {
    return function() {
      h();
    };
  }, []), function(b) {
    var g = b.which;
    if ([].concat(nc, [Qa, Cd, Xn, Yn]).includes(g)) {
      var m = i(), f = Ko(m, n), y = f, p = y.elements, C = y.key2element, S = y.element2key, E = C.get(t), w = xp(E, p), P = S.get(w), N = Ep(e, o(P, !0).length === 1, r, g);
      if (!N && g !== Xn && g !== Yn)
        return;
      (nc.includes(g) || [Xn, Yn].includes(g)) && b.preventDefault();
      var M = function(z) {
        if (z) {
          var V = z, k = z.querySelector("a");
          k != null && k.getAttribute("href") && (V = k);
          var B = S.get(z);
          s(B), h(), u.current = Jt(function() {
            v.current === B && V.focus();
          });
        }
      };
      if ([Xn, Yn].includes(g) || N.sibling || !w) {
        var _;
        !w || e === "inline" ? _ = a.current : _ = wp(w);
        var x, R = Ps(_, p);
        g === Xn ? x = R[0] : g === Yn ? x = R[R.length - 1] : x = ac(_, p, w, N.offset), M(x);
      } else if (N.inlineTrigger)
        l(P);
      else if (N.offset > 0)
        l(P, !0), h(), u.current = Jt(function() {
          f = Ko(m, n);
          var D = w.getAttribute("aria-controls"), z = document.getElementById(D), V = ac(z, f.elements);
          M(V);
        }, 5);
      else if (N.offset < 0) {
        var $ = o(P, !0), T = $[$.length - 2], A = C.get(T);
        l(T, !1), M(A);
      }
    }
    c == null || c(b);
  };
}
function Pp(e) {
  Promise.resolve().then(e);
}
var $s = "__RC_UTIL_PATH_SPLIT__", ic = function(t) {
  return t.join($s);
}, $p = function(t) {
  return t.split($s);
}, qo = "rc-menu-more";
function Op() {
  var e = d.useState({}), t = F(e, 2), r = t[1], n = De(/* @__PURE__ */ new Map()), a = De(/* @__PURE__ */ new Map()), i = d.useState([]), o = F(i, 2), s = o[0], l = o[1], c = De(0), u = De(!1), v = function() {
    u.current || r({});
  }, h = kr(function(C, S) {
    process.env.NODE_ENV !== "production" && Ae(!n.current.has(C), "Duplicated key '".concat(C, "' used in Menu by path [").concat(S.join(" > "), "]"));
    var E = ic(S);
    a.current.set(E, C), n.current.set(C, E), c.current += 1;
    var w = c.current;
    Pp(function() {
      w === c.current && v();
    });
  }, []), b = kr(function(C, S) {
    var E = ic(S);
    a.current.delete(E), n.current.delete(C);
  }, []), g = kr(function(C) {
    l(C);
  }, []), m = kr(function(C, S) {
    var E = n.current.get(C) || "", w = $p(E);
    return S && s.includes(w[0]) && w.unshift(qo), w;
  }, [s]), f = kr(function(C, S) {
    return C.filter(function(E) {
      return E !== void 0;
    }).some(function(E) {
      var w = m(E, !0);
      return w.includes(S);
    });
  }, [m]), y = function() {
    var S = te(n.current.keys());
    return s.length && S.push(qo), S;
  }, p = kr(function(C) {
    var S = "".concat(n.current.get(C)).concat($s), E = /* @__PURE__ */ new Set();
    return te(a.current.keys()).forEach(function(w) {
      w.startsWith(S) && E.add(a.current.get(w));
    }), E;
  }, []);
  return d.useEffect(function() {
    return function() {
      u.current = !0;
    };
  }, []), {
    // Register
    registerPath: h,
    unregisterPath: b,
    refreshOverflowKeys: g,
    // Util
    isSubPathKey: f,
    getKeyPath: m,
    getKeys: y,
    getSubPathKeys: p
  };
}
function Qn(e) {
  var t = d.useRef(e);
  t.current = e;
  var r = d.useCallback(function() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return (n = t.current) === null || n === void 0 ? void 0 : n.call.apply(n, [t].concat(i));
  }, []);
  return e ? r : void 0;
}
var Mp = Math.random().toFixed(5).toString().slice(2), oc = 0;
function Rp(e) {
  var t = hn(e, {
    value: e
  }), r = F(t, 2), n = r[0], a = r[1];
  return d.useEffect(function() {
    oc += 1;
    var i = process.env.NODE_ENV === "test" ? "test" : "".concat(Mp, "-").concat(oc);
    a("rc-menu-uuid-".concat(i));
  }, []), n;
}
function Sd(e, t, r, n) {
  var a = d.useContext(gr), i = a.activeKey, o = a.onActive, s = a.onInactive, l = {
    active: i === e
  };
  return t || (l.onMouseEnter = function(c) {
    r == null || r({
      key: e,
      domEvent: c
    }), o(e);
  }, l.onMouseLeave = function(c) {
    n == null || n({
      key: e,
      domEvent: c
    }), s(e);
  }), l;
}
function Ed(e) {
  var t = d.useContext(gr), r = t.mode, n = t.rtl, a = t.inlineIndent;
  if (r !== "inline")
    return null;
  var i = e;
  return n ? {
    paddingRight: i * a
  } : {
    paddingLeft: i * a
  };
}
function wd(e) {
  var t = e.icon, r = e.props, n = e.children, a;
  return t === null || t === !1 ? null : (typeof t == "function" ? a = /* @__PURE__ */ d.createElement(t, I({}, r)) : typeof t != "boolean" && (a = t), a || n || null);
}
var Np = ["item"];
function ai(e) {
  var t = e.item, r = Le(e, Np);
  return Object.defineProperty(r, "item", {
    get: function() {
      return Ae(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), t;
    }
  }), r;
}
var Tp = ["title", "attribute", "elementRef"], Ip = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], Ap = ["active"], kp = /* @__PURE__ */ function(e) {
  Vr(r, e);
  var t = jr(r);
  function r() {
    return Rt(this, r), t.apply(this, arguments);
  }
  return Nt(r, [{
    key: "render",
    value: function() {
      var a = this.props, i = a.title, o = a.attribute, s = a.elementRef, l = Le(a, Tp), c = Ur(l, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return Ae(!o, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ d.createElement(_r.Item, he({}, o, {
        title: typeof i == "string" ? i : void 0
      }, c, {
        ref: s
      }));
    }
  }]), r;
}(d.Component), Fp = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.style, n = e.className, a = e.eventKey, i = e.warnKey, o = e.disabled, s = e.itemIcon, l = e.children, c = e.role, u = e.onMouseEnter, v = e.onMouseLeave, h = e.onClick, b = e.onKeyDown, g = e.onFocus, m = Le(e, Ip), f = md(a), y = d.useContext(gr), p = y.prefixCls, C = y.onItemClick, S = y.disabled, E = y.overflowDisabled, w = y.itemIcon, P = y.selectedKeys, N = y.onActive, M = d.useContext(_s), _ = M._internalRenderMenuItem, x = "".concat(p, "-item"), R = d.useRef(), $ = d.useRef(), T = S || o, A = ma(t, $), D = Sa(a);
  process.env.NODE_ENV !== "production" && i && Ae(!1, "MenuItem should not leave undefined `key`.");
  var z = function(fe) {
    return {
      key: a,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: te(D).reverse(),
      item: R.current,
      domEvent: fe
    };
  }, V = s || w, k = Sd(a, T, u, v), B = k.active, q = Le(k, Ap), W = P.includes(a), H = Ed(D.length), j = function(fe) {
    if (!T) {
      var me = z(fe);
      h == null || h(ai(me)), C(me);
    }
  }, K = function(fe) {
    if (b == null || b(fe), fe.which === Et.ENTER) {
      var me = z(fe);
      h == null || h(ai(me)), C(me);
    }
  }, J = function(fe) {
    N(a), g == null || g(fe);
  }, Z = {};
  e.role === "option" && (Z["aria-selected"] = W);
  var ae = /* @__PURE__ */ d.createElement(kp, he({
    ref: R,
    elementRef: A,
    role: c === null ? "none" : c || "menuitem",
    tabIndex: o ? null : -1,
    "data-menu-id": E && f ? null : f
  }, Ur(m, ["extra"]), q, Z, {
    component: "li",
    "aria-disabled": o,
    style: I(I({}, H), r),
    className: ne(x, O(O(O({}, "".concat(x, "-active"), B), "".concat(x, "-selected"), W), "".concat(x, "-disabled"), T), n),
    onClick: j,
    onKeyDown: K,
    onFocus: J
  }), l, /* @__PURE__ */ d.createElement(wd, {
    props: I(I({}, e), {}, {
      isSelected: W
    }),
    icon: V
  }));
  return _ && (ae = _(ae, e, {
    selected: W
  })), ae;
});
function Dp(e, t) {
  var r = e.eventKey, n = Ei(), a = Sa(r);
  return d.useEffect(function() {
    if (n)
      return n.registerPath(r, a), function() {
        n.unregisterPath(r, a);
      };
  }, [a]), n ? null : /* @__PURE__ */ d.createElement(Fp, he({}, e, {
    ref: t
  }));
}
const wi = /* @__PURE__ */ d.forwardRef(Dp);
var Lp = ["className", "children"], Vp = function(t, r) {
  var n = t.className, a = t.children, i = Le(t, Lp), o = d.useContext(gr), s = o.prefixCls, l = o.mode, c = o.rtl;
  return /* @__PURE__ */ d.createElement("ul", he({
    className: ne(s, c && "".concat(s, "-rtl"), "".concat(s, "-sub"), "".concat(s, "-").concat(l === "inline" ? "inline" : "vertical"), n),
    role: "menu"
  }, i, {
    "data-menu-list": !0,
    ref: r
  }), a);
}, Os = /* @__PURE__ */ d.forwardRef(Vp);
Os.displayName = "SubMenuList";
function Ms(e, t) {
  return xn(e).map(function(r, n) {
    if (/* @__PURE__ */ d.isValidElement(r)) {
      var a, i, o = r.key, s = (a = (i = r.props) === null || i === void 0 ? void 0 : i.eventKey) !== null && a !== void 0 ? a : o, l = s == null;
      l && (s = "tmp_key-".concat([].concat(te(t), [n]).join("-")));
      var c = {
        key: s,
        eventKey: s
      };
      return process.env.NODE_ENV !== "production" && l && (c.warnKey = !0), /* @__PURE__ */ d.cloneElement(r, c);
    }
    return r;
  });
}
var Lt = {
  adjustX: 1,
  adjustY: 1
}, jp = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Lt
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Lt
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Lt
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Lt
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: Lt
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: Lt
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: Lt
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: Lt
  }
}, zp = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Lt
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Lt
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Lt
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Lt
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: Lt
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: Lt
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: Lt
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: Lt
  }
};
function xd(e, t, r) {
  if (t)
    return t;
  if (r)
    return r[e] || r.other;
}
var Hp = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function Bp(e) {
  var t = e.prefixCls, r = e.visible, n = e.children, a = e.popup, i = e.popupStyle, o = e.popupClassName, s = e.popupOffset, l = e.disabled, c = e.mode, u = e.onVisibleChange, v = d.useContext(gr), h = v.getPopupContainer, b = v.rtl, g = v.subMenuOpenDelay, m = v.subMenuCloseDelay, f = v.builtinPlacements, y = v.triggerSubMenuAction, p = v.forceSubMenuRender, C = v.rootClassName, S = v.motion, E = v.defaultMotions, w = d.useState(!1), P = F(w, 2), N = P[0], M = P[1], _ = I(b ? I({}, zp) : I({}, jp), f), x = Hp[c], R = xd(c, S, E), $ = d.useRef(R);
  c !== "inline" && ($.current = R);
  var T = I(I({}, $.current), {}, {
    leavedClassName: "".concat(t, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), A = d.useRef();
  return d.useEffect(function() {
    return A.current = Jt(function() {
      M(r);
    }), function() {
      Jt.cancel(A.current);
    };
  }, [r]), /* @__PURE__ */ d.createElement(ud, {
    prefixCls: t,
    popupClassName: ne("".concat(t, "-popup"), O({}, "".concat(t, "-rtl"), b), o, C),
    stretch: c === "horizontal" ? "minWidth" : null,
    getPopupContainer: h,
    builtinPlacements: _,
    popupPlacement: x,
    popupVisible: N,
    popup: a,
    popupStyle: i,
    popupAlign: s && {
      offset: s
    },
    action: l ? [] : [y],
    mouseEnterDelay: g,
    mouseLeaveDelay: m,
    onPopupVisibleChange: u,
    forceRender: p,
    popupMotion: T,
    fresh: !0
  }, n);
}
function Wp(e) {
  var t = e.id, r = e.open, n = e.keyPath, a = e.children, i = "inline", o = d.useContext(gr), s = o.prefixCls, l = o.forceSubMenuRender, c = o.motion, u = o.defaultMotions, v = o.mode, h = d.useRef(!1);
  h.current = v === i;
  var b = d.useState(!h.current), g = F(b, 2), m = g[0], f = g[1], y = h.current ? r : !1;
  d.useEffect(function() {
    h.current && f(!1);
  }, [v]);
  var p = I({}, xd(i, c, u));
  n.length > 1 && (p.motionAppear = !1);
  var C = p.onVisibleChanged;
  return p.onVisibleChanged = function(S) {
    return !h.current && !S && f(!0), C == null ? void 0 : C(S);
  }, m ? null : /* @__PURE__ */ d.createElement(ha, {
    mode: i,
    locked: !h.current
  }, /* @__PURE__ */ d.createElement(ba, he({
    visible: y
  }, p, {
    forceRender: l,
    removeOnLeave: !1,
    leavedClassName: "".concat(s, "-hidden")
  }), function(S) {
    var E = S.className, w = S.style;
    return /* @__PURE__ */ d.createElement(Os, {
      id: t,
      className: E,
      style: w
    }, a);
  }));
}
var Kp = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], qp = ["active"], Up = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.style, n = e.className, a = e.title, i = e.eventKey, o = e.warnKey, s = e.disabled, l = e.internalPopupClose, c = e.children, u = e.itemIcon, v = e.expandIcon, h = e.popupClassName, b = e.popupOffset, g = e.popupStyle, m = e.onClick, f = e.onMouseEnter, y = e.onMouseLeave, p = e.onTitleClick, C = e.onTitleMouseEnter, S = e.onTitleMouseLeave, E = Le(e, Kp), w = md(i), P = d.useContext(gr), N = P.prefixCls, M = P.mode, _ = P.openKeys, x = P.disabled, R = P.overflowDisabled, $ = P.activeKey, T = P.selectedKeys, A = P.itemIcon, D = P.expandIcon, z = P.onItemClick, V = P.onOpenChange, k = P.onActive, B = d.useContext(_s), q = B._internalRenderSubMenuItem, W = d.useContext(bd), H = W.isSubPathKey, j = Sa(), K = "".concat(N, "-submenu"), J = x || s, Z = d.useRef(), ae = d.useRef();
  process.env.NODE_ENV !== "production" && o && Ae(!1, "SubMenu should not leave undefined `key`.");
  var oe = u ?? A, fe = v ?? D, me = _.includes(i), ue = !R && me, Ce = H(T, i), L = Sd(i, J, C, S), de = L.active, ye = Le(L, qp), Ge = d.useState(!1), Oe = F(Ge, 2), He = Oe[0], ve = Oe[1], U = function(Re) {
    J || ve(Re);
  }, pe = function(Re) {
    U(!0), f == null || f({
      key: i,
      domEvent: Re
    });
  }, se = function(Re) {
    U(!1), y == null || y({
      key: i,
      domEvent: Re
    });
  }, tt = d.useMemo(function() {
    return de || (M !== "inline" ? He || H([$], i) : !1);
  }, [M, de, $, He, i, H]), Ie = Ed(j.length), ge = function(Re) {
    J || (p == null || p({
      key: i,
      domEvent: Re
    }), M === "inline" && V(i, !me));
  }, mt = Qn(function(Me) {
    m == null || m(ai(Me)), z(Me);
  }), qe = function(Re) {
    M !== "inline" && V(i, Re);
  }, Xe = function() {
    k(i);
  }, pt = w && "".concat(w, "-popup"), at = d.useMemo(function() {
    return /* @__PURE__ */ d.createElement(wd, {
      icon: M !== "horizontal" ? fe : void 0,
      props: I(I({}, e), {}, {
        isOpen: ue,
        // [Legacy] Not sure why need this mark
        isSubMenu: !0
      })
    }, /* @__PURE__ */ d.createElement("i", {
      className: "".concat(K, "-arrow")
    }));
  }, [M, fe, e, ue, K]), Ye = /* @__PURE__ */ d.createElement("div", he({
    role: "menuitem",
    style: Ie,
    className: "".concat(K, "-title"),
    tabIndex: J ? null : -1,
    ref: Z,
    title: typeof a == "string" ? a : null,
    "data-menu-id": R && w ? null : w,
    "aria-expanded": ue,
    "aria-haspopup": !0,
    "aria-controls": pt,
    "aria-disabled": J,
    onClick: ge,
    onFocus: Xe
  }, ye), a, at), Ve = d.useRef(M);
  if (M !== "inline" && j.length > 1 ? Ve.current = "vertical" : Ve.current = M, !R) {
    var Ue = Ve.current;
    Ye = /* @__PURE__ */ d.createElement(Bp, {
      mode: Ue,
      prefixCls: K,
      visible: !l && ue && M !== "inline",
      popupClassName: h,
      popupOffset: b,
      popupStyle: g,
      popup: /* @__PURE__ */ d.createElement(
        ha,
        {
          mode: Ue === "horizontal" ? "vertical" : Ue
        },
        /* @__PURE__ */ d.createElement(Os, {
          id: pt,
          ref: ae
        }, c)
      ),
      disabled: J,
      onVisibleChange: qe
    }, Ye);
  }
  var xt = /* @__PURE__ */ d.createElement(_r.Item, he({
    ref: t,
    role: "none"
  }, E, {
    component: "li",
    style: r,
    className: ne(K, "".concat(K, "-").concat(M), n, O(O(O(O({}, "".concat(K, "-open"), ue), "".concat(K, "-active"), tt), "".concat(K, "-selected"), Ce), "".concat(K, "-disabled"), J)),
    onMouseEnter: pe,
    onMouseLeave: se
  }), Ye, !R && /* @__PURE__ */ d.createElement(Wp, {
    id: pt,
    open: ue,
    keyPath: j
  }, c));
  return q && (xt = q(xt, e, {
    selected: Ce,
    active: tt,
    open: ue,
    disabled: J
  })), /* @__PURE__ */ d.createElement(ha, {
    onItemClick: mt,
    mode: M === "horizontal" ? "vertical" : M,
    itemIcon: oe,
    expandIcon: fe
  }, xt);
}), xi = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.eventKey, n = e.children, a = Sa(r), i = Ms(n, a), o = Ei();
  d.useEffect(function() {
    if (o)
      return o.registerPath(r, a), function() {
        o.unregisterPath(r, a);
      };
  }, [a]);
  var s;
  return o ? s = i : s = /* @__PURE__ */ d.createElement(Up, he({
    ref: t
  }, e), i), /* @__PURE__ */ d.createElement(yd.Provider, {
    value: a
  }, s);
});
process.env.NODE_ENV !== "production" && (xi.displayName = "SubMenu");
function _d(e) {
  var t = e.className, r = e.style, n = d.useContext(gr), a = n.prefixCls, i = Ei();
  return i ? null : /* @__PURE__ */ d.createElement("li", {
    role: "separator",
    className: ne("".concat(a, "-item-divider"), t),
    style: r
  });
}
var Gp = ["className", "title", "eventKey", "children"], Xp = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.className, n = e.title;
  e.eventKey;
  var a = e.children, i = Le(e, Gp), o = d.useContext(gr), s = o.prefixCls, l = "".concat(s, "-item-group");
  return /* @__PURE__ */ d.createElement("li", he({
    ref: t,
    role: "presentation"
  }, i, {
    onClick: function(u) {
      return u.stopPropagation();
    },
    className: ne(l, r)
  }), /* @__PURE__ */ d.createElement("div", {
    role: "presentation",
    className: "".concat(l, "-title"),
    title: typeof n == "string" ? n : void 0
  }, n), /* @__PURE__ */ d.createElement("ul", {
    role: "group",
    className: "".concat(l, "-list")
  }, a));
}), Rs = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.eventKey, n = e.children, a = Sa(r), i = Ms(n, a), o = Ei();
  return o ? i : /* @__PURE__ */ d.createElement(Xp, he({
    ref: t
  }, Ur(e, ["warnKey"])), i);
});
process.env.NODE_ENV !== "production" && (Rs.displayName = "MenuItemGroup");
var Yp = ["label", "children", "key", "type", "extra"];
function Uo(e, t, r) {
  var n = t.item, a = t.group, i = t.submenu, o = t.divider;
  return (e || []).map(function(s, l) {
    if (s && le(s) === "object") {
      var c = s, u = c.label, v = c.children, h = c.key, b = c.type, g = c.extra, m = Le(c, Yp), f = h ?? "tmp-".concat(l);
      return v || b === "group" ? b === "group" ? /* @__PURE__ */ d.createElement(a, he({
        key: f
      }, m, {
        title: u
      }), Uo(v, t, r)) : /* @__PURE__ */ d.createElement(i, he({
        key: f
      }, m, {
        title: u
      }), Uo(v, t, r)) : b === "divider" ? /* @__PURE__ */ d.createElement(o, he({
        key: f
      }, m)) : /* @__PURE__ */ d.createElement(n, he({
        key: f
      }, m, {
        extra: g
      }), u, (!!g || g === 0) && /* @__PURE__ */ d.createElement("span", {
        className: "".concat(r, "-item-extra")
      }, g));
    }
    return null;
  }).filter(function(s) {
    return s;
  });
}
function sc(e, t, r, n, a) {
  var i = e, o = I({
    divider: _d,
    item: wi,
    group: Rs,
    submenu: xi
  }, n);
  return t && (i = Uo(t, o, a)), Ms(i, r);
}
var Qp = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem", "_internalComponents"], Hr = [], Zp = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r, n = e, a = n.prefixCls, i = a === void 0 ? "rc-menu" : a, o = n.rootClassName, s = n.style, l = n.className, c = n.tabIndex, u = c === void 0 ? 0 : c, v = n.items, h = n.children, b = n.direction, g = n.id, m = n.mode, f = m === void 0 ? "vertical" : m, y = n.inlineCollapsed, p = n.disabled, C = n.disabledOverflow, S = n.subMenuOpenDelay, E = S === void 0 ? 0.1 : S, w = n.subMenuCloseDelay, P = w === void 0 ? 0.1 : w, N = n.forceSubMenuRender, M = n.defaultOpenKeys, _ = n.openKeys, x = n.activeKey, R = n.defaultActiveFirst, $ = n.selectable, T = $ === void 0 ? !0 : $, A = n.multiple, D = A === void 0 ? !1 : A, z = n.defaultSelectedKeys, V = n.selectedKeys, k = n.onSelect, B = n.onDeselect, q = n.inlineIndent, W = q === void 0 ? 24 : q, H = n.motion, j = n.defaultMotions, K = n.triggerSubMenuAction, J = K === void 0 ? "hover" : K, Z = n.builtinPlacements, ae = n.itemIcon, oe = n.expandIcon, fe = n.overflowedIndicator, me = fe === void 0 ? "..." : fe, ue = n.overflowedIndicatorPopupClassName, Ce = n.getPopupContainer, L = n.onClick, de = n.onOpenChange, ye = n.onKeyDown, Ge = n.openAnimation, Oe = n.openTransitionName, He = n._internalRenderMenuItem, ve = n._internalRenderSubMenuItem, U = n._internalComponents, pe = Le(n, Qp), se = d.useMemo(function() {
    return [sc(h, v, Hr, U, i), sc(h, v, Hr, {}, i)];
  }, [h, v, U]), tt = F(se, 2), Ie = tt[0], ge = tt[1], mt = d.useState(!1), qe = F(mt, 2), Xe = qe[0], pt = qe[1], at = d.useRef(), Ye = Rp(g), Ve = b === "rtl";
  process.env.NODE_ENV !== "production" && Ae(!Ge && !Oe, "`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.");
  var Ue = hn(M, {
    value: _,
    postState: function(Te) {
      return Te || Hr;
    }
  }), xt = F(Ue, 2), Me = xt[0], Re = xt[1], dt = function(Te) {
    var We = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function Ot() {
      Re(Te), de == null || de(Te);
    }
    We ? Gd(Ot) : Ot();
  }, Xt = d.useState(Me), Bt = F(Xt, 2), jt = Bt[0], er = Bt[1], st = d.useRef(!1), Qe = d.useMemo(function() {
    return (f === "inline" || f === "vertical") && y ? ["vertical", y] : [f, !1];
  }, [f, y]), Je = F(Qe, 2), xe = Je[0], ee = Je[1], X = xe === "inline", ie = d.useState(xe), Ee = F(ie, 2), we = Ee[0], Tt = Ee[1], _e = d.useState(ee), zt = F(_e, 2), tr = zt[0], Pe = zt[1];
  d.useEffect(function() {
    Tt(xe), Pe(ee), st.current && (X ? Re(jt) : dt(Hr));
  }, [xe, ee]);
  var je = d.useState(0), yt = F(je, 2), rt = yt[0], It = yt[1], Wt = rt >= Ie.length - 1 || we !== "horizontal" || C;
  d.useEffect(function() {
    X && er(Me);
  }, [Me]), d.useEffect(function() {
    return st.current = !0, function() {
      st.current = !1;
    };
  }, []);
  var ft = Op(), At = ft.registerPath, _t = ft.unregisterPath, kt = ft.refreshOverflowKeys, Ft = ft.isSubPathKey, vt = ft.getKeyPath, nt = ft.getKeys, br = ft.getSubPathKeys, $e = d.useMemo(function() {
    return {
      registerPath: At,
      unregisterPath: _t
    };
  }, [At, _t]), re = d.useMemo(function() {
    return {
      isSubPathKey: Ft
    };
  }, [Ft]);
  d.useEffect(function() {
    kt(Wt ? Hr : Ie.slice(rt + 1).map(function(Be) {
      return Be.key;
    }));
  }, [rt, Wt]);
  var Ne = hn(x || R && ((r = Ie[0]) === null || r === void 0 ? void 0 : r.key), {
    value: x
  }), ze = F(Ne, 2), it = ze[0], lt = ze[1], Dt = Qn(function(Be) {
    lt(Be);
  }), bt = Qn(function() {
    lt(void 0);
  });
  Wd(t, function() {
    return {
      list: at.current,
      focus: function(Te) {
        var We, Ot = nt(), Pt = Ko(Ot, Ye), Mr = Pt.elements, zr = Pt.key2element, Yr = Pt.element2key, Qr = Ps(at.current, Mr), Zr = it ?? (Qr[0] ? Yr.get(Qr[0]) : (We = Ie.find(function(kn) {
          return !kn.props.disabled;
        })) === null || We === void 0 ? void 0 : We.key), cr = zr.get(Zr);
        if (Zr && cr) {
          var qt;
          cr == null || (qt = cr.focus) === null || qt === void 0 || qt.call(cr, Te);
        }
      }
    };
  });
  var rr = hn(z || [], {
    value: V,
    // Legacy convert key to array
    postState: function(Te) {
      return Array.isArray(Te) ? Te : Te == null ? Hr : [Te];
    }
  }), Ct = F(rr, 2), lr = Ct[0], $r = Ct[1], Kt = function(Te) {
    if (T) {
      var We = Te.key, Ot = lr.includes(We), Pt;
      D ? Ot ? Pt = lr.filter(function(zr) {
        return zr !== We;
      }) : Pt = [].concat(te(lr), [We]) : Pt = [We], $r(Pt);
      var Mr = I(I({}, Te), {}, {
        selectedKeys: Pt
      });
      Ot ? B == null || B(Mr) : k == null || k(Mr);
    }
    !D && Me.length && we !== "inline" && dt(Hr);
  }, Ht = Qn(function(Be) {
    L == null || L(ai(Be)), Kt(Be);
  }), Cr = Qn(function(Be, Te) {
    var We = Me.filter(function(Pt) {
      return Pt !== Be;
    });
    if (Te)
      We.push(Be);
    else if (we !== "inline") {
      var Ot = br(Be);
      We = We.filter(function(Pt) {
        return !Ot.has(Pt);
      });
    }
    ia(Me, We, !0) || dt(We, !0);
  }), Or = function(Te, We) {
    var Ot = We ?? !Me.includes(Te);
    Cr(Te, Ot);
  }, nr = _p(we, it, Ve, Ye, at, nt, vt, lt, Or, ye);
  d.useEffect(function() {
    pt(!0);
  }, []);
  var In = d.useMemo(function() {
    return {
      _internalRenderMenuItem: He,
      _internalRenderSubMenuItem: ve
    };
  }, [He, ve]), Xr = we !== "horizontal" || C ? Ie : (
    // Need wrap for overflow dropdown that do not response for open
    Ie.map(function(Be, Te) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ d.createElement(ha, {
          key: Be.key,
          overflowDisabled: Te > rt
        }, Be)
      );
    })
  ), An = /* @__PURE__ */ d.createElement(_r, he({
    id: g,
    ref: at,
    prefixCls: "".concat(i, "-overflow"),
    component: "ul",
    itemComponent: wi,
    className: ne(i, "".concat(i, "-root"), "".concat(i, "-").concat(we), l, O(O({}, "".concat(i, "-inline-collapsed"), tr), "".concat(i, "-rtl"), Ve), o),
    dir: b,
    style: s,
    role: "menu",
    tabIndex: u,
    data: Xr,
    renderRawItem: function(Te) {
      return Te;
    },
    renderRawRest: function(Te) {
      var We = Te.length, Ot = We ? Ie.slice(-We) : null;
      return /* @__PURE__ */ d.createElement(xi, {
        eventKey: qo,
        title: me,
        disabled: Wt,
        internalPopupClose: We === 0,
        popupClassName: ue
      }, Ot);
    },
    maxCount: we !== "horizontal" || C ? _r.INVALIDATE : _r.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(Te) {
      It(Te);
    },
    onKeyDown: nr
  }, pe));
  return /* @__PURE__ */ d.createElement(_s.Provider, {
    value: In
  }, /* @__PURE__ */ d.createElement(hd.Provider, {
    value: Ye
  }, /* @__PURE__ */ d.createElement(ha, {
    prefixCls: i,
    rootClassName: o,
    mode: we,
    openKeys: Me,
    rtl: Ve,
    disabled: p,
    motion: Xe ? H : null,
    defaultMotions: Xe ? j : null,
    activeKey: it,
    onActive: Dt,
    onInactive: bt,
    selectedKeys: lr,
    inlineIndent: W,
    subMenuOpenDelay: E,
    subMenuCloseDelay: P,
    forceSubMenuRender: N,
    builtinPlacements: Z,
    triggerSubMenuAction: J,
    getPopupContainer: Ce,
    itemIcon: ae,
    expandIcon: oe,
    onItemClick: Ht,
    onOpenChange: Cr
  }, /* @__PURE__ */ d.createElement(bd.Provider, {
    value: re
  }, An), /* @__PURE__ */ d.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ d.createElement(pd.Provider, {
    value: $e
  }, ge)))));
}), Ea = Zp;
Ea.Item = wi;
Ea.SubMenu = xi;
Ea.ItemGroup = Rs;
Ea.Divider = _d;
var Jp = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.id, a = e.tabs, i = e.locale, o = e.mobile, s = e.more, l = s === void 0 ? {} : s, c = e.style, u = e.className, v = e.editable, h = e.tabBarGutter, b = e.rtl, g = e.removeAriaLabel, m = e.onTabClick, f = e.getPopupContainer, y = e.popupClassName, p = Ze(!1), C = F(p, 2), S = C[0], E = C[1], w = Ze(null), P = F(w, 2), N = P[0], M = P[1], _ = l.icon, x = _ === void 0 ? "More" : _, R = "".concat(n, "-more-popup"), $ = "".concat(r, "-dropdown"), T = N !== null ? "".concat(R, "-").concat(N) : null, A = i == null ? void 0 : i.dropdownAriaLabel;
  function D(H, j) {
    H.preventDefault(), H.stopPropagation(), v.onEdit("remove", {
      key: j,
      event: H
    });
  }
  var z = /* @__PURE__ */ d.createElement(Ea, {
    onClick: function(j) {
      var K = j.key, J = j.domEvent;
      m(K, J), E(!1);
    },
    prefixCls: "".concat($, "-menu"),
    id: R,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": T,
    selectedKeys: [N],
    "aria-label": A !== void 0 ? A : "expanded dropdown"
  }, a.map(function(H) {
    var j = H.closable, K = H.disabled, J = H.closeIcon, Z = H.key, ae = H.label, oe = ws(j, J, v, K);
    return /* @__PURE__ */ d.createElement(wi, {
      key: Z,
      id: "".concat(R, "-").concat(Z),
      role: "option",
      "aria-controls": n && "".concat(n, "-panel-").concat(Z),
      disabled: K
    }, /* @__PURE__ */ d.createElement("span", null, ae), oe && /* @__PURE__ */ d.createElement("button", {
      type: "button",
      "aria-label": g || "remove",
      tabIndex: 0,
      className: "".concat($, "-menu-item-remove"),
      onClick: function(me) {
        me.stopPropagation(), D(me, Z);
      }
    }, J || v.removeIcon || "×"));
  }));
  function V(H) {
    for (var j = a.filter(function(oe) {
      return !oe.disabled;
    }), K = j.findIndex(function(oe) {
      return oe.key === N;
    }) || 0, J = j.length, Z = 0; Z < J; Z += 1) {
      K = (K + H + J) % J;
      var ae = j[K];
      if (!ae.disabled) {
        M(ae.key);
        return;
      }
    }
  }
  function k(H) {
    var j = H.which;
    if (!S) {
      [Et.DOWN, Et.SPACE, Et.ENTER].includes(j) && (E(!0), H.preventDefault());
      return;
    }
    switch (j) {
      case Et.UP:
        V(-1), H.preventDefault();
        break;
      case Et.DOWN:
        V(1), H.preventDefault();
        break;
      case Et.ESC:
        E(!1);
        break;
      case Et.SPACE:
      case Et.ENTER:
        N !== null && m(N, H);
        break;
    }
  }
  gt(function() {
    var H = document.getElementById(T);
    H && H.scrollIntoView && H.scrollIntoView(!1);
  }, [N]), gt(function() {
    S || M(null);
  }, [S]);
  var B = O({}, b ? "marginRight" : "marginLeft", h);
  a.length || (B.visibility = "hidden", B.order = 1);
  var q = ne(O({}, "".concat($, "-rtl"), b)), W = o ? null : /* @__PURE__ */ d.createElement(op, he({
    prefixCls: $,
    overlay: z,
    visible: a.length ? S : !1,
    onVisibleChange: E,
    overlayClassName: ne(q, y),
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    getPopupContainer: f
  }, l), /* @__PURE__ */ d.createElement("button", {
    type: "button",
    className: "".concat(r, "-nav-more"),
    style: B,
    "aria-haspopup": "listbox",
    "aria-controls": R,
    id: "".concat(n, "-more"),
    "aria-expanded": S,
    onKeyDown: k
  }, x));
  return /* @__PURE__ */ d.createElement("div", {
    className: ne("".concat(r, "-nav-operations"), u),
    style: c,
    ref: t
  }, W, /* @__PURE__ */ d.createElement(ad, {
    prefixCls: r,
    locale: i,
    editable: v
  }));
});
const e0 = /* @__PURE__ */ d.memo(Jp, function(e, t) {
  return (
    // https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    t.tabMoving
  );
});
var t0 = function(t) {
  var r = t.prefixCls, n = t.id, a = t.active, i = t.focus, o = t.tab, s = o.key, l = o.label, c = o.disabled, u = o.closeIcon, v = o.icon, h = t.closable, b = t.renderWrapper, g = t.removeAriaLabel, m = t.editable, f = t.onClick, y = t.onFocus, p = t.onBlur, C = t.onKeyDown, S = t.onMouseDown, E = t.onMouseUp, w = t.style, P = t.tabCount, N = t.currentPosition, M = "".concat(r, "-tab"), _ = ws(h, u, m, c);
  function x(D) {
    c || f(D);
  }
  function R(D) {
    D.preventDefault(), D.stopPropagation(), m.onEdit("remove", {
      key: s,
      event: D
    });
  }
  var $ = d.useMemo(function() {
    return v && typeof l == "string" ? /* @__PURE__ */ d.createElement("span", null, l) : l;
  }, [l, v]), T = d.useRef(null);
  d.useEffect(function() {
    i && T.current && T.current.focus();
  }, [i]);
  var A = /* @__PURE__ */ d.createElement("div", {
    key: s,
    "data-node-key": nd(s),
    className: ne(M, O(O(O(O({}, "".concat(M, "-with-remove"), _), "".concat(M, "-active"), a), "".concat(M, "-disabled"), c), "".concat(M, "-focus"), i)),
    style: w,
    onClick: x
  }, /* @__PURE__ */ d.createElement("div", {
    ref: T,
    role: "tab",
    "aria-selected": a,
    id: n && "".concat(n, "-tab-").concat(s),
    className: "".concat(M, "-btn"),
    "aria-controls": n && "".concat(n, "-panel-").concat(s),
    "aria-disabled": c,
    tabIndex: c ? null : a ? 0 : -1,
    onClick: function(z) {
      z.stopPropagation(), x(z);
    },
    onKeyDown: C,
    onMouseDown: S,
    onMouseUp: E,
    onFocus: y,
    onBlur: p
  }, i && /* @__PURE__ */ d.createElement("div", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "Tab ".concat(N, " of ").concat(P)), v && /* @__PURE__ */ d.createElement("span", {
    className: "".concat(M, "-icon")
  }, v), l && $), _ && /* @__PURE__ */ d.createElement("button", {
    type: "button",
    role: "tab",
    "aria-label": g || "remove",
    tabIndex: a ? 0 : -1,
    className: "".concat(M, "-remove"),
    onClick: function(z) {
      z.stopPropagation(), R(z);
    }
  }, u || m.removeIcon || "×"));
  return b ? b(A) : A;
}, r0 = function(t, r) {
  var n = t.offsetWidth, a = t.offsetHeight, i = t.offsetTop, o = t.offsetLeft, s = t.getBoundingClientRect(), l = s.width, c = s.height, u = s.left, v = s.top;
  return Math.abs(l - n) < 1 ? [l, c, u - r.left, v - r.top] : [n, a, o, i];
}, on = function(t) {
  var r = t.current || {}, n = r.offsetWidth, a = n === void 0 ? 0 : n, i = r.offsetHeight, o = i === void 0 ? 0 : i;
  if (t.current) {
    var s = t.current.getBoundingClientRect(), l = s.width, c = s.height;
    if (Math.abs(l - a) < 1)
      return [l, c];
  }
  return [a, o];
}, Va = function(t, r) {
  return t[r ? 0 : 1];
}, lc = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.className, n = e.style, a = e.id, i = e.animated, o = e.activeKey, s = e.rtl, l = e.extra, c = e.editable, u = e.locale, v = e.tabPosition, h = e.tabBarGutter, b = e.children, g = e.onTabClick, m = e.onTabScroll, f = e.indicator, y = d.useContext(Ci), p = y.prefixCls, C = y.tabs, S = De(null), E = De(null), w = De(null), P = De(null), N = De(null), M = De(null), _ = De(null), x = v === "top" || v === "bottom", R = Vl(0, function($e, re) {
    x && m && m({
      direction: $e > re ? "left" : "right"
    });
  }), $ = F(R, 2), T = $[0], A = $[1], D = Vl(0, function($e, re) {
    !x && m && m({
      direction: $e > re ? "top" : "bottom"
    });
  }), z = F(D, 2), V = z[0], k = z[1], B = Ze([0, 0]), q = F(B, 2), W = q[0], H = q[1], j = Ze([0, 0]), K = F(j, 2), J = K[0], Z = K[1], ae = Ze([0, 0]), oe = F(ae, 2), fe = oe[0], me = oe[1], ue = Ze([0, 0]), Ce = F(ue, 2), L = Ce[0], de = Ce[1], ye = Rm(/* @__PURE__ */ new Map()), Ge = F(ye, 2), Oe = Ge[0], He = Ge[1], ve = $m(C, Oe, J[0]), U = Va(W, x), pe = Va(J, x), se = Va(fe, x), tt = Va(L, x), Ie = Math.floor(U) < Math.floor(pe + se), ge = Ie ? U - tt : U - se, mt = "".concat(p, "-nav-operations-hidden"), qe = 0, Xe = 0;
  x && s ? (qe = 0, Xe = Math.max(0, pe - ge)) : (qe = Math.min(0, ge - pe), Xe = 0);
  function pt($e) {
    return $e < qe ? qe : $e > Xe ? Xe : $e;
  }
  var at = De(null), Ye = Ze(), Ve = F(Ye, 2), Ue = Ve[0], xt = Ve[1];
  function Me() {
    xt(Date.now());
  }
  function Re() {
    at.current && clearTimeout(at.current);
  }
  Mm(P, function($e, re) {
    function Ne(ze, it) {
      ze(function(lt) {
        var Dt = pt(lt + it);
        return Dt;
      });
    }
    return Ie ? (x ? Ne(A, $e) : Ne(k, re), Re(), Me(), !0) : !1;
  }), gt(function() {
    return Re(), Ue && (at.current = setTimeout(function() {
      xt(0);
    }, 100)), Re;
  }, [Ue]);
  var dt = Nm(
    ve,
    // Container
    ge,
    // Transform
    x ? T : V,
    // Tabs
    pe,
    // Add
    se,
    // Operation
    tt,
    I(I({}, e), {}, {
      tabs: C
    })
  ), Xt = F(dt, 2), Bt = Xt[0], jt = Xt[1], er = Ut(function() {
    var $e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : o, re = ve.get($e) || {
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0
    };
    if (x) {
      var Ne = T;
      s ? re.right < T ? Ne = re.right : re.right + re.width > T + ge && (Ne = re.right + re.width - ge) : re.left < -T ? Ne = -re.left : re.left + re.width > -T + ge && (Ne = -(re.left + re.width - ge)), k(0), A(pt(Ne));
    } else {
      var ze = V;
      re.top < -V ? ze = -re.top : re.top + re.height > -V + ge && (ze = -(re.top + re.height - ge)), A(0), k(pt(ze));
    }
  }), st = Ze(), Qe = F(st, 2), Je = Qe[0], xe = Qe[1], ee = Ze(!1), X = F(ee, 2), ie = X[0], Ee = X[1], we = C.filter(function($e) {
    return !$e.disabled;
  }).map(function($e) {
    return $e.key;
  }), Tt = function(re) {
    var Ne = we.indexOf(Je || o), ze = we.length, it = (Ne + re + ze) % ze, lt = we[it];
    xe(lt);
  }, _e = function(re) {
    var Ne = re.code, ze = s && x, it = we[0], lt = we[we.length - 1];
    switch (Ne) {
      // LEFT
      case "ArrowLeft": {
        x && Tt(ze ? 1 : -1);
        break;
      }
      // RIGHT
      case "ArrowRight": {
        x && Tt(ze ? -1 : 1);
        break;
      }
      // UP
      case "ArrowUp": {
        re.preventDefault(), x || Tt(-1);
        break;
      }
      // DOWN
      case "ArrowDown": {
        re.preventDefault(), x || Tt(1);
        break;
      }
      // HOME
      case "Home": {
        re.preventDefault(), xe(it);
        break;
      }
      // END
      case "End": {
        re.preventDefault(), xe(lt);
        break;
      }
      // Enter & Space
      case "Enter":
      case "Space": {
        re.preventDefault(), g(Je ?? o, re);
        break;
      }
      // Backspace
      case "Backspace":
      case "Delete": {
        var Dt = we.indexOf(Je), bt = C.find(function(Ct) {
          return Ct.key === Je;
        }), rr = ws(bt == null ? void 0 : bt.closable, bt == null ? void 0 : bt.closeIcon, c, bt == null ? void 0 : bt.disabled);
        rr && (re.preventDefault(), re.stopPropagation(), c.onEdit("remove", {
          key: Je,
          event: re
        }), Dt === we.length - 1 ? Tt(-1) : Tt(1));
        break;
      }
    }
  }, zt = {};
  x ? zt[s ? "marginRight" : "marginLeft"] = h : zt.marginTop = h;
  var tr = C.map(function($e, re) {
    var Ne = $e.key;
    return /* @__PURE__ */ d.createElement(t0, {
      id: a,
      prefixCls: p,
      key: Ne,
      tab: $e,
      style: re === 0 ? void 0 : zt,
      closable: $e.closable,
      editable: c,
      active: Ne === o,
      focus: Ne === Je,
      renderWrapper: b,
      removeAriaLabel: u == null ? void 0 : u.removeAriaLabel,
      tabCount: we.length,
      currentPosition: re + 1,
      onClick: function(it) {
        g(Ne, it);
      },
      onKeyDown: _e,
      onFocus: function() {
        ie || xe(Ne), er(Ne), Me(), P.current && (s || (P.current.scrollLeft = 0), P.current.scrollTop = 0);
      },
      onBlur: function() {
        xe(void 0);
      },
      onMouseDown: function() {
        Ee(!0);
      },
      onMouseUp: function() {
        Ee(!1);
      }
    });
  }), Pe = function() {
    return He(function() {
      var re, Ne = /* @__PURE__ */ new Map(), ze = (re = N.current) === null || re === void 0 ? void 0 : re.getBoundingClientRect();
      return C.forEach(function(it) {
        var lt, Dt = it.key, bt = (lt = N.current) === null || lt === void 0 ? void 0 : lt.querySelector('[data-node-key="'.concat(nd(Dt), '"]'));
        if (bt) {
          var rr = r0(bt, ze), Ct = F(rr, 4), lr = Ct[0], $r = Ct[1], Kt = Ct[2], Ht = Ct[3];
          Ne.set(Dt, {
            width: lr,
            height: $r,
            left: Kt,
            top: Ht
          });
        }
      }), Ne;
    });
  };
  gt(function() {
    Pe();
  }, [C.map(function($e) {
    return $e.key;
  }).join("_")]);
  var je = rd(function() {
    var $e = on(S), re = on(E), Ne = on(w);
    H([$e[0] - re[0] - Ne[0], $e[1] - re[1] - Ne[1]]);
    var ze = on(_);
    me(ze);
    var it = on(M);
    de(it);
    var lt = on(N);
    Z([lt[0] - ze[0], lt[1] - ze[1]]), Pe();
  }), yt = C.slice(0, Bt), rt = C.slice(jt + 1), It = [].concat(te(yt), te(rt)), Wt = ve.get(o), ft = Pm({
    activeTabOffset: Wt,
    horizontal: x,
    indicator: f,
    rtl: s
  }), At = ft.style;
  gt(function() {
    er();
  }, [o, qe, Xe, Bl(Wt), Bl(ve), x]), gt(function() {
    je();
  }, [s]);
  var _t = !!It.length, kt = "".concat(p, "-nav-wrap"), Ft, vt, nt, br;
  return x ? s ? (vt = T > 0, Ft = T !== Xe) : (Ft = T < 0, vt = T !== qe) : (nt = V < 0, br = V !== qe), /* @__PURE__ */ d.createElement(xr, {
    onResize: je
  }, /* @__PURE__ */ d.createElement("div", {
    ref: ma(t, S),
    role: "tablist",
    "aria-orientation": x ? "horizontal" : "vertical",
    className: ne("".concat(p, "-nav"), r),
    style: n,
    onKeyDown: function() {
      Me();
    }
  }, /* @__PURE__ */ d.createElement(jo, {
    ref: E,
    position: "left",
    extra: l,
    prefixCls: p
  }), /* @__PURE__ */ d.createElement(xr, {
    onResize: je
  }, /* @__PURE__ */ d.createElement("div", {
    className: ne(kt, O(O(O(O({}, "".concat(kt, "-ping-left"), Ft), "".concat(kt, "-ping-right"), vt), "".concat(kt, "-ping-top"), nt), "".concat(kt, "-ping-bottom"), br)),
    ref: P
  }, /* @__PURE__ */ d.createElement(xr, {
    onResize: je
  }, /* @__PURE__ */ d.createElement("div", {
    ref: N,
    className: "".concat(p, "-nav-list"),
    style: {
      transform: "translate(".concat(T, "px, ").concat(V, "px)"),
      transition: Ue ? "none" : void 0
    }
  }, tr, /* @__PURE__ */ d.createElement(ad, {
    ref: _,
    prefixCls: p,
    locale: u,
    editable: c,
    style: I(I({}, tr.length === 0 ? void 0 : zt), {}, {
      visibility: _t ? "hidden" : null
    })
  }), /* @__PURE__ */ d.createElement("div", {
    className: ne("".concat(p, "-ink-bar"), O({}, "".concat(p, "-ink-bar-animated"), i.inkBar)),
    style: At
  }))))), /* @__PURE__ */ d.createElement(e0, he({}, e, {
    removeAriaLabel: u == null ? void 0 : u.removeAriaLabel,
    ref: M,
    prefixCls: p,
    tabs: It,
    className: !_t && mt,
    tabMoving: !!Ue
  })), /* @__PURE__ */ d.createElement(jo, {
    ref: w,
    position: "right",
    extra: l,
    prefixCls: p
  })));
}), Ns = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.className, a = e.style, i = e.id, o = e.active, s = e.tabKey, l = e.children;
  return /* @__PURE__ */ d.createElement("div", {
    id: i && "".concat(i, "-panel-").concat(s),
    role: "tabpanel",
    tabIndex: o ? 0 : -1,
    "aria-labelledby": i && "".concat(i, "-tab-").concat(s),
    "aria-hidden": !o,
    style: a,
    className: ne(r, o && "".concat(r, "-active"), n),
    ref: t
  }, l);
});
process.env.NODE_ENV !== "production" && (Ns.displayName = "TabPane");
var n0 = ["renderTabBar"], a0 = ["label", "key"], Pd = function(t) {
  var r = t.renderTabBar, n = Le(t, n0), a = d.useContext(Ci), i = a.tabs;
  if (r) {
    var o = I(I({}, n), {}, {
      // Legacy support. We do not use this actually
      panes: i.map(function(s) {
        var l = s.label, c = s.key, u = Le(s, a0);
        return /* @__PURE__ */ d.createElement(Ns, he({
          tab: l,
          key: c,
          tabKey: c
        }, u));
      })
    });
    return r(o, lc);
  }
  return /* @__PURE__ */ d.createElement(lc, n);
};
process.env.NODE_ENV !== "production" && (Pd.displayName = "TabNavListWrapper");
var i0 = ["key", "forceRender", "style", "className", "destroyInactiveTabPane"], o0 = function(t) {
  var r = t.id, n = t.activeKey, a = t.animated, i = t.tabPosition, o = t.destroyInactiveTabPane, s = d.useContext(Ci), l = s.prefixCls, c = s.tabs, u = a.tabPane, v = "".concat(l, "-tabpane");
  return /* @__PURE__ */ d.createElement("div", {
    className: ne("".concat(l, "-content-holder"))
  }, /* @__PURE__ */ d.createElement("div", {
    className: ne("".concat(l, "-content"), "".concat(l, "-content-").concat(i), O({}, "".concat(l, "-content-animated"), u))
  }, c.map(function(h) {
    var b = h.key, g = h.forceRender, m = h.style, f = h.className, y = h.destroyInactiveTabPane, p = Le(h, i0), C = b === n;
    return /* @__PURE__ */ d.createElement(ba, he({
      key: b,
      visible: C,
      forceRender: g,
      removeOnLeave: !!(o || y),
      leavedClassName: "".concat(v, "-hidden")
    }, a.tabPaneMotion), function(S, E) {
      var w = S.style, P = S.className;
      return /* @__PURE__ */ d.createElement(Ns, he({}, p, {
        prefixCls: v,
        id: r,
        tabKey: b,
        animated: u,
        active: C,
        style: I(I({}, m), w),
        className: ne(f, P),
        ref: E
      }));
    });
  })));
};
function s0() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    inkBar: !0,
    tabPane: !1
  }, t;
  return e === !1 ? t = {
    inkBar: !1,
    tabPane: !1
  } : e === !0 ? t = {
    inkBar: !0,
    tabPane: !1
  } : t = I({
    inkBar: !0
  }, le(e) === "object" ? e : {}), t.tabPaneMotion && t.tabPane === void 0 && (t.tabPane = !0), !t.tabPaneMotion && t.tabPane && (process.env.NODE_ENV !== "production" && Ae(!1, "`animated.tabPane` is true but `animated.tabPaneMotion` is not provided. Motion will not work."), t.tabPane = !1), t;
}
var l0 = ["id", "prefixCls", "className", "items", "direction", "activeKey", "defaultActiveKey", "editable", "animated", "tabPosition", "tabBarGutter", "tabBarStyle", "tabBarExtraContent", "locale", "more", "destroyInactiveTabPane", "renderTabBar", "onChange", "onTabClick", "onTabScroll", "getPopupContainer", "popupClassName", "indicator"], cc = 0, $d = /* @__PURE__ */ d.forwardRef(function(e, t) {
  var r = e.id, n = e.prefixCls, a = n === void 0 ? "rc-tabs" : n, i = e.className, o = e.items, s = e.direction, l = e.activeKey, c = e.defaultActiveKey, u = e.editable, v = e.animated, h = e.tabPosition, b = h === void 0 ? "top" : h, g = e.tabBarGutter, m = e.tabBarStyle, f = e.tabBarExtraContent, y = e.locale, p = e.more, C = e.destroyInactiveTabPane, S = e.renderTabBar, E = e.onChange, w = e.onTabClick, P = e.onTabScroll, N = e.getPopupContainer, M = e.popupClassName, _ = e.indicator, x = Le(e, l0), R = d.useMemo(function() {
    return (o || []).filter(function(L) {
      return L && le(L) === "object" && "key" in L;
    });
  }, [o]), $ = s === "rtl", T = s0(v), A = Ze(!1), D = F(A, 2), z = D[0], V = D[1];
  gt(function() {
    V(Uu());
  }, []);
  var k = hn(function() {
    var L;
    return (L = R[0]) === null || L === void 0 ? void 0 : L.key;
  }, {
    value: l,
    defaultValue: c
  }), B = F(k, 2), q = B[0], W = B[1], H = Ze(function() {
    return R.findIndex(function(L) {
      return L.key === q;
    });
  }), j = F(H, 2), K = j[0], J = j[1];
  gt(function() {
    var L = R.findIndex(function(ye) {
      return ye.key === q;
    });
    if (L === -1) {
      var de;
      L = Math.max(0, Math.min(K, R.length - 1)), W((de = R[L]) === null || de === void 0 ? void 0 : de.key);
    }
    J(L);
  }, [R.map(function(L) {
    return L.key;
  }).join("_"), q, K]);
  var Z = hn(null, {
    value: r
  }), ae = F(Z, 2), oe = ae[0], fe = ae[1];
  gt(function() {
    r || (fe("rc-tabs-".concat(process.env.NODE_ENV === "test" ? "test" : cc)), cc += 1);
  }, []);
  function me(L, de) {
    w == null || w(L, de);
    var ye = L !== q;
    W(L), ye && (E == null || E(L));
  }
  var ue = {
    id: oe,
    activeKey: q,
    animated: T,
    tabPosition: b,
    rtl: $,
    mobile: z
  }, Ce = I(I({}, ue), {}, {
    editable: u,
    locale: y,
    more: p,
    tabBarGutter: g,
    onTabClick: me,
    onTabScroll: P,
    extra: f,
    style: m,
    panes: null,
    getPopupContainer: N,
    popupClassName: M,
    indicator: _
  });
  return /* @__PURE__ */ d.createElement(Ci.Provider, {
    value: {
      tabs: R,
      prefixCls: a
    }
  }, /* @__PURE__ */ d.createElement("div", he({
    ref: t,
    id: r,
    className: ne(a, "".concat(a, "-").concat(b), O(O(O({}, "".concat(a, "-mobile"), z), "".concat(a, "-editable"), u), "".concat(a, "-rtl"), $), i)
  }, x), /* @__PURE__ */ d.createElement(Pd, he({}, Ce, {
    renderTabBar: S
  })), /* @__PURE__ */ d.createElement(o0, he({
    destroyInactiveTabPane: C
  }, ue, {
    animated: T
  }))));
});
process.env.NODE_ENV !== "production" && ($d.displayName = "Tabs");
const c0 = (e) => {
  const [, , , , t] = gi();
  return t ? `${e}-css-var` : "";
}, u0 = (e, t, r) => `${e}-${t}`, d0 = {
  motionAppear: !1,
  motionEnter: !0,
  motionLeave: !0
};
function f0(e, t = {
  inkBar: !0,
  tabPane: !1
}) {
  let r;
  return t === !1 ? r = {
    inkBar: !1,
    tabPane: !1
  } : t === !0 ? r = {
    inkBar: !0,
    tabPane: !0
  } : r = Object.assign({
    inkBar: !0
  }, typeof t == "object" ? t : {}), r.tabPane && (r.tabPaneMotion = Object.assign(Object.assign({}, d0), {
    motionName: u0(e, "switch")
  })), r;
}
var v0 = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function h0(e) {
  return e.filter((t) => t);
}
function g0(e, t) {
  if (process.env.NODE_ENV !== "production" && qr("Tabs").deprecated(!t, "Tabs.TabPane", "items"), e)
    return e.map((n) => {
      var a;
      const i = (a = n.destroyOnHidden) !== null && a !== void 0 ? a : n.destroyInactiveTabPane;
      return Object.assign(Object.assign({}, n), {
        // TODO: In the future, destroyInactiveTabPane in rc-tabs needs to be upgrade to destroyOnHidden
        destroyInactiveTabPane: i
      });
    });
  const r = xn(t).map((n) => {
    if (/* @__PURE__ */ d.isValidElement(n)) {
      const {
        key: a,
        props: i
      } = n, o = i || {}, {
        tab: s
      } = o, l = v0(o, ["tab"]);
      return Object.assign(Object.assign({
        key: String(a)
      }, l), {
        label: s
      });
    }
    return null;
  });
  return h0(r);
}
const m0 = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), p0 = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), y0 = (e, t, r, n, a = !1) => {
  const i = a ? "&" : "";
  return {
    [`
      ${i}${e}-enter,
      ${i}${e}-appear
    `]: Object.assign(Object.assign({}, m0(n)), {
      animationPlayState: "paused"
    }),
    [`${i}${e}-leave`]: Object.assign(Object.assign({}, p0(n)), {
      animationPlayState: "paused"
    }),
    [`
      ${i}${e}-enter${e}-enter-active,
      ${i}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${i}${e}-leave${e}-leave-active`]: {
      animationName: r,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, b0 = new Pr("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), C0 = new Pr("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), S0 = new Pr("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), E0 = new Pr("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), w0 = new Pr("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), x0 = new Pr("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), _0 = new Pr("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), P0 = new Pr("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), $0 = {
  "slide-up": {
    inKeyframes: b0,
    outKeyframes: C0
  },
  "slide-down": {
    inKeyframes: S0,
    outKeyframes: E0
  },
  "slide-left": {
    inKeyframes: w0,
    outKeyframes: x0
  },
  "slide-right": {
    inKeyframes: _0,
    outKeyframes: P0
  }
}, uc = (e, t) => {
  const {
    antCls: r
  } = e, n = `${r}-${t}`, {
    inKeyframes: a,
    outKeyframes: i
  } = $0[t];
  return [y0(n, a, i, e.motionDurationMid), {
    [`
      ${n}-enter,
      ${n}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${n}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
}, O0 = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: r
  } = e;
  return [
    {
      [t]: {
        [`${t}-switch`]: {
          "&-appear, &-enter": {
            transition: "none",
            "&-start": {
              opacity: 0
            },
            "&-active": {
              opacity: 1,
              transition: `opacity ${r}`
            }
          },
          "&-leave": {
            position: "absolute",
            transition: "none",
            inset: 0,
            "&-start": {
              opacity: 1
            },
            "&-active": {
              opacity: 0,
              transition: `opacity ${r}`
            }
          }
        }
      }
    },
    // Follow code may reuse in other components
    [uc(e, "slide-up"), uc(e, "slide-down")]
  ];
}, M0 = (e) => {
  const {
    componentCls: t,
    tabsCardPadding: r,
    cardBg: n,
    cardGutter: a,
    colorBorderSecondary: i,
    itemSelectedColor: o
  } = e;
  return {
    [`${t}-card`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-tab`]: {
          margin: 0,
          padding: r,
          background: n,
          border: `${G(e.lineWidth)} ${e.lineType} ${i}`,
          transition: `all ${e.motionDurationSlow} ${e.motionEaseInOut}`
        },
        [`${t}-tab-active`]: {
          color: o,
          background: e.colorBgContainer
        },
        [`${t}-tab-focus`]: Object.assign({}, Cs(e, -3)),
        [`${t}-ink-bar`]: {
          visibility: "hidden"
        },
        [`& ${t}-tab${t}-tab-focus ${t}-tab-btn`]: {
          outline: "none"
        }
      },
      // ========================== Top & Bottom ==========================
      [`&${t}-top, &${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginLeft: {
              _skip_check_: !0,
              value: G(a)
            }
          }
        }
      },
      [`&${t}-top`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: `${G(e.borderRadiusLG)} ${G(e.borderRadiusLG)} 0 0`
          },
          [`${t}-tab-active`]: {
            borderBottomColor: e.colorBgContainer
          }
        }
      },
      [`&${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: `0 0 ${G(e.borderRadiusLG)} ${G(e.borderRadiusLG)}`
          },
          [`${t}-tab-active`]: {
            borderTopColor: e.colorBgContainer
          }
        }
      },
      // ========================== Left & Right ==========================
      [`&${t}-left, &${t}-right`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginTop: G(a)
          }
        }
      },
      [`&${t}-left`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${G(e.borderRadiusLG)} 0 0 ${G(e.borderRadiusLG)}`
            }
          },
          [`${t}-tab-active`]: {
            borderRightColor: {
              _skip_check_: !0,
              value: e.colorBgContainer
            }
          }
        }
      },
      [`&${t}-right`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${G(e.borderRadiusLG)} ${G(e.borderRadiusLG)} 0`
            }
          },
          [`${t}-tab-active`]: {
            borderLeftColor: {
              _skip_check_: !0,
              value: e.colorBgContainer
            }
          }
        }
      }
    }
  };
}, R0 = (e) => {
  const {
    componentCls: t,
    itemHoverColor: r,
    dropdownEdgeChildVerticalPadding: n
  } = e;
  return {
    [`${t}-dropdown`]: Object.assign(Object.assign({}, bs(e)), {
      position: "absolute",
      top: -9999,
      left: {
        _skip_check_: !0,
        value: -9999
      },
      zIndex: e.zIndexPopup,
      display: "block",
      "&-hidden": {
        display: "none"
      },
      [`${t}-dropdown-menu`]: {
        maxHeight: e.tabsDropdownHeight,
        margin: 0,
        padding: `${G(n)} 0`,
        overflowX: "hidden",
        overflowY: "auto",
        textAlign: {
          _skip_check_: !0,
          value: "left"
        },
        listStyleType: "none",
        backgroundColor: e.colorBgContainer,
        backgroundClip: "padding-box",
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        "&-item": Object.assign(Object.assign({}, ys), {
          display: "flex",
          alignItems: "center",
          minWidth: e.tabsDropdownWidth,
          margin: 0,
          padding: `${G(e.paddingXXS)} ${G(e.paddingSM)}`,
          color: e.colorText,
          fontWeight: "normal",
          fontSize: e.fontSize,
          lineHeight: e.lineHeight,
          cursor: "pointer",
          transition: `all ${e.motionDurationSlow}`,
          "> span": {
            flex: 1,
            whiteSpace: "nowrap"
          },
          "&-remove": {
            flex: "none",
            marginLeft: {
              _skip_check_: !0,
              value: e.marginSM
            },
            color: e.colorIcon,
            fontSize: e.fontSizeSM,
            background: "transparent",
            border: 0,
            cursor: "pointer",
            "&:hover": {
              color: r
            }
          },
          "&:hover": {
            background: e.controlItemBgHover
          },
          "&-disabled": {
            "&, &:hover": {
              color: e.colorTextDisabled,
              background: "transparent",
              cursor: "not-allowed"
            }
          }
        })
      }
    })
  };
}, N0 = (e) => {
  const {
    componentCls: t,
    margin: r,
    colorBorderSecondary: n,
    horizontalMargin: a,
    verticalItemPadding: i,
    verticalItemMargin: o,
    calc: s
  } = e;
  return {
    // ========================== Top & Bottom ==========================
    [`${t}-top, ${t}-bottom`]: {
      flexDirection: "column",
      [`> ${t}-nav, > div > ${t}-nav`]: {
        margin: a,
        "&::before": {
          position: "absolute",
          right: {
            _skip_check_: !0,
            value: 0
          },
          left: {
            _skip_check_: !0,
            value: 0
          },
          borderBottom: `${G(e.lineWidth)} ${e.lineType} ${n}`,
          content: "''"
        },
        [`${t}-ink-bar`]: {
          height: e.lineWidthBold,
          "&-animated": {
            transition: `width ${e.motionDurationSlow}, left ${e.motionDurationSlow},
            right ${e.motionDurationSlow}`
          }
        },
        [`${t}-nav-wrap`]: {
          "&::before, &::after": {
            top: 0,
            bottom: 0,
            width: e.controlHeight
          },
          "&::before": {
            left: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: e.boxShadowTabsOverflowLeft
          },
          "&::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: e.boxShadowTabsOverflowRight
          },
          [`&${t}-nav-wrap-ping-left::before`]: {
            opacity: 1
          },
          [`&${t}-nav-wrap-ping-right::after`]: {
            opacity: 1
          }
        }
      }
    },
    [`${t}-top`]: {
      [`> ${t}-nav,
        > div > ${t}-nav`]: {
        "&::before": {
          bottom: 0
        },
        [`${t}-ink-bar`]: {
          bottom: 0
        }
      }
    },
    [`${t}-bottom`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        order: 1,
        marginTop: r,
        marginBottom: 0,
        "&::before": {
          top: 0
        },
        [`${t}-ink-bar`]: {
          top: 0
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        order: 0
      }
    },
    // ========================== Left & Right ==========================
    [`${t}-left, ${t}-right`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        flexDirection: "column",
        minWidth: s(e.controlHeight).mul(1.25).equal(),
        // >>>>>>>>>>> Tab
        [`${t}-tab`]: {
          padding: i,
          textAlign: "center"
        },
        [`${t}-tab + ${t}-tab`]: {
          margin: o
        },
        // >>>>>>>>>>> Nav
        [`${t}-nav-wrap`]: {
          flexDirection: "column",
          "&::before, &::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: e.controlHeight
          },
          "&::before": {
            top: 0,
            boxShadow: e.boxShadowTabsOverflowTop
          },
          "&::after": {
            bottom: 0,
            boxShadow: e.boxShadowTabsOverflowBottom
          },
          [`&${t}-nav-wrap-ping-top::before`]: {
            opacity: 1
          },
          [`&${t}-nav-wrap-ping-bottom::after`]: {
            opacity: 1
          }
        },
        // >>>>>>>>>>> Ink Bar
        [`${t}-ink-bar`]: {
          width: e.lineWidthBold,
          "&-animated": {
            transition: `height ${e.motionDurationSlow}, top ${e.motionDurationSlow}`
          }
        },
        [`${t}-nav-list, ${t}-nav-operations`]: {
          flex: "1 0 auto",
          // fix safari scroll problem
          flexDirection: "column"
        }
      }
    },
    [`${t}-left`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-ink-bar`]: {
          right: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        marginLeft: {
          _skip_check_: !0,
          value: G(s(e.lineWidth).mul(-1).equal())
        },
        borderLeft: {
          _skip_check_: !0,
          value: `${G(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        [`> ${t}-content > ${t}-tabpane`]: {
          paddingLeft: {
            _skip_check_: !0,
            value: e.paddingLG
          }
        }
      }
    },
    [`${t}-right`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        order: 1,
        [`${t}-ink-bar`]: {
          left: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        order: 0,
        marginRight: {
          _skip_check_: !0,
          value: s(e.lineWidth).mul(-1).equal()
        },
        borderRight: {
          _skip_check_: !0,
          value: `${G(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        [`> ${t}-content > ${t}-tabpane`]: {
          paddingRight: {
            _skip_check_: !0,
            value: e.paddingLG
          }
        }
      }
    }
  };
}, T0 = (e) => {
  const {
    componentCls: t,
    cardPaddingSM: r,
    cardPaddingLG: n,
    cardHeightSM: a,
    cardHeightLG: i,
    horizontalItemPaddingSM: o,
    horizontalItemPaddingLG: s
  } = e;
  return {
    // >>>>> shared
    [t]: {
      "&-small": {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: o,
            fontSize: e.titleFontSizeSM
          }
        }
      },
      "&-large": {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: s,
            fontSize: e.titleFontSizeLG,
            lineHeight: e.lineHeightLG
          }
        }
      }
    },
    // >>>>> card
    [`${t}-card`]: {
      // Small
      [`&${t}-small`]: {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: r
          },
          [`${t}-nav-add`]: {
            minWidth: a,
            minHeight: a
          }
        },
        [`&${t}-bottom`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: `0 0 ${G(e.borderRadius)} ${G(e.borderRadius)}`
          }
        },
        [`&${t}-top`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: `${G(e.borderRadius)} ${G(e.borderRadius)} 0 0`
          }
        },
        [`&${t}-right`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${G(e.borderRadius)} ${G(e.borderRadius)} 0`
            }
          }
        },
        [`&${t}-left`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${G(e.borderRadius)} 0 0 ${G(e.borderRadius)}`
            }
          }
        }
      },
      // Large
      [`&${t}-large`]: {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: n
          },
          [`${t}-nav-add`]: {
            minWidth: i,
            minHeight: i
          }
        }
      }
    }
  };
}, I0 = (e) => {
  const {
    componentCls: t,
    itemActiveColor: r,
    itemHoverColor: n,
    iconCls: a,
    tabsHorizontalItemMargin: i,
    horizontalItemPadding: o,
    itemSelectedColor: s,
    itemColor: l
  } = e, c = `${t}-tab`;
  return {
    [c]: {
      position: "relative",
      WebkitTouchCallout: "none",
      WebkitTapHighlightColor: "transparent",
      display: "inline-flex",
      alignItems: "center",
      padding: o,
      fontSize: e.titleFontSize,
      background: "transparent",
      border: 0,
      outline: "none",
      cursor: "pointer",
      color: l,
      "&-btn, &-remove": {
        "&:focus:not(:focus-visible), &:active": {
          color: r
        }
      },
      "&-btn": {
        outline: "none",
        transition: `all ${e.motionDurationSlow}`,
        [`${c}-icon:not(:last-child)`]: {
          marginInlineEnd: e.marginSM
        }
      },
      "&-remove": Object.assign({
        flex: "none",
        marginRight: {
          _skip_check_: !0,
          value: e.calc(e.marginXXS).mul(-1).equal()
        },
        marginLeft: {
          _skip_check_: !0,
          value: e.marginXS
        },
        color: e.colorIcon,
        fontSize: e.fontSizeSM,
        background: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        "&:hover": {
          color: e.colorTextHeading
        }
      }, No(e)),
      "&:hover": {
        color: n
      },
      [`&${c}-active ${c}-btn`]: {
        color: s,
        textShadow: e.tabsActiveTextShadow
      },
      [`&${c}-focus ${c}-btn`]: Object.assign({}, Cs(e)),
      [`&${c}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed"
      },
      [`&${c}-disabled ${c}-btn, &${c}-disabled ${t}-remove`]: {
        "&:focus, &:active": {
          color: e.colorTextDisabled
        }
      },
      [`& ${c}-remove ${a}`]: {
        margin: 0
      },
      [`${a}:not(:last-child)`]: {
        marginRight: {
          _skip_check_: !0,
          value: e.marginSM
        }
      }
    },
    [`${c} + ${c}`]: {
      margin: {
        _skip_check_: !0,
        value: i
      }
    }
  };
}, A0 = (e) => {
  const {
    componentCls: t,
    tabsHorizontalItemMarginRTL: r,
    iconCls: n,
    cardGutter: a,
    calc: i
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl",
      [`${t}-nav`]: {
        [`${t}-tab`]: {
          margin: {
            _skip_check_: !0,
            value: r
          },
          [`${t}-tab:last-of-type`]: {
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          },
          [n]: {
            marginRight: {
              _skip_check_: !0,
              value: 0
            },
            marginLeft: {
              _skip_check_: !0,
              value: G(e.marginSM)
            }
          },
          [`${t}-tab-remove`]: {
            marginRight: {
              _skip_check_: !0,
              value: G(e.marginXS)
            },
            marginLeft: {
              _skip_check_: !0,
              value: G(i(e.marginXXS).mul(-1).equal())
            },
            [n]: {
              margin: 0
            }
          }
        }
      },
      [`&${t}-left`]: {
        [`> ${t}-nav`]: {
          order: 1
        },
        [`> ${t}-content-holder`]: {
          order: 0
        }
      },
      [`&${t}-right`]: {
        [`> ${t}-nav`]: {
          order: 0
        },
        [`> ${t}-content-holder`]: {
          order: 1
        }
      },
      // ====================== Card ======================
      [`&${t}-card${t}-top, &${t}-card${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginRight: {
              _skip_check_: !0,
              value: a
            },
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          }
        }
      }
    },
    [`${t}-dropdown-rtl`]: {
      direction: "rtl"
    },
    [`${t}-menu-item`]: {
      [`${t}-dropdown-rtl`]: {
        textAlign: {
          _skip_check_: !0,
          value: "right"
        }
      }
    }
  };
}, k0 = (e) => {
  const {
    componentCls: t,
    tabsCardPadding: r,
    cardHeight: n,
    cardGutter: a,
    itemHoverColor: i,
    itemActiveColor: o,
    colorBorderSecondary: s
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, bs(e)), {
      display: "flex",
      // ========================== Navigation ==========================
      [`> ${t}-nav, > div > ${t}-nav`]: {
        position: "relative",
        display: "flex",
        flex: "none",
        alignItems: "center",
        [`${t}-nav-wrap`]: {
          position: "relative",
          display: "flex",
          flex: "auto",
          alignSelf: "stretch",
          overflow: "hidden",
          whiteSpace: "nowrap",
          transform: "translate(0)",
          // Fix chrome render bug
          // >>>>> Ping shadow
          "&::before, &::after": {
            position: "absolute",
            zIndex: 1,
            opacity: 0,
            transition: `opacity ${e.motionDurationSlow}`,
            content: "''",
            pointerEvents: "none"
          }
        },
        [`${t}-nav-list`]: {
          position: "relative",
          display: "flex",
          transition: `opacity ${e.motionDurationSlow}`
        },
        // >>>>>>>> Operations
        [`${t}-nav-operations`]: {
          display: "flex",
          alignSelf: "stretch"
        },
        [`${t}-nav-operations-hidden`]: {
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none"
        },
        [`${t}-nav-more`]: {
          position: "relative",
          padding: r,
          background: "transparent",
          border: 0,
          color: e.colorText,
          "&::after": {
            position: "absolute",
            right: {
              _skip_check_: !0,
              value: 0
            },
            bottom: 0,
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: e.calc(e.controlHeightLG).div(8).equal(),
            transform: "translateY(100%)",
            content: "''"
          }
        },
        [`${t}-nav-add`]: Object.assign({
          minWidth: n,
          minHeight: n,
          marginLeft: {
            _skip_check_: !0,
            value: a
          },
          background: "transparent",
          border: `${G(e.lineWidth)} ${e.lineType} ${s}`,
          borderRadius: `${G(e.borderRadiusLG)} ${G(e.borderRadiusLG)} 0 0`,
          outline: "none",
          cursor: "pointer",
          color: e.colorText,
          transition: `all ${e.motionDurationSlow} ${e.motionEaseInOut}`,
          "&:hover": {
            color: i
          },
          "&:active, &:focus:not(:focus-visible)": {
            color: o
          }
        }, No(e, -3))
      },
      [`${t}-extra-content`]: {
        flex: "none"
      },
      // ============================ InkBar ============================
      [`${t}-ink-bar`]: {
        position: "absolute",
        background: e.inkBarColor,
        pointerEvents: "none"
      }
    }), I0(e)), {
      // =========================== TabPanes ===========================
      [`${t}-content`]: {
        position: "relative",
        width: "100%"
      },
      [`${t}-content-holder`]: {
        flex: "auto",
        minWidth: 0,
        minHeight: 0
      },
      [`${t}-tabpane`]: Object.assign(Object.assign({}, No(e)), {
        "&-hidden": {
          display: "none"
        }
      })
    }),
    [`${t}-centered`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-nav-wrap`]: {
          [`&:not([class*='${t}-nav-wrap-ping']) > ${t}-nav-list`]: {
            margin: "auto"
          }
        }
      }
    }
  };
}, F0 = (e) => {
  const {
    cardHeight: t,
    cardHeightSM: r,
    cardHeightLG: n,
    controlHeight: a,
    controlHeightLG: i
  } = e, o = t || i, s = r || a, l = n || i + 8;
  return {
    zIndexPopup: e.zIndexPopupBase + 50,
    cardBg: e.colorFillAlter,
    // We can not pass this as valid value,
    // Since `cardHeight` will lock nav add button height.
    cardHeight: o,
    cardHeightSM: s,
    cardHeightLG: l,
    // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
    cardPadding: `${(o - e.fontHeight) / 2 - e.lineWidth}px ${e.padding}px`,
    cardPaddingSM: `${(s - e.fontHeight) / 2 - e.lineWidth}px ${e.paddingXS}px`,
    cardPaddingLG: `${(l - e.fontHeightLG) / 2 - e.lineWidth}px ${e.padding}px`,
    titleFontSize: e.fontSize,
    titleFontSizeLG: e.fontSizeLG,
    titleFontSizeSM: e.fontSize,
    inkBarColor: e.colorPrimary,
    horizontalMargin: `0 0 ${e.margin}px 0`,
    horizontalItemGutter: 32,
    // Fixed Value
    // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
    horizontalItemMargin: "",
    horizontalItemMarginRTL: "",
    horizontalItemPadding: `${e.paddingSM}px 0`,
    horizontalItemPaddingSM: `${e.paddingXS}px 0`,
    horizontalItemPaddingLG: `${e.padding}px 0`,
    verticalItemPadding: `${e.paddingXS}px ${e.paddingLG}px`,
    verticalItemMargin: `${e.margin}px 0 0 0`,
    itemColor: e.colorText,
    itemSelectedColor: e.colorPrimary,
    itemHoverColor: e.colorPrimaryHover,
    itemActiveColor: e.colorPrimaryActive,
    cardGutter: e.marginXXS / 2
  };
}, D0 = Ss("Tabs", (e) => {
  const t = ya(e, {
    // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
    tabsCardPadding: e.cardPadding,
    dropdownEdgeChildVerticalPadding: e.paddingXXS,
    tabsActiveTextShadow: "0 0 0.25px currentcolor",
    tabsDropdownHeight: 200,
    tabsDropdownWidth: 120,
    tabsHorizontalItemMargin: `0 0 0 ${G(e.horizontalItemGutter)}`,
    tabsHorizontalItemMarginRTL: `0 0 0 ${G(e.horizontalItemGutter)}`
  });
  return [T0(t), A0(t), N0(t), R0(t), M0(t), k0(t), O0(t)];
}, F0), Od = () => null;
process.env.NODE_ENV !== "production" && (Od.displayName = "DeprecatedTabPane");
var L0 = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const Ts = (e) => {
  var t, r, n, a, i, o, s, l, c, u, v;
  const {
    type: h,
    className: b,
    rootClassName: g,
    size: m,
    onEdit: f,
    hideAdd: y,
    centered: p,
    addIcon: C,
    removeIcon: S,
    moreIcon: E,
    more: w,
    popupClassName: P,
    children: N,
    items: M,
    animated: _,
    style: x,
    indicatorSize: R,
    indicator: $,
    destroyInactiveTabPane: T,
    destroyOnHidden: A
  } = e, D = L0(e, ["type", "className", "rootClassName", "size", "onEdit", "hideAdd", "centered", "addIcon", "removeIcon", "moreIcon", "more", "popupClassName", "children", "items", "animated", "style", "indicatorSize", "indicator", "destroyInactiveTabPane", "destroyOnHidden"]), {
    prefixCls: z
  } = D, {
    direction: V,
    tabs: k,
    getPrefixCls: B,
    getPopupContainer: q
  } = d.useContext(Mt), W = B("tabs", z), H = c0(W), [j, K, J] = D0(W, H);
  let Z;
  h === "editable-card" && (Z = {
    onEdit: (L, {
      key: de,
      event: ye
    }) => {
      f == null || f(L === "add" ? ye : de, L);
    },
    removeIcon: (t = S ?? (k == null ? void 0 : k.removeIcon)) !== null && t !== void 0 ? t : /* @__PURE__ */ d.createElement(Wu, null),
    addIcon: (C ?? (k == null ? void 0 : k.addIcon)) || /* @__PURE__ */ d.createElement(qu, null),
    showAdd: y !== !0
  });
  const ae = B();
  if (process.env.NODE_ENV !== "production") {
    const L = qr("Tabs");
    process.env.NODE_ENV !== "production" && L(!("onPrevClick" in e) && !("onNextClick" in e), "breaking", "`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead."), process.env.NODE_ENV !== "production" && L(!(R || k != null && k.indicatorSize), "deprecated", "`indicatorSize` has been deprecated. Please use `indicator={{ size: ... }}` instead."), L.deprecated(!("destroyInactiveTabPane" in e || M != null && M.some((de) => "destroyInactiveTabPane" in de)), "destroyInactiveTabPane", "destroyOnHidden");
  }
  const oe = Vu(m), fe = g0(M, N), me = f0(W, _), ue = Object.assign(Object.assign({}, k == null ? void 0 : k.style), x), Ce = {
    align: (r = $ == null ? void 0 : $.align) !== null && r !== void 0 ? r : (n = k == null ? void 0 : k.indicator) === null || n === void 0 ? void 0 : n.align,
    size: (s = (i = (a = $ == null ? void 0 : $.size) !== null && a !== void 0 ? a : R) !== null && i !== void 0 ? i : (o = k == null ? void 0 : k.indicator) === null || o === void 0 ? void 0 : o.size) !== null && s !== void 0 ? s : k == null ? void 0 : k.indicatorSize
  };
  return j(/* @__PURE__ */ d.createElement($d, Object.assign({
    direction: V,
    getPopupContainer: q
  }, D, {
    items: fe,
    className: ne({
      [`${W}-${oe}`]: oe,
      [`${W}-card`]: ["card", "editable-card"].includes(h),
      [`${W}-editable-card`]: h === "editable-card",
      [`${W}-centered`]: p
    }, k == null ? void 0 : k.className, b, g, K, J, H),
    popupClassName: ne(P, K, J, H),
    style: ue,
    editable: Z,
    more: Object.assign({
      icon: (v = (u = (c = (l = k == null ? void 0 : k.more) === null || l === void 0 ? void 0 : l.icon) !== null && c !== void 0 ? c : k == null ? void 0 : k.moreIcon) !== null && u !== void 0 ? u : E) !== null && v !== void 0 ? v : /* @__PURE__ */ d.createElement(Ku, null),
      transitionName: `${ae}-slide-up`
    }, w),
    prefixCls: W,
    animated: me,
    indicator: Ce,
    // TODO: In the future, destroyInactiveTabPane in rc-tabs needs to be upgrade to destroyOnHidden
    destroyInactiveTabPane: A ?? T
  })));
};
Ts.TabPane = Od;
process.env.NODE_ENV !== "production" && (Ts.displayName = "Tabs");
var V0 = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const Md = (e) => {
  var {
    prefixCls: t,
    className: r,
    hoverable: n = !0
  } = e, a = V0(e, ["prefixCls", "className", "hoverable"]);
  const {
    getPrefixCls: i
  } = d.useContext(Mt), o = i("card", t), s = ne(`${o}-grid`, r, {
    [`${o}-grid-hoverable`]: n
  });
  return /* @__PURE__ */ d.createElement("div", Object.assign({}, a, {
    className: s
  }));
}, j0 = (e) => {
  const {
    antCls: t,
    componentCls: r,
    headerHeight: n,
    headerPadding: a,
    tabsMarginBottom: i
  } = e;
  return Object.assign(Object.assign({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    minHeight: n,
    marginBottom: -1,
    padding: `0 ${G(a)}`,
    color: e.colorTextHeading,
    fontWeight: e.fontWeightStrong,
    fontSize: e.headerFontSize,
    background: e.headerBg,
    borderBottom: `${G(e.lineWidth)} ${e.lineType} ${e.colorBorderSecondary}`,
    borderRadius: `${G(e.borderRadiusLG)} ${G(e.borderRadiusLG)} 0 0`
  }, mi()), {
    "&-wrapper": {
      width: "100%",
      display: "flex",
      alignItems: "center"
    },
    "&-title": Object.assign(Object.assign({
      display: "inline-block",
      flex: 1
    }, ys), {
      [`
          > ${r}-typography,
          > ${r}-typography-edit-content
        `]: {
        insetInlineStart: 0,
        marginTop: 0,
        marginBottom: 0
      }
    }),
    [`${t}-tabs-top`]: {
      clear: "both",
      marginBottom: i,
      color: e.colorText,
      fontWeight: "normal",
      fontSize: e.fontSize,
      "&-bar": {
        borderBottom: `${G(e.lineWidth)} ${e.lineType} ${e.colorBorderSecondary}`
      }
    }
  });
}, z0 = (e) => {
  const {
    cardPaddingBase: t,
    colorBorderSecondary: r,
    cardShadow: n,
    lineWidth: a
  } = e;
  return {
    width: "33.33%",
    padding: t,
    border: 0,
    borderRadius: 0,
    boxShadow: `
      ${G(a)} 0 0 0 ${r},
      0 ${G(a)} 0 0 ${r},
      ${G(a)} ${G(a)} 0 0 ${r},
      ${G(a)} 0 0 0 ${r} inset,
      0 ${G(a)} 0 0 ${r} inset;
    `,
    transition: `all ${e.motionDurationMid}`,
    "&-hoverable:hover": {
      position: "relative",
      zIndex: 1,
      boxShadow: n
    }
  };
}, H0 = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    actionsLiMargin: n,
    cardActionsIconSize: a,
    colorBorderSecondary: i,
    actionsBg: o
  } = e;
  return Object.assign(Object.assign({
    margin: 0,
    padding: 0,
    listStyle: "none",
    background: o,
    borderTop: `${G(e.lineWidth)} ${e.lineType} ${i}`,
    display: "flex",
    borderRadius: `0 0 ${G(e.borderRadiusLG)} ${G(e.borderRadiusLG)}`
  }, mi()), {
    "& > li": {
      margin: n,
      color: e.colorTextDescription,
      textAlign: "center",
      "> span": {
        position: "relative",
        display: "block",
        minWidth: e.calc(e.cardActionsIconSize).mul(2).equal(),
        fontSize: e.fontSize,
        lineHeight: e.lineHeight,
        cursor: "pointer",
        "&:hover": {
          color: e.colorPrimary,
          transition: `color ${e.motionDurationMid}`
        },
        [`a:not(${t}-btn), > ${r}`]: {
          display: "inline-block",
          width: "100%",
          color: e.colorIcon,
          lineHeight: G(e.fontHeight),
          transition: `color ${e.motionDurationMid}`,
          "&:hover": {
            color: e.colorPrimary
          }
        },
        [`> ${r}`]: {
          fontSize: a,
          lineHeight: G(e.calc(a).mul(e.lineHeight).equal())
        }
      },
      "&:not(:last-child)": {
        borderInlineEnd: `${G(e.lineWidth)} ${e.lineType} ${i}`
      }
    }
  });
}, B0 = (e) => Object.assign(Object.assign({
  margin: `${G(e.calc(e.marginXXS).mul(-1).equal())} 0`,
  display: "flex"
}, mi()), {
  "&-avatar": {
    paddingInlineEnd: e.padding
  },
  "&-detail": {
    overflow: "hidden",
    flex: 1,
    "> div:not(:last-child)": {
      marginBottom: e.marginXS
    }
  },
  "&-title": Object.assign({
    color: e.colorTextHeading,
    fontWeight: e.fontWeightStrong,
    fontSize: e.fontSizeLG
  }, ys),
  "&-description": {
    color: e.colorTextDescription
  }
}), W0 = (e) => {
  const {
    componentCls: t,
    colorFillAlter: r,
    headerPadding: n,
    bodyPadding: a
  } = e;
  return {
    [`${t}-head`]: {
      padding: `0 ${G(n)}`,
      background: r,
      "&-title": {
        fontSize: e.fontSize
      }
    },
    [`${t}-body`]: {
      padding: `${G(e.padding)} ${G(a)}`
    }
  };
}, K0 = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    overflow: "hidden",
    [`${t}-body`]: {
      userSelect: "none"
    }
  };
}, q0 = (e) => {
  const {
    componentCls: t,
    cardShadow: r,
    cardHeadPadding: n,
    colorBorderSecondary: a,
    boxShadowTertiary: i,
    bodyPadding: o,
    extraColor: s
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, bs(e)), {
      position: "relative",
      background: e.colorBgContainer,
      borderRadius: e.borderRadiusLG,
      [`&:not(${t}-bordered)`]: {
        boxShadow: i
      },
      [`${t}-head`]: j0(e),
      [`${t}-extra`]: {
        // https://stackoverflow.com/a/22429853/3040605
        marginInlineStart: "auto",
        color: s,
        fontWeight: "normal",
        fontSize: e.fontSize
      },
      [`${t}-body`]: Object.assign({
        padding: o,
        borderRadius: `0 0 ${G(e.borderRadiusLG)} ${G(e.borderRadiusLG)}`
      }, mi()),
      [`${t}-grid`]: z0(e),
      [`${t}-cover`]: {
        "> *": {
          display: "block",
          width: "100%",
          borderRadius: `${G(e.borderRadiusLG)} ${G(e.borderRadiusLG)} 0 0`
        }
      },
      [`${t}-actions`]: H0(e),
      [`${t}-meta`]: B0(e)
    }),
    [`${t}-bordered`]: {
      border: `${G(e.lineWidth)} ${e.lineType} ${a}`,
      [`${t}-cover`]: {
        marginTop: -1,
        marginInlineStart: -1,
        marginInlineEnd: -1
      }
    },
    [`${t}-hoverable`]: {
      cursor: "pointer",
      transition: `box-shadow ${e.motionDurationMid}, border-color ${e.motionDurationMid}`,
      "&:hover": {
        borderColor: "transparent",
        boxShadow: r
      }
    },
    [`${t}-contain-grid`]: {
      borderRadius: `${G(e.borderRadiusLG)} ${G(e.borderRadiusLG)} 0 0 `,
      [`${t}-body`]: {
        display: "flex",
        flexWrap: "wrap"
      },
      [`&:not(${t}-loading) ${t}-body`]: {
        marginBlockStart: e.calc(e.lineWidth).mul(-1).equal(),
        marginInlineStart: e.calc(e.lineWidth).mul(-1).equal(),
        padding: 0
      }
    },
    [`${t}-contain-tabs`]: {
      [`> div${t}-head`]: {
        minHeight: 0,
        [`${t}-head-title, ${t}-extra`]: {
          paddingTop: n
        }
      }
    },
    [`${t}-type-inner`]: W0(e),
    [`${t}-loading`]: K0(e),
    [`${t}-rtl`]: {
      direction: "rtl"
    }
  };
}, U0 = (e) => {
  const {
    componentCls: t,
    bodyPaddingSM: r,
    headerPaddingSM: n,
    headerHeightSM: a,
    headerFontSizeSM: i
  } = e;
  return {
    [`${t}-small`]: {
      [`> ${t}-head`]: {
        minHeight: a,
        padding: `0 ${G(n)}`,
        fontSize: i,
        [`> ${t}-head-wrapper`]: {
          [`> ${t}-extra`]: {
            fontSize: e.fontSize
          }
        }
      },
      [`> ${t}-body`]: {
        padding: r
      }
    },
    [`${t}-small${t}-contain-tabs`]: {
      [`> ${t}-head`]: {
        [`${t}-head-title, ${t}-extra`]: {
          paddingTop: 0,
          display: "flex",
          alignItems: "center"
        }
      }
    }
  };
}, G0 = (e) => {
  var t, r;
  return {
    headerBg: "transparent",
    headerFontSize: e.fontSizeLG,
    headerFontSizeSM: e.fontSize,
    headerHeight: e.fontSizeLG * e.lineHeightLG + e.padding * 2,
    headerHeightSM: e.fontSize * e.lineHeight + e.paddingXS * 2,
    actionsBg: e.colorBgContainer,
    actionsLiMargin: `${e.paddingSM}px 0`,
    tabsMarginBottom: -e.padding - e.lineWidth,
    extraColor: e.colorText,
    bodyPaddingSM: 12,
    // Fixed padding.
    headerPaddingSM: 12,
    bodyPadding: (t = e.bodyPadding) !== null && t !== void 0 ? t : e.paddingLG,
    headerPadding: (r = e.headerPadding) !== null && r !== void 0 ? r : e.paddingLG
  };
}, X0 = Ss("Card", (e) => {
  const t = ya(e, {
    cardShadow: e.boxShadowCard,
    cardHeadPadding: e.padding,
    cardPaddingBase: e.paddingLG,
    cardActionsIconSize: e.fontSize
  });
  return [
    // Style
    q0(t),
    // Size
    U0(t)
  ];
}, G0);
function mr() {
  mr = function() {
    return t;
  };
  var e, t = {}, r = Object.prototype, n = r.hasOwnProperty, a = typeof Symbol == "function" ? Symbol : {}, i = a.iterator || "@@iterator", o = a.asyncIterator || "@@asyncIterator", s = a.toStringTag || "@@toStringTag";
  function l(_, x, R, $) {
    return Object.defineProperty(_, x, {
      value: R,
      enumerable: !$,
      configurable: !$,
      writable: !$
    });
  }
  try {
    l({}, "");
  } catch {
    l = function(R, $, T) {
      return R[$] = T;
    };
  }
  function c(_, x, R, $) {
    var T = x && x.prototype instanceof h ? x : h, A = Object.create(T.prototype);
    return l(A, "_invoke", /* @__PURE__ */ function(D, z, V) {
      var k = 1;
      return function(B, q) {
        if (k === 3) throw Error("Generator is already running");
        if (k === 4) {
          if (B === "throw") throw q;
          return {
            value: e,
            done: !0
          };
        }
        for (V.method = B, V.arg = q; ; ) {
          var W = V.delegate;
          if (W) {
            var H = E(W, V);
            if (H) {
              if (H === v) continue;
              return H;
            }
          }
          if (V.method === "next") V.sent = V._sent = V.arg;
          else if (V.method === "throw") {
            if (k === 1) throw k = 4, V.arg;
            V.dispatchException(V.arg);
          } else V.method === "return" && V.abrupt("return", V.arg);
          k = 3;
          var j = u(D, z, V);
          if (j.type === "normal") {
            if (k = V.done ? 4 : 2, j.arg === v) continue;
            return {
              value: j.arg,
              done: V.done
            };
          }
          j.type === "throw" && (k = 4, V.method = "throw", V.arg = j.arg);
        }
      };
    }(_, R, new N($ || [])), !0), A;
  }
  function u(_, x, R) {
    try {
      return {
        type: "normal",
        arg: _.call(x, R)
      };
    } catch ($) {
      return {
        type: "throw",
        arg: $
      };
    }
  }
  t.wrap = c;
  var v = {};
  function h() {
  }
  function b() {
  }
  function g() {
  }
  var m = {};
  l(m, i, function() {
    return this;
  });
  var f = Object.getPrototypeOf, y = f && f(f(M([])));
  y && y !== r && n.call(y, i) && (m = y);
  var p = g.prototype = h.prototype = Object.create(m);
  function C(_) {
    ["next", "throw", "return"].forEach(function(x) {
      l(_, x, function(R) {
        return this._invoke(x, R);
      });
    });
  }
  function S(_, x) {
    function R(T, A, D, z) {
      var V = u(_[T], _, A);
      if (V.type !== "throw") {
        var k = V.arg, B = k.value;
        return B && le(B) == "object" && n.call(B, "__await") ? x.resolve(B.__await).then(function(q) {
          R("next", q, D, z);
        }, function(q) {
          R("throw", q, D, z);
        }) : x.resolve(B).then(function(q) {
          k.value = q, D(k);
        }, function(q) {
          return R("throw", q, D, z);
        });
      }
      z(V.arg);
    }
    var $;
    l(this, "_invoke", function(T, A) {
      function D() {
        return new x(function(z, V) {
          R(T, A, z, V);
        });
      }
      return $ = $ ? $.then(D, D) : D();
    }, !0);
  }
  function E(_, x) {
    var R = x.method, $ = _.i[R];
    if ($ === e) return x.delegate = null, R === "throw" && _.i.return && (x.method = "return", x.arg = e, E(_, x), x.method === "throw") || R !== "return" && (x.method = "throw", x.arg = new TypeError("The iterator does not provide a '" + R + "' method")), v;
    var T = u($, _.i, x.arg);
    if (T.type === "throw") return x.method = "throw", x.arg = T.arg, x.delegate = null, v;
    var A = T.arg;
    return A ? A.done ? (x[_.r] = A.value, x.next = _.n, x.method !== "return" && (x.method = "next", x.arg = e), x.delegate = null, v) : A : (x.method = "throw", x.arg = new TypeError("iterator result is not an object"), x.delegate = null, v);
  }
  function w(_) {
    this.tryEntries.push(_);
  }
  function P(_) {
    var x = _[4] || {};
    x.type = "normal", x.arg = e, _[4] = x;
  }
  function N(_) {
    this.tryEntries = [[-1]], _.forEach(w, this), this.reset(!0);
  }
  function M(_) {
    if (_ != null) {
      var x = _[i];
      if (x) return x.call(_);
      if (typeof _.next == "function") return _;
      if (!isNaN(_.length)) {
        var R = -1, $ = function T() {
          for (; ++R < _.length; ) if (n.call(_, R)) return T.value = _[R], T.done = !1, T;
          return T.value = e, T.done = !0, T;
        };
        return $.next = $;
      }
    }
    throw new TypeError(le(_) + " is not iterable");
  }
  return b.prototype = g, l(p, "constructor", g), l(g, "constructor", b), b.displayName = l(g, s, "GeneratorFunction"), t.isGeneratorFunction = function(_) {
    var x = typeof _ == "function" && _.constructor;
    return !!x && (x === b || (x.displayName || x.name) === "GeneratorFunction");
  }, t.mark = function(_) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(_, g) : (_.__proto__ = g, l(_, s, "GeneratorFunction")), _.prototype = Object.create(p), _;
  }, t.awrap = function(_) {
    return {
      __await: _
    };
  }, C(S.prototype), l(S.prototype, o, function() {
    return this;
  }), t.AsyncIterator = S, t.async = function(_, x, R, $, T) {
    T === void 0 && (T = Promise);
    var A = new S(c(_, x, R, $), T);
    return t.isGeneratorFunction(x) ? A : A.next().then(function(D) {
      return D.done ? D.value : A.next();
    });
  }, C(p), l(p, s, "Generator"), l(p, i, function() {
    return this;
  }), l(p, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(_) {
    var x = Object(_), R = [];
    for (var $ in x) R.unshift($);
    return function T() {
      for (; R.length; ) if (($ = R.pop()) in x) return T.value = $, T.done = !1, T;
      return T.done = !0, T;
    };
  }, t.values = M, N.prototype = {
    constructor: N,
    reset: function(x) {
      if (this.prev = this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(P), !x) for (var R in this) R.charAt(0) === "t" && n.call(this, R) && !isNaN(+R.slice(1)) && (this[R] = e);
    },
    stop: function() {
      this.done = !0;
      var x = this.tryEntries[0][4];
      if (x.type === "throw") throw x.arg;
      return this.rval;
    },
    dispatchException: function(x) {
      if (this.done) throw x;
      var R = this;
      function $(B) {
        D.type = "throw", D.arg = x, R.next = B;
      }
      for (var T = R.tryEntries.length - 1; T >= 0; --T) {
        var A = this.tryEntries[T], D = A[4], z = this.prev, V = A[1], k = A[2];
        if (A[0] === -1) return $("end"), !1;
        if (!V && !k) throw Error("try statement without catch or finally");
        if (A[0] != null && A[0] <= z) {
          if (z < V) return this.method = "next", this.arg = e, $(V), !0;
          if (z < k) return $(k), !1;
        }
      }
    },
    abrupt: function(x, R) {
      for (var $ = this.tryEntries.length - 1; $ >= 0; --$) {
        var T = this.tryEntries[$];
        if (T[0] > -1 && T[0] <= this.prev && this.prev < T[2]) {
          var A = T;
          break;
        }
      }
      A && (x === "break" || x === "continue") && A[0] <= R && R <= A[2] && (A = null);
      var D = A ? A[4] : {};
      return D.type = x, D.arg = R, A ? (this.method = "next", this.next = A[2], v) : this.complete(D);
    },
    complete: function(x, R) {
      if (x.type === "throw") throw x.arg;
      return x.type === "break" || x.type === "continue" ? this.next = x.arg : x.type === "return" ? (this.rval = this.arg = x.arg, this.method = "return", this.next = "end") : x.type === "normal" && R && (this.next = R), v;
    },
    finish: function(x) {
      for (var R = this.tryEntries.length - 1; R >= 0; --R) {
        var $ = this.tryEntries[R];
        if ($[2] === x) return this.complete($[4], $[3]), P($), v;
      }
    },
    catch: function(x) {
      for (var R = this.tryEntries.length - 1; R >= 0; --R) {
        var $ = this.tryEntries[R];
        if ($[0] === x) {
          var T = $[4];
          if (T.type === "throw") {
            var A = T.arg;
            P($);
          }
          return A;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(x, R, $) {
      return this.delegate = {
        i: M(x),
        r: R,
        n: $
      }, this.method === "next" && (this.arg = e), v;
    }
  }, t;
}
function dc(e, t, r, n, a, i, o) {
  try {
    var s = e[i](o), l = s.value;
  } catch (c) {
    return void r(c);
  }
  s.done ? t(l) : Promise.resolve(l).then(n, a);
}
function wa(e) {
  return function() {
    var t = this, r = arguments;
    return new Promise(function(n, a) {
      var i = e.apply(t, r);
      function o(l) {
        dc(i, n, a, o, s, "next", l);
      }
      function s(l) {
        dc(i, n, a, o, s, "throw", l);
      }
      o(void 0);
    });
  };
}
var Wr = "RC_FORM_INTERNAL_HOOKS", Ke = function() {
  Ae(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, Pn = /* @__PURE__ */ d.createContext({
  getFieldValue: Ke,
  getFieldsValue: Ke,
  getFieldError: Ke,
  getFieldWarning: Ke,
  getFieldsError: Ke,
  isFieldsTouched: Ke,
  isFieldTouched: Ke,
  isFieldValidating: Ke,
  isFieldsValidating: Ke,
  resetFields: Ke,
  setFields: Ke,
  setFieldValue: Ke,
  setFieldsValue: Ke,
  validateFields: Ke,
  submit: Ke,
  getInternalHooks: function() {
    return Ke(), {
      dispatch: Ke,
      initEntityValue: Ke,
      registerField: Ke,
      useSubscribe: Ke,
      setInitialValues: Ke,
      destroyForm: Ke,
      setCallbacks: Ke,
      registerWatch: Ke,
      getFields: Ke,
      setValidateMessages: Ke,
      setPreserve: Ke,
      getInitialValue: Ke
    };
  }
}), ii = /* @__PURE__ */ d.createContext(null);
function Go(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function Y0(e) {
  return e && !!e._init;
}
function Xo() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var Yo = Xo();
function Q0(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function Z0(e, t, r) {
  if (cs()) return Reflect.construct.apply(null, arguments);
  var n = [null];
  n.push.apply(n, t);
  var a = new (e.bind.apply(e, n))();
  return r && oa(a, r.prototype), a;
}
function Qo(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Qo = function(n) {
    if (n === null || !Q0(n)) return n;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n)) return t.get(n);
      t.set(n, a);
    }
    function a() {
      return Z0(n, arguments, sa(this).constructor);
    }
    return a.prototype = Object.create(n.prototype, {
      constructor: {
        value: a,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), oa(a, n);
  }, Qo(e);
}
var J0 = /%[sdj%]/g, Rd = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (Rd = function(t, r) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && r.every(function(n) {
    return typeof n == "string";
  }) && console.warn(t, r);
});
function Zo(e) {
  if (!e || !e.length) return null;
  var t = {};
  return e.forEach(function(r) {
    var n = r.field;
    t[n] = t[n] || [], t[n].push(r);
  }), t;
}
function Zt(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  var a = 0, i = r.length;
  if (typeof e == "function")
    return e.apply(null, r);
  if (typeof e == "string") {
    var o = e.replace(J0, function(s) {
      if (s === "%%")
        return "%";
      if (a >= i)
        return s;
      switch (s) {
        case "%s":
          return String(r[a++]);
        case "%d":
          return Number(r[a++]);
        case "%j":
          try {
            return JSON.stringify(r[a++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return s;
      }
    });
    return o;
  }
  return e;
}
function ey(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function wt(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || ey(t) && typeof e == "string" && !e);
}
function ty(e, t, r) {
  var n = [], a = 0, i = e.length;
  function o(s) {
    n.push.apply(n, te(s || [])), a++, a === i && r(n);
  }
  e.forEach(function(s) {
    t(s, o);
  });
}
function fc(e, t, r) {
  var n = 0, a = e.length;
  function i(o) {
    if (o && o.length) {
      r(o);
      return;
    }
    var s = n;
    n = n + 1, s < a ? t(e[s], i) : r([]);
  }
  i([]);
}
function ry(e) {
  var t = [];
  return Object.keys(e).forEach(function(r) {
    t.push.apply(t, te(e[r] || []));
  }), t;
}
var vc = /* @__PURE__ */ function(e) {
  Vr(r, e);
  var t = jr(r);
  function r(n, a) {
    var i;
    return Rt(this, r), i = t.call(this, "Async Validation Error"), O(be(i), "errors", void 0), O(be(i), "fields", void 0), i.errors = n, i.fields = a, i;
  }
  return Nt(r);
}(/* @__PURE__ */ Qo(Error));
function ny(e, t, r, n, a) {
  if (t.first) {
    var i = new Promise(function(h, b) {
      var g = function(y) {
        return n(y), y.length ? b(new vc(y, Zo(y))) : h(a);
      }, m = ry(e);
      fc(m, r, g);
    });
    return i.catch(function(h) {
      return h;
    }), i;
  }
  var o = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], s = Object.keys(e), l = s.length, c = 0, u = [], v = new Promise(function(h, b) {
    var g = function(f) {
      if (u.push.apply(u, f), c++, c === l)
        return n(u), u.length ? b(new vc(u, Zo(u))) : h(a);
    };
    s.length || (n(u), h(a)), s.forEach(function(m) {
      var f = e[m];
      o.indexOf(m) !== -1 ? fc(f, r, g) : ty(f, r, g);
    });
  });
  return v.catch(function(h) {
    return h;
  }), v;
}
function ay(e) {
  return !!(e && e.message !== void 0);
}
function iy(e, t) {
  for (var r = e, n = 0; n < t.length; n++) {
    if (r == null)
      return r;
    r = r[t[n]];
  }
  return r;
}
function hc(e, t) {
  return function(r) {
    var n;
    return e.fullFields ? n = iy(t, e.fullFields) : n = t[r.field || e.fullField], ay(r) ? (r.field = r.field || e.fullField, r.fieldValue = n, r) : {
      message: typeof r == "function" ? r() : r,
      fieldValue: n,
      field: r.field || e.fullField
    };
  };
}
function gc(e, t) {
  if (t) {
    for (var r in t)
      if (t.hasOwnProperty(r)) {
        var n = t[r];
        le(n) === "object" && le(e[r]) === "object" ? e[r] = I(I({}, e[r]), n) : e[r] = n;
      }
  }
  return e;
}
var sn = "enum", oy = function(t, r, n, a, i) {
  t[sn] = Array.isArray(t[sn]) ? t[sn] : [], t[sn].indexOf(r) === -1 && a.push(Zt(i.messages[sn], t.fullField, t[sn].join(", ")));
}, sy = function(t, r, n, a, i) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(r) || a.push(Zt(i.messages.pattern.mismatch, t.fullField, r, t.pattern));
    else if (typeof t.pattern == "string") {
      var o = new RegExp(t.pattern);
      o.test(r) || a.push(Zt(i.messages.pattern.mismatch, t.fullField, r, t.pattern));
    }
  }
}, ly = function(t, r, n, a, i) {
  var o = typeof t.len == "number", s = typeof t.min == "number", l = typeof t.max == "number", c = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, u = r, v = null, h = typeof r == "number", b = typeof r == "string", g = Array.isArray(r);
  if (h ? v = "number" : b ? v = "string" : g && (v = "array"), !v)
    return !1;
  g && (u = r.length), b && (u = r.replace(c, "_").length), o ? u !== t.len && a.push(Zt(i.messages[v].len, t.fullField, t.len)) : s && !l && u < t.min ? a.push(Zt(i.messages[v].min, t.fullField, t.min)) : l && !s && u > t.max ? a.push(Zt(i.messages[v].max, t.fullField, t.max)) : s && l && (u < t.min || u > t.max) && a.push(Zt(i.messages[v].range, t.fullField, t.min, t.max));
}, Nd = function(t, r, n, a, i, o) {
  t.required && (!n.hasOwnProperty(t.field) || wt(r, o || t.type)) && a.push(Zt(i.messages.required, t.fullField));
}, ja;
const cy = function() {
  if (ja)
    return ja;
  var e = "[a-fA-F\\d:]", t = function(w) {
    return w && w.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(e, ")|(?<=").concat(e, ")(?=\\s|$))") : "";
  }, r = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", n = "[a-fA-F\\d]{1,4}", a = [
    "(?:".concat(n, ":){7}(?:").concat(n, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat(n, ":){6}(?:").concat(r, "|:").concat(n, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat(n, ":){5}(?::").concat(r, "|(?::").concat(n, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat(n, ":){4}(?:(?::").concat(n, "){0,1}:").concat(r, "|(?::").concat(n, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat(n, ":){3}(?:(?::").concat(n, "){0,2}:").concat(r, "|(?::").concat(n, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat(n, ":){2}(?:(?::").concat(n, "){0,3}:").concat(r, "|(?::").concat(n, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat(n, ":){1}(?:(?::").concat(n, "){0,4}:").concat(r, "|(?::").concat(n, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat(n, "){0,5}:").concat(r, "|(?::").concat(n, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ], i = "(?:%[0-9a-zA-Z]{1,})?", o = "(?:".concat(a.join("|"), ")").concat(i), s = new RegExp("(?:^".concat(r, "$)|(?:^").concat(o, "$)")), l = new RegExp("^".concat(r, "$")), c = new RegExp("^".concat(o, "$")), u = function(w) {
    return w && w.exact ? s : new RegExp("(?:".concat(t(w)).concat(r).concat(t(w), ")|(?:").concat(t(w)).concat(o).concat(t(w), ")"), "g");
  };
  u.v4 = function(E) {
    return E && E.exact ? l : new RegExp("".concat(t(E)).concat(r).concat(t(E)), "g");
  }, u.v6 = function(E) {
    return E && E.exact ? c : new RegExp("".concat(t(E)).concat(o).concat(t(E)), "g");
  };
  var v = "(?:(?:[a-z]+:)?//)", h = "(?:\\S+(?::\\S*)?@)?", b = u.v4().source, g = u.v6().source, m = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", f = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", y = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", p = "(?::\\d{2,5})?", C = '(?:[/?#][^\\s"]*)?', S = "(?:".concat(v, "|www\\.)").concat(h, "(?:localhost|").concat(b, "|").concat(g, "|").concat(m).concat(f).concat(y, ")").concat(p).concat(C);
  return ja = new RegExp("(?:^".concat(S, "$)"), "i"), ja;
};
var mc = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, Zn = {
  integer: function(t) {
    return Zn.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return Zn.number(t) && !Zn.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return le(t) === "object" && !Zn.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(mc.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(cy());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(mc.hex);
  }
}, uy = function(t, r, n, a, i) {
  if (t.required && r === void 0) {
    Nd(t, r, n, a, i);
    return;
  }
  var o = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s = t.type;
  o.indexOf(s) > -1 ? Zn[s](r) || a.push(Zt(i.messages.types[s], t.fullField, t.type)) : s && le(r) !== t.type && a.push(Zt(i.messages.types[s], t.fullField, t.type));
}, dy = function(t, r, n, a, i) {
  (/^\s+$/.test(r) || r === "") && a.push(Zt(i.messages.whitespace, t.fullField));
};
const Se = {
  required: Nd,
  whitespace: dy,
  type: uy,
  range: ly,
  enum: oy,
  pattern: sy
};
var fy = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (wt(r) && !t.required)
      return n();
    Se.required(t, r, a, o, i);
  }
  n(o);
}, vy = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (r == null && !t.required)
      return n();
    Se.required(t, r, a, o, i, "array"), r != null && (Se.type(t, r, a, o, i), Se.range(t, r, a, o, i));
  }
  n(o);
}, hy = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (wt(r) && !t.required)
      return n();
    Se.required(t, r, a, o, i), r !== void 0 && Se.type(t, r, a, o, i);
  }
  n(o);
}, gy = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (wt(r, "date") && !t.required)
      return n();
    if (Se.required(t, r, a, o, i), !wt(r, "date")) {
      var l;
      r instanceof Date ? l = r : l = new Date(r), Se.type(t, l, a, o, i), l && Se.range(t, l.getTime(), a, o, i);
    }
  }
  n(o);
}, my = "enum", py = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (wt(r) && !t.required)
      return n();
    Se.required(t, r, a, o, i), r !== void 0 && Se[my](t, r, a, o, i);
  }
  n(o);
}, yy = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (wt(r) && !t.required)
      return n();
    Se.required(t, r, a, o, i), r !== void 0 && (Se.type(t, r, a, o, i), Se.range(t, r, a, o, i));
  }
  n(o);
}, by = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (wt(r) && !t.required)
      return n();
    Se.required(t, r, a, o, i), r !== void 0 && (Se.type(t, r, a, o, i), Se.range(t, r, a, o, i));
  }
  n(o);
}, Cy = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (wt(r) && !t.required)
      return n();
    Se.required(t, r, a, o, i), r !== void 0 && Se.type(t, r, a, o, i);
  }
  n(o);
}, Sy = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (r === "" && (r = void 0), wt(r) && !t.required)
      return n();
    Se.required(t, r, a, o, i), r !== void 0 && (Se.type(t, r, a, o, i), Se.range(t, r, a, o, i));
  }
  n(o);
}, Ey = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (wt(r) && !t.required)
      return n();
    Se.required(t, r, a, o, i), r !== void 0 && Se.type(t, r, a, o, i);
  }
  n(o);
}, wy = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (wt(r, "string") && !t.required)
      return n();
    Se.required(t, r, a, o, i), wt(r, "string") || Se.pattern(t, r, a, o, i);
  }
  n(o);
}, xy = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (wt(r) && !t.required)
      return n();
    Se.required(t, r, a, o, i), wt(r) || Se.type(t, r, a, o, i);
  }
  n(o);
}, _y = function(t, r, n, a, i) {
  var o = [], s = Array.isArray(r) ? "array" : le(r);
  Se.required(t, r, a, o, i, s), n(o);
}, Py = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (wt(r, "string") && !t.required)
      return n();
    Se.required(t, r, a, o, i, "string"), wt(r, "string") || (Se.type(t, r, a, o, i), Se.range(t, r, a, o, i), Se.pattern(t, r, a, o, i), t.whitespace === !0 && Se.whitespace(t, r, a, o, i));
  }
  n(o);
}, eo = function(t, r, n, a, i) {
  var o = t.type, s = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if (wt(r, o) && !t.required)
      return n();
    Se.required(t, r, a, s, i, o), wt(r, o) || Se.type(t, r, a, s, i);
  }
  n(s);
};
const ra = {
  string: Py,
  method: Cy,
  number: Sy,
  boolean: hy,
  regexp: xy,
  integer: by,
  float: yy,
  array: vy,
  object: Ey,
  enum: py,
  pattern: wy,
  date: gy,
  url: eo,
  hex: eo,
  email: eo,
  required: _y,
  any: fy
};
var xa = /* @__PURE__ */ function() {
  function e(t) {
    Rt(this, e), O(this, "rules", null), O(this, "_messages", Yo), this.define(t);
  }
  return Nt(e, [{
    key: "define",
    value: function(r) {
      var n = this;
      if (!r)
        throw new Error("Cannot configure a schema with no rules");
      if (le(r) !== "object" || Array.isArray(r))
        throw new Error("Rules must be an object");
      this.rules = {}, Object.keys(r).forEach(function(a) {
        var i = r[a];
        n.rules[a] = Array.isArray(i) ? i : [i];
      });
    }
  }, {
    key: "messages",
    value: function(r) {
      return r && (this._messages = gc(Xo(), r)), this._messages;
    }
  }, {
    key: "validate",
    value: function(r) {
      var n = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      }, o = r, s = a, l = i;
      if (typeof s == "function" && (l = s, s = {}), !this.rules || Object.keys(this.rules).length === 0)
        return l && l(null, o), Promise.resolve(o);
      function c(g) {
        var m = [], f = {};
        function y(C) {
          if (Array.isArray(C)) {
            var S;
            m = (S = m).concat.apply(S, te(C));
          } else
            m.push(C);
        }
        for (var p = 0; p < g.length; p++)
          y(g[p]);
        m.length ? (f = Zo(m), l(m, f)) : l(null, o);
      }
      if (s.messages) {
        var u = this.messages();
        u === Yo && (u = Xo()), gc(u, s.messages), s.messages = u;
      } else
        s.messages = this.messages();
      var v = {}, h = s.keys || Object.keys(this.rules);
      h.forEach(function(g) {
        var m = n.rules[g], f = o[g];
        m.forEach(function(y) {
          var p = y;
          typeof p.transform == "function" && (o === r && (o = I({}, o)), f = o[g] = p.transform(f), f != null && (p.type = p.type || (Array.isArray(f) ? "array" : le(f)))), typeof p == "function" ? p = {
            validator: p
          } : p = I({}, p), p.validator = n.getValidationMethod(p), p.validator && (p.field = g, p.fullField = p.fullField || g, p.type = n.getType(p), v[g] = v[g] || [], v[g].push({
            rule: p,
            value: f,
            source: o,
            field: g
          }));
        });
      });
      var b = {};
      return ny(v, s, function(g, m) {
        var f = g.rule, y = (f.type === "object" || f.type === "array") && (le(f.fields) === "object" || le(f.defaultField) === "object");
        y = y && (f.required || !f.required && g.value), f.field = g.field;
        function p(P, N) {
          return I(I({}, N), {}, {
            fullField: "".concat(f.fullField, ".").concat(P),
            fullFields: f.fullFields ? [].concat(te(f.fullFields), [P]) : [P]
          });
        }
        function C() {
          var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], N = Array.isArray(P) ? P : [P];
          !s.suppressWarning && N.length && e.warning("async-validator:", N), N.length && f.message !== void 0 && (N = [].concat(f.message));
          var M = N.map(hc(f, o));
          if (s.first && M.length)
            return b[f.field] = 1, m(M);
          if (!y)
            m(M);
          else {
            if (f.required && !g.value)
              return f.message !== void 0 ? M = [].concat(f.message).map(hc(f, o)) : s.error && (M = [s.error(f, Zt(s.messages.required, f.field))]), m(M);
            var _ = {};
            f.defaultField && Object.keys(g.value).map(function($) {
              _[$] = f.defaultField;
            }), _ = I(I({}, _), g.rule.fields);
            var x = {};
            Object.keys(_).forEach(function($) {
              var T = _[$], A = Array.isArray(T) ? T : [T];
              x[$] = A.map(p.bind(null, $));
            });
            var R = new e(x);
            R.messages(s.messages), g.rule.options && (g.rule.options.messages = s.messages, g.rule.options.error = s.error), R.validate(g.value, g.rule.options || s, function($) {
              var T = [];
              M && M.length && T.push.apply(T, te(M)), $ && $.length && T.push.apply(T, te($)), m(T.length ? T : null);
            });
          }
        }
        var S;
        if (f.asyncValidator)
          S = f.asyncValidator(f, g.value, C, g.source, s);
        else if (f.validator) {
          try {
            S = f.validator(f, g.value, C, g.source, s);
          } catch (P) {
            var E, w;
            (E = (w = console).error) === null || E === void 0 || E.call(w, P), s.suppressValidatorError || setTimeout(function() {
              throw P;
            }, 0), C(P.message);
          }
          S === !0 ? C() : S === !1 ? C(typeof f.message == "function" ? f.message(f.fullField || f.field) : f.message || "".concat(f.fullField || f.field, " fails")) : S instanceof Array ? C(S) : S instanceof Error && C(S.message);
        }
        S && S.then && S.then(function() {
          return C();
        }, function(P) {
          return C(P);
        });
      }, function(g) {
        c(g);
      }, o);
    }
  }, {
    key: "getType",
    value: function(r) {
      if (r.type === void 0 && r.pattern instanceof RegExp && (r.type = "pattern"), typeof r.validator != "function" && r.type && !ra.hasOwnProperty(r.type))
        throw new Error(Zt("Unknown rule type %s", r.type));
      return r.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function(r) {
      if (typeof r.validator == "function")
        return r.validator;
      var n = Object.keys(r), a = n.indexOf("message");
      return a !== -1 && n.splice(a, 1), n.length === 1 && n[0] === "required" ? ra.required : ra[this.getType(r)] || void 0;
    }
  }]), e;
}();
O(xa, "register", function(t, r) {
  if (typeof r != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  ra[t] = r;
});
O(xa, "warning", Rd);
O(xa, "messages", Yo);
O(xa, "validators", ra);
var Qt = "'${name}' is not a valid ${type}", Td = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: Qt,
    method: Qt,
    array: Qt,
    object: Qt,
    number: Qt,
    date: Qt,
    boolean: Qt,
    integer: Qt,
    float: Qt,
    regexp: Qt,
    email: Qt,
    url: Qt,
    hex: Qt
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, pc = xa;
function $y(e, t) {
  return e.replace(/\\?\$\{\w+\}/g, function(r) {
    if (r.startsWith("\\"))
      return r.slice(1);
    var n = r.slice(2, -1);
    return t[n];
  });
}
var yc = "CODE_LOGIC_ERROR";
function Jo(e, t, r, n, a) {
  return es.apply(this, arguments);
}
function es() {
  return es = wa(/* @__PURE__ */ mr().mark(function e(t, r, n, a, i) {
    var o, s, l, c, u, v, h, b, g;
    return mr().wrap(function(f) {
      for (; ; ) switch (f.prev = f.next) {
        case 0:
          return o = I({}, n), delete o.ruleIndex, pc.warning = function() {
          }, o.validator && (s = o.validator, o.validator = function() {
            try {
              return s.apply(void 0, arguments);
            } catch (y) {
              return console.error(y), Promise.reject(yc);
            }
          }), l = null, o && o.type === "array" && o.defaultField && (l = o.defaultField, delete o.defaultField), c = new pc(O({}, t, [o])), u = cn(Td, a.validateMessages), c.messages(u), v = [], f.prev = 10, f.next = 13, Promise.resolve(c.validate(O({}, t, r), I({}, a)));
        case 13:
          f.next = 18;
          break;
        case 15:
          f.prev = 15, f.t0 = f.catch(10), f.t0.errors && (v = f.t0.errors.map(function(y, p) {
            var C = y.message, S = C === yc ? u.default : C;
            return /* @__PURE__ */ d.isValidElement(S) ? (
              // Wrap ReactNode with `key`
              /* @__PURE__ */ d.cloneElement(S, {
                key: "error_".concat(p)
              })
            ) : S;
          }));
        case 18:
          if (!(!v.length && l)) {
            f.next = 23;
            break;
          }
          return f.next = 21, Promise.all(r.map(function(y, p) {
            return Jo("".concat(t, ".").concat(p), y, l, a, i);
          }));
        case 21:
          return h = f.sent, f.abrupt("return", h.reduce(function(y, p) {
            return [].concat(te(y), te(p));
          }, []));
        case 23:
          return b = I(I({}, n), {}, {
            name: t,
            enum: (n.enum || []).join(", ")
          }, i), g = v.map(function(y) {
            return typeof y == "string" ? $y(y, b) : y;
          }), f.abrupt("return", g);
        case 26:
        case "end":
          return f.stop();
      }
    }, e, null, [[10, 15]]);
  })), es.apply(this, arguments);
}
function Oy(e, t, r, n, a, i) {
  var o = e.join("."), s = r.map(function(u, v) {
    var h = u.validator, b = I(I({}, u), {}, {
      ruleIndex: v
    });
    return h && (b.validator = function(g, m, f) {
      var y = !1, p = function() {
        for (var E = arguments.length, w = new Array(E), P = 0; P < E; P++)
          w[P] = arguments[P];
        Promise.resolve().then(function() {
          Ae(!y, "Your validator function has already return a promise. `callback` will be ignored."), y || f.apply(void 0, w);
        });
      }, C = h(g, m, p);
      y = C && typeof C.then == "function" && typeof C.catch == "function", Ae(y, "`callback` is deprecated. Please return a promise instead."), y && C.then(function() {
        f();
      }).catch(function(S) {
        f(S || " ");
      });
    }), b;
  }).sort(function(u, v) {
    var h = u.warningOnly, b = u.ruleIndex, g = v.warningOnly, m = v.ruleIndex;
    return !!h == !!g ? b - m : h ? 1 : -1;
  }), l;
  if (a === !0)
    l = new Promise(/* @__PURE__ */ function() {
      var u = wa(/* @__PURE__ */ mr().mark(function v(h, b) {
        var g, m, f;
        return mr().wrap(function(p) {
          for (; ; ) switch (p.prev = p.next) {
            case 0:
              g = 0;
            case 1:
              if (!(g < s.length)) {
                p.next = 12;
                break;
              }
              return m = s[g], p.next = 5, Jo(o, t, m, n, i);
            case 5:
              if (f = p.sent, !f.length) {
                p.next = 9;
                break;
              }
              return b([{
                errors: f,
                rule: m
              }]), p.abrupt("return");
            case 9:
              g += 1, p.next = 1;
              break;
            case 12:
              h([]);
            case 13:
            case "end":
              return p.stop();
          }
        }, v);
      }));
      return function(v, h) {
        return u.apply(this, arguments);
      };
    }());
  else {
    var c = s.map(function(u) {
      return Jo(o, t, u, n, i).then(function(v) {
        return {
          errors: v,
          rule: u
        };
      });
    });
    l = (a ? Ry(c) : My(c)).then(function(u) {
      return Promise.reject(u);
    });
  }
  return l.catch(function(u) {
    return u;
  }), l;
}
function My(e) {
  return ts.apply(this, arguments);
}
function ts() {
  return ts = wa(/* @__PURE__ */ mr().mark(function e(t) {
    return mr().wrap(function(n) {
      for (; ; ) switch (n.prev = n.next) {
        case 0:
          return n.abrupt("return", Promise.all(t).then(function(a) {
            var i, o = (i = []).concat.apply(i, te(a));
            return o;
          }));
        case 1:
        case "end":
          return n.stop();
      }
    }, e);
  })), ts.apply(this, arguments);
}
function Ry(e) {
  return rs.apply(this, arguments);
}
function rs() {
  return rs = wa(/* @__PURE__ */ mr().mark(function e(t) {
    var r;
    return mr().wrap(function(a) {
      for (; ; ) switch (a.prev = a.next) {
        case 0:
          return r = 0, a.abrupt("return", new Promise(function(i) {
            t.forEach(function(o) {
              o.then(function(s) {
                s.errors.length && i([s]), r += 1, r === t.length && i([]);
              });
            });
          }));
        case 2:
        case "end":
          return a.stop();
      }
    }, e);
  })), rs.apply(this, arguments);
}
function ct(e) {
  return Go(e);
}
function bc(e, t) {
  var r = {};
  return t.forEach(function(n) {
    var a = yr(e, n);
    r = dr(r, n, a);
  }), r;
}
function mn(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return e && e.some(function(n) {
    return Id(t, n, r);
  });
}
function Id(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !e || !t || !r && e.length !== t.length ? !1 : t.every(function(n, a) {
    return e[a] === n;
  });
}
function Ny(e, t) {
  if (e === t)
    return !0;
  if (!e && t || e && !t || !e || !t || le(e) !== "object" || le(t) !== "object")
    return !1;
  var r = Object.keys(e), n = Object.keys(t), a = new Set([].concat(r, n));
  return te(a).every(function(i) {
    var o = e[i], s = t[i];
    return typeof o == "function" && typeof s == "function" ? !0 : o === s;
  });
}
function Ty(e) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && le(t.target) === "object" && e in t.target ? t.target[e] : t;
}
function Cc(e, t, r) {
  var n = e.length;
  if (t < 0 || t >= n || r < 0 || r >= n)
    return e;
  var a = e[t], i = t - r;
  return i > 0 ? [].concat(te(e.slice(0, r)), [a], te(e.slice(r, t)), te(e.slice(t + 1, n))) : i < 0 ? [].concat(te(e.slice(0, t)), te(e.slice(t + 1, r + 1)), [a], te(e.slice(r + 1, n))) : e;
}
var Iy = ["name"], or = [];
function to(e, t, r, n, a, i) {
  return typeof e == "function" ? e(t, r, "source" in i ? {
    source: i.source
  } : {}) : n !== a;
}
var Is = /* @__PURE__ */ function(e) {
  Vr(r, e);
  var t = jr(r);
  function r(n) {
    var a;
    if (Rt(this, r), a = t.call(this, n), O(be(a), "state", {
      resetCount: 0
    }), O(be(a), "cancelRegisterFunc", null), O(be(a), "mounted", !1), O(be(a), "touched", !1), O(be(a), "dirty", !1), O(be(a), "validatePromise", void 0), O(be(a), "prevValidating", void 0), O(be(a), "errors", or), O(be(a), "warnings", or), O(be(a), "cancelRegister", function() {
      var l = a.props, c = l.preserve, u = l.isListField, v = l.name;
      a.cancelRegisterFunc && a.cancelRegisterFunc(u, c, ct(v)), a.cancelRegisterFunc = null;
    }), O(be(a), "getNamePath", function() {
      var l = a.props, c = l.name, u = l.fieldContext, v = u.prefixName, h = v === void 0 ? [] : v;
      return c !== void 0 ? [].concat(te(h), te(c)) : [];
    }), O(be(a), "getRules", function() {
      var l = a.props, c = l.rules, u = c === void 0 ? [] : c, v = l.fieldContext;
      return u.map(function(h) {
        return typeof h == "function" ? h(v) : h;
      });
    }), O(be(a), "refresh", function() {
      a.mounted && a.setState(function(l) {
        var c = l.resetCount;
        return {
          resetCount: c + 1
        };
      });
    }), O(be(a), "metaCache", null), O(be(a), "triggerMetaEvent", function(l) {
      var c = a.props.onMetaChange;
      if (c) {
        var u = I(I({}, a.getMeta()), {}, {
          destroy: l
        });
        ia(a.metaCache, u) || c(u), a.metaCache = u;
      } else
        a.metaCache = null;
    }), O(be(a), "onStoreChange", function(l, c, u) {
      var v = a.props, h = v.shouldUpdate, b = v.dependencies, g = b === void 0 ? [] : b, m = v.onReset, f = u.store, y = a.getNamePath(), p = a.getValue(l), C = a.getValue(f), S = c && mn(c, y);
      switch (u.type === "valueUpdate" && u.source === "external" && !ia(p, C) && (a.touched = !0, a.dirty = !0, a.validatePromise = null, a.errors = or, a.warnings = or, a.triggerMetaEvent()), u.type) {
        case "reset":
          if (!c || S) {
            a.touched = !1, a.dirty = !1, a.validatePromise = void 0, a.errors = or, a.warnings = or, a.triggerMetaEvent(), m == null || m(), a.refresh();
            return;
          }
          break;
        /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */
        case "remove": {
          if (h && to(h, l, f, p, C, u)) {
            a.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var E = u.data;
          if (S) {
            "touched" in E && (a.touched = E.touched), "validating" in E && !("originRCField" in E) && (a.validatePromise = E.validating ? Promise.resolve([]) : null), "errors" in E && (a.errors = E.errors || or), "warnings" in E && (a.warnings = E.warnings || or), a.dirty = !0, a.triggerMetaEvent(), a.reRender();
            return;
          } else if ("value" in E && mn(c, y, !0)) {
            a.reRender();
            return;
          }
          if (h && !y.length && to(h, l, f, p, C, u)) {
            a.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var w = g.map(ct);
          if (w.some(function(P) {
            return mn(u.relatedFields, P);
          })) {
            a.reRender();
            return;
          }
          break;
        }
        default:
          if (S || (!g.length || y.length || h) && to(h, l, f, p, C, u)) {
            a.reRender();
            return;
          }
          break;
      }
      h === !0 && a.reRender();
    }), O(be(a), "validateRules", function(l) {
      var c = a.getNamePath(), u = a.getValue(), v = l || {}, h = v.triggerName, b = v.validateOnly, g = b === void 0 ? !1 : b, m = Promise.resolve().then(/* @__PURE__ */ wa(/* @__PURE__ */ mr().mark(function f() {
        var y, p, C, S, E, w, P;
        return mr().wrap(function(M) {
          for (; ; ) switch (M.prev = M.next) {
            case 0:
              if (a.mounted) {
                M.next = 2;
                break;
              }
              return M.abrupt("return", []);
            case 2:
              if (y = a.props, p = y.validateFirst, C = p === void 0 ? !1 : p, S = y.messageVariables, E = y.validateDebounce, w = a.getRules(), h && (w = w.filter(function(_) {
                return _;
              }).filter(function(_) {
                var x = _.validateTrigger;
                if (!x)
                  return !0;
                var R = Go(x);
                return R.includes(h);
              })), !(E && h)) {
                M.next = 10;
                break;
              }
              return M.next = 8, new Promise(function(_) {
                setTimeout(_, E);
              });
            case 8:
              if (a.validatePromise === m) {
                M.next = 10;
                break;
              }
              return M.abrupt("return", []);
            case 10:
              return P = Oy(c, u, w, l, C, S), P.catch(function(_) {
                return _;
              }).then(function() {
                var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : or;
                if (a.validatePromise === m) {
                  var x;
                  a.validatePromise = null;
                  var R = [], $ = [];
                  (x = _.forEach) === null || x === void 0 || x.call(_, function(T) {
                    var A = T.rule.warningOnly, D = T.errors, z = D === void 0 ? or : D;
                    A ? $.push.apply($, te(z)) : R.push.apply(R, te(z));
                  }), a.errors = R, a.warnings = $, a.triggerMetaEvent(), a.reRender();
                }
              }), M.abrupt("return", P);
            case 13:
            case "end":
              return M.stop();
          }
        }, f);
      })));
      return g || (a.validatePromise = m, a.dirty = !0, a.errors = or, a.warnings = or, a.triggerMetaEvent(), a.reRender()), m;
    }), O(be(a), "isFieldValidating", function() {
      return !!a.validatePromise;
    }), O(be(a), "isFieldTouched", function() {
      return a.touched;
    }), O(be(a), "isFieldDirty", function() {
      if (a.dirty || a.props.initialValue !== void 0)
        return !0;
      var l = a.props.fieldContext, c = l.getInternalHooks(Wr), u = c.getInitialValue;
      return u(a.getNamePath()) !== void 0;
    }), O(be(a), "getErrors", function() {
      return a.errors;
    }), O(be(a), "getWarnings", function() {
      return a.warnings;
    }), O(be(a), "isListField", function() {
      return a.props.isListField;
    }), O(be(a), "isList", function() {
      return a.props.isList;
    }), O(be(a), "isPreserve", function() {
      return a.props.preserve;
    }), O(be(a), "getMeta", function() {
      a.prevValidating = a.isFieldValidating();
      var l = {
        touched: a.isFieldTouched(),
        validating: a.prevValidating,
        errors: a.errors,
        warnings: a.warnings,
        name: a.getNamePath(),
        validated: a.validatePromise === null
      };
      return l;
    }), O(be(a), "getOnlyChild", function(l) {
      if (typeof l == "function") {
        var c = a.getMeta();
        return I(I({}, a.getOnlyChild(l(a.getControlled(), c, a.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var u = xn(l);
      return u.length !== 1 || !/* @__PURE__ */ d.isValidElement(u[0]) ? {
        child: u,
        isFunction: !1
      } : {
        child: u[0],
        isFunction: !1
      };
    }), O(be(a), "getValue", function(l) {
      var c = a.props.fieldContext.getFieldsValue, u = a.getNamePath();
      return yr(l || c(!0), u);
    }), O(be(a), "getControlled", function() {
      var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = a.props, u = c.name, v = c.trigger, h = c.validateTrigger, b = c.getValueFromEvent, g = c.normalize, m = c.valuePropName, f = c.getValueProps, y = c.fieldContext, p = h !== void 0 ? h : y.validateTrigger, C = a.getNamePath(), S = y.getInternalHooks, E = y.getFieldsValue, w = S(Wr), P = w.dispatch, N = a.getValue(), M = f || function(T) {
        return O({}, m, T);
      }, _ = l[v], x = u !== void 0 ? M(N) : {};
      process.env.NODE_ENV !== "production" && x && Object.keys(x).forEach(function(T) {
        Ae(typeof x[T] != "function", "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(T, ")"));
      });
      var R = I(I({}, l), x);
      R[v] = function() {
        a.touched = !0, a.dirty = !0, a.triggerMetaEvent();
        for (var T, A = arguments.length, D = new Array(A), z = 0; z < A; z++)
          D[z] = arguments[z];
        b ? T = b.apply(void 0, D) : T = Ty.apply(void 0, [m].concat(D)), g && (T = g(T, N, E(!0))), T !== N && P({
          type: "updateValue",
          namePath: C,
          value: T
        }), _ && _.apply(void 0, D);
      };
      var $ = Go(p || []);
      return $.forEach(function(T) {
        var A = R[T];
        R[T] = function() {
          A && A.apply(void 0, arguments);
          var D = a.props.rules;
          D && D.length && P({
            type: "validateField",
            namePath: C,
            triggerName: T
          });
        };
      }), R;
    }), n.fieldContext) {
      var i = n.fieldContext.getInternalHooks, o = i(Wr), s = o.initEntityValue;
      s(be(a));
    }
    return a;
  }
  return Nt(r, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props, i = a.shouldUpdate, o = a.fieldContext;
      if (this.mounted = !0, o) {
        var s = o.getInternalHooks, l = s(Wr), c = l.registerField;
        this.cancelRegisterFunc = c(this);
      }
      i === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var a = this.state.resetCount, i = this.props.children, o = this.getOnlyChild(i), s = o.child, l = o.isFunction, c;
      return l ? c = s : /* @__PURE__ */ d.isValidElement(s) ? c = /* @__PURE__ */ d.cloneElement(s, this.getControlled(s.props)) : (Ae(!s, "`children` of Field is not validate ReactElement."), c = s), /* @__PURE__ */ d.createElement(d.Fragment, {
        key: a
      }, c);
    }
  }]), r;
}(d.Component);
O(Is, "contextType", Pn);
O(Is, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function Ad(e) {
  var t, r = e.name, n = Le(e, Iy), a = d.useContext(Pn), i = d.useContext(ii), o = r !== void 0 ? ct(r) : void 0, s = (t = n.isListField) !== null && t !== void 0 ? t : !!i, l = "keep";
  return s || (l = "_".concat((o || []).join("_"))), process.env.NODE_ENV !== "production" && n.preserve === !1 && s && o.length <= 1 && Ae(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ d.createElement(Is, he({
    key: l,
    name: o,
    isListField: s
  }, n, {
    fieldContext: a
  }));
}
function Ay(e) {
  var t = e.name, r = e.initialValue, n = e.children, a = e.rules, i = e.validateTrigger, o = e.isListField, s = d.useContext(Pn), l = d.useContext(ii), c = d.useRef({
    keys: [],
    id: 0
  }), u = c.current, v = d.useMemo(function() {
    var m = ct(s.prefixName) || [];
    return [].concat(te(m), te(ct(t)));
  }, [s.prefixName, t]), h = d.useMemo(function() {
    return I(I({}, s), {}, {
      prefixName: v
    });
  }, [s, v]), b = d.useMemo(function() {
    return {
      getKey: function(f) {
        var y = v.length, p = f[y];
        return [u.keys[p], f.slice(y + 1)];
      }
    };
  }, [v]);
  if (typeof n != "function")
    return Ae(!1, "Form.List only accepts function as children."), null;
  var g = function(f, y, p) {
    var C = p.source;
    return C === "internal" ? !1 : f !== y;
  };
  return /* @__PURE__ */ d.createElement(ii.Provider, {
    value: b
  }, /* @__PURE__ */ d.createElement(Pn.Provider, {
    value: h
  }, /* @__PURE__ */ d.createElement(Ad, {
    name: [],
    shouldUpdate: g,
    rules: a,
    validateTrigger: i,
    initialValue: r,
    isList: !0,
    isListField: o ?? !!l
  }, function(m, f) {
    var y = m.value, p = y === void 0 ? [] : y, C = m.onChange, S = s.getFieldValue, E = function() {
      var M = S(v || []);
      return M || [];
    }, w = {
      add: function(M, _) {
        var x = E();
        _ >= 0 && _ <= x.length ? (u.keys = [].concat(te(u.keys.slice(0, _)), [u.id], te(u.keys.slice(_))), C([].concat(te(x.slice(0, _)), [M], te(x.slice(_))))) : (process.env.NODE_ENV !== "production" && (_ < 0 || _ > x.length) && Ae(!1, "The second parameter of the add function should be a valid positive number."), u.keys = [].concat(te(u.keys), [u.id]), C([].concat(te(x), [M]))), u.id += 1;
      },
      remove: function(M) {
        var _ = E(), x = new Set(Array.isArray(M) ? M : [M]);
        x.size <= 0 || (u.keys = u.keys.filter(function(R, $) {
          return !x.has($);
        }), C(_.filter(function(R, $) {
          return !x.has($);
        })));
      },
      move: function(M, _) {
        if (M !== _) {
          var x = E();
          M < 0 || M >= x.length || _ < 0 || _ >= x.length || (u.keys = Cc(u.keys, M, _), C(Cc(x, M, _)));
        }
      }
    }, P = p || [];
    return Array.isArray(P) || (P = [], process.env.NODE_ENV !== "production" && Ae(!1, "Current value of '".concat(v.join(" > "), "' is not an array type."))), n(P.map(function(N, M) {
      var _ = u.keys[M];
      return _ === void 0 && (u.keys[M] = u.id, _ = u.keys[M], u.id += 1), {
        name: M,
        key: _,
        isListField: !0
      };
    }), w, f);
  })));
}
function ky(e) {
  var t = !1, r = e.length, n = [];
  return e.length ? new Promise(function(a, i) {
    e.forEach(function(o, s) {
      o.catch(function(l) {
        return t = !0, l;
      }).then(function(l) {
        r -= 1, n[s] = l, !(r > 0) && (t && i(n), a(n));
      });
    });
  }) : Promise.resolve([]);
}
var kd = "__@field_split__";
function ro(e) {
  return e.map(function(t) {
    return "".concat(le(t), ":").concat(t);
  }).join(kd);
}
var ln = /* @__PURE__ */ function() {
  function e() {
    Rt(this, e), O(this, "kvs", /* @__PURE__ */ new Map());
  }
  return Nt(e, [{
    key: "set",
    value: function(r, n) {
      this.kvs.set(ro(r), n);
    }
  }, {
    key: "get",
    value: function(r) {
      return this.kvs.get(ro(r));
    }
  }, {
    key: "update",
    value: function(r, n) {
      var a = this.get(r), i = n(a);
      i ? this.set(r, i) : this.delete(r);
    }
  }, {
    key: "delete",
    value: function(r) {
      this.kvs.delete(ro(r));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(r) {
      return te(this.kvs.entries()).map(function(n) {
        var a = F(n, 2), i = a[0], o = a[1], s = i.split(kd);
        return r({
          key: s.map(function(l) {
            var c = l.match(/^([^:]*):(.*)$/), u = F(c, 3), v = u[1], h = u[2];
            return v === "number" ? Number(h) : h;
          }),
          value: o
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var r = {};
      return this.map(function(n) {
        var a = n.key, i = n.value;
        return r[a.join(".")] = i, null;
      }), r;
    }
  }]), e;
}(), Fy = ["name"], Dy = /* @__PURE__ */ Nt(function e(t) {
  var r = this;
  Rt(this, e), O(this, "formHooked", !1), O(this, "forceRootUpdate", void 0), O(this, "subscribable", !0), O(this, "store", {}), O(this, "fieldEntities", []), O(this, "initialValues", {}), O(this, "callbacks", {}), O(this, "validateMessages", null), O(this, "preserve", null), O(this, "lastValidatePromise", null), O(this, "getForm", function() {
    return {
      getFieldValue: r.getFieldValue,
      getFieldsValue: r.getFieldsValue,
      getFieldError: r.getFieldError,
      getFieldWarning: r.getFieldWarning,
      getFieldsError: r.getFieldsError,
      isFieldsTouched: r.isFieldsTouched,
      isFieldTouched: r.isFieldTouched,
      isFieldValidating: r.isFieldValidating,
      isFieldsValidating: r.isFieldsValidating,
      resetFields: r.resetFields,
      setFields: r.setFields,
      setFieldValue: r.setFieldValue,
      setFieldsValue: r.setFieldsValue,
      validateFields: r.validateFields,
      submit: r.submit,
      _init: !0,
      getInternalHooks: r.getInternalHooks
    };
  }), O(this, "getInternalHooks", function(n) {
    return n === Wr ? (r.formHooked = !0, {
      dispatch: r.dispatch,
      initEntityValue: r.initEntityValue,
      registerField: r.registerField,
      useSubscribe: r.useSubscribe,
      setInitialValues: r.setInitialValues,
      destroyForm: r.destroyForm,
      setCallbacks: r.setCallbacks,
      setValidateMessages: r.setValidateMessages,
      getFields: r.getFields,
      setPreserve: r.setPreserve,
      getInitialValue: r.getInitialValue,
      registerWatch: r.registerWatch
    }) : (Ae(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), O(this, "useSubscribe", function(n) {
    r.subscribable = n;
  }), O(this, "prevWithoutPreserves", null), O(this, "setInitialValues", function(n, a) {
    if (r.initialValues = n || {}, a) {
      var i, o = cn(n, r.store);
      (i = r.prevWithoutPreserves) === null || i === void 0 || i.map(function(s) {
        var l = s.key;
        o = dr(o, l, yr(n, l));
      }), r.prevWithoutPreserves = null, r.updateStore(o);
    }
  }), O(this, "destroyForm", function(n) {
    if (n)
      r.updateStore({});
    else {
      var a = new ln();
      r.getFieldEntities(!0).forEach(function(i) {
        r.isMergedPreserve(i.isPreserve()) || a.set(i.getNamePath(), !0);
      }), r.prevWithoutPreserves = a;
    }
  }), O(this, "getInitialValue", function(n) {
    var a = yr(r.initialValues, n);
    return n.length ? cn(a) : a;
  }), O(this, "setCallbacks", function(n) {
    r.callbacks = n;
  }), O(this, "setValidateMessages", function(n) {
    r.validateMessages = n;
  }), O(this, "setPreserve", function(n) {
    r.preserve = n;
  }), O(this, "watchList", []), O(this, "registerWatch", function(n) {
    return r.watchList.push(n), function() {
      r.watchList = r.watchList.filter(function(a) {
        return a !== n;
      });
    };
  }), O(this, "notifyWatch", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (r.watchList.length) {
      var a = r.getFieldsValue(), i = r.getFieldsValue(!0);
      r.watchList.forEach(function(o) {
        o(a, i, n);
      });
    }
  }), O(this, "timeoutId", null), O(this, "warningUnhooked", function() {
    process.env.NODE_ENV !== "production" && !r.timeoutId && typeof window < "u" && (r.timeoutId = setTimeout(function() {
      r.timeoutId = null, r.formHooked || Ae(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), O(this, "updateStore", function(n) {
    r.store = n;
  }), O(this, "getFieldEntities", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return n ? r.fieldEntities.filter(function(a) {
      return a.getNamePath().length;
    }) : r.fieldEntities;
  }), O(this, "getFieldsMap", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, a = new ln();
    return r.getFieldEntities(n).forEach(function(i) {
      var o = i.getNamePath();
      a.set(o, i);
    }), a;
  }), O(this, "getFieldEntitiesForNamePathList", function(n) {
    if (!n)
      return r.getFieldEntities(!0);
    var a = r.getFieldsMap(!0);
    return n.map(function(i) {
      var o = ct(i);
      return a.get(o) || {
        INVALIDATE_NAME_PATH: ct(i)
      };
    });
  }), O(this, "getFieldsValue", function(n, a) {
    r.warningUnhooked();
    var i, o, s;
    if (n === !0 || Array.isArray(n) ? (i = n, o = a) : n && le(n) === "object" && (s = n.strict, o = n.filter), i === !0 && !o)
      return r.store;
    var l = r.getFieldEntitiesForNamePathList(Array.isArray(i) ? i : null), c = [];
    return l.forEach(function(u) {
      var v, h, b = "INVALIDATE_NAME_PATH" in u ? u.INVALIDATE_NAME_PATH : u.getNamePath();
      if (s) {
        var g, m;
        if ((g = (m = u).isList) !== null && g !== void 0 && g.call(m))
          return;
      } else if (!i && (v = (h = u).isListField) !== null && v !== void 0 && v.call(h))
        return;
      if (!o)
        c.push(b);
      else {
        var f = "getMeta" in u ? u.getMeta() : null;
        o(f) && c.push(b);
      }
    }), bc(r.store, c.map(ct));
  }), O(this, "getFieldValue", function(n) {
    r.warningUnhooked();
    var a = ct(n);
    return yr(r.store, a);
  }), O(this, "getFieldsError", function(n) {
    r.warningUnhooked();
    var a = r.getFieldEntitiesForNamePathList(n);
    return a.map(function(i, o) {
      return i && !("INVALIDATE_NAME_PATH" in i) ? {
        name: i.getNamePath(),
        errors: i.getErrors(),
        warnings: i.getWarnings()
      } : {
        name: ct(n[o]),
        errors: [],
        warnings: []
      };
    });
  }), O(this, "getFieldError", function(n) {
    r.warningUnhooked();
    var a = ct(n), i = r.getFieldsError([a])[0];
    return i.errors;
  }), O(this, "getFieldWarning", function(n) {
    r.warningUnhooked();
    var a = ct(n), i = r.getFieldsError([a])[0];
    return i.warnings;
  }), O(this, "isFieldsTouched", function() {
    r.warningUnhooked();
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    var o = a[0], s = a[1], l, c = !1;
    a.length === 0 ? l = null : a.length === 1 ? Array.isArray(o) ? (l = o.map(ct), c = !1) : (l = null, c = o) : (l = o.map(ct), c = s);
    var u = r.getFieldEntities(!0), v = function(f) {
      return f.isFieldTouched();
    };
    if (!l)
      return c ? u.every(function(m) {
        return v(m) || m.isList();
      }) : u.some(v);
    var h = new ln();
    l.forEach(function(m) {
      h.set(m, []);
    }), u.forEach(function(m) {
      var f = m.getNamePath();
      l.forEach(function(y) {
        y.every(function(p, C) {
          return f[C] === p;
        }) && h.update(y, function(p) {
          return [].concat(te(p), [m]);
        });
      });
    });
    var b = function(f) {
      return f.some(v);
    }, g = h.map(function(m) {
      var f = m.value;
      return f;
    });
    return c ? g.every(b) : g.some(b);
  }), O(this, "isFieldTouched", function(n) {
    return r.warningUnhooked(), r.isFieldsTouched([n]);
  }), O(this, "isFieldsValidating", function(n) {
    r.warningUnhooked();
    var a = r.getFieldEntities();
    if (!n)
      return a.some(function(o) {
        return o.isFieldValidating();
      });
    var i = n.map(ct);
    return a.some(function(o) {
      var s = o.getNamePath();
      return mn(i, s) && o.isFieldValidating();
    });
  }), O(this, "isFieldValidating", function(n) {
    return r.warningUnhooked(), r.isFieldsValidating([n]);
  }), O(this, "resetWithFieldInitialValue", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = new ln(), i = r.getFieldEntities(!0);
    i.forEach(function(l) {
      var c = l.props.initialValue, u = l.getNamePath();
      if (c !== void 0) {
        var v = a.get(u) || /* @__PURE__ */ new Set();
        v.add({
          entity: l,
          value: c
        }), a.set(u, v);
      }
    });
    var o = function(c) {
      c.forEach(function(u) {
        var v = u.props.initialValue;
        if (v !== void 0) {
          var h = u.getNamePath(), b = r.getInitialValue(h);
          if (b !== void 0)
            Ae(!1, "Form already set 'initialValues' with path '".concat(h.join("."), "'. Field can not overwrite it."));
          else {
            var g = a.get(h);
            if (g && g.size > 1)
              Ae(!1, "Multiple Field with path '".concat(h.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (g) {
              var m = r.getFieldValue(h), f = u.isListField();
              !f && (!n.skipExist || m === void 0) && r.updateStore(dr(r.store, h, te(g)[0].value));
            }
          }
        }
      });
    }, s;
    n.entities ? s = n.entities : n.namePathList ? (s = [], n.namePathList.forEach(function(l) {
      var c = a.get(l);
      if (c) {
        var u;
        (u = s).push.apply(u, te(te(c).map(function(v) {
          return v.entity;
        })));
      }
    })) : s = i, o(s);
  }), O(this, "resetFields", function(n) {
    r.warningUnhooked();
    var a = r.store;
    if (!n) {
      r.updateStore(cn(r.initialValues)), r.resetWithFieldInitialValue(), r.notifyObservers(a, null, {
        type: "reset"
      }), r.notifyWatch();
      return;
    }
    var i = n.map(ct);
    i.forEach(function(o) {
      var s = r.getInitialValue(o);
      r.updateStore(dr(r.store, o, s));
    }), r.resetWithFieldInitialValue({
      namePathList: i
    }), r.notifyObservers(a, i, {
      type: "reset"
    }), r.notifyWatch(i);
  }), O(this, "setFields", function(n) {
    r.warningUnhooked();
    var a = r.store, i = [];
    n.forEach(function(o) {
      var s = o.name, l = Le(o, Fy), c = ct(s);
      i.push(c), "value" in l && r.updateStore(dr(r.store, c, l.value)), r.notifyObservers(a, [c], {
        type: "setField",
        data: o
      });
    }), r.notifyWatch(i);
  }), O(this, "getFields", function() {
    var n = r.getFieldEntities(!0), a = n.map(function(i) {
      var o = i.getNamePath(), s = i.getMeta(), l = I(I({}, s), {}, {
        name: o,
        value: r.getFieldValue(o)
      });
      return Object.defineProperty(l, "originRCField", {
        value: !0
      }), l;
    });
    return a;
  }), O(this, "initEntityValue", function(n) {
    var a = n.props.initialValue;
    if (a !== void 0) {
      var i = n.getNamePath(), o = yr(r.store, i);
      o === void 0 && r.updateStore(dr(r.store, i, a));
    }
  }), O(this, "isMergedPreserve", function(n) {
    var a = n !== void 0 ? n : r.preserve;
    return a ?? !0;
  }), O(this, "registerField", function(n) {
    r.fieldEntities.push(n);
    var a = n.getNamePath();
    if (r.notifyWatch([a]), n.props.initialValue !== void 0) {
      var i = r.store;
      r.resetWithFieldInitialValue({
        entities: [n],
        skipExist: !0
      }), r.notifyObservers(i, [n.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(o, s) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (r.fieldEntities = r.fieldEntities.filter(function(v) {
        return v !== n;
      }), !r.isMergedPreserve(s) && (!o || l.length > 1)) {
        var c = o ? void 0 : r.getInitialValue(a);
        if (a.length && r.getFieldValue(a) !== c && r.fieldEntities.every(function(v) {
          return (
            // Only reset when no namePath exist
            !Id(v.getNamePath(), a)
          );
        })) {
          var u = r.store;
          r.updateStore(dr(u, a, c, !0)), r.notifyObservers(u, [a], {
            type: "remove"
          }), r.triggerDependenciesUpdate(u, a);
        }
      }
      r.notifyWatch([a]);
    };
  }), O(this, "dispatch", function(n) {
    switch (n.type) {
      case "updateValue": {
        var a = n.namePath, i = n.value;
        r.updateValue(a, i);
        break;
      }
      case "validateField": {
        var o = n.namePath, s = n.triggerName;
        r.validateFields([o], {
          triggerName: s
        });
        break;
      }
    }
  }), O(this, "notifyObservers", function(n, a, i) {
    if (r.subscribable) {
      var o = I(I({}, i), {}, {
        store: r.getFieldsValue(!0)
      });
      r.getFieldEntities().forEach(function(s) {
        var l = s.onStoreChange;
        l(n, a, o);
      });
    } else
      r.forceRootUpdate();
  }), O(this, "triggerDependenciesUpdate", function(n, a) {
    var i = r.getDependencyChildrenFields(a);
    return i.length && r.validateFields(i), r.notifyObservers(n, i, {
      type: "dependenciesUpdate",
      relatedFields: [a].concat(te(i))
    }), i;
  }), O(this, "updateValue", function(n, a) {
    var i = ct(n), o = r.store;
    r.updateStore(dr(r.store, i, a)), r.notifyObservers(o, [i], {
      type: "valueUpdate",
      source: "internal"
    }), r.notifyWatch([i]);
    var s = r.triggerDependenciesUpdate(o, i), l = r.callbacks.onValuesChange;
    if (l) {
      var c = bc(r.store, [i]);
      l(c, r.getFieldsValue());
    }
    r.triggerOnFieldsChange([i].concat(te(s)));
  }), O(this, "setFieldsValue", function(n) {
    r.warningUnhooked();
    var a = r.store;
    if (n) {
      var i = cn(r.store, n);
      r.updateStore(i);
    }
    r.notifyObservers(a, null, {
      type: "valueUpdate",
      source: "external"
    }), r.notifyWatch();
  }), O(this, "setFieldValue", function(n, a) {
    r.setFields([{
      name: n,
      value: a,
      errors: [],
      warnings: []
    }]);
  }), O(this, "getDependencyChildrenFields", function(n) {
    var a = /* @__PURE__ */ new Set(), i = [], o = new ln();
    r.getFieldEntities().forEach(function(l) {
      var c = l.props.dependencies;
      (c || []).forEach(function(u) {
        var v = ct(u);
        o.update(v, function() {
          var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return h.add(l), h;
        });
      });
    });
    var s = function l(c) {
      var u = o.get(c) || /* @__PURE__ */ new Set();
      u.forEach(function(v) {
        if (!a.has(v)) {
          a.add(v);
          var h = v.getNamePath();
          v.isFieldDirty() && h.length && (i.push(h), l(h));
        }
      });
    };
    return s(n), i;
  }), O(this, "triggerOnFieldsChange", function(n, a) {
    var i = r.callbacks.onFieldsChange;
    if (i) {
      var o = r.getFields();
      if (a) {
        var s = new ln();
        a.forEach(function(c) {
          var u = c.name, v = c.errors;
          s.set(u, v);
        }), o.forEach(function(c) {
          c.errors = s.get(c.name) || c.errors;
        });
      }
      var l = o.filter(function(c) {
        var u = c.name;
        return mn(n, u);
      });
      l.length && i(l, o);
    }
  }), O(this, "validateFields", function(n, a) {
    r.warningUnhooked();
    var i, o;
    Array.isArray(n) || typeof n == "string" || typeof a == "string" ? (i = n, o = a) : o = n;
    var s = !!i, l = s ? i.map(ct) : [], c = [], u = String(Date.now()), v = /* @__PURE__ */ new Set(), h = o || {}, b = h.recursive, g = h.dirty;
    r.getFieldEntities(!0).forEach(function(p) {
      if (s || l.push(p.getNamePath()), !(!p.props.rules || !p.props.rules.length) && !(g && !p.isFieldDirty())) {
        var C = p.getNamePath();
        if (v.add(C.join(u)), !s || mn(l, C, b)) {
          var S = p.validateRules(I({
            validateMessages: I(I({}, Td), r.validateMessages)
          }, o));
          c.push(S.then(function() {
            return {
              name: C,
              errors: [],
              warnings: []
            };
          }).catch(function(E) {
            var w, P = [], N = [];
            return (w = E.forEach) === null || w === void 0 || w.call(E, function(M) {
              var _ = M.rule.warningOnly, x = M.errors;
              _ ? N.push.apply(N, te(x)) : P.push.apply(P, te(x));
            }), P.length ? Promise.reject({
              name: C,
              errors: P,
              warnings: N
            }) : {
              name: C,
              errors: P,
              warnings: N
            };
          }));
        }
      }
    });
    var m = ky(c);
    r.lastValidatePromise = m, m.catch(function(p) {
      return p;
    }).then(function(p) {
      var C = p.map(function(S) {
        var E = S.name;
        return E;
      });
      r.notifyObservers(r.store, C, {
        type: "validateFinish"
      }), r.triggerOnFieldsChange(C, p);
    });
    var f = m.then(function() {
      return r.lastValidatePromise === m ? Promise.resolve(r.getFieldsValue(l)) : Promise.reject([]);
    }).catch(function(p) {
      var C = p.filter(function(S) {
        return S && S.errors.length;
      });
      return Promise.reject({
        values: r.getFieldsValue(l),
        errorFields: C,
        outOfDate: r.lastValidatePromise !== m
      });
    });
    f.catch(function(p) {
      return p;
    });
    var y = l.filter(function(p) {
      return v.has(p.join(u));
    });
    return r.triggerOnFieldsChange(y), f;
  }), O(this, "submit", function() {
    r.warningUnhooked(), r.validateFields().then(function(n) {
      var a = r.callbacks.onFinish;
      if (a)
        try {
          a(n);
        } catch (i) {
          console.error(i);
        }
    }).catch(function(n) {
      var a = r.callbacks.onFinishFailed;
      a && a(n);
    });
  }), this.forceRootUpdate = t;
});
function Fd(e) {
  var t = d.useRef(), r = d.useState({}), n = F(r, 2), a = n[1];
  if (!t.current)
    if (e)
      t.current = e;
    else {
      var i = function() {
        a({});
      }, o = new Dy(i);
      t.current = o.getForm();
    }
  return [t.current];
}
var ns = /* @__PURE__ */ d.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), Ly = function(t) {
  var r = t.validateMessages, n = t.onFormChange, a = t.onFormFinish, i = t.children, o = d.useContext(ns), s = d.useRef({});
  return /* @__PURE__ */ d.createElement(ns.Provider, {
    value: I(I({}, o), {}, {
      validateMessages: I(I({}, o.validateMessages), r),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(c, u) {
        n && n(c, {
          changedFields: u,
          forms: s.current
        }), o.triggerFormChange(c, u);
      },
      triggerFormFinish: function(c, u) {
        a && a(c, {
          values: u,
          forms: s.current
        }), o.triggerFormFinish(c, u);
      },
      registerForm: function(c, u) {
        c && (s.current = I(I({}, s.current), {}, O({}, c, u))), o.registerForm(c, u);
      },
      unregisterForm: function(c) {
        var u = I({}, s.current);
        delete u[c], s.current = u, o.unregisterForm(c);
      }
    })
  }, i);
}, Vy = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"], jy = function(t, r) {
  var n = t.name, a = t.initialValues, i = t.fields, o = t.form, s = t.preserve, l = t.children, c = t.component, u = c === void 0 ? "form" : c, v = t.validateMessages, h = t.validateTrigger, b = h === void 0 ? "onChange" : h, g = t.onValuesChange, m = t.onFieldsChange, f = t.onFinish, y = t.onFinishFailed, p = t.clearOnDestroy, C = Le(t, Vy), S = d.useRef(null), E = d.useContext(ns), w = Fd(o), P = F(w, 1), N = P[0], M = N.getInternalHooks(Wr), _ = M.useSubscribe, x = M.setInitialValues, R = M.setCallbacks, $ = M.setValidateMessages, T = M.setPreserve, A = M.destroyForm;
  d.useImperativeHandle(r, function() {
    return I(I({}, N), {}, {
      nativeElement: S.current
    });
  }), d.useEffect(function() {
    return E.registerForm(n, N), function() {
      E.unregisterForm(n);
    };
  }, [E, N, n]), $(I(I({}, E.validateMessages), v)), R({
    onValuesChange: g,
    onFieldsChange: function(j) {
      if (E.triggerFormChange(n, j), m) {
        for (var K = arguments.length, J = new Array(K > 1 ? K - 1 : 0), Z = 1; Z < K; Z++)
          J[Z - 1] = arguments[Z];
        m.apply(void 0, [j].concat(J));
      }
    },
    onFinish: function(j) {
      E.triggerFormFinish(n, j), f && f(j);
    },
    onFinishFailed: y
  }), T(s);
  var D = d.useRef(null);
  x(a, !D.current), D.current || (D.current = !0), d.useEffect(
    function() {
      return function() {
        return A(p);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var z, V = typeof l == "function";
  if (V) {
    var k = N.getFieldsValue(!0);
    z = l(k, N);
  } else
    z = l;
  _(!V);
  var B = d.useRef();
  d.useEffect(function() {
    Ny(B.current || [], i || []) || N.setFields(i || []), B.current = i;
  }, [i, N]);
  var q = d.useMemo(function() {
    return I(I({}, N), {}, {
      validateTrigger: b
    });
  }, [N, b]), W = /* @__PURE__ */ d.createElement(ii.Provider, {
    value: null
  }, /* @__PURE__ */ d.createElement(Pn.Provider, {
    value: q
  }, z));
  return u === !1 ? W : /* @__PURE__ */ d.createElement(u, he({}, C, {
    ref: S,
    onSubmit: function(j) {
      j.preventDefault(), j.stopPropagation(), N.submit();
    },
    onReset: function(j) {
      var K;
      j.preventDefault(), N.resetFields(), (K = C.onReset) === null || K === void 0 || K.call(C, j);
    }
  }), W);
};
function Sc(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return Math.random();
  }
}
var zy = process.env.NODE_ENV !== "production" ? function(e) {
  var t = e.join("__RC_FIELD_FORM_SPLIT__"), r = De(t);
  Ae(r.current === t, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function Hy() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n = t[0], a = t[1], i = a === void 0 ? {} : a, o = Y0(i) ? {
    form: i
  } : i, s = o.form, l = Ze(), c = F(l, 2), u = c[0], v = c[1], h = pn(function() {
    return Sc(u);
  }, [u]), b = De(h);
  b.current = h;
  var g = Lr(Pn), m = s || g, f = m && m._init;
  process.env.NODE_ENV !== "production" && Ae(t.length === 2 ? s ? f : !0 : f, "useWatch requires a form instance since it can not auto detect from context.");
  var y = ct(n), p = De(y);
  return p.current = y, zy(y), gt(
    function() {
      if (f) {
        var C = m.getFieldsValue, S = m.getInternalHooks, E = S(Wr), w = E.registerWatch, P = function(x, R) {
          var $ = o.preserve ? R : x;
          return typeof n == "function" ? n($) : yr($, p.current);
        }, N = w(function(_, x) {
          var R = P(_, x), $ = Sc(R);
          b.current !== $ && (b.current = $, v(R));
        }), M = P(C(), C(!0));
        return u !== M && v(M), N;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [f]
  ), u;
}
var By = /* @__PURE__ */ d.forwardRef(jy), _a = By;
_a.FormProvider = Ly;
_a.Field = Ad;
_a.List = Ay;
_a.useForm = Fd;
_a.useWatch = Hy;
const Wy = /* @__PURE__ */ d.createContext({});
process.env.NODE_ENV !== "production" && (Wy.displayName = "FormItemInputContext");
const Ky = /* @__PURE__ */ d.createContext(void 0), qy = (e, t, r = void 0) => {
  var n, a;
  const {
    variant: i,
    [e]: o
  } = d.useContext(Mt), s = d.useContext(Ky), l = o == null ? void 0 : o.variant;
  let c;
  typeof t < "u" ? c = t : r === !1 ? c = "borderless" : c = (a = (n = s ?? l) !== null && n !== void 0 ? n : i) !== null && a !== void 0 ? a : "outlined";
  const u = nh.includes(c);
  return [c, u];
};
var Ec = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const Uy = (e) => {
  const {
    actionClasses: t,
    actions: r = [],
    actionStyle: n
  } = e;
  return /* @__PURE__ */ d.createElement("ul", {
    className: t,
    style: n
  }, r.map((a, i) => {
    const o = `action-${i}`;
    return /* @__PURE__ */ d.createElement("li", {
      style: {
        width: `${100 / r.length}%`
      },
      key: o
    }, /* @__PURE__ */ d.createElement("span", null, a));
  }));
}, Gy = /* @__PURE__ */ d.forwardRef((e, t) => {
  const {
    prefixCls: r,
    className: n,
    rootClassName: a,
    style: i,
    extra: o,
    headStyle: s = {},
    bodyStyle: l = {},
    title: c,
    loading: u,
    bordered: v,
    variant: h,
    size: b,
    type: g,
    cover: m,
    actions: f,
    tabList: y,
    children: p,
    activeTabKey: C,
    defaultActiveTabKey: S,
    tabBarExtraContent: E,
    hoverable: w,
    tabProps: P = {},
    classNames: N,
    styles: M
  } = e, _ = Ec(e, ["prefixCls", "className", "rootClassName", "style", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "variant", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent", "hoverable", "tabProps", "classNames", "styles"]), {
    getPrefixCls: x,
    direction: R,
    card: $
  } = d.useContext(Mt), [T] = qy("card", h, v);
  if (process.env.NODE_ENV !== "production") {
    const ve = qr("Card");
    [["headStyle", "styles.header"], ["bodyStyle", "styles.body"], ["bordered", "variant"]].forEach(([U, pe]) => {
      ve.deprecated(!(U in e), U, pe);
    });
  }
  const A = (ve) => {
    var U;
    (U = e.onTabChange) === null || U === void 0 || U.call(e, ve);
  }, D = (ve) => {
    var U;
    return ne((U = $ == null ? void 0 : $.classNames) === null || U === void 0 ? void 0 : U[ve], N == null ? void 0 : N[ve]);
  }, z = (ve) => {
    var U;
    return Object.assign(Object.assign({}, (U = $ == null ? void 0 : $.styles) === null || U === void 0 ? void 0 : U[ve]), M == null ? void 0 : M[ve]);
  }, V = d.useMemo(() => {
    let ve = !1;
    return d.Children.forEach(p, (U) => {
      (U == null ? void 0 : U.type) === Md && (ve = !0);
    }), ve;
  }, [p]), k = x("card", r), [B, q, W] = X0(k), H = /* @__PURE__ */ d.createElement(Gr, {
    loading: !0,
    active: !0,
    paragraph: {
      rows: 4
    },
    title: !1
  }, p), j = C !== void 0, K = Object.assign(Object.assign({}, P), {
    [j ? "activeKey" : "defaultActiveKey"]: j ? C : S,
    tabBarExtraContent: E
  });
  let J;
  const Z = Vu(b), ae = !Z || Z === "default" ? "large" : Z, oe = y ? /* @__PURE__ */ d.createElement(Ts, Object.assign({
    size: ae
  }, K, {
    className: `${k}-head-tabs`,
    onChange: A,
    items: y.map((ve) => {
      var {
        tab: U
      } = ve, pe = Ec(ve, ["tab"]);
      return Object.assign({
        label: U
      }, pe);
    })
  })) : null;
  if (c || o || oe) {
    const ve = ne(`${k}-head`, D("header")), U = ne(`${k}-head-title`, D("title")), pe = ne(`${k}-extra`, D("extra")), se = Object.assign(Object.assign({}, s), z("header"));
    J = /* @__PURE__ */ d.createElement("div", {
      className: ve,
      style: se
    }, /* @__PURE__ */ d.createElement("div", {
      className: `${k}-head-wrapper`
    }, c && /* @__PURE__ */ d.createElement("div", {
      className: U,
      style: z("title")
    }, c), o && /* @__PURE__ */ d.createElement("div", {
      className: pe,
      style: z("extra")
    }, o)), oe);
  }
  const fe = ne(`${k}-cover`, D("cover")), me = m ? /* @__PURE__ */ d.createElement("div", {
    className: fe,
    style: z("cover")
  }, m) : null, ue = ne(`${k}-body`, D("body")), Ce = Object.assign(Object.assign({}, l), z("body")), L = /* @__PURE__ */ d.createElement("div", {
    className: ue,
    style: Ce
  }, u ? H : p), de = ne(`${k}-actions`, D("actions")), ye = f != null && f.length ? /* @__PURE__ */ d.createElement(Uy, {
    actionClasses: de,
    actionStyle: z("actions"),
    actions: f
  }) : null, Ge = Ur(_, ["onTabChange"]), Oe = ne(k, $ == null ? void 0 : $.className, {
    [`${k}-loading`]: u,
    [`${k}-bordered`]: T !== "borderless",
    [`${k}-hoverable`]: w,
    [`${k}-contain-grid`]: V,
    [`${k}-contain-tabs`]: y == null ? void 0 : y.length,
    [`${k}-${Z}`]: Z,
    [`${k}-type-${g}`]: !!g,
    [`${k}-rtl`]: R === "rtl"
  }, n, a, q, W), He = Object.assign(Object.assign({}, $ == null ? void 0 : $.style), i);
  return B(/* @__PURE__ */ d.createElement("div", Object.assign({
    ref: t
  }, Ge, {
    className: Oe,
    style: He
  }), J, me, L, ye));
});
var Xy = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const Yy = (e) => {
  const {
    prefixCls: t,
    className: r,
    avatar: n,
    title: a,
    description: i
  } = e, o = Xy(e, ["prefixCls", "className", "avatar", "title", "description"]), {
    getPrefixCls: s
  } = d.useContext(Mt), l = s("card", t), c = ne(`${l}-meta`, r), u = n ? /* @__PURE__ */ d.createElement("div", {
    className: `${l}-meta-avatar`
  }, n) : null, v = a ? /* @__PURE__ */ d.createElement("div", {
    className: `${l}-meta-title`
  }, a) : null, h = i ? /* @__PURE__ */ d.createElement("div", {
    className: `${l}-meta-description`
  }, i) : null, b = v || h ? /* @__PURE__ */ d.createElement("div", {
    className: `${l}-meta-detail`
  }, v, h) : null;
  return /* @__PURE__ */ d.createElement("div", Object.assign({}, o, {
    className: c
  }), u, b);
}, _i = Gy;
_i.Grid = Md;
_i.Meta = Yy;
process.env.NODE_ENV !== "production" && (_i.displayName = "Card");
const { Column: wc } = _c, Qy = ({ person: e }) => {
  gt(() => {
    console.log(e);
  }, [e]);
  const t = [
    {
      name: "ИНН",
      value: e.Subject.INN
    },
    {
      name: "СНИЛС",
      value: e.Subject.SNILS
    },
    {
      name: "Алгоритм",
      value: e.Algorithm
    },
    {
      name: "Выдан",
      value: Xd(e.ValidFromDate, "dd-MM-yyyy")
    },
    {
      name: "Владелец",
      value: e.Subject.CN
    },
    {
      name: "Номер сертификата",
      value: e.SerialNumber
    }
  ];
  return /* @__PURE__ */ Q.createElement(
    _i,
    {
      classNames: { body: "cryptography-selected-person-card-body" },
      style: { marginTop: 16 }
    },
    /* @__PURE__ */ Q.createElement(fn.Title, { level: 5, style: { marginBottom: 10 } }, e.Name),
    /* @__PURE__ */ Q.createElement(
      "p",
      {
        style: {
          color: e.IsValid ? "#43A047" : "#F20404",
          border: "1px solid",
          borderColor: e.IsValid ? "#43A047" : "#F20404",
          padding: "5px 8px",
          display: "inline-block",
          borderRadius: 16
        }
      },
      e.IsValid ? "Валидный" : "Не валидный"
    ),
    /* @__PURE__ */ Q.createElement(
      _c,
      {
        dataSource: t,
        className: "cryptography-selected-person-table",
        pagination: !1
      },
      /* @__PURE__ */ Q.createElement(
        wc,
        {
          dataIndex: "name",
          render: (r) => /* @__PURE__ */ Q.createElement(fn.Text, { type: "secondary" }, r),
          width: "33%"
        }
      ),
      /* @__PURE__ */ Q.createElement(
        wc,
        {
          dataIndex: "value",
          render: (r) => /* @__PURE__ */ Q.createElement(fn.Text, null, r)
        }
      )
    )
  );
}, Zy = ({ disabled: e }) => {
  const {
    certificates: t,
    errorList: r,
    isLoadingCerts: n,
    fetchCertificates: a,
    selectedCertificate: i,
    fetchSelectCertificate: o
  } = Nc(), s = !n && (r.includes(
    yn.StorageNotInitialized
  ) || Array.isArray(t) && !t.length);
  return /* @__PURE__ */ Q.createElement("div", { style: { marginTop: 16, position: "relative" } }, /* @__PURE__ */ Q.createElement(as, { justify: "space-between", align: "center", style: { marginBottom: 16 } }, /* @__PURE__ */ Q.createElement(
    fn.Title,
    {
      level: 5,
      style: { marginBottom: 0, textAlign: "center" }
    },
    "Выберите сертификат"
  ), /* @__PURE__ */ Q.createElement(
    xc,
    {
      type: "link",
      style: { paddingRight: 0 },
      onClick: a
    },
    "Обновить список"
  )), n && /* @__PURE__ */ Q.createElement($g, null), !n && (t == null ? void 0 : t.length) && /* @__PURE__ */ Q.createElement(
    Dd.Group,
    {
      style: { display: "flex", flexDirection: "column", gap: 8 },
      onChange: (l) => o(l.target.value),
      value: i == null ? void 0 : i.Thumbprint,
      disabled: e,
      options: t == null ? void 0 : t.map((l) => ({
        value: l.id,
        label: `${l.subject ? `${l.subject.CN}, ИНН ${l.subject.INN ?? "-"}, СНИЛС ${l.subject.SNILS ?? "-"}` : l.id}`
      }))
    }
  ), i && /* @__PURE__ */ Q.createElement(Qy, { person: i }), s && /* @__PURE__ */ Q.createElement(mf, null));
}, Jy = (e, t) => {
  const r = e.Subject.CN.toLowerCase(), n = `${t.lastName} ${t.firstName} ${t.middleName}`.toLowerCase();
  return r === n;
}, eb = {
  token: {
    fontFamily: "Roboto, sans-serif"
  },
  components: {
    Table: {
      borderColor: "rgb(255,255,255)",
      headerColor: "rgb(102,102,102)",
      fontWeightStrong: 400,
      headerBg: "rgb(255,255,255)",
      headerFilterHoverBg: "rgba(255,255,255,0.06)",
      headerSortHoverBg: "rgb(255,255,255)",
      rowHoverBg: "rgb(255,255,255)",
      bodySortBg: "rgb(255,255,255)",
      headerSortActiveBg: "rgb(255,255,255)",
      headerSplitColor: "rgb(255,255,255)",
      padding: 10.5
    },
    Typography: {
      fontSizeHeading3: 24,
      colorText: "#333333",
      fontFamilyCode: "'Roboto",
      fontWeightStrong: 500,
      colorTextHeading: "#333333",
      colorLinkActive: "rgb(0,52,173)",
      colorLink: "rgb(0,52,173)",
      colorLinkHover: "rgb(0,52,173)"
    },
    Button: {
      colorLink: "rgb(0,52,173)",
      colorLinkHover: "rgb(65,105,225)",
      colorPrimary: "rgb(65,105,225)",
      borderRadius: 10,
      defaultBorderColor: "rgb(234,238,248)",
      defaultHoverBorderColor: "rgb(234,238,248)",
      borderColorDisabled: "transparent",
      colorBgContainerDisabled: "rgba(65,105,225,0.5)",
      colorTextDisabled: "rgb(255,255,255)"
    },
    Tabs: {
      inkBarColor: "rgb(51,51,51)",
      itemHoverColor: "rgb(0,0,0)",
      itemSelectedColor: "rgb(51,51,51)",
      horizontalMargin: "0 0 0 0",
      verticalItemMargin: "16px 0 16px 0",
      colorBorder: "rgb(255,0,0)",
      colorBorderSecondary: "#BCBFC0",
      titleFontSize: 16
    },
    Switch: {
      colorPrimary: "rgb(0,52,173)",
      colorPrimaryBorder: "rgb(0,52,173)",
      colorPrimaryHover: "rgb(0,78,173)",
      colorTextQuaternary: "rgb(188,191,192)",
      handleSize: 16,
      trackHeight: 20
    },
    Card: {
      boxShadow: "none",
      boxShadowSecondary: "none"
    },
    Input: {
      borderRadius: 10
    },
    Select: {
      borderRadius: 10,
      activeBorderColor: "rgb(65, 105, 225)",
      hoverBorderColor: "rgb(65, 105, 225, 0.8)",
      activeOutlineColor: "rgb(65, 105, 225, 0.4)",
      colorBorder: "#D9D9D9",
      optionPadding: "8px 12px"
    },
    Radio: {
      colorPrimary: "rgb(188,191,192)",
      dotSize: 8,
      colorText: "rgb(51,51,51)"
    },
    Modal: {
      fontSizeHeading5: 20,
      fontWeightStrong: 500
    },
    Divider: {
      colorSplit: "rgb(221,221,221)"
    },
    Form: {
      labelFontSize: 14,
      verticalLabelMargin: 0,
      verticalLabelPadding: 0,
      itemMarginBottom: 48
    }
  }
}, sb = ({
  children: e,
  signType: t = "xml",
  signMode: r = "single",
  signContent: n,
  currentUser: a,
  onSuccess: i,
  forceDisableSignButton: o,
  skipUserMatching: s
}) => {
  const { onOpen: l, isOpen: c, onClose: u } = cf(), {
    fetchCertificates: v,
    init: h,
    isInitialized: b,
    selectedCertificate: g,
    signXML: m,
    verifyXML: f,
    signHash: y,
    verifyString: p
  } = Nc(), [C, S] = Ze("Sign"), [E, w] = Ze(
    () => r === "single" ? { mode: "single", data: "" } : { mode: "multi", data: [] }
  );
  gt(() => {
    console.log("signContent", n);
  }, [n]), gt(() => {
    c && !b && h();
  }, [c]), gt(() => {
    b && c && v();
  }, [b, c]);
  const P = async () => {
    if (!g || !g.Thumbprint) {
      ur.error({
        message: "Произошла ошибка",
        description: "Сертификат не выбран / отстутствует thumbPrint",
        placement: "topRight"
      });
      return;
    }
    if (a && !Jy(g, a) && !s) {
      ur.error({
        description: "Ошибка при подписании",
        message: "ФИО учетной записи не совпадает с ФИО сертификата для подписи"
      });
      return;
    }
    try {
      if (r === "single") {
        const M = n, _ = t === "xml" ? await m(M, g.Thumbprint) : await y(M, g.Thumbprint);
        w({ mode: "single", data: _ }), typeof i == "function" && i(_);
      } else {
        const M = n, _ = await Promise.all(
          M.map(
            (x) => t === "xml" ? m(x, g.Thumbprint) : y(x, g.Thumbprint)
          )
        );
        w({ mode: "multi", data: _ }), typeof i == "function" && i(_);
      }
    } catch (M) {
      ur.error({
        message: "Произошла ошибка при подписании",
        description: String(M),
        placement: "topRight"
      });
    }
    u();
  }, N = () => r === "single" ? !!n : Array.isArray(n) && n.length > 0;
  return /* @__PURE__ */ Q.createElement(Q.Fragment, null, e({ onOpen: l }), /* @__PURE__ */ Q.createElement(Ld, { theme: eb, locale: lf }, /* @__PURE__ */ Q.createElement(
    Vd,
    {
      onCancel: u,
      onOk: P,
      okText: "Подписать",
      okButtonProps: {
        disabled: !N() || !(g != null && g.IsValid) || o
      },
      open: c,
      className: "cryptography-wrapper-modal",
      destroyOnClose: !0,
      centered: !0,
      width: 720,
      title: "Подписание",
      classNames: { header: "cryptography-modal-header" }
    },
    g && !g.IsValid && /* @__PURE__ */ Q.createElement(
      Rc,
      {
        notificationType: yn.InvalidCertificate
      }
    ),
    /* @__PURE__ */ Q.createElement(Zy, { disabled: o })
  )));
};
export {
  vf as CryptoPro,
  sb as CryptographyWrapper,
  Jy as isMatchingUser,
  Nc as useCryptographyStore
};
